/**
 * File: pixelOriginal.js
 *
 * Handle popup snipet script
 *
 * Chronological main function order:
 *
 * 1. Anonymous function line - 101
 * 2. poptinInit()
 * 3. poptinDependentFunction()
 * 4. getGeoLocation()
 * 5. poptinInitiate()
 * 6. initiatePullPoptinsRequest()
 * 7. setPoptinTrigger(this)
 * 8. setPoptin()
 * 9. showPoptin()
 * 10. poptinNewsTicker()
 * 11. poptinViewed()
 * 12. poptinConversion()
 * 13. closePoptin()
 * 14. animateButton()

 *
 * Mail:    dani@poptin.com
 *
 */
import { createClient as poptinWixSdkCreateClient } from '@wix/sdk';
import { site as poptinWixSite } from '@wix/site';

(function(window, document) {
    if(window.pixelAdded === undefined){
        window.pixelAdded = true;
        window.fakeEmailDomains = null;
        window.poptinValidationState = {
            loaded: false,
            emailValidationRequested: false,
            emailAutofillRequested: false,
            phoneValidationRequested: false,
            emailValidationNotRequired: false,
            emailAutofillNotRequired: false,
            phoneValidationNotRequired: false,
            phoneValidationLoaded: false,
            emailValidationLoaded: false,
            emailAutofillLoaded: false,
        };

        // Save href query data
        var query_string = new Object();
        //var poptin_active = true;

        // Set poptins URL
        var api_link = "";
        var app_link = "https://app.popt.in";
        var cdn_server = "";
        var env = "{PIXEL_ENV}";
        var WIX_APP_ID = "{WIX_APP_ID}";
        var WIX_STORE_ID = "{WIX_STORE_ID}";

        const hostname = window.location.hostname;
        const params = new URLSearchParams(window.location.search);
        const https = (host) => `https://${host}`;
        cartItems = [];
        poptinSetCookie('poptin_wix_cart_total_value', 0)

        const cookieCdn = poptinCheckCookie('poptin_cdn_server')
            ? https(poptinGetCookie('poptin_cdn_server'))
            : null;

        const paramCdn = params.has("cdn")
            ? https(params.get("cdn"))
            : null;

        if (hostname === "192.168.10.10") {
            api_link = cdn_server = "http://192.168.10.10";
        } else if (hostname.endsWith(".test")) {
            api_link = cdn_server = cookieCdn || https(hostname);
        } else if (env === "dev") {
            api_link = cdn_server =
                hostname === "popages.com"
                    ? "https://dev2.dev.popt.in"
                    : paramCdn || cookieCdn || https(hostname);
        } else if (env === "app") {
            api_link = "https://display.popt.in";
            cdn_server = "https://cdn.popt.in";
        }

        var css_link = api_link;

        // var api_link = "http://staggingDisplayLB2-194458017.us-west-2.elb.amazonaws.com";
        // var s3_link = "https://s3-us-west-2.amazonaws.com/app.popt.in";
        var poptin_il_url = "https://www.poptin.co.il/";
        var poptin;
        var poptin_com_url = "https://www.poptin.com/";

        // Set HTML components
        var html_poptin_x_button = '<button type="button" id="closeXButton" onclick="closePoptinOnXclick(this);" class="close-x-button" style="text-align: right; margin-top: -2px;-webkit-appearance: none;cursor: pointer;background: 0 0;border: 0;float: right;padding:0px;font-size: 20px;line-height: 0.5;color: #000;text-shadow: #fff 0px 0px 10px;filter: alpha(opacity=20);text-transform: none;overflow: visible;margin: 0;font-size:53px;line-height: 31px;z-index: 9999;position: relative;">&times;</button>';
        var html_poptin_skip_button = '<button type="button" id="closeSkipButton" onclick="closePoptinOnXclick(this);" class="close-x-button" style="text-align: right; margin-top: -2px;-webkit-appearance: none;padding: 5px;cursor: pointer;background: 0 0;border: 0;float: right;font-size: 25px;line-height: 0.5;color: #000;text-shadow: 0 1px 0 #fff;filter: alpha(opacity=20);opacity: 0.7;text-transform: none;overflow: visible;margin: 0;font-weight:bold;z-index: 9999;position: relative;">Skip</button>';
        var html_button_note = '<div id="closeButtonNote" class="close-button-note" style="display:none;text-align: center;padding: 9px 14px;position: absolute;top: -65px;right:0px;background: white;border-radius: 6px;word-wrap: break-word;max-width: 200px;border: 1px solid rgba(0,0,0,.2);opacity: 1;z-index:8999"></div>'
        var html_credit = '<div class="poptin-credit" style="z-index:100000;position: absolute;bottom: 0px;left: 0px;line-height: 0px;"><a href="https://www.poptin.co.il" target="_BLANK"><img src="'+cdn_server+'/css/images/credit.png" alt="Powered by poptin" style="width: 118px;height: 20px;"></a></div>';
        //var redirect = new Array();

        // Set poptins size and position
        var screen_width = window.screen.availWidth;
        var screen_height = window.innerHeight;

        var litghtbox_poptin_width = 800;
        var litghtbox_poptin_height = 500;
        var litghtbox_poptin_width_30 = 677;
        var litghtbox_poptin_height_30 = 556;
        var litghtbox_poptin_width_31 = 900;
        var litghtbox_poptin_height_31 = 556;
        var litghtbox_poptin_width_32 = 670;
        var litghtbox_poptin_height_32 = 556;
        var litghtbox_poptin_width_33 = 670;
        var litghtbox_poptin_height_33 = 556;
        var litghtbox_poptin_width_34 = 677;
        var litghtbox_poptin_height_34 = 556;

        var bar_poptin_width = 1920;
        var bar_poptin_height = 100;
        var bar_poptin_height_2 = 197;
        var bar_poptin_height_4 = 50;
        var bar_poptin_height_5 = 105;
        var bar_poptin_height_18 = 137;

        var browsing_poptin_width = 285;
        var browsing_poptin_height = 186;

        var sside_poptin_width = 500;
        var sside_poptin_width_2 = 300;
        var sside_poptin_height = 200;
        var sside_poptin_width_4 = 300;
        var sside_poptin_height_4 = 450;
        var sside_poptin_width_19 = 70;
        var sside_poptin_height_19 = 70;
        var sside_poptin_width_20 = 507;
        var sside_poptin_height_20 = 804;
        var sside_poptin_width_21 = 741;
        var sside_poptin_height_21 = 556;
        var sside_poptin_width_22 = 607;
        var sside_poptin_height_22 = 804;
        var sside_poptin_width_23 = 677;
        var sside_poptin_height_23 = 640;

        var bside_poptin_width = 402;
        var bside_poptin_height = 1080;

        var fullpage_poptin_width = 1920;
        var fullpage_poptin_height = 1080;
        var fullpage_poptin_width_2 = screen.width;
        var fullpage_poptin_height_2 = screen.height;

        var mobile_poptin_width = 483;
        var mobile_poptin_height = 150;

        var mobile_poptin_width_2 = 390;
        var mobile_poptin_height_2 = 242;

        var mobile_poptin_height_4 = 100;
        var mobile_poptin_height_5 = 75;

        var social_poptin_height = 214;
        var social_poptin_width = 340;
        var social_poptin_height_2 = 70;
        var social_poptin_width_2 = 70;
        var social_poptin_height_3 = 70;
        var social_poptin_width_3 = 70;
        var social_poptin_height_4 = 300;
        var social_poptin_width_4 = 300;

        var embedded_poptin_width_1 = 365;
        var embedded_poptin_height_1 = 370;
        var embedded_poptin_width_2 = 770;
        var embedded_poptin_height_2 = 160;
        var embedded_poptin_width_3 = 370;
        var embedded_poptin_height_3 = 635;
        var embedded_poptin_width_4 = 370;
        var embedded_poptin_height_4 = 570;
        var embedded_poptin_width_5 = 335;
        var embedded_poptin_height_5 = 520;
        var embedded_poptin_width_6 = 770;
        var embedded_poptin_height_6 = 192;
        var embedded_poptin_width_7 = 800;
        var embedded_poptin_height_7 = 500;
        var embedded_poptin_width_8 = 700;
        var embedded_poptin_height_8 = 400;
        var embedded_poptin_width_9 = 800;
        var embedded_poptin_height_9 = 500;

        var responsive_fullpage_height = false;
        var responsive_fullpage_width = false;
        var poptin_size = new Object();
        var poptin_position;
        var redirect_flag = false;
        var is_restricted =false;
        var default_close_delay = 4; // seconds
        window.poptin_loadcontrol_fix = window.poptin_loadcontrol_fix ? window.poptin_loadcontrol_fix : false;
        window.poptin_strip_font_imp = window.poptin_strip_font_imp ? window.poptin_strip_font_imp : false;
        window.poptin_disable_fa = window.poptin_disable_fa ? window.poptin_disable_fa : false;
        window.poptin_disable_localstorage = window.poptin_disable_localstorage ? window.poptin_disable_localstorage : false;
        window.poptin_single_page_app = window.poptin_single_page_app ? window.poptin_single_page_app : false;
        window.landing_page_teaser_on = window.landing_page_teaser_on ? window.landing_page_teaser_on : false;
        window.upgrade_popup_setting = window.upgrade_popup_setting ? window.upgrade_popup_setting : null;
        window.previous_url_spa = window.previous_url_spa ? window.previous_url_spa : null;
        window.poptinTimeDelayTrigger = window.poptinTimeDelayTrigger ? window.poptinTimeDelayTrigger : null;
        window.poptinExitPopupShown = window.poptinExitPopupShown ? window.poptinExitPopupShown : false;
        window.poptin_display_trigger = window.poptin_display_trigger ? window.poptin_display_trigger : false;
        window.poptin_disable_fonts = window.poptin_disable_fonts ? window.poptin_disable_fonts : false;
        window.poptin_jquery_version = window.poptin_jquery_version ? window.poptin_jquery_version : '3.7.1';

        var isMobileContainerAvailableObj = {};

        var poptinViewdArr = [];
        var poptinAnimateTab = [];
        var poptinTeaserShowTimeout = {};


        window.updateClockInterval = 0;
        //var socialProofInterval = new Object();
        var poptin_animation_speed = 300; // Poptin show animation speed
        // var country = new Object(); // Save user location data
        var pop_country = ""; // Save user location data
        var pop_country_code = ""; // Save user location data
        var showPoptinCount = 0;

        var field_desing = {
            'browsing_format_1' : {type:'vertical'},
            'browsing_format_2' : {type:'vertical'},
            'browsing_format_3' : {type:'vertical'},
            'bside_format_1' : {type:'vertical'},
            'bside_format_2' : {type:'vertical'},
            'bside_format_3' : {type:'vertical'},
            'bside_format_4' : {type:'vertical'},
            'bside_format_5' : {type:'vertical'},
            'bside_format_6' : {type:'vertical'},
            'bside_format_7' : {type:'vertical'},
            'bside_format_8' : {type:'vertical'},
            'bside_format_9' : {type:'vertical'},
            'lightbox_format_1' : {type:'vertical'},
            'lightbox_format_2' : {type:'horizontal'},
            'lightbox_format_3' : {type:'vertical'},
            'lightbox_format_4' : {type:'horizontal'},
            'lightbox_format_5' : {type:'horizontal'},
            'lightbox_format_6' : {type:'horizontal'},
            'lightbox_format_7' : {type:'vertical'},
            'lightbox_format_8' : {type:'horizontal'},
            'lightbox_format_9' : {type:'vertical'},
            'lightbox_format_10' : {type:'horizontal'},
            'lightbox_format_11' : {type:'horizontal'},
            'lightbox_format_12' : {type:'horizontal'},
            'lightbox_format_13' : {type:'vertical'},
            'lightbox_format_14' : {type:'horizontal'},
            'lightbox_format_15' : {type:'horizontal'},
            'lightbox_format_16' : {type:'horizontal'},
            'lightbox_format_17' : {type:'vertical'},
            'lightbox_format_18' : {type:'horizontal'},
            'lightbox_format_19' : {type:'vertical'},
            'lightbox_format_20' : {type:'vertical'},
            'lightbox_format_21' : {type:'vertical'},
            'lightbox_format_22' : {type:'vertical'},
            'sside_format_1' : {type:'vertical'},
            'sside_format_2' : {type:'vertical'},
            'sside_format_3' : {type:'vertical'},
            'sside_format_4' : {type:'vertical'},
            'sside_format_5' : {type:'vertical'},
            'sside_format_6' : {type:'vertical'},
            'sside_format_7' : {type:'vertical'},
            'sside_format_8' : {type:'vertical'},
            'sside_format_9' : {type:'vertical'},
            'sside_format_10' : {type:'vertical'},
            'sside_format_11' : {type:'vertical'},
            'sside_format_12' : {type:'vertical'},
            'sside_format_13' : {type:'vertical'},
            'sside_format_14' : {type:'vertical'},
            'sside_format_15' : {type:'vertical'},
            'sside_format_16' : {type:'vertical'},
            'sside_format_17' : {type:'vertical'},
            'sside_format_18' : {type:'vertical'},
            'sside_format_19' : {type:'vertical'},
            'sside_format_20' : {type:'vertical'},
            'sside_format_21' : {type:'vertical'},
            'sside_format_22' : {type:'vertical'},
            'sside_format_23' : {type:'vertical'},
            'social_format_1' : {type:'vertical'},
            'social_format_2' : {type:'vertical'},
            'social_format_3' : {type:'vertical'},
            'social_format_4' : {type:'vertical'},
            'social_format_5' : {type:'vertical'},
            'social_format_6' : {type:'vertical'},
            'social_format_7' : {type:'vertical'},
            'social_format_8' : {type:'vertical'},
            'bar_format_1' : {type:'horizontal'},
            'bar_format_2' : {type:'horizontal'},
            'bar_format_3' : {type:'horizontal'},
            'bar_format_4' : {type:'horizontal'},
            'bar_format_5' : {type:'horizontal'},
            'bar_format_6' : {type:'horizontal'},
            'bar_format_7' : {type:'horizontal'},
            'bar_format_8' : {type:'horizontal'},
            'bar_format_9' : {type:'horizontal'},
            'bar_format_10' : {type:'horizontal'},
            'bar_format_11' : {type:'horizontal'},
            'bar_format_12' : {type:'horizontal'},
            'bar_format_13' : {type:'horizontal'},
            'bar_format_14' : {type:'horizontal'},
            'bar_format_15' : {type:'horizontal'},
            'bar_format_16' : {type:'horizontal'},
            'bar_format_17' : {type:'horizontal'},
            'bar_format_18' : {type:'horizontal'},
            'fullpage_format_1' : {type:'vertical'},
            'fullpage_format_2' : {type:'vertical'},
            'fullpage_format_3' : {type:'horizontal'},
            'fullpage_format_4' : {type:'horizontal'},
            'fullpage_format_5' : {type:'vertical'},
            'fullpage_format_6' : {type:'vertical'},
            'fullpage_format_7' : {type:'vertical'},
            'fullpage_format_8' : {type:'horizontal'},
            'fullpage_format_9' : {type:'vertical'},
            'fullpage_format_10' : {type:'vertical'},
            'fullpage_format_11' : {type:'vertical'},
            'fullpage_format_12' : {type:'vertical'},
            'mobile_format_1' : {type:'horizontal'},
            'mobile_format_2' : {type:'horizontal'},
            'mobile_format_3' : {type:'vertical'},
            'mobile_format_4' : {type:'horizontal'},
            'mobile_format_5' : {type:'horizontal'},
            'mobile_format_6' : {type:'horizontal'},
            'mobile_format_7' : {type:'horizontal'},
            'mobile_format_8' : {type:'vertical'},
            'mobile_format_9' : {type:'horizontal'},
            'mobile_format_10' : {type:'horizontal'},
            'mobile_format_11' : {type:'horizontal'},
            'mobile_format_12' : {type:'horizontal'},
            'mobile_format_13' : {type:'vertical'},
            'mobile_format_14' : {type:'horizontal'},
            'mobile_format_15' : {type:'horizontal'},
            'mobile_format_16' : {type:'horizontal'},
            'mobile_format_17' : {type:'horizontal'},
            'embedded_format_1' : {type:'vertical'},
            'embedded_format_2' : {type:'horizontal'},
            'embedded_format_3' : {type:'vertical'},
            'embedded_format_4' : {type:'vertical'},
            'embedded_format_5' : {type:'vertical'},
            'embedded_format_6' : {type:'horizontal'},
            'embedded_format_7' : {type:'vertical'},
            'gamified_format_1' : {type:'vertical'},
            'gamified_format_2' : {type:'vertical'},
            'gamified_format_3' : {type:'vertical'}
        }

        // The jQuery primary instance
        window.jQ224 = null;

        // Save poptins data
        window.poptins = new Array();
        window.all_poptins = new Object();
        window.click_poptins = new Object();

        // Debounce variable
        var is_submit_poptin_run = true;
        var submit_poptin_disable_interval = 2000;

        // Common flags
        var ifAndroidPoptin = ( /Android/i.test(navigator.userAgent) ? true : false);
        var isIphonePoptin = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
        var isFirefoxPoptin = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        var isChromePoptin = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
        var isSafariPoptin = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') == -1 && navigator.userAgent.indexOf('FxiOS') == -1;
        var ifMobilePoptin = (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));

        // Initialize window.poptins if it doesn't exist
        if (!window.poptins) {
            window.poptins = {};
        }

        // Add a proxy to track changes to window.poptins
        try {
            const originalPoptins = window.poptins;
            window.poptins = new Proxy(originalPoptins, {
                set: function(target, prop, value) {
                    if (prop && typeof prop === 'string' && prop.length === 13) {
                        showLog('window.poptins[' + prop + '] being set to:', value);
                        if (value && typeof value === 'object' && value.redirect_target) {
                            showLog('redirect_target being set to:', value.redirect_target);
                        }
                    }
                    target[prop] = value;
                    return true;
                }
            });
            showLog('Proxy added to window.poptins for debugging');
        } catch (e) {
            showLog('Failed to add proxy to window.poptins:', e);
        }
        var if_display= false;
        var if_html_pad=false;
        var user_lang = "en";
        var if_freemium=null;
        window.poptinSubmitted = new Array();
        var newScaleTimeout = new Array();

        var poptinValidationLoaded = false;

        // Set default multy-lang message
        // var skip_en = "Are you sure?";
        // var skip_he = "האם אתה בטוח?";
        var skip_en = "Skip";
        var skip_he = "דלג";
        var copied_en = "Copied";
        var copied_he = "הועתק";

        // facebook_messanger_key
        var facebook_messanger_data_ref = '';

        var fr_templates = {'mobile':5,'fullpage':4,'browsing':1,'sside':4,'bside':3,'social':4,'bar':5,'lightbox':6}

        var url_conversion_query = '';
        // set and init Poptin Cookies
        //var PC = new PoptinCookies();
        //PC.init();

        var curr_year = new Date().getFullYear();

        var pop_days = {
            "en": ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],
            "he": ["יום ראשון" ,"יום שני" ,"יום שלישי" ,"יום רביעי" ,"יום חמישי" ,"יום שישי" ,"יום שבת"]
        }

        var pop_months = {
            "en": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            "he": ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"]
        }

        var prev_mon = new Date();
        prev_mon.setMonth(prev_mon.getMonth()-1);
        prev_mon = {
            "en": pop_months["en"][prev_mon.getMonth()],
            "he": pop_months["he"][prev_mon.getMonth()],
            "xx": prev_mon.toLocaleString('default', { month: 'long' })
        }

        var curr_mon = new Date();
        curr_mon = {
            "en": pop_months["en"][curr_mon.getMonth()],
            "he": pop_months["he"][curr_mon.getMonth()],
            "xx": curr_mon.toLocaleString('default', { month: 'long' })
        }

        var next_mon = new Date();
        next_mon.setMonth(next_mon.getMonth()+1);
        next_mon = {
            "en": pop_months["en"][next_mon.getMonth()],
            "he": pop_months["he"][next_mon.getMonth()],
            "xx": next_mon.toLocaleString('default', { month: 'long' })
        }

        var yest_day = new Date();
        yest_day.setDate(yest_day.getDate()-1);
        var yest_dmy = yest_day.getDate()+'/'+ yest_day.getMonth()+'/'+yest_day.getFullYear();
        var yest_mdy = yest_day.getMonth()+'/'+ yest_day.getDate()+'/'+yest_day.getFullYear();
        yest_day = {
            "en": pop_days["en"][yest_day.getDay()],
            "he": pop_days["he"][yest_day.getDay()],
        }

        var today_day = new Date();
        today_day.setDate(today_day.getDate());
        var today_dmy = today_day.getDate()+'/'+ today_day.getMonth()+'/'+today_day.getFullYear();
        var today_mdy = today_day.getMonth()+'/'+ today_day.getDate()+'/'+today_day.getFullYear();
        today_day = {
            "en": pop_days["en"][today_day.getDay()],
            "he": pop_days["he"][today_day.getDay()],
        }

        var tomo_day = new Date();
        tomo_day.setDate(tomo_day.getDate()+1);
        var tomo_dmy = tomo_day.getDate()+'/'+ tomo_day.getMonth()+'/'+tomo_day.getFullYear();
        var tomo_mdy = tomo_day.getMonth()+'/'+ tomo_day.getDate()+'/'+tomo_day.getFullYear();
        tomo_day = {
            "en": pop_days["en"][tomo_day.getDay()],
            "he": pop_days["he"][tomo_day.getDay()],
        }

        //Pre-defined array of merge tags
        var defined_tag_arr = [
            {tag_input:'curr_year', pre:1, value:curr_year},
            {tag_input:'prev_mon', pre:2, value:prev_mon},
            {tag_input:'curr_mon', pre:2, value:curr_mon },
            {tag_input:'next_mon', pre:2, value:next_mon },
            {tag_input:'yest_day', pre:2, value:yest_day },
            {tag_input:'today_day', pre:2, value:today_day },
            {tag_input:'tomo_day', pre:2, value:tomo_day },
            {tag_input:'yest_dmy', pre:1, value:yest_dmy },
            {tag_input:'yest_mdy', pre:1, value:yest_mdy },
            {tag_input:'today_dmy', pre:1, value:today_dmy },
            {tag_input:'today_mdy', pre:1, value:today_mdy },
            {tag_input:'tomo_dmy', pre:1, value:tomo_dmy },
            {tag_input:'tomo_mdy', pre:1, value:tomo_mdy }
        ]

        const CLIENT_ID_TTL_MINUTES = 30; // Adjust as needed

        var shopify_price_rules = [];
        var shopify_cart_cache = null;

        function showLog(...message) {
            try {
                if (env !="app" || poptinCheckCookie("poptin_enable_console_messages")) {
                    const stack = new Error().stack;
                    const callerLine = stack.split("\n")[2]; // Gets the specific stack line
                    const formattedCallerLine = callerLine.trim().replace(/^at\s+/, ''); // Format the string
                    console.info(...message, '\nCalled from:', formattedCallerLine);
                }
            } catch (error) {}
        }

        // Helper function to ensure poptin_trigger object exists
        function ensurePoptinTrigger(poptin_id) {
            if (!window.poptins[poptin_id]) {
                window.poptins[poptin_id] = {};
            }
            if (!window.poptins[poptin_id].poptin_trigger) {
                window.poptins[poptin_id].poptin_trigger = {
                    convert: false,
                    shown: false,
                    poptin_active: true,
                    scroll_flag: true,
                    mouse_leave_flag: true,
                    click_counter: 0,
                    trigger: '',
                    close_trigger: ''
                };
            }
            return window.poptins[poptin_id].poptin_trigger;
        }

        // Check for preview poptin ID
        var previewPoptinId = new URLSearchParams(window.location.search).get('ppt-preview');

        // Store integration (Shopify | Wix)
        var store_integration = null;
        var store_integration_customer_id = null;

        //Get shopify customer id
        var shopify_customer_id = 0;
        if (window.ShopifyAnalytics) {
            store_integration = 'shopify';
            shopify_customer_id = store_integration_customer_id = window.ShopifyAnalytics.meta.page.customerId;
            if (typeof shopify_customer_id == 'undefined') {
                shopify_customer_id = store_integration_customer_id = 0;
            }
        }

        // Create Shopify Event for Cart
        if(window.Shopify !== undefined) {
            // Custom event manager for Shopify cart
            let previousCart = null;
            const ShopifyCartEvents = {
                events: {},

                init() {
                    this.interceptXHR();
                    this.interceptFetch();
                    return this;
                },

                emit(eventName, data) {
                    if (this.events[eventName]) {
                        this.events[eventName].forEach(callback => callback(data));
                    }
                },

                on(eventName, callback) {
                    if (!this.events[eventName]) {
                        this.events[eventName] = [];
                    }
                    this.events[eventName].push(callback);
                },

                // Intercept XMLHttpRequest
                interceptXHR() {
                    const originalXHR = window.XMLHttpRequest;
                    const self = this;

                    window.XMLHttpRequest = function() {
                        const xhr = new originalXHR();
                        const originalOpen = xhr.open;
                        const originalSend = xhr.send;

                        xhr.open = function() {
                            const url = arguments[1];
                            if (url && url.includes('/cart') && !url.includes('/cart.js')) {
                                this._isCartRequest = true;
                                this._cartUrl = url;
                            }
                            return originalOpen.apply(this, arguments);
                        };

                        xhr.send = function() {
                            if (this._isCartRequest) {
                                const originalOnLoad = this.onload;
                                this.onload = function() {
                                    if (this.status >= 200 && this.status < 300) {
                                        try {
                                            const data = JSON.parse(this.responseText);
                                            const url = this._cartUrl;

                                            if (url.includes('/cart/add')) {
                                                self.emit('productAdded', data);
                                                self.getCartState();
                                            } else if (url.includes('/cart/update')) {
                                                self.emit('productUpdated', data);
                                                self.getCartState();
                                            } else if (url.includes('/cart/change')) {
                                                self.emit('productChanged', data);
                                                self.getCartState();
                                            }
                                        } catch (error) {
                                            self.emit('error', error);
                                        }
                                    }
                                    if (originalOnLoad) {
                                        originalOnLoad.apply(this, arguments);
                                    }
                                };
                            }
                            return originalSend.apply(this, arguments);
                        };

                        return xhr;
                    };
                },

                // Intercept Fetch (if available)
                interceptFetch() {
                    if (window.fetch) {
                        const originalFetch = window.fetch;
                        window.fetch = async (...args) => {
                            const [url, config] = args;

                            if (typeof url === 'string' && url.includes('/cart') && !url.includes('/cart.js')) {
                                try {
                                    const response = await originalFetch(...args);
                                    const clone = response.clone();

                                    if (url.includes('/cart/add')) {
                                        const data = await clone.json();
                                        this.emit('productAdded', data);
                                        this.getCartState();
                                    } else if (url.includes('/cart/update')) {
                                        const data = await clone.json();
                                        this.emit('productUpdated', data);
                                        this.getCartState();
                                    } else if (url.includes('/cart/change')) {
                                        const data = await clone.json();
                                        this.emit('productChanged', data);
                                        this.getCartState();
                                    }

                                    return response;
                                } catch (error) {
                                    this.emit('error', error);
                                    throw error;
                                }
                            }

                            return originalFetch(...args);
                        };
                    }
                },

                getCartState() {
                    const cartRequest = new XMLHttpRequest();
                    cartRequest.open('GET', '/cart.js', true);

                    cartRequest.onload = () => {
                        if (cartRequest.status >= 200 && cartRequest.status < 300) {
                            try {
                                const cartData = JSON.parse(cartRequest.responseText);
                                this.emit('cartUpdated', cartData);
                            } catch (error) {
                                this.emit('error', error);
                                console.error('Error parsing cart data:', error);
                            }
                        }
                    };

                    cartRequest.onerror = () => {
                        const error = new Error('Failed to fetch cart state');
                        this.emit('error', error);
                        console.error('Error fetching cart:', error);
                    };

                    cartRequest.send();
                }
            };
            /*
            // Initialize event handler
            const cartEvents = ShopifyCartEvents.init();

            cartEvents.on('productAdded', (data) => {
                console.log('Product added:', data);
                console.log("All Poptins");
                console.log(window.all_poptins)
                //shopifyCartTrigger(data, 'add');
            });

            // Add new handler for productRemoved events
            cartEvents.on('productRemoved', (item) => {
                console.log('Product removed:', item);
                //shopifyCartTrigger(item, 'remove');
            });

            cartEvents.on('cartUpdated', (cart) => {
                console.log('Cart state:', cart);
                if (previousCart) {
                    const removedItems = previousCart.items.filter(prevItem =>
                        !cart.items.some(currentItem => currentItem.id === prevItem.id)
                    );

                    removedItems.forEach(item => {
                        cartEvents.emit('productRemoved', item);
                    });
                }

                previousCart = cart;
                //shopifyCartTrigger(cart, 'changed');
            });

            */
        }

        function shopifyCartTrigger(data, action) {
            console.log("POPTIN")
            console.log(poptin)
            if(action == 'add') {
                if (poptin.shopify_cart_trigger_action == "added_product" && poptin.shopify_cart_trigger_products != null) {
                    if (poptin.shopify_cart_trigger_products == "any_product") {
                        appendPoptin(poptin)
                    } else {
                        var specifiedProductsArr = poptin.shopify_cart_trigger_products.split(',');
                        var responseProductId = (data.variant_id.toString() || data.product_id.toString());
                        if (specifiedProductsArr.includes(responseProductId)) {
                            appendPoptin(poptin)
                        }
                    }
                }
            }
            else if(action == 'remove') {
                console.log("REMOVE Data")
                console.log(data);
                if(poptin.shopify_cart_trigger_action == "removed_product") {

                    if ((poptin.shopify_cart_trigger_products == "any_product")) {
                        appendPoptin(poptin);
                    } else if((poptin.shopify_cart_trigger_products == "empty_cart") && (data.item_count < 1)) {
                        appendPoptin(poptin);
                    } else {
                        var oldCartProductIds = poptinCheckCookie('poptin_shopify_cart_product_id') ?
                            poptinGetCookie('poptin_shopify_cart_product_id').split(',') : [];

                        if (oldCartProductIds.length > 0) {
                            jQ224.each(oldCartProductIds, function(index,OldproductId) {
                                if (!newProductIds.includes(OldproductId)) {
                                    var specifiedRemovedProducts = poptin.shopify_cart_trigger_products.split(',');
                                    if (specifiedRemovedProducts.includes(OldproductId)) {
                                        appendPoptin(poptin);
                                    }
                                }
                            });
                        }
                    }
                }
            }
            else if(action == 'changed') {
                if ((poptin.shopify_cart_trigger_action == "cart_item" || poptin.shopify_cart_trigger_action == "cart_value") &&
                    poptin.shopify_cart_trigger_cart_spec_filter != null &&
                    poptin.shopify_cart_trigger_cart_spec_value != null) {

                    var cartSpecFilter = poptin.shopify_cart_trigger_cart_spec_filter;
                    var cartSpecValue = poptin.shopify_cart_trigger_cart_spec_value;

                    var cartItemOrValueCount = poptin.shopify_cart_trigger_action == "cart_item" ? data.item_count : (data.total_price / 100);

                    switch (cartSpecFilter) {
                        case 'greater_than':
                            if(cartItemOrValueCount > cartSpecValue) {
                                appendPoptin(poptin);
                            }
                            break;
                        case 'equal':
                            if(cartItemOrValueCount == cartSpecValue) {
                                appendPoptin(poptin);
                            }
                            break;
                        case 'greater_than_or_equal':
                            if(cartItemOrValueCount >= cartSpecValue) {
                                appendPoptin(poptin);
                            }
                            break;
                    }

                }
            }
        }

        var poptinWixAuthorizedClient = null;
        if (typeof window.wixDevelopersAnalytics != 'undefined') {
            try {
                poptinWixAuthorizedClient = poptinWixSdkCreateClient({
                    host: poptinWixSite.host({ applicationId: WIX_APP_ID }),
                    auth: poptinWixSite.auth(),
                });
            } catch (error) {
                console.error('Wix SDK initialization failed', error);
            }

            if (poptinWixAuthorizedClient) {
                store_integration = 'wix';

                attempWixLogin();

                window.wixDevelopersAnalytics.register(WIX_APP_ID, function report(eventName, eventData) {
                    switch(eventName) {
                        case 'CustomEvent':
                            if(eventData.eventAction.trim() == "Log in Submit") {
                                setTimeout(attempWixLogin, 2000);
                            }
                            break;
                        case 'ViewContent':
                            if (eventData.origin == 'Stores' && eventData.id && eventData.name) { // view store product
                                wixBrowseAbandonment(eventData);
                            }
                            break;
                        case 'AddToCart':
                            if((!localStorage.getItem('poptin_wix_cart_id')) ||
                                (localStorage.getItem('poptin_wix_cart_id') && localStorage.getItem('poptin_wix_cart_id') != eventData.cartId)) {
                                localStorage.setItem('poptin_wix_cart_id', eventData.cartId);
                            }
                            wixCartTrigger(eventData, 'add', false, 'AddToCart');
                            break;
                        case 'RemoveFromCart':
                            wixCartTrigger(eventData, 'remove', false, 'RemoveFromCart');
                            break;
                        case 'CustomizeProduct':
                            wixCartTrigger(eventData, 'add', true, 'CustomizeProduct');
                            break;
                        case 'productPageLoaded':
                            var recent_product_ids = poptinCheckCookie('poptin_wix_recent_product_id') ? poptinGetCookie('poptin_wix_recent_product_id').split(",") : [];
                            if (eventData.productId) {
                                var selectedProducttId = eventData.productId.toString();
                                if (!recent_product_ids.includes(selectedProducttId) || (recent_product_ids.length > 2 && recent_product_ids[2] == selectedProducttId)) {
                                    recent_product_ids.unshift(selectedProducttId);
                                }
                                if (recent_product_ids.length > 3) {
                                    recent_product_ids.pop();
                                }
                            }
                            poptinSetCookie("poptin_wix_recent_product_id",recent_product_ids.join(","));
                            break;
                        default:
                            // console.log('Handle_default_event_event_name', eventName);
                            // console.log('Handle default event with this event data', eventData);
                            break;
                    }
                });
            }
        }

        var wix_customer_id = 0;
        function attempWixLogin() {
            var urlOrigin = document.location.host;
            const memberResponse = fetch(`https://${urlOrigin}/_api/apps/current-member/${WIX_APP_ID}`).then(response => response.json()).then(response => {
                if(response.hasOwnProperty('member') && response.member.hasOwnProperty('id') && response.member.id) {
                    wix_customer_id = store_integration_customer_id = response.member.id;
                } else {
                    wix_customer_id = store_integration_customer_id = 0;
                }
            });
        }

        function getCartDetails (cartId, isInit, toReturn = 'cart_items') {
            if (!cartId) return null;
            return new Promise((resolve, reject) => {
                jQ224.ajax({
                    url: `${api_link}/api/display/wix/cart-details?cart_id=${cartId}&client_id=${getClientId()}&domain=${window.location.host}`,
                    async: true,
                    cache: true,
                    dataType: 'json',
                    contentType: 'application/json',
                    type: 'GET'
                }).done(function(res) {
                    const data = res.data;
                    if (data) {
                        if (isInit) {
                            cartItems = data[toReturn];
                        }
                        resolve(data[toReturn]);
                    }
                    poptinSetCookie('poptin_wix_cart_total_value', data.subtotal.amount);
                }).fail(function(xhr, status, error) {
                    reject(error);
                });
            });
        }

        async function wixCartTrigger(product, action, isProductCustomize = false, eventName) {
            var productObj = {
                product_id: product.id,
                product_name: product.name,
                category: product.category,
            };
    
            const newCartItems = await getCartDetails(product.cartId || localStorage.getItem('poptin_wix_cart_id'), false) || [];
    
             var wixCartProductArr= poptinCheckCookie('poptin_wix_cart_products') ? JSON.parse(poptinGetCookie('poptin_wix_cart_products')) : [];
    
            //  if (newCartItems) {
    
                if (action == "add") {
                    const productInCart = newCartItems?.find(item => item.id === product.id);
                    product = {...productInCart, ...product};

                    if (wixCartProductArr.length > 0) {
                        if (wixCartProductArr.some(e => e.product_id === product.id)) {
                            var objIndex = wixCartProductArr.findIndex((obj => obj.product_id === product.id));
                            wixCartProductArr[objIndex].category = product?.category;
                        } else {
                            wixCartProductArr.push(productObj);
                        }
                    } else {
                        wixCartProductArr.push(productObj);
                    }
                    poptinSetCookie('poptin_wix_cart_products', JSON.stringify(wixCartProductArr));
                    // poptinSetCookie('poptin_wix_cart_item_threshold', newCartItems.reduce((acc, item) => acc + item.quantity, 0));
                    
                    if (wix_cart_trigger_poptins.length > 0) {
                        poptin = window.all_poptins[jQ224(this)[0].poptin_id]
                        jQ224.each(wix_cart_trigger_poptins, function (index, poptin) {
                            if (poptin.wix_cart_trigger_action == "added_product" && poptin.wix_cart_trigger_products != null && !isProductCustomize) {

                                if (poptin.wix_cart_trigger_products == "any_product") {
                                    appendPoptin(poptin);
                                } else {
                                    var specifiedProductsArr = poptin.wix_cart_trigger_products.split(',');
                                    var productIndex = poptin.wix_cart_trigger_type == "any_product" ? specifiedProductsArr.findIndex((obj => product.id == obj)) : specifiedProductsArr.findIndex((obj => product.collectionIds?.includes(obj)));
                                    if (productIndex != -1) {
                                        appendPoptin(poptin)
                                    }
                                }
                            } else {
                                handleOtherCartActions(poptin, "add");
                            }
                        });
                    }
                } else {
                    var objIndex =  wixCartProductArr.findIndex((obj => obj.product_name == product.name));
                    const removedProducts = cartItems?.find(x => !newCartItems?.map(item => item.id)?.includes(x.id));
    
                    cartItems = newCartItems;
                    wixCartProductArr.splice(objIndex, 1);
                    poptinSetCookie('poptin_wix_cart_products', JSON.stringify(wixCartProductArr));
    
                    jQ224.each(wix_cart_trigger_poptins, function (index, poptin) {
                        if((poptin.wix_cart_trigger_action == "removed_product") &&
                            (wix_cart_trigger_poptins.length > 0) &&
                            (poptin.wix_cart_trigger_products != null)) {
                                var specifiedProductsArr = poptin.wix_cart_trigger_products.split(',');
                                if (poptin.wix_cart_trigger_type == "any_product") {
                                    if(((poptin.wix_cart_trigger_products == "empty_cart") && (wixCartProductArr.length < 1) || poptin.wix_cart_trigger_products == "any_product")) {
                                        appendPoptin(poptin);
                                    } else { 
                                        var productIndex = specifiedProductsArr.findIndex((obj => removedProducts.id == obj));
                                        if (productIndex != -1) {
                                            appendPoptin(poptin);
                                        }
                                    }
                                } else {
                                    var productIndex = specifiedProductsArr.findIndex((obj => removedProducts?.collectionIds.includes(obj)));
                                    if (productIndex != -1) {
                                        appendPoptin(poptin)
                                    }
                                }
                        } else {
                            if (eventName !== "RemoveFromCart") {
                                handleOtherCartActions(poptin, "remove");
                            } else if (eventName == "RemoveFromCart" && (poptin.wix_cart_trigger_action == "deletes_cart" || poptin.wix_cart_trigger_action == "cart_value")) {
                                handleOtherCartActions(poptin, "remove");
                            }
                        }
                    });
                }
            // }
        }

        async function handleOtherCartActions(poptin, action) {
            const lineItems = await getCartDetails(localStorage.getItem('poptin_wix_cart_id'), false, 'line_items') || [];
            const subtotal = await getCartDetails(localStorage.getItem('poptin_wix_cart_id'), false, 'subtotal') || [];
            if ((poptin.wix_cart_trigger_action == "cart_item" || poptin.wix_cart_trigger_action == "cart_value") &&
                poptin.wix_cart_trigger_cart_spec_filter != null &&
                poptin.wix_cart_trigger_cart_spec_value != null) {

                var cartSpecFilter = poptin.wix_cart_trigger_cart_spec_filter;
                var cartSpecValue = Number(poptin.wix_cart_trigger_cart_spec_value);

                var wixCartProductArr= poptinCheckCookie('poptin_wix_cart_products') ? JSON.parse(poptinGetCookie('poptin_wix_cart_products')) : [];
                
                var cartItemOrValueCount = poptin.wix_cart_trigger_action == "cart_item" ? wixCartProductArr.length : Number(subtotal.amount);
                
                switch (cartSpecFilter) {
                    case 'greater_than':
                        if(cartItemOrValueCount > cartSpecValue) {
                            appendPoptin(poptin);
                        }
                        break;
                    case 'equal':
                        if(cartItemOrValueCount == cartSpecValue) {
                            appendPoptin(poptin);
                        }
                        break;
                    case 'greater_than_or_equal':
                        if(cartItemOrValueCount >= cartSpecValue) {
                            console.log("Loyola")
                            appendPoptin(poptin);
                        }
                        break;
                }

            }else if (poptin.wix_cart_trigger_action == "creates_cart" && action == "add" && lineItems.length == 1) {
                appendPoptin(poptin);
            } else if (poptin.wix_cart_trigger_action == "deletes_cart" && action == "remove" && lineItems.length == 0) {
                appendPoptin(poptin);
            } else {
                console.log(poptin.wix_cart_trigger_action)
            }
        }

        function saveWixCartDetails(cartData) {
            cartItems = [];
            if(cartData.lineItems.length > 0) {
                cartItems = cartData.lineItems.map(function (item) {
                    return {
                        product_id: item.rootCatalogItemId,
                        product_name: item.productName.original,
                        category: null,
                    };
                });
            }
            poptinSetCookie('poptin_wix_cart_products', JSON.stringify(cartItems));
            poptinSetCookie('poptin_wix_cart_total_value',cartData.subtotal.amount);

        }

        if(typeof poptinVisible !== 'function'){
            window.poptinVisible = function (poptin_id){showLog('Showing '+poptin_id);}
        }

        var scratchPopupInitialScrollPosition;
        var scratchPopupActive = false;

        // Initiate multi-select vars
        var poptinMultiSelectTexts = [];
        var poptinMultiSelectValues = [];

        /*On poptinClose*/
        if (typeof onpoptinClose !== 'function') {
            window.onpoptinClose = function (poptin_id) {
                showLog('Closing ' + poptin_id);

                // Enable scroll for mobile - scratch popup
                if (ifMobilePoptin && poptin.poptin_type + '_' + poptin.poptin_format == "gamified_format_2") {
                    jQ224('html, body').css({
                        overflow: 'auto',
                        height: 'auto'
                    });

                    if (scratchPopupInitialScrollPosition) {
                        // Set the scroll position back to where it was
                        window.scrollTo(0, scratchPopupInitialScrollPosition);
                        scratchPopupActive = false;
                    }
                }

                const landing_page = window.location.href;

                const payload = {
                    client_id: getClientId(),
                    url: landing_page,
                    converted_email: poptinGetCookie('poptin_converted_email'),
                    store_integration: store_integration,
                    store_integration_customer_id: store_integration_customer_id,
                };

                jQ224.ajax({
                    url: `${api_link}/api/display/closed/${poptin_id}`,
                    async: true,
                    cache: true,
                    dataType: 'json',
                    contentType: 'application/json',
                    type: 'POST',
                    data: JSON.stringify(payload),
                });

                // window.onscroll = function() {};
            };
        }


        /*On poptinSubmit*/
        if(typeof onpoptinSubmit !== 'function'){
            window.onpoptinSubmit = function (poptin_id){showLog('Submitting '+poptin_id);}
        }

        /**
         * Triggered functions  : Script load
         * Desc                 : Get and set Client ID from url query
         */

        var poptinPageLoaded = 0;
        window.poptinStarted = window.poptinStarted ? window.poptinStarted : false;
        var checkTimeOutArray = [];
        var spinAfterSubmit = false;
        var pop_urls = sessionStorage.getItem('pop_urls') || '[]';
        var pop_landed_url = sessionStorage.getItem('pop_landed_url') || '[]';

        // First function to start adding poptin
        if(typeof runPoptinNow !== 'function'){
            window.runPoptinNow = function (){
                // Check for Shopify Cookies
                if(window.Shopify !== undefined && window.Shopify.shop) {
                    window.Shopify.loadFeatures(
                        [
                            {
                                name: 'consent-tracking-api',
                                version: '0.1',
                            },
                        ],
                        error => {
                            if (error) {
                                // Rescue error
                            }
                            // If error is false, the API has loaded and ready to use!
                        },
                    );

                    document.addEventListener("visitorConsentCollected", (event) => {
                        if(window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.userCanBeTracked()) {
                            runPoptinNowStart();
                        }
                    });

                    if(window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.getTrackingConsent() == "no") {
                        //showLog("Do not load Poptin as Cookies not accepted!");
                    } else if(window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.getTrackingConsent() == "yes") {
                        runPoptinNowStart();
                    } else {
                        shopifyCookieInterval = setInterval(function(){
                            if(window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.userCanBeTracked()) {
                                clearInterval(shopifyCookieInterval);
                                runPoptinNowStart();
                            } else if(window.Shopify.customerPrivacy && !window.Shopify.customerPrivacy.userCanBeTracked()) {
                                clearInterval(shopifyCookieInterval);
                            }else{
                                runPoptinNowStart();
                                clearInterval(shopifyCookieInterval);
                            }

                        }, 1000);
                    }

                }else{
                    runPoptinNowStart();
                }

            }
        }

        if(typeof runPoptinNowStart !== 'function'){
            window.runPoptinNowStart = function (){
                // Run this function only once
                if(poptinStarted){ return false; } else { poptinStarted = true; }

                console.log('runPoptinNow');
                var script_tags = Array();
                var didFindPoptinScriptID = false;
                var query = "";

                // If script was ingected via third party like: Shopify, Magento etc'
                if (document.getElementById('pixel-script-poptin') == null || document.getElementById('pixel-script-poptin')== undefined){

                    script_tags = document.getElementsByTagName('script');

                    for(var i = 0; i < script_tags.length ; i++ ) {
                        var currentURL = script_tags[i].src;
                        if(currentURL && currentURL.indexOf("{PIXEL_URL}/pixel.js") !== -1) {
                            didFindPoptinScriptID = true;
                            query = currentURL;
                            break;
                        }

                    }
                    // Get the 'src' from the injected script
                }else{
                    query = document.getElementById('pixel-script-poptin').src;
                }

                // If 'query' is not empty
                // -> loop query and set all query parameters to object 'query_string'
                if (query.length >0 &&
                    (document.getElementById('pixel-script-poptin-shopify') == null || document.getElementById('pixel-script-poptin-shopify')== undefined) ) {
                    query = query.split('?')[1];

                    // If 'query' have only one paramter
                    if (query.indexOf('&') > -1){
                        query = query.split('&');
                        for (var i=0;i<query.length;i++) {
                            var pair = query[i].split("=");

                            if (typeof pair[0] != 'undefined' && typeof pair[1] != 'undefined') {
                                query_string[pair[0]] = decodeURIComponent(pair[1]);
                            }
                        }
                    }else{
                        // showLog(query);
                        var pair = query.split('=');

                        if (typeof pair[0] != 'undefined' && typeof pair[1] != 'undefined') {
                            query_string[pair[0]] = decodeURIComponent(pair[1]);
                        }
                    }
                    setTimeout(function() { poptinInit(); }, 0);
                }else{
                    // If script is loaded from Shopify theme extension or Nuvemshop script cdn
                    if(document.getElementById('pixel-script-poptin-shopify') || (window.LS && window.LS.store && window.LS.store.url)) {
                        setTimeout(function() { poptinInit(); }, 0);
                    }else{
                        showLog('Poptin pixel Code not exist')
                    }
                }
            }
        }

        // Page load check if poptinAfterPageLoad variable is true

        if(typeof pageLoadCheck !== 'function'){
            window.pageLoadCheck = function (checkCount){
                poptinPageLoaded++;
                if(poptinPageLoaded == 2){
                    runPoptinNow();
                } else {
                    try {
                        clearTimeout(checkTimeOutArray[checkCount]);
                    } catch (error) {}
                    checkTimeOutArray[checkCount] = setTimeout(function(){
                        runPoptinNow();
                    },1000);
                }
            }
        }

        // Check if currently on landing page
        window.isPoptinLandingPage = window.isPoptinLandingPage ? window.isPoptinLandingPage : false;

        // Check if poptin should be added after page load or immediately
        // var poptinAfterPageLoad = true;
        window.poptinAfterPageLoad = window.poptinAfterPageLoad ? window.poptinAfterPageLoad : false;
        if(poptinAfterPageLoad){
            poptinAfterPageLoad = poptinCheckCookie("poptinAfterPageLoad_debug") ? poptinCheckCookie("poptinAfterPageLoad_debug") : poptinAfterPageLoad;
            console.log('poptinAfterPageLoad');
            setTimeout(function(){
                if(document.readyState == 'complete'){
                    runPoptinNow();
                } else if(window.addEventListener || window.hasOwnProperty('onload')){
                    window.addEventListener('load', function() {
                        pageLoadCheck('check1');
                    }, true);
                    window.onload = function() {
                        pageLoadCheck('check2');
                    };
                } else {
                    runPoptinNow();
                }
            },1500 * ( (poptinAfterPageLoad == 'noJqueryUi' || poptinAfterPageLoad == 'noConflict') ? 0 : 1));
        } else {
            runPoptinNow();
        }

        /**
         * Triggered functions  : Script load function
         * Desc                 : Check if jquery script is loaded and set it to jQ224 with jQuery.noConflict.
         *                      : "value", Run poptinDependentFunction() after setting jQ224
         */
        function poptinInit() {
            console.log("poptinInit loading");
            setPoptinSession();
            setClientId();

            j_1();

            /**
             * Triggered functions  : j_1()
             * Desc                 : Set jQuery.noConflict to jQ224. in order to handle with number of jquery liberary
             *                      : Run poptinDependentFunction()
             */
            function setJ() {
                jQ224 = jQuery.noConflict(true);
                jQ224.ui = window.jQuery.ui;
                poptinDependentFunction();
            }

            /*
            * Triggered functions  : j_1()
            * Desc                 : Set jQuery.noConflict to jQ224. in order to handle with number of jquery liberary
            *                      : Run poptinDependentFunction()
            */
            function setDolar() {
                jQ224 = jQuery.noConflict(true);
                jQ224.ui = (typeof window.$ !== 'undefined' && window.$.ui !== undefined) ? window.$.ui : undefined;
                poptinDependentFunction();
            }

            /**
             * Triggered functions  : j_1()
             * Desc                 : Set jQuery.noConflict to jQ224. in order to handle with number of jquery liberary
             * Desc                 : Run poptinDependentFunction()
             */
            function setJQ224() {
                jQ224 = jQuery.noConflict(true);
                poptinDependentFunction();
            }

            /**
             * Triggered functions  : poptinInit()
             * Desc                 : Check if jquery script is loaded, and select the right jQuery function to set.
             */
            function j_1(){
                try{
                    if(poptinAfterPageLoad && (poptinAfterPageLoad == 'noConflict' || poptinAfterPageLoad == 'noJqueryUi')){
                        var poptin_copy_jq = true;
                        if (typeof window.$ !== 'undefined'){
                            jQ_ver_arr = $.fn.jquery.split('.');
                            if(jQ_ver_arr[0] > 1 || (jQ_ver_arr[0] == 1 && jQ_ver_arr[1] > 7) ) {
                                jQ224 = (poptinAfterPageLoad == 'noJqueryUi') ? $ : $.noConflict();
                            } else {
                                poptin_copy_jq = false;
                            }
                        }else if (typeof window.jQuery !== 'undefined'){
                            jQ_ver_arr = jQuery.fn.jquery.split('.');
                            if(jQ_ver_arr[0] > 1 || (jQ_ver_arr[0] == 1 && jQ_ver_arr[1] > 7) ) {
                                jQ224 = (poptinAfterPageLoad == 'noJqueryUi') ? jQuery : jQuery.noConflict();
                            } else {
                                poptin_copy_jq = false;
                            }
                        }
                        if(poptin_copy_jq || poptinAfterPageLoad == 'noJqueryUi'){
                            poptinDependentFunction();
                        } else {
                            console.log('Upgrade your jQuery to atleast 1.7 to show poptins');
                        }
                    } else {
                        if (typeof window.$ !== 'undefined' && window.$.ui !== undefined){
                            j_2(setDolar);
                        }else if (typeof window.jQuery !== 'undefined' && window.jQuery.ui !== undefined){
                            j_2(setJ);
                        }else{
                            j_2(setJQ224);
                        }
                    }
                }catch(err){
                    // showLog(err);

                    // Default jQuery function
                    j_2(setJQ224);
                }
            }

            /**
             * Triggered functions  : j_1()
             * Desc                 : Download jQuery 2.2.4 and append it to document
             */
            function j_2(setJquery){

                var allowedVersions = [
                    '3.5.0',
                    '3.5.1',
                    '3.6.0',
                    '3.6.1',
                    '3.6.2',
                    '3.6.3',
                    '3.6.4',
                    '3.7.0',
                    '3.7.1'
                ];

                // Default to 3.7.1 if poptin_jquery_version is not valid
                var selectedVersion = allowedVersions.includes(poptin_jquery_version)
                ? poptin_jquery_version
                : '3.7.1';

                var poptin_jQuery_elem = document.getElementById("poptin_jQuery");
                    if(poptin_jQuery_elem){
                        document.getElementById("poptin_jQuery").remove();
                    }
                    var r = document.createElement("script");
                    r.setAttribute("type", "text/javascript");
                    r.setAttribute('id', 'poptin_jQuery');
                    r.setAttribute("src", `https://cdnjs.cloudflare.com/ajax/libs/jquery/${selectedVersion}/jquery.min.js`);
                    r.setAttribute('async','true');
                    if (r.readyState) {
                        r.onreadystatechange = function() {
                            if (this.readyState == "complete" || this.readyState == "loaded") {
                                setJquery();
                            }
                        }
                    } else {
                        r.onload = setJquery
                    }
                    (document.getElementsByTagName("head")[0] || document.documentElement).appendChild(r);

                //Adding xhook script for cart taregting
                if(window.Shopify!==undefined && window.Shopify.shop){
                    var poptin_xhook_elem = document.getElementById("poptin_xhook");
                    if(poptin_xhook_elem){
                        document.getElementById("poptin_xhook").remove();
                    }

                    var x = document.createElement("script");
                    x.setAttribute('id', 'poptin_xhook');
                    x.setAttribute("src", "//unpkg.com/xhook@latest/dist/xhook.min.js");
                    (document.getElementsByTagName("head")[0] || document.documentElement).appendChild(x);
                }

                var poptin_googleapis_elem = document.getElementById("poptin_googleapis");
                if(!poptin_googleapis_elem){
                    // var lefgapis = this.document.createElement('link');
                    //     lefgapis.setAttribute('rel', 'preconnect');
                    //     lefgapis.setAttribute('id', 'poptin_googleapis');
                    //     lefgapis.setAttribute('href', 'https://fonts.popt.in' );
                    //     (document.getElementsByTagName("head")[0] || document.documentElement).appendChild(lefgapis);
                }
                var poptin_cloudflare_elem = document.getElementById("poptin_cloudflare");
                if(!poptin_cloudflare_elem){
                    var lecdn = this.document.createElement('link');
                    lecdn.setAttribute('rel', 'preconnect');
                    lecdn.setAttribute('id', 'poptin_cloudflare');
                    lecdn.setAttribute('href', 'https://cdnjs.cloudflare.com' );
                    (document.getElementsByTagName("head")[0] || document.documentElement).appendChild(lecdn);
                }
                var poptin_css_link_elem = document.getElementById("poptin_css_link");
                if(!poptin_css_link_elem){
                    var lecss_link = this.document.createElement('link');
                    lecss_link.setAttribute('rel', 'preconnect');
                    lecss_link.setAttribute('id', 'poptin_css_link');
                    lecss_link.setAttribute('href', css_link );
                    (document.getElementsByTagName("head")[0] || document.documentElement).appendChild(lecss_link);
                }

            }
        };

        /**
         * Triggered functions  : poptinInit()
         * Desc                 : Set Client ID to browser session
         */
        function setClientId(){
            if (query_string.id !== undefined){
                if (typeof(Storage) !== "undefined") {
                    if (window.sessionStorage.getItem("poptin_client_id") == null){
                        window.sessionStorage.setItem("poptin_client_id",query_string.id);
                    }
                } else {
                    if (!poptinCheckCookie('poptin_client_id')){
                        poptinSetCookie('poptin_client_id', query_string.id, 365);
                    }
                }
            }
        }

        // function setShopifyClientId(type = 'storage') {
        //     if(Shopify && Shopify.shop) {
        //         if (typeof(Storage) !== "undefined") {
        //             if (window.sessionStorage.getItem("poptin_client_id") == null){
        //                 jQ224.ajax({
        //                     url: `${api_link}/api/display/shopify/get-client-id/${Shopify.shop}`,
        //                     type: 'GET',
        //                     dataType: 'json',
        //                     async: false,
        //                     success: function(resp) {
        //                         window.sessionStorage.setItem("poptin_client_id",resp.client_id);
        //                     }
        //                 });
        //             }
        //         } else {
        //             if (!poptinCheckCookie('poptin_client_id')){
        //                 jQ224.ajax({
        //                     url: `${api_link}/api/display/shopify/get-client-id/${Shopify.shop}`,
        //                     type: 'GET',
        //                     dataType: 'json',
        //                     async: false,
        //                     success: function(resp) {
        //                         poptinSetCookie('poptin_client_id', resp.client_id, 365);
        //                     }
        //                 });
        //             }
        //         }
            //
        //     }
        // }

        function setNuvemshopClientId(callback) {
            callback = callback || function() {};

            if (window.LS && window.LS.store && window.LS.store.url) {
                const useStorage = typeof Storage !== "undefined";
                const storeUrl = window.LS.store.url;

                const storedClientId = useStorage
                    ? window.sessionStorage.getItem("poptin_client_id")
                    : poptinGetCookie('poptin_client_id');

                const storedExpiry = useStorage
                    ? window.sessionStorage.getItem("poptin_client_id_expiry")
                    : poptinGetCookie('poptin_client_id_expiry');

                const isExpired = !storedExpiry || Date.now() > parseInt(storedExpiry);

                // Only call API if no client ID stored OR TTL has expired
                if (!storedClientId || isExpired) {
                    jQ224.ajax({
                        url: `${api_link}/api/display/nuvemshop/get-client-id`,
                        type: 'POST',
                        dataType: 'json',
                        data: { store_url: storeUrl },
                        async: true,
                        success: function(resp) {
                            const expiry = Date.now() + (CLIENT_ID_TTL_MINUTES * 60 * 1000);
                            storeClientId(useStorage, resp.client_id, expiry);
                        },
                        complete: callback
                    });
                } else {
                    callback();
                }
            } else {
                callback();
            }
        }

        function setShopifyClientId(callback) {
            callback = callback || function() {};

            if (Shopify && Shopify.shop) {
                const useStorage = typeof Storage !== "undefined";

                const storedClientId = useStorage
                    ? window.sessionStorage.getItem("poptin_client_id")
                    : poptinGetCookie('poptin_client_id');

                const storedExpiry = useStorage
                    ? window.sessionStorage.getItem("poptin_client_id_expiry")
                    : poptinGetCookie('poptin_client_id_expiry');

                const isExpired = !storedExpiry || Date.now() > parseInt(storedExpiry);

                // Only call API if no client ID stored OR TTL has expired
                if (!storedClientId || isExpired) {
                    jQ224.ajax({
                        url: `${api_link}/api/display/shopify/get-client-id/${Shopify.shop}`,
                        type: 'GET',
                        dataType: 'json',
                        async: true,
                        success: function(resp) {
                            const expiry = Date.now() + (CLIENT_ID_TTL_MINUTES * 60 * 1000);
                            storeClientId(useStorage, resp.client_id, expiry);
                        },
                        complete: callback
                    });
                } else {
                    callback();
                }
            } else {
                callback();
            }
        }

        function storeClientId(useStorage, clientId, expiry) {
            if (useStorage) {
                window.sessionStorage.setItem("poptin_client_id", clientId);
                window.sessionStorage.setItem("poptin_client_id_expiry", expiry);
            } else {
                poptinSetCookie('poptin_client_id', clientId, 365);
                poptinSetCookie('poptin_client_id_expiry', expiry, 365);
            }
        }

        /**
         * Triggered functions  : initiatePullPoptinsRequest(), initiatePullPoptinsRequestOnClick(), monitorError()
         * Desc                 : Return Client ID from browser session
         */
				function getClientId(){
					var client_id = query_string.id;

					if (query_string.id == undefined){
						if (typeof(Storage) !== "undefined" && window.sessionStorage.getItem("poptin_client_id") != null) {
							client_id = window.sessionStorage.getItem("poptin_client_id");
						}else{
							if (poptinCheckCookie('poptin_client_id')){
								client_id = poptinGetCookie('poptin_client_id');
							}
						}
					}

					return client_id;
				}

			/**
			 * Trigger functions: j_2()
			 * Desc             : Run dependent functions
			 *
			 */
			function poptinDependentFunction(){
				setMarketplaceClientId(runPoptinDependentTasks);
			}

			function runPoptinDependentTasks(){
				setReferrer();
				setPreviousUrl();
				displayPoptinOnClick();
				onTextClickClose();
				poptinInitiate();
				setOriginLandingPage();
				//Don't store localstorage if poptin_disable_localstorage is et true
				if( !poptin_disable_localstorage ){
					setPreviousVisitedPages();
					setPreviousVisitedPagesWithTimeStamp();
					setAllVisitedPages();
				}
				//getGeoLocation();
				// windowResize();
				shopifyBrowseAbandonment();

            updateShopifyCustomerData();
            // Track product view if on product page
            trackProductView();
        }

        function shopifyBrowseAbandonment() {
            //Browse Abandonmment for shopify
            var shopify_customer_id = false;
            if(typeof window.ShopifyAnalytics != "undefined"){
                shopify_customer_id = window.ShopifyAnalytics.meta.page.customerId;
                if (typeof shopify_customer_id == 'undefined') {
                    shopify_customer_id = false;
                }

                if (shopify_customer_id && window.ShopifyAnalytics.meta.page.resourceType == "product") {
                    var productId = window.ShopifyAnalytics.meta.page.resourceId.toString();
                    var productCategory = window.ShopifyAnalytics.meta.product.type;
                    var productName = window.ShopifyAnalytics.meta.product.variants[0].name;
                    setTimeout(function() {
                        var productObj = {product_id: productId, product_name:productName, category: productCategory};
                        var browseAbandonmentProductArr= poptinCheckCookie('poptin_browse_abandonment_products') ?
                            JSON.parse(poptinGetCookie('poptin_browse_abandonment_products')) : [];

                    if (browseAbandonmentProductArr.length > 0) {
                            if (browseAbandonmentProductArr.some(e => e.product_id === productId)) {
                                var objIndex = browseAbandonmentProductArr.findIndex((obj => obj.product_id === productId));
                                browseAbandonmentProductArr[objIndex].category = productCategory;
                            } else {
                                browseAbandonmentProductArr.push(productObj);
                            }
                        } else {
                            browseAbandonmentProductArr.push(productObj);
                        }

                        poptinSetCookie('poptin_browse_abandonment_products', JSON.stringify(browseAbandonmentProductArr));

                        /*jQ224.get(api_link+"/api/display/shopify/save/browse-abandonment?clientId="+getClientId()+"&customer="+shopify_customer_id.toString()+"&products="+JSON.stringify(browseAbandonmentProductArr)+"&data_for=abandonment",{
                        },"json");*/
                        jQ224.ajax({
                            url: api_link + "/api/display/shopify/save/browse-abandonment",
                            method: "POST",
                            contentType: "application/json",
                            dataType: "json",
                            data: JSON.stringify({
                                clientId: getClientId(),
                                customer: shopify_customer_id.toString(),
                                products: JSON.stringify(browseAbandonmentProductArr),
                                data_for: "abandonment",
                            })
                        });
                    },5000);
                }
            }

        }

        // Browse Abandonmment for wix
        function wixBrowseAbandonment(product = null) {
            if(!product || !product?.id || !product.name) {
                return;
            }

            if (typeof wix_customer_id == 'undefined' || wix_customer_id == 0) {
                attempWixLogin();
            }

            if (!wix_customer_id || wix_customer_id == 0) {
                return;
            }

            var productObj = {
                product_id: product.id,
                product_name: product.name,
                category: product?.category,
            };
            var browseAbandonmentProductArr= poptinCheckCookie('poptin_browse_abandonment_products')
                ? JSON.parse(poptinGetCookie('poptin_browse_abandonment_products'))
                : [];

            if (browseAbandonmentProductArr.length > 0) {
                if (browseAbandonmentProductArr.some(e => e.product_id === product.id)) {
                    var objIndex = browseAbandonmentProductArr.findIndex((obj => obj.product_id === product.id));
                    browseAbandonmentProductArr[objIndex].category = product?.category;
                } else {
                    browseAbandonmentProductArr.push(productObj);
                }
            } else {
                browseAbandonmentProductArr.push(productObj);
            }

            poptinSetCookie('poptin_browse_abandonment_products', JSON.stringify(browseAbandonmentProductArr));

            const params = {
                client_id: getClientId(),
                customer_id: wix_customer_id,
                products: browseAbandonmentProductArr,
                source_table: 'browse_abandonment',
            };

            jQ224.ajax({
                url: `${api_link}/api/display/wix/save-ordered-products`,
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(params),
                dataType: 'json',
            }, "json");
        }

        function updateShopifyCustomerData() {
            var shopify_customer_id = false;
            if(typeof window.ShopifyAnalytics != "undefined") {
                shopify_customer_id = window.ShopifyAnalytics.meta.page.customerId;
                if (typeof shopify_customer_id == 'undefined') {
                    shopify_customer_id = false;
                }

                if (shopify_customer_id) {
                    if ((!poptinCheckCookie('poptin_fetch_initial_shopify_cart_for_filter'))) {
                        storeShopifyProductIncart()
                        poptinSetCookie('poptin_fetch_initial_shopify_cart_for_filter', true);
                    }

                    (function (ns, fetch) {
                        if (typeof fetch !== 'function') return;

                        ns.fetch = function () {
                            const response = fetch.apply(this, arguments);
                            var shopify_lang_route = shopifylanguageRoute();

                            response.then(res => {
                                if ([
                                    `${window.location.origin}${shopify_lang_route}cart/add.js`,
                                    `${window.location.origin}${shopify_lang_route}cart/add`,
                                    `${window.location.origin}${shopify_lang_route}cart/update.js`,
                                    `${window.location.origin}${shopify_lang_route}cart/update`,
                                    `${window.location.origin}${shopify_lang_route}cart/change.js`,
                                    `${window.location.origin}${shopify_lang_route}cart/change`,
                                    `${window.location.origin}${shopify_lang_route}cart/clear.js`,
                                    `${window.location.origin}${shopify_lang_route}cart/clear`,
                                ].includes(res.url)) {
                                    res.clone().json().then((data) => {
                                        storeShopifyProductIncart()
                                    });

                                }
                            });

                            return response;
                        }

                    }(window, window.fetch));
                }
            }
        }

        function storeShopifyProductIncart() {

            jQ224.ajax({
                url: "/cart.js",
                type: 'get',
                dataType: 'json',
                async: true,
            }, "json")
                .done(function (data) {
                    var productsArr = []
                    var total_cart_value = 0;
                    if(data.items.length > 0) {
                        jQ224.each(data.items, function (index, item) {
                            var productObj = {product_id: item.product_id.toString(), product_name:item.product_title, variant_id: item.variant_id};
                            productsArr.push(productObj);
                        });

                        total_cart_value = data.total_price;
                    }
                    /*jQ224.get(api_link+"/api/display/shopify/save/browse-abandonment?clientId="+getClientId()+"&customer="+shopify_customer_id.toString()+"&products="+JSON.stringify(productsArr)+"&data_for=cart&total_cart_value="+total_cart_value,{},"json");*/

                    jQ224.ajax({
                        url: api_link + "/api/display/shopify/save/browse-abandonment",
                        method: "POST",
                        contentType: "application/json",
                        dataType: "json",
                        async: true,
                        data: JSON.stringify({
                            clientId: getClientId(),
                            customer: shopify_customer_id.toString(),
                            products: JSON.stringify(productsArr),
                            data_for: "cart",
                            total_cart_value: total_cart_value
                        })
                    });

                });
        }

        /**
         * Trigger functions: poptinDependentFunction()
         * parameters       :
         * Desc             : This function will set shopify cart details if pixel run on Shopify
         */
        function setMarketplaceClientId(callback) {
            callback = callback || function() {};

            // Shopify detection
            if(window.Shopify !== undefined && window.Shopify.shop){
                // Get Client ID from shop and set in storage
                setShopifyClientId(function() {
                    jQ224.ajax({
                        url: shopifylanguageRoute()+"cart.js",
                        type: 'get',
                        dataType: 'json',
                        async: true,
                    }, "json")
                    .done(function(cart){
                        shopify_cart_cache = cart;
                        var cart_value = (cart.total_price)/100;
                        defined_tag_arr.push({tag_input:'shpfy_value', pre:1, value:cart_value});
                        defined_tag_arr.push({tag_input:'shpfy_count', pre:1, value:cart.item_count});

                        // Get Shopify Price Rules if any
                        jQ224.ajax({
                            url: api_link+"/api/display/shopify/get-price-rules/"+getClientId(),
                            type: 'get',
                            async: true,
                            success: function(res) {
                                shopify_price_rules = res.price_rules;
                                var one_rule = null;
                                jQ224(shopify_price_rules).each(function(idx, rule){
                                    if(
                                        one_rule == null &&
                                        (
                                            (rule.target_type == "shipping_line" && rule.allocation_method == "each") ||
                                            (rule.target_type == "line_item" && rule.allocation_method == "across")
                                        ) &&
                                        rule.target_selection == "all"
                                    ) {
                                        one_rule = rule;
                                        var cart_threshold = (one_rule && one_rule.prerequisite_subtotal_range && one_rule.prerequisite_subtotal_range.greater_than_or_equal_to) ? parseFloat(one_rule.prerequisite_subtotal_range.greater_than_or_equal_to) : 0;
                                        defined_tag_arr.push({tag_input:'shpfy_thres', pre:1, value:cart_threshold});
                                        defined_tag_arr.push({tag_input:'shpfy_gap', pre:1, value:cart_threshold-cart_value});
                                    }
                                });
                            },
                            complete: callback
                        });
                    })
                    .fail(callback);
                });

            }
            // Nuvemshop detection
            else if (window.LS && window.LS.store && window.LS.store.url) {
                // Handle Nuvemshop - set client ID
                setNuvemshopClientId(function() {
                    // Nuvemshop specific tasks if needed in future
                    // For now, just call callback after client ID is set
                    callback();
                });

            }
            // No marketplace detected
            else {
                callback();
            }
        }

        /**
         * Product View Tracking Functions
         */

        /**
         * Check if current page is a product page
         */
        function isProductPage() {
						const page_type = jQ224("#poptin-page-type").val();

						if(page_type && page_type == 'product') {
							return true;
						}

            return false;
        }

        /**
         * Track product view and send to backend
         */
        function trackProductView() {
					// Only track if we're on a product page
					if (!isProductPage()) {
						return;
					}

					// Get customer information
					const storeIntegrationCustomerId = shopify_customer_id || 0;

					// Only track if we have customer info
					if (!storeIntegrationCustomerId) {
						return;
					}

					const productId = jQ224("#poptin-s-product-id").val();
					const productCollections = jQ224("#poptin-product-collections").val();

					// Only track if we have product id
					if (!productId) {
						return;
					}

					const payload = {
						product_id: productId,
						product_collections: productCollections,
						store_integration_customer_id: storeIntegrationCustomerId,
						url: document.location.href,
					};

					// Send product view data to backend
					jQ224.ajax({
						url: `${api_link}/api/display/product-view/${getClientId()}`,
						type: "POST",
						dataType: "json",
						contentType: "application/json",
						async: true,
						data: JSON.stringify(payload),
						success: function (response) {
							console.log("Product view tracked successfully", response);
						},
						error: function (xhr, status, error) {
							console.log("Product view tracking failed", error);
						},
					});
				}

        /**
         * Trigger functions: doResizePoptin()
         * parameters       : poptin:object | click:Boolean (if poptin click trigger)
         * Desc             : Handle poptin style and view to fit to all window screen size(width*height)
         */
        function setReferrer(){
            var poptin_referrer = (getReferrer().length > 1) ? getReferrer() : document.referrer;
            var poptin_referrer_protocol = (poptin_referrer && poptin_referrer.startsWith("https://")) ? "secure" : (poptin_referrer && poptin_referrer.startsWith("http://")) ? "unsecure" : "";
            poptin_referrer = poptin_referrer.replace(/^https?:\/\//, '');

            if (document.referrer.length>1){
                //poptinSetCookie('poptin_referrer', document.referrer, 0.00138888888888889);
                poptinSetCookie('poptin_referrer', poptin_referrer, 0.00138888888888889);
                if(poptin_referrer_protocol) {
                    poptinSetCookie('poptin_referrer_protocol', poptin_referrer_protocol, 0.00138888888888889);
                }
            }
            setInterval(function(){
                poptinSetCookie('poptin_referrer', poptin_referrer, 0.00138888888888889);
                if(poptin_referrer_protocol) {
                    poptinSetCookie('poptin_referrer_protocol', poptin_referrer_protocol, 0.00138888888888889);
                }
            },60000);
        }

        /**
         * Trigger functions: setPreviousPage()
         * parameters       : store previous pages visited by the user
         */
        function setPreviousVisitedPages(){
            var clientDomain = (document.referrer ? ( document.referrer.indexOf(window.location.host) !== -1 ? document.referrer : null ) : null);
            if (clientDomain){
                var referrerUrl = new URL(document.referrer)
                var referrerPath = referrerUrl.pathname + referrerUrl.search;

                var previousPages = localStorage.getItem('poptin_previous_visited_pages');
                if (previousPages && previousPages.length > 0) {
                    var previousPagesArray = previousPages.split('|');
                    if (previousPagesArray.includes(referrerPath)) {
                        var pageIndex = previousPagesArray.indexOf(referrerPath);
                        previousPagesArray.splice(pageIndex, 1);
                    }
                    previousPagesArray.push(referrerPath);

                    localStorage.setItem('poptin_previous_visited_pages', previousPagesArray.join('|'));

                } else {
                localStorage.setItem('poptin_previous_visited_pages', referrerPath);
                }
            }
        }

        function setAllVisitedPages(){
            var locationUrl = document.location.href;
            var allVisitedPages = localStorage.getItem('poptin_all_visited_pages');
            if (allVisitedPages && allVisitedPages.length > 0) {
                var allPagesArray = allVisitedPages.split('|');
                if (allPagesArray.includes(locationUrl)) {
                    var pageIndex = allPagesArray.indexOf(locationUrl);
                    if((allPagesArray.length - 1) != pageIndex) {
                        allPagesArray.push(locationUrl);
                    }
                } else {
                    allPagesArray.push(locationUrl);
                }

                localStorage.setItem('poptin_all_visited_pages', allPagesArray.join('|'));

            } else {
                localStorage.setItem('poptin_all_visited_pages', locationUrl);
            }
        }

        function setPreviousVisitedPagesWithTimeStamp(){
            var clientDomain = (document.referrer ? ( document.referrer.indexOf(window.location.host) !== -1 ? document.referrer : null ) : null);
            if (clientDomain){
                var referrerUrl = new URL(document.referrer)
                var referrerPath = referrerUrl.pathname + referrerUrl.search + ";" + getCurrentDateTime();

                var previousPages = localStorage.getItem('poptin_previous_visited_pages_with_timestamp');
                if (previousPages && previousPages.length > 0) {
                    var previousPagesArray = previousPages.split('|');
                    if (previousPagesArray.includes(referrerPath)) {
                        var pageIndex = previousPagesArray.indexOf(referrerPath);
                        previousPagesArray.splice(pageIndex, 1);
                    }
                    previousPagesArray.push(referrerPath);

                    localStorage.setItem('poptin_previous_visited_pages_with_timestamp', previousPagesArray.join('|'));

                } else {
                localStorage.setItem('poptin_previous_visited_pages_with_timestamp', referrerPath);
                }
            }
        }

        function getCurrentDateTime() {
            const options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            };

            const formatter = new Intl.DateTimeFormat('en-US', options);
            const formattedDateParts = formatter.formatToParts(new Date())
                .reduce((acc, part) => {
                    if (part.type === 'literal') {
                        acc.push('-');
                    } else {
                        acc.push(part.value);
                    }
                    return acc;
                }, []);

            return formattedDateParts.join('');
        }

        // Main validation initialization function
        function initializePoptinValidations(poptin) {
            const validatePoptinInputs = (poptin) => {
                if (!poptin) return;

                const this_pop = jQ224("[data-poptin-id=" + poptin.poptin_id + "]");
                if (!this_pop.length) return;

                // Phone validation
                const phoneInput = this_pop.find("input#poptinDesignInputTextFieldPhone").get(0);
                if (phoneInput && window.poptinValidationState.phoneValidationLoaded) {
                    poptinPhoneValidation(poptin, phoneInput);
                }

                // Email validation
                if (window.poptinValidationState.emailAutofillLoaded || window.poptinValidationState.emailValidationLoaded) {
                    poptinEmailValidation(poptin);
                }

                // Birthday validation
                birthdayDateValidation(poptin);
            };

            // Make validatePoptinInputs available globally before running
            window.validatePoptinInputs = validatePoptinInputs;

            if (window.poptinValidationState.loaded) {
                validatePoptinInputs(poptin);
            }
        }

        function setPoptinValidationLoaded() {
            const emailAutofillReady = window.poptinValidationState.emailAutofillNotRequired ||
                            (window.poptinValidationState.emailAutofillRequested && window.poptinValidationState.emailAutofillLoaded);

            const emailValidationReady = window.poptinValidationState.emailValidationNotRequired ||
                            (window.poptinValidationState.emailValidationRequested && window.poptinValidationState.emailValidationLoaded);

            const phoneReady = window.poptinValidationState.phoneValidationNotRequired ||
                            (window.poptinValidationState.phoneValidationRequested && window.poptinValidationState.phoneValidationLoaded);

            if (!window.poptinValidationState.loaded && emailAutofillReady && emailValidationReady && phoneReady) {
                // Set the validation function first
                if (!window.poptinInputValidations) {
                    window.poptinInputValidations = initializePoptinValidations;
                }

                // Then mark as loaded
                window.poptinValidationState.loaded = true;

                // Finally run validation if possible
                if (typeof window.validatePoptinInputs === 'function' && window.currentPoptin) {
                    setTimeout(() => {
                        window.validatePoptinInputs(window.currentPoptin);
                    }, 100);
                }
            }
        }

        function getFakeEmailDomains(validationType) {
            if (!window.fakeEmailDomains && !window.poptinValidationState.emailValidationRequested) {

                const needsDomains = ['business-email', 'typos-business'].includes(validationType);
                const needsScript = ['check-typos', 'typos-business'].includes(validationType);

                const promises = [];

                if (needsDomains) {
                    window.poptinValidationState.emailValidationRequested = true;
                    let validationEmailUrl;
                    if (env == "app"){
                        validationEmailUrl = cdn_server + "/validation/email/validation-emails.txt";
                    }else{
                        validationEmailUrl = cdn_server + "/api/display/validation-emails"
                    }
                    const domainsPromise = new Promise((resolve, reject) => {
                        jQ224.ajax({
                            url: validationEmailUrl,
                            type: 'GET',
                            dataType: 'text',
                            async: true,
                        })
                        .done(function(domains) {
                            window.fakeEmailDomains = domains.split(/\r?\n/).filter(Boolean);
                            window.poptinValidationState.emailValidationLoaded = true;
                            resolve();
                        })
                        .fail(function(data) {
                            window.poptinValidationState.emailValidationNotRequired = true;
                            showLog("Failed to fetch domains", data);
                            reject(data);
                        });
                    });
                    promises.push(domainsPromise);
                } else {
                    window.poptinValidationState.emailValidationNotRequired = true;
                }

                if (needsScript) {
                    window.poptinValidationState.emailAutofillRequested = true;
                    const scriptPromise = new Promise((resolve, reject) => {
                        const emailAutofillScript = document.createElement("script");
                        emailAutofillScript.onload = () => {
                            window.poptinValidationState.emailAutofillLoaded = true;
                            resolve();
                        };
                        emailAutofillScript.onerror = () => {
                            window.poptinValidationState.emailValidationNotRequired = true;
                            reject(new Error('Failed to load email autofill script'));
                        };
                        emailAutofillScript.async = true;
                        emailAutofillScript.src = cdn_server + "/validation/email/email-autofill.js";
                        document.body.appendChild(emailAutofillScript);
                    });
                    promises.push(scriptPromise);
                } else {
                    window.poptinValidationState.emailAutofillNotRequired = true;
                }

                if (promises.length === 0) {
                    window.poptinValidationState.emailValidationNotRequired = true;
                    window.poptinValidationState.emailAutofillNotRequired = true;
                    setPoptinValidationLoaded();
                    return;
                }

                Promise.all(promises)
                    .then(() => {
                        setPoptinValidationLoaded();
                    })
                    .catch((err) => {
                        window.poptinValidationState.emailValidationNotRequired = true;
                        window.poptinValidationState.emailAutofillNotRequired = true;
                        setPoptinValidationLoaded();
                        showLog("Email validation setup failed:", err);
                    });
            }
        }

        function getIntlPhoneValidation(poptin) {
            // If validation was requested but not loaded, check if library is already available
            // This handles the case where popup was closed during loading
            if (window.poptinValidationState.phoneValidationRequested && !window.poptinValidationState.phoneValidationLoaded && !window.poptinValidationState.phoneValidationNotRequired) {
                if (window.intlTelInput) {
                    // Library is available, just mark as loaded and initialize
                    window.poptinValidationState.phoneValidationLoaded = true;
                    setPoptinValidationLoaded();
                    setTimeout(() => {
                        poptinInitializePhoneInputs(poptin);
                    }, 500);
                    return;
                } else {
                    // Library not available, reset state to allow retry
                    window.poptinValidationState.phoneValidationRequested = false;
                }
            }

            if (!window.poptinValidationState.phoneValidationRequested && !window.poptinValidationState.phoneValidationNotRequired) {
                window.poptinValidationState.phoneValidationRequested = true;

                // Set submit button to loading state while phone validation assets load
                try { togglePoptinSubmitLoading(poptin, true); } catch(e) {}

                Promise.all([
                    // Load CSS
                    new Promise((resolve, reject) => {
                        const link = document.createElement('link');
                        link.rel = 'stylesheet';
                        link.href = cdn_server + '/phone-validation/css/intlTelInput.css';
                        link.onload = resolve;
                        link.onerror = reject;
                        document.head.appendChild(link);
                    }),
                    // Load main script
                    new Promise((resolve, reject) => {
                        const script = document.createElement("script");
                        script.onload = resolve;
                        script.onerror = reject;
                        script.async = true;
                        script.src = cdn_server + "/phone-validation/js/intlTelInput.min.js";
                        document.body.appendChild(script);
                    }),
                    // Load utils script
                    new Promise((resolve, reject) => {
                        const utilsScript = document.createElement("script");
                        utilsScript.onload = resolve;
                        utilsScript.onerror = reject;
                        utilsScript.async = true;
                        utilsScript.src = cdn_server + "/phone-validation/js/utils.js";
                        document.body.appendChild(utilsScript);
                    })
                ])
                .then(() => {
                    window.poptinValidationState.phoneValidationLoaded = true;
                    // Wait for a small delay to ensure utils are fully loaded
                    return new Promise(resolve => {
                        setTimeout(() => {
                            poptinInitializePhoneInputs(poptin);
                            resolve();
                        }, 500);
                    });
                })
                .then(() => {
                    setPoptinValidationLoaded();
                })
                .catch((err) => {
                    window.poptinValidationState.phoneValidationNotRequired = false;
                    window.poptinValidationState.phoneValidationRequested = false; // Reset on error to allow retry
                    setPoptinValidationLoaded();
                    showLog("Phone validation setup failed:", err);
                })
                .finally(() => {
                    // Remove loading state regardless of outcome
                    try { togglePoptinSubmitLoading(poptin, false); } catch(e) {}
                });
            } else if(window.poptinValidationState.phoneValidationRequested && window.poptinValidationState.phoneValidationLoaded && !window.poptinValidationState.phoneValidationNotRequired){
                setTimeout(() => {
                    poptinInitializePhoneInputs(poptin);
                }, 500);
            }
        }

        // Toggle loading state on the submit button for a specific poptin
        function togglePoptinSubmitLoading(poptin, isLoading){
            if(!poptin || !poptin.poptin_id) return;
            var $root = jQ224('[data-poptin-id="'+poptin.poptin_id+'"]');
            if(!$root.length) return;

            var $container = $root.find('.poptin-form-submit-button');
            var $inputBtn = $root.find('input.poptin-form-submit-button');
            var $styledBtn = $container.find('.froala-editor-button');

            if(isLoading){
                if($container.length){
                    $container.addClass('poptin-btn-loading').attr('aria-busy', 'true').attr('aria-disabled', 'true');
                }
                if($inputBtn.length){
                    if(typeof $inputBtn.data('orig-text') === 'undefined'){
                        $inputBtn.data('orig-text', $inputBtn.val());
                    }
                    $inputBtn.prop('disabled', true).addClass('poptin-btn-loading');
                    $inputBtn.val('');
                }
                if($styledBtn.length){
                    if(typeof $styledBtn.data('orig-html') === 'undefined'){
                        $styledBtn.data('orig-html', $styledBtn.html());
                    }
                    $styledBtn.addClass('poptin-btn-loading');
                    $styledBtn.html('');
                    $styledBtn.attr('aria-busy', 'true').attr('aria-disabled', 'true');
                }
            } else {
                if($container.length){
                    $container.removeClass('poptin-btn-loading').removeAttr('aria-busy').removeAttr('aria-disabled');
                }
                if($inputBtn.length){
                    $inputBtn.prop('disabled', false).removeClass('poptin-btn-loading');
                    if(typeof $inputBtn.data('orig-text') !== 'undefined'){
                        $inputBtn.val($inputBtn.data('orig-text'));
                    }
                }
                if($styledBtn.length){
                    $styledBtn.removeClass('poptin-btn-loading').removeAttr('aria-busy').removeAttr('aria-disabled');
                    if(typeof $styledBtn.data('orig-html') !== 'undefined'){
                        $styledBtn.html($styledBtn.data('orig-html'));
                    }
                }
            }
        }

        function poptinInitializePhoneInputs(poptin) {
            // Select ALL matching phone inputs inside this poptin
            var phoneInputs = jQ224(
                '[data-poptin-id="' + poptin.poptin_id + '"] input[data-name="poptinDesignInputTextFieldPhone"]'
            );

            if (!phoneInputs.length || !window.intlTelInput) return;

            phoneInputs.each(function () {
                const phoneInput = this;

                // Avoid double initialization
                if (phoneInput._iti || jQ224(phoneInput).parents(".iti").length) return;

                try {
                    const isRequired = phoneInput.required; // snapshot before poptinPhoneValidation removes the attribute
                    const itiInstance = window.intlTelInput(phoneInput, {
                        initialCountry: pop_country_code.toLowerCase() !== "zz" ? pop_country_code : "us",
                        autoPlaceholder: "aggressive",
                        nationalMode: true,
                        utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js",
                        customPlaceholder: (ph) => isRequired ? ph + "*" : ph,
                    });

                    // Store instance on this element
                    phoneInput._iti = itiInstance;

                    // Per-input state (separate for each phone field)
                    let userSelectedCountry = itiInstance.getSelectedCountryData().iso2;
                    let isManualChange = false;
                    let isReverting = false;

                    // Detect dropdown open (manual change)
                    phoneInput.addEventListener("open:countrydropdown", () => {
                        isManualChange = true;
                    });

                    // Prevent auto-switches
                    phoneInput.addEventListener("countrychange", () => {
                        const newCountry = itiInstance.getSelectedCountryData().iso2;

                        if (isManualChange) {
                            userSelectedCountry = newCountry; // allow manual selection
                            isManualChange = false;
                        } else if (!isReverting) {
                            isReverting = true;
                            itiInstance.setCountry(userSelectedCountry); // revert auto-change
                            isReverting = false;
                        }
                    });

                    // Handle utils loading
                    if (itiInstance.promise) {
                        itiInstance.promise.then(() => {
                            phoneInput._utilsLoaded = true;
                        });
                    }
                } catch (err) {
                    showLog("Phone input initialization error:", err);
                }
            });
        }

        function checkForEmailPhoneValidations(poptins) {
            if (!poptins || !Object.values(poptins).length) return;

            let emailValidationType = null;
            let requiresInternationalPhone = false;
            let firstPoptinWithPhone = null;

            // Loop through all poptins in the object
            for (let poptin of Object.values(poptins)) {
                if (!poptin) continue;

                if (poptin.validations?.email) {
                    emailValidationType = poptin.validations.email;
                }

                if (poptin.validations?.phone === "international" && !firstPoptinWithPhone) {
                    requiresInternationalPhone = true;
                    firstPoptinWithPhone = poptin;
                }
            }

            // Set the default states first
            window.poptinValidationState.emailValidationNotRequired = !emailValidationType;
            window.poptinValidationState.phoneValidationNotRequired = !requiresInternationalPhone;

            // Then initialize what's needed
            if (emailValidationType) {
                getFakeEmailDomains(emailValidationType);
            }

            if (requiresInternationalPhone && firstPoptinWithPhone) {
                getIntlPhoneValidation(firstPoptinWithPhone);
            }

            // Store the first poptin for later use
            window.currentPoptin = Object.values(poptins)[0];
        }

        function getPreviousVisitedPages(){
            return localStorage.getItem('poptin_previous_visited_pages');
        }

        function getAllVisitedPages(){
            return localStorage.getItem('poptin_all_visited_pages');
        }

        function getPreviousVisitedPagesWithTimeStamp(){
            var currentPathWithTime = window.location.pathname + ";" + getCurrentDateTime();
            var previousPagesWithTime = localStorage.getItem('poptin_previous_visited_pages_with_timestamp');
            if (previousPagesWithTime && previousPagesWithTime.length > 0) {
                var previousPagesWithTimeArray = previousPagesWithTime.split('|');
                if (previousPagesWithTimeArray.includes(currentPathWithTime)) {
                    var pageIndex = previousPagesWithTimeArray.indexOf(currentPathWithTime);
                    previousPagesWithTimeArray.splice(pageIndex, 1);
                }
                previousPagesWithTimeArray.push(currentPathWithTime);

                return previousPagesWithTimeArray.join('|')
            } else {
                return currentPathWithTime;
            }
        }

        function getPreviousVisitedPagesWithCurrentPage(){
            var currentPath = window.location.pathname;
            var previousPages = localStorage.getItem('poptin_previous_visited_pages');
            if (previousPages && previousPages.length > 0) {
                var previousPagesArray = previousPages.split('|');
                if (previousPagesArray.includes(currentPath)) {
                    var pageIndex = previousPagesArray.indexOf(currentPath);
                    previousPagesArray.splice(pageIndex, 1);
                }
                previousPagesArray.push(currentPath);

            // localStorage.setItem('poptin_previous_visited_pages', previousPagesArray.join('|'));
                return previousPagesArray.join('|')
            } else {
                return currentPath;
            }
        }


        function setPreviousUrl(){
            var poptin_previous_url = (previous_url_spa!=null && poptin_single_page_app) ? previous_url_spa :  document.referrer;
            var poptin_previous_url_protocol = (poptin_previous_url && poptin_previous_url.startsWith("https://")) ? "secure" : (poptin_previous_url && poptin_previous_url.startsWith("http://")) ? "unsecure" : "";
            poptin_previous_url = poptin_previous_url.replace(/^https?:\/\//, '');

            poptinSetCookie('poptin_previous_url', poptin_previous_url, 0.00138888888888889);
            if(poptin_previous_url_protocol) {
                poptinSetCookie('poptin_previous_url_protocol', poptin_previous_url_protocol, 0.00138888888888889);
            }
        }
        /**
         * Trigger functions: poptinDependentFunction()
         * Desc             : Set 'a' tag click event to trigger initiate poptin pull request on click event
         */
        function displayPoptinOnClick(){
            // Check if we're on an Ecwid page
            const isEcwidPage = document.documentElement.id === 'ecwid_html';

            /**
             * Non-Ecwid: rewrite tracking links on hover/focus/touch so click can open poptin.
             * Mobile often never fires mouseover — click handler below also prepares as fallback.
             */
            function preparePoptinClickLink(anchor) {
                if (isEcwidPage) return;
                var $a = jQ224(anchor);
                if ($a.hasClass('poptin-click')) return;
                var href = anchor.href || '';
                if (href.indexOf("/APIRequest/click/") === -1 && href.indexOf("/api/display/click/") === -1) return;
                $a.addClass('poptin-click');
                $a.attr('data-href', $a.attr('href'));
                $a.attr('href', 'javascript:void(0);');
            }

            // If it's an Ecwid page, set up the blocking mechanism
            if (isEcwidPage) {
                function isPoptinLink(href) {
                    return href.indexOf("/APIRequest/click/") !== -1 || href.indexOf("/api/display/click/") !== -1;
                }

                function processLink(link) {
                    if (link.getAttribute('data-processed') || !isPoptinLink(link.href)) return;

                    const href = link.href;

                    function disableLink() {
                        link.removeAttribute('href');
                        link.style.cursor = 'pointer';
                        link.role = 'button';

                        link.onclick = null;
                        link.onmousedown = null;
                        link.onmouseup = null;

                        const blockHandler = (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            e.stopImmediatePropagation();
                            console.log('Blocked poptin link:', href);

                            try {
                                let poptin_id;
                                if (href.indexOf("/APIRequest/click/") !== -1) {
                                    poptin_id = href.split('APIRequest/click/')[1];
                                } else {
                                    poptin_id = href.split('api/display/click/')[1];
                                }
                                showPoptinOnClick(poptin_id);
                            } catch(err) {
                                monitorError('displayPoptinOnClick()->error()', err, 'OK', href, false);
                            }

                            return false;
                        };

                        link.addEventListener('click', blockHandler, true);
                        link.addEventListener('mousedown', blockHandler, true);
                        link.addEventListener('mouseup', blockHandler, true);
                        link.addEventListener('touchstart', blockHandler, true);
                        link.addEventListener('touchend', blockHandler, true);
                    }

                    disableLink();
                    link.addEventListener('mouseenter', disableLink);

                    link.setAttribute('data-processed', 'true');
                }

                // Set up observer for Ecwid page
                const observer = new MutationObserver((mutations) => {
                    mutations.forEach(mutation => {
                        mutation.addedNodes.forEach(node => {
                            if (node.nodeType === 1) {
                                if (node.tagName === 'A') {
                                    processLink(node);
                                }
                                node.querySelectorAll('a').forEach(processLink);
                            }
                        });
                    });
                });

                observer.observe(document.body, {
                    childList: true,
                    subtree: true
                });

                // Process existing links
                document.querySelectorAll('a').forEach(processLink);
            }

            // Original poptin handlers - these run on all pages (touchstart/focusin: mobile / keyboard)
            jQ224(document).on('mouseover touchstart focusin', 'a:not(.poptin-click)', function() {
                preparePoptinClickLink(this);
            });

            // Click: prepare if hover/touch never ran (mobile), then show poptin.
            // Exclude data-poptinaction="onclick" — separate handler below uses data-poptinid.
            // Fix for mobile touch onclick issue
            jQ224(document).on('click', 'a:not([data-poptinaction="onclick"])', function(e) {
                if (isEcwidPage) return;

                var el = this;
                var $a = jQ224(el);
                var hrefForMatch = $a.attr('data-href') || el.href || '';
                if (hrefForMatch.indexOf("/APIRequest/click/") === -1 && hrefForMatch.indexOf("/api/display/click/") === -1) {
                    return;
                }

                if (!$a.hasClass('poptin-click')) {
                    preparePoptinClickLink(el);
                    $a = jQ224(el);
                }

                var dataHref = $a.attr('data-href');
                if (!dataHref) return;

                showLog('displayPoptinOnClick');
                e.preventDefault();
                try {
                    //initiatePullPoptinsRequestOnClick(dataHref.split('?')[0],false);
                    poptin_id = dataHref.split('click/')[1];
                    showPoptinOnClick(poptin_id);
                } catch (err) {
                    monitorError('displayPoptinOnClick()->error()', err, 'OK', el.href, false);
                }
            });

            jQ224(document).on('click', 'a[data-poptinaction="onclick"],button[data-poptinaction="onclick"]', function(e) {
                e.preventDefault(); // Prevent default action of the anchor tag
                const poptinId = jQ224(this).attr('data-poptinid');
                if (poptinId.length === 13) {
                    if (!isEcwidPage) {
                        showLog('displayPoptinOnClick');
                        try{
                            showPoptinOnClick(poptinId);
                        }catch(err){
                            monitorError('displayPoptinOnClick()->error()',err,'OK',poptinId,false);
                        }
                    }
                }
            });
        }

        function checkPoptinCloseCriteria(poptin_id){
            if((jQ224(".poptin-popup[data-poptin-id="+poptin_id+"] .poptin_winning_screen.poptin-visible").length || jQ224(".poptin-popup[data-poptin-id="+poptin_id+"] .poptin_losing_screen.poptin-visible").length)){
                return true;
            }else if(jQ224(".poptin-popup[data-poptin-id="+poptin_id+"] .poptin_thank_you_screen.poptin-visible").length){
                return true;
            }
            return false;
        }

        /**
         * Trigger functions: Click on X button
         * parameters       : this:object
         * Desc             : Handle poptin close when 'X' button is clicked
         */

        if (typeof closePoptinOnXclick !== 'function') {
            window.closePoptinOnXclick = function ($this) {
                let poptin_id = null;

                if (typeof jQ224 !== 'undefined') {
                    if (typeof $this !== 'undefined' && $this !== null) {
                        poptin_id = jQ224($this).closest('.poptin-popup').attr('data-poptin-id');
                    } else if (typeof event !== 'undefined' && event.target) {
                        poptin_id = jQ224(event.target).closest('.poptin-popup').attr('data-poptin-id');
                    }
                }

                if (poptin_id && typeof poptins !== 'undefined' && window.poptins[poptin_id]) {
                    ensurePoptinTrigger(poptin_id);
                    window.poptins[poptin_id].poptin_trigger.close_trigger = "x_click";

                    let setCloseCookie = !checkPoptinCloseCriteria(poptin_id);
                    closePoptin(poptin_id, true);

                    setTimeout(() => {
                        if (setCloseCookie) {
                            setClosePoptinOnXCookie(poptin_id);
                        }
                    }, 1000);
                }
            };
        }



        /**
         * Trigger functions: Click on X button tab
         * parameters       : this:object
         * Desc             : Handle poptin tab close when 'X' button is clicked
         */

        if(typeof closeTabPoptinOnXclick !== 'function'){
            window.closeTabPoptinOnXclick = function ($this,poptin_id){
                //jQ224("#poptinDraggableContainer-tab").hide();
                if(landing_page_teaser_on==1){
                    var close_poptin = window.click_poptins[poptin_id];
                }else{
                    var close_poptin = window.all_poptins[poptin_id];
                }
                showTeaserEffect(close_poptin, 'exit');
                if(poptinAnimateTab[poptin_id] !== undefined) {
                    clearInterval(poptinAnimateTab[poptin_id]);
                }
                if(poptinTeaserShowTimeout[poptin_id] !== undefined) {
                    clearTimeout(poptinTeaserShowTimeout[poptin_id]);
                    delete poptinTeaserShowTimeout[poptin_id];
                }
                return false;
            }
        }


        /**
         * Trigger functions: poptinDependentFunction()
         * Desc             : Set close poptin on '.o-close' class click event
         */
        function onTextClickClose(){
            showLog('set: onTextClickClose()');
            try{
                jQ224('.o-close').off("click");
            }catch(err){
                showLog(err);
            }

            jQ224(document).on('click','.o-close',function(e){
                // showLog('trigger: onTextClickClose()');
                poptin_id = jQ224(e.target).parents('.poptin-popup').attr('data-poptin_id');
                ensurePoptinTrigger(poptin_id);
                window.poptins[poptin_id].poptin_trigger.close_trigger = "cancel_click";
                closePoptin(poptin_id);
            });
        }

        function setupClickPoptins($poptin){
            showLog($poptin);
            jQ224.when( jQ224.ajax($poptin.poptin_url)).then(function( data, textStatus, jqXHR ) {
                window.all_poptins[$poptin.poptin_id].poptin = data;
                window.click_poptins[$poptin.poptin_id].poptin = data;
            },function( data, textStatus, jqXHR) {
                showLog(data);
            });
        }

        /**
         * Trigger functions: displayPoptinOnClick()
         * parameters       : $href:string -> (URL)
         * Desc             : Initiate poptins get request to poptin api server after setting reqiued parameters
         * Desc             : If client have avialble poptins
         * Desc             : -> set all poptins attributes and poptins popup
         */
        // function initiatePullPoptinsRequestOnClick($href, $display_flag,$show_now,$cancel_visitor_count,$is_form){

        //     $show_now=$show_now!=undefined?$show_now:false;
        //     $cancel_visitor_count=$cancel_visitor_count!=undefined?$cancel_visitor_count:false;
        //     $is_form=$is_form!=undefined?$is_form:false;

        //     showLog('initiatePullPoptinsRequestOnClick()');

        //     poptin_id = $href.split('click/')[1].substr(0,13);

        //     if (window.click_poptins[poptin_id]==undefined || !window.click_poptins[poptin_id].display){
        //         var domain      = window.location.href;
        //         var cookies     = getReleventCookie()+' '+getCustomNewVisitSession();
        //         var triggers    = getAutoPilots();
        //         // Get page Title
        //         var page_title = document.title;

        //         var cart_total_price = 0;
        //         var cart_total_items = 0;
        //         var cart_items = [];
        //         var cart_products_ids_list = "";
        //         var browser_language = window.navigator.language;
        //         var operating_system = window.navigator?.userAgentData?.platform || window.navigator?.platform || 'Unknown';
        //         var cart_products_org_ids_list = "";

        //         if(typeof Shopify != "undefined") {
        //             var cart_details = getShopifyCartDetails();
        //             cart_total_price = cart_details.total_price || 0;
        //             cart_total_items = cart_details.item_count || 0;
        //             cart_items = cart_details.items || [];

        //             if(cart_items.length > 0 ) {
        //                 var cart_products_ids = cart_items.map(function (value, index, array) {
        //                     //return value.product_id;
        //                     return value.variant_id;
        //                 });
        //                 cart_products_ids_list = cart_products_ids.join(',');

        //                 var cart_products_org_ids = cart_items.map(function (value, index, array) {
        //                     return value.product_id;
        //                     // return value.variant_id;
        //                 });
        //                 cart_products_org_ids_list = cart_products_org_ids.join(',');

        //             }
        //         }

        //         var landing_info = null;
        //         if(typeof poptin_landing_page != 'undefined'){
        //             landing_info ='&from_landing_page=1'
        //         }

        //         var urlParams = new URLSearchParams({
        //             client_id: getClientId(),
        //             domain: domain,
        //             referrer: getReferrer(),
        //             previous_url: getPreviousUrl(),
        //             cookies: cookies,
        //             triggers: triggers,
        //             if_mobile: ifMobilePoptin,
        //             page_title: page_title,
        //             poptin_display: $display_flag,
        //             origin_landing_page: getOriginLandingPage(),
        //             cancel_visitor_count: $cancel_visitor_count,
        //             previous_visited_pages: getPreviousVisitedPages(),
        //             previous_visited_pages_with_time_stamp: getPreviousVisitedPagesWithTimeStamp(),
        //             all_visited_pages: getAllVisitedPages(),
        //             store_integration: store_integration,
        //             store_integration_customer_id: store_integration_customer_id,
        //             cart_total_price: cart_total_price,
        //             cart_total_items: cart_total_items,
        //             cart_products_ids_list: cart_products_ids_list,
        //             browser_language: browser_language,
        //             operating_system: operating_system,
        //             cart_products_org_ids_list: cart_products_org_ids_list,
        //             wix_cart_id: localStorage.getItem('poptin_wix_cart_id'),
        //         });

        //         jQ224.post($href.replace("app", "app") + "?" + urlParams.toString() + landing_info, {}, "json")
        //             .done(function(data) {
        //                 showLog(data);

        //                 if (data.display !== "not_allowed"){

        //                     // if ($display_flag && data.if_freemium){
        //                     //     showLog('not_allowed: freemium');
        //                     //     return false;
        //                     // }

        // 					pop_country = data.country;
        //                     pop_country_code = data.country_code;

        // 	                // check if account is free or paid
        // 	                if_freemium = data.if_freemium;

        //                     user_lang = data.lang;
        //                     fontDownload(user_lang);
        //                     //downloadJqueryUi();
        //                     if(!$is_form){
        //                         var $poptin;
        //                         jQ224.each(data.poptins,function(key,index){
        //                             $poptin = this;
        //                             window.click_poptins[$poptin.poptin_id] = $poptin;
        //                             if ($show_now){
        //                                 if(landing_page_teaser_on==1){
        //                                     extractTeaser(window.click_poptins[$poptin.poptin_id],0);
        //                                 }else{
        //                                     if(typeof poptin_landing_page !='undefined'){
        //                                         if(window.click_poptins[poptin_id].display){
        //                                             showPoptinOnClick($poptin.poptin_id);
        //                                         }
        //                                     }else{
        //                                         showPoptinOnClick($poptin.poptin_id);
        //                                     }

        //                                 }
        //                             }else{
        // 								setupClickPoptins($poptin);
        //                             }
        //                         });
        //                     } else{
        //                         showPoptinOnClick($poptin);
        //                     }
        //                 } else {
        //                     if(data.display == "not_allowed" && (data.message =="Client restricted" || data.message=="You have been reached the max poptins views number")){
        //                         is_restricted=true;
        //                     }
        //                     showLog(data.display);
        //                     return false;
        //                 }
        //             }).fail(function(xhr, status, error){
        //             //monitorError('poptinViewed()->error()',error,status,xhr.responseText,poptin)
        //         });
        //     }else{
        //         if ($show_now){
        //             showPoptinOnClick(poptin_id)
        //         }
        //     }
        // }

        // Update popoup direction attribute based on language
        function updateStylesForDirection(lang, poptin) {
            var popup = jQ224('.poptin-popup[data-poptin-id="' + poptin.poptin_id + '"]');
            var directionLang = popup.attr('data-lang') || lang;
            popup.find('[dir]').each(function() {
                if (jQ224(this).closest(".inputs-container").length) {
                    return;
                }
                jQ224(this).attr('dir', directionLang === 'he' ? 'rtl' : 'ltr');
            });
        }

        function initiatePullPoptinsRequestOnClick($href, $display_flag, $show_now, $cancel_visitor_count, $is_form) {
            $show_now = $show_now !== undefined ? $show_now : false;
            $cancel_visitor_count = $cancel_visitor_count !== undefined ? $cancel_visitor_count : false;
            $is_form = $is_form !== undefined ? $is_form : false;

            showLog('initiatePullPoptinsRequestOnClick()');

            poptin_id = $href.split('click/')[1].substr(0, 13);

            if (window.click_poptins[poptin_id] === undefined || !window.click_poptins[poptin_id].display) {
                var domain = window.location.href;
                var cookies = getReleventCookie() + ' ' + getCustomNewVisitSession();
                var triggers = getAutoPilots();
                var page_title = document.title;

                var browser_language = window.navigator.language;
                var operating_system = window.navigator?.userAgentData?.platform || window.navigator?.platform || 'Unknown';

                var cartPromise = (typeof Shopify !== "undefined")
                    ? getShopifyCartDetails()
                    : jQ224.Deferred().resolve({}).promise();

                cartPromise.then(function(cart_details) {
                    var cart_total_price = 0;
                    var cart_total_items = 0;
                    var cart_items = [];
                    var cart_products_ids_list = "";
                    var cart_products_org_ids_list = "";

                    cart_total_price = cart_details.total_price || 0;
                    cart_total_items = cart_details.item_count || 0;
                    cart_items = cart_details.items || [];

                    if (cart_items.length > 0) {
                        var cart_products_ids = cart_items.map(function (value) {
                            return value.variant_id;
                        });
                        cart_products_ids_list = cart_products_ids.join(',');

                        var cart_products_org_ids = cart_items.map(function (value) {
                            return value.product_id;
                        });
                        cart_products_org_ids_list = cart_products_org_ids.join(',');
                    }

                var landing_info = null;
                if (typeof poptin_landing_page !== 'undefined') {
                    landing_info = '&from_landing_page=1';
                }

                var payload = {
                    client_id: getClientId(),
                    domain: domain,
                    referrer: getReferrer(),
                    previous_url: getPreviousUrl(),
                    cookies: cookies,
                    triggers: triggers,
                    if_mobile: ifMobilePoptin,
                    page_title: page_title,
                    poptin_display: $display_flag,
                    origin_landing_page: getOriginLandingPage(),
                    cancel_visitor_count: $cancel_visitor_count,
                    previous_visited_pages: getPreviousVisitedPages(),
                    previous_visited_pages_with_time_stamp: getPreviousVisitedPagesWithTimeStamp(),
                    all_visited_pages: getAllVisitedPages(),
                    store_integration: store_integration,
                    store_integration_customer_id: store_integration_customer_id,
                    cart_total_price: cart_total_price,
                    cart_total_items: cart_total_items,
                    cart_products_ids_list: cart_products_ids_list,
                    browser_language: browser_language,
                    operating_system: operating_system,
                    cart_products_org_ids_list: cart_products_org_ids_list,
                    wix_cart_id: localStorage.getItem('poptin_wix_cart_id'),
                    converted_email: localStorage.getItem('poptin_converted_email'),
                    preview_poptin_id: previewPoptinId

                };

                jQ224.post($href.replace("app", "app"), payload, "json")
                    .done(function (data) {
                        showLog(data);

                        if (data.display !== "not_allowed") {
                            pop_country = data.country;
                            pop_country_code = data.country_code;

                            if_freemium = data.if_freemium;

                            user_lang = data.lang;
                            fontDownload(user_lang);

                            var $poptin;
                            if (!$is_form) {
                                checkForEmailPhoneValidations(data.poptins);
                                jQ224.each(data.poptins, function () {
                                    $poptin = this;
                                    window.click_poptins[$poptin.poptin_id] = $poptin;
                                    if ($show_now) {
                                        if (landing_page_teaser_on == 1) {
                                            extractTeaser(window.click_poptins[$poptin.poptin_id], 0);
                                        } else {
                                            if (typeof poptin_landing_page !== 'undefined') {
                                                if (window.click_poptins[poptin_id].display) {
                                                    showPoptinOnClick($poptin.poptin_id);
                                                }
                                            } else {
                                                showPoptinOnClick($poptin.poptin_id);
                                            }
                                        }
                                    } else {
                                        setupClickPoptins($poptin);
                                    }
                                });
                            } else {
                                showPoptinOnClick($poptin);
                            }
                        } else {
                            if (data.display === "not_allowed" && (data.message === "Client restricted" || data.message === "You have been reached the max poptins views number")) {
                                is_restricted = true;
                            }
                            showLog(data.display);
                            return false;
                        }
                    }).fail(function (xhr, status, error) {
                        // monitorError('poptinViewed()->error()', error, status, xhr.responseText, poptin)
                    });
                });
            } else {
                if ($show_now) {
                    showPoptinOnClick(poptin_id);
                }
            }
        }


        function getShopifyCartDetails() {
            if (shopify_cart_cache) {
                return jQ224.Deferred().resolve(shopify_cart_cache).promise();
            }

            return jQ224.ajax({
                url: shopifylanguageRoute()+"cart.js",
                type: 'get',
                dataType: 'json',
                async: true,
            }, "json")
                .then(function(data) {
                    shopify_cart_cache = data;
                    return data;
                }, function () {
                    showLog('Cart Error');
                    return {};
                });
        }


        // Allow client to fire the poptin pull function
        if(typeof poptin_display !== 'function'){
            window.poptin_display = function (poptin_id){
                poptin_display_trigger = true;
                $href = api_link+'/api/display/click/'+poptin_id
                initiatePullPoptinsRequestOnClick($href,true,true,false)

            }
        }
        if(typeof poptin_display_form !== 'function'){
            window.poptin_display_form = function (poptin_id){
                poptin_display_trigger = true;
                $href = api_link+'/api/display/click/'+poptin_id
                initiatePullPoptinsRequestOnClick($href,true,true,false,true)
            }
        }



        /**
         * Trigger functions: getGeoLocation()
         * Desc             : trigger initiatePullPoptinsRequest()
         */
        function poptinInitiate(){
            try{
                if (typeof poptin_landing_page == "undefined") {
                    initiatePullPoptinsRequest();
                }   else {
                    jQ224('.landing-form').show();
                    initiatePullPoptinsRequestOnClick(poptin_landing_page_url,false,true);

                }
            }catch(err){
                //monitorError('poptinDependentFunction()->initiatePullPoptinsRequest()->error()',err,'','',false);
            }
        }

        function downloadPoptinOnClick(poptin_id,show_now,cancel_visitor_count){
            $href = api_link+'/api/display/click/'+poptin_id
            //if ((if_freemium!=null && if_freemium == false) || if_freemium==null){
            initiatePullPoptinsRequestOnClick($href,true,show_now,cancel_visitor_count)
            //}
        }

        function showPoptinOnClick(poptin_id, from_teaser = false, teaser_poptin_data = null){
            if (window.click_poptins[poptin_id]!=undefined){
                poptin = window.click_poptins[poptin_id];
                if (poptin.display){
                    //downloadPoptinBackground(poptin);
                    //setTimeout(function(){
                    if (jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]")[0]===undefined){

                        if (typeof window.all_poptins == undefined){
                            window.all_poptins = new Object();
                        }

                        poptin_template = '';

                        if (window.all_poptins[poptin.poptin_id]!=undefined && window.all_poptins[poptin.poptin_id].poptin!=''){
                            poptin_template = window.all_poptins[poptin.poptin_id].poptin;
                        }

                        // Set poptin data
                        window.all_poptins[poptin.poptin_id] = poptin;

                        // Set poptin template
                        window.all_poptins[poptin.poptin_id].poptin = poptin_template;

                        window.poptins[poptin.poptin_id]={};
                        //poptins[this.poptin_id].data_point = new DataPoint();
                        //poptins[this.poptin_id].data_point.onLoad(this.poptin_id);
                        timerDownload(poptin);
                        wheelDownload(poptin);
                        window.poptins[poptin.poptin_id].poptin_trigger = {convert:false,shown:false,poptin_active:true,scroll_flag:true,mouse_leave_flag:true,click_counter:0,trigger:'',close_trigger:''};
                        setPoptinSize(poptin,true);
                        setAutoPilot(poptin,true);
                        //setPoptin(poptin,true);
                        appendPoptin(poptin,true);
                        if( !(poptin.poptin_type == 'embedded' || poptin.poptin_type == 'fullpage') ){
                            loadbgAnimationOverlay(poptin);
                        }
                        loadpoptinNewsTicker(poptin);
                        // loadScratchCardFunctionality(poptin)
                        loadcouponbutton(poptin);
                        readylinkbuttons(poptin);
                    }
                    //},10);
                } else {
                    if(!poptin_display_trigger){
                        downloadPoptinOnClick(poptin_id,true,false);
                    }
                }

            }else{
                downloadPoptinOnClick(poptin_id,true,false);
            }

            if(from_teaser){
                //poptinViewed(teaser_poptin_data);
            }

        }

        /**
         * Trigger functions: poptinInitiate()
         * Desc             : Initiate poptins get request to poptin api server after setting reqiuerment parameters
         * Desc             : If client have avialble poptins
         * Desc             : -> set all poptins attributes and poptins popup
         */
        function initiatePullPoptinsRequest(){
            console.log('initiatePullPoptinsRequest()');

            // Track pages only if on mobile
            if(ifMobilePoptin){
                // Check if window history is available
                if(ifMobilePoptin){
                    // Check if window history is available
                    if (window.history && window.history.pushState && typeof Ecwid=='undefined') {
                        // Don't create fake histroy states if on SPA because they create their own
                        if(!poptin_single_page_app){
                            var pageState = 100;
                            if (window.history.state && window.history.state.page) {
                                pageState = window.history.state.page;
                            }
                            window.history.pushState({page: pageState + 1}, '');
                        }
                        setTimeout(function(){
                            showLog("pop_urls", pop_urls);
                            // Check if you already have on object because SPA don't reload pages
                            pop_urls = typeof pop_urls === 'object' ? pop_urls : JSON.parse(pop_urls);
                            if(pop_urls[pop_urls.length - 1] != window.location.href){
                                pop_urls.push(window.location.href);
                                showLog("pop_urls2", pop_urls);
                                sessionStorage.setItem('pop_urls', JSON.stringify(pop_urls));
                            }
                        }, 300);

                        function browserPopState(){
                            pop_urls.pop();
                            showLog("pop_urls", pop_urls);
                            sessionStorage.setItem('pop_urls', JSON.stringify(pop_urls));
                            // const lastUrl = pop_urls[pop_urls.length - 1];
                            // if (lastUrl) {
                            //     window.location.href = lastUrl;
                            // }
                        }
                        // Commenting below EventListener just to check if it fixs mobile back button issue
                        if(typeof Ecwid=='undefined'){
                            window.addEventListener('popstate', function () {
                                browserPopState();
                            });
                        }

                    }
                }
            }

            // Get page href
            var domain = window.location.href;

            // Get all poptin cookies
            var cookies = getReleventCookie()+' '+getPoptinNewUser()+' '+getPoptinViewedSession()+' '+getSessionStorageByKey('poptin_abtest_session_')+' '+getCustomNewVisitSession();

            // Get all website cookies
            //website_cookies = getWebsiteCookie();

            // Get AutoPilot flag and trigger
            var triggers = getAutoPilots();

            // Get visitor location data
            //country_code = (typeof country == "undefined" || country.country_code == undefined ? false : country.country_code);

            var country_code = getUserCountryCode();

            // Get visitor referrer url
            var referrer_url = getReferrer();

            // Get visitor previous url
            var previous_url = getPreviousUrl();

            // Get page Title
            var page_title = document.title;

            jQ224(document).ready(function(){

                var poptinForms = document.querySelectorAll('.poptin-embedded');
                var poptinFormsLen = poptinForms.length;
                var poptinFormsIDs = [];
                if(poptinFormsLen){
                    for(let i=0;i<poptinFormsLen;i++){
                        poptinFormsIDs.push(poptinForms[i].getAttribute('data-id'));
                    }
                }

                var cartPromise = (typeof Shopify != "undefined")
                    ? getShopifyCartDetails()
                    : jQ224.Deferred().resolve({}).promise();

                cartPromise.then(function(cart_details) {
                    var cart_total_price = 0;
                    var cart_total_items = 0;
                    var cart_items = [];
                    var cart_products_ids_list = "";
                    var cart_products_org_ids_list = "";

                    cart_total_price = cart_details.total_price || 0;
                    cart_total_items = cart_details.item_count || 0;
                    cart_items = cart_details.items || [];

                    if(cart_items.length > 0 ) {
                        var cart_products_ids = cart_items.map(function (value, index, array) {
                            //return value.product_id;
                            return value.variant_id;
                        });
                        cart_products_ids_list = cart_products_ids.join(',');

                        var cart_products_org_ids = cart_items.map(function (value, index, array) {
                            return value.product_id;
                            // return value.variant_id;
                        });
                        cart_products_org_ids_list = cart_products_org_ids.join(',');

                    }

                var cancel_visitor_count = previewPoptinId ? true : false;

                jQ224(".poptin-embedded").empty();
                jQ224.ajax({
                    url: api_link+"/api/display/"+getClientId(),
                    type: 'POST',
                    data: {
                        domain: domain,
                        referrer: referrer_url,
                        previous_url: previous_url,
                        cookies: cookies,
                        triggers: triggers,
                        cc: country_code,
                        poptin_forms_id: poptinFormsIDs,
                        if_mobile: ifMobilePoptin,
                        page_title: page_title,
                        origin_landing_page: getOriginLandingPage(),
                        if_page_refreshed: ifPageRefreshed(),
                        poptin_viewed_url: getPoptinViewedUrl(),
                        previous_visited_pages: getPreviousVisitedPages(),
                        previous_visited_pages_with_current_page: getPreviousVisitedPagesWithCurrentPage(),
                        previous_visited_pages_with_time_stamp: getPreviousVisitedPagesWithTimeStamp(),
                        all_visited_pages: getAllVisitedPages(),
                        store_integration: store_integration,
                        store_integration_customer_id: store_integration_customer_id,
                        wix_cart_id: localStorage.getItem('poptin_wix_cart_id'),
                        cart_total_items,
                        cart_total_price,
                        cart_products_ids_list,
                        cart_products_org_ids_list,
                        preview_poptin_id: previewPoptinId,
                        cancel_visitor_count: cancel_visitor_count,
                        converted_email: poptinGetCookie('poptin_converted_email'),
                    },
                    dataType: 'json',
                    async: true,
                }, "json")
                    .done(function(data){

                        // set poptins into inner array
                        window.all_poptins = data.poptins;

                        // check if account is free or paid
                        if_freemium = data.if_freemium;

                        pop_country = data.country;
                        pop_country_code = data.country_code;

                        showLog(data);
                        // If client don't have view restriction
                        if (data.display !== "not_allowed"){
                            jQ224.each(window.all_poptins,function(key,index){

                                if(this.ab_test_parent_id){
                                    jQ224(".poptin-embedded[data-id='"+this.ab_test_parent_id+"']").attr('data-id', this.poptin_id);
                                }

                                // If poptin is available
                                if (this.display || this.is_teasers_on){
                                    if(this.poptin_type == "embedded" && jQ224(".poptin-embedded[data-id='"+this.poptin_id+"']").length == 0){
                                        // Do nothing
                                    } else {
                                        user_lang = data.lang;
                                        fontDownload(data.lang);
                                        downloadPoptinTemplateFromS3(this);
                                        // downloadPoptinBackground(this);
                                            if_display = true;
                                    }
                                }

                                //localStorage.setItem('poptin_wix_cart_details', JSON.stringify(this.wix_cart_details));

                                if (this.on_click){
                                    window.click_poptins[this.poptin_id] = this;
                                    if (!this.display){
                                        //Initiate Download poptin on click
                                        user_lang = data.lang;
                                        fontDownload(data.lang);
                                        showLog(this);
                                        setupClickPoptins(this);
                                    // downloadPoptinOnClick(this.poptin_id,false,true); temprory fix
                                    }
                                }
                            });

                            if ((typeof window.wixDevelopersAnalytics !='undefined') && (data.wix_cart_details))  {
                                saveWixCartDetails(data.wix_cart_details);
                            }

                            // If one of the poptins is available
                            if (if_display){
                                // set client lang
                                user_lang = data.lang;
                                fontDownload(data.lang);

                                // Removed JQueryUI
                                // if(!(poptinAfterPageLoad == 'noConflict' || poptinAfterPageLoad == 'noJqueryUi')){
                                //     downloadJqueryUi();
                                // }
                            }

                            if(poptin_single_page_app){
                                setTimeout(function(){
                                        setInterval(() => {
                                            jQ224(".poptin-embedded").each(function(e){
                                                if(jQ224(this).is(":empty")){
                                                    var poptin_form_id = jQ224(this).attr("data-id");
                                                    poptin_display_form(poptin_form_id);
                                                }
                                            });
                                        }, 5000);
                                }, 5000);

                            }


                        } else if(data.is_client_restriction){
                            upgrade_popup_setting = data.client_restriction_setting;
                            showPoptinLimitPopup(data);
                            is_restricted=true;
                        }else{
                            if(data.display == "not_allowed" && (data.message =="Client restricted" || data.message=="You have been reached the max poptins views number")){
                                is_restricted=true;
                            }
                        }

                        // Set geolocation cookies
                        setGeolocationCookies(data)
                        // Set deafult poptin cookies
                        defaultCookie();
                    })
                    .fail(function (xhr, status, error) {
                        // showLog('initiatePullPoptinsRequest()->auto->->error()',error,status,xhr.responseText,false);
                        showLog('initiatePullPoptinsRequest()->auto->->error()');
                        // Monitoring perpase
                        //monitorError('initiatePullPoptinsRequest()->error()',error,status,xhr.responseText,false);
                    });

                });

            });

        }

        /**
         * Trigger functions: initiatePullPoptinsRequest()
         * parameters       : Lang -> string ('he'/'en')
         * Desc             : Download & append fonts and poptin style from aws S3 service and CDN realated to client 'lang'(language)
         */
        function setGeolocationCookies(data){
            if (!poptinCheckCookie('poptin_user_ip') && data.ip != undefined ){
                poptinSetCookie('poptin_user_ip',data.ip,365);
            }

            if ((!poptinCheckCookie('poptin_user_country_code') && data.cc != undefined) || (poptinGetCookie('poptin_user_country_code') != data.cc && data.cc!= undefined )){
                poptinSetCookie('poptin_user_country_code',data.cc,365);
            }
        }
        /**
         * Trigger functions: initiatePullPoptinsRequest()
         * parameters       : Lang -> string ('he'/'en')
         * Desc             : Download & append fonts and poptin style from aws S3 service and CDN realated to client 'lang'(language)
         */

        function fontDownload(lang){
            // showLog('fontDownload');
            winie = ( (/Windows NT 6.1/i.test(navigator.userAgent)) && (/Trident/i.test(navigator.userAgent) || /MSIE/i.test(navigator.userAgent)) ? '-ie' : '');
            font_link ='';
            jQ224("#poptin_heb_fonts_preload").remove();
            jQ224("#poptin_heb_fonts").remove();

            font_link += '<link rel="preload" id="poptin_heb_fonts_preload" as="style"  href="'+cdn_server+'/css/heb-fonts'+winie+'.min.css">';
            font_link += '<link rel="stylesheet" id="poptin_heb_fonts" type="text/css" href="'+cdn_server+'/css/heb-fonts'+winie+'.min.css" defer>';

            if(!poptin_disable_fa){
                if(jQ224("#poptin-fa-preload").length==0 && jQ224("#poptin-fa").length==0){
                    jQ224("#poptin-fa-preload").remove();
                    jQ224("#poptin-fa").remove();
                    font_link += '<link rel="preload" id="poptin-fa-preload" as="style" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">';
                    font_link += '<link rel="stylesheet" id="poptin-fa" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css" defer>';
                    font_link += '<link rel="preload" id="poptin-fa-brands-preload" as="style" href="https://cdn.popt.in/css/brands.min.css">';
                    font_link += '<link rel="stylesheet" id="poptin-fa-brands" type="text/css" href="https://cdn.popt.in/css/brands.min.css" defer>';
                }
            }
            if(api_link.indexOf('dev')>=0){
                if(jQ224("#poptin-css-file-preload").length==0 && jQ224("#poptin-css-file-preload").length==0){
                    jQ224("#poptin-css-file-preload").remove();
                    jQ224("#poptin-css-file").remove();
                    font_link += '<link  rel="preload" as="style" id="poptin-css-file-preload"  href="'+css_link+'/css/poptin-style-'+lang+'.css?ver=10">';
                    font_link += '<link rel="stylesheet" type="text/css" id="poptin-css-file" href="'+css_link+'/css/poptin-style-'+lang+'.css?ver=10" defer>';
                }
            } else {
                if(jQ224("#poptin-css-file-preload").length==0 && jQ224("#poptin-css-file-preload").length==0){
                    jQ224("#poptin-css-file-preload").remove()
                    jQ224("#poptin-css-file").remove()
                    font_link += '<link  rel="preload" as="style" id="poptin-css-file-preload"  href="'+cdn_server+'/css/poptin-style-'+lang+'.css?ver=10">';
                    font_link += '<link  rel="stylesheet" type="text/css" id="poptin-css-file" href="'+cdn_server+'/css/poptin-style-'+lang+'.css?ver=10" defer>';
                }
            }

            jQ224("#poptin_custom_fonts_preconnect, #poptin_custom_fonts_preload").remove();
            jQ224('head').append('<link rel="preconnect" id="poptin_custom_fonts_preconnect" href="https://d362h7pxdteoyk.cloudfront.net/"></link>');
            // jQ224('head').append('<link rel="preload" as="style" id="poptin_custom_fonts_preload" href="https://d362h7pxdteoyk.cloudfront.net/"></link>');

            if(lang == "en"){
                jQ224("#poptin_poppins_font_preload").remove();
                jQ224("#poptin_poppins_font_link").remove();
                if (!poptin_disable_fonts) {
                    jQ224('head').append('<link rel="preload" id="poptin_poppins_font_preload" as="style" href="https://fonts.popt.in?family=Poppins&display=swap">');
                    jQ224('head').append('<link rel="stylesheet" id="poptin_poppins_font_link" href="https://fonts.popt.in?family=Poppins&display=swap">');
                }

            } else {
                jQ224("#poptin_opensanshebrew_font_preload").remove();
                jQ224("#poptin_opensanshebrew_font_link").remove();
                jQ224('head').append('<link rel="preload" id="poptin_opensanshebrew_font_preload" as="style" href="https://fonts.popt.in/?family=Open%20Sans%20Hebrew&display=swap">');
                jQ224('head').append('<link rel="stylesheet" id="poptin_opensanshebrew_font_link" href="https://fonts.popt.in/?family=Open%20Sans%20Hebrew&display=swap">');
            }

            jQ224('head').append(font_link);
            setPoptinStyle();
        }

        function poptinInputValidations(poptin){
            if(!poptin || !poptin.poptin_id) return;

            function poptinEmailValidation(poptin){
                if(!window.poptinValidationState.emailAutofillLoaded) return;

                var this_pop = jQ224("[data-poptin-id=" + poptin.poptin_id + "]");
                if(!this_pop.length) return;

                var emailInput = '[data-poptin-id=' + poptin.poptin_id + '] [name="poptinDesignInputTextFieldEmail"][data-action-validate="check-typos"], [data-poptin-id=' + poptin.poptin_id + '] [name="poptinDesignInputTextFieldEmail"][data-action-validate="typos-business"]';

                try {
                    const poptin_eaf = new EmailAutoFill({
                        domains: [
                            {
                                name: 'gmail.com',
                                autoCompleteAfter: 1,
                                misspelledVariations: ['gmial.com', 'gmai.com', 'gamil.com', 'gmal.com', 'gmail.cm', 'mgail.com', 'gmil.com', 'gmail.om', 'gmaill.com', 'gmaiil.com', 'gmaiill.com', 'gmi.com', 'gmail.co', 'gmali.com', 'gml.com', 'gma.com']
                            },
                            {
                                name: 'yahoo.com',
                                autoCompleteAfter: 2,
                                misspelledVariations: ['yaho.com', 'yhoo.com', 'yaaho.com', 'yaahoo.com', 'yahu.com', 'yahuo.com', 'yahou.com', 'yah00.com', 'yaho0.com']
                            },
                            {
                                name: 'icloud.com',
                                autoCompleteAfter: 2,
                                misspelledVariations: ['iclooud.com', 'iclud.com', 'iclod.com', 'icloudd.com', 'iccloud.com', 'iclloud.com', 'iclou.com', 'icl0ud.com']
                            },
                            {
                                name: 'me.com',
                                autoCompleteAfter: 2
                            },
                            {
                                name: 'mac.com',
                                autoCompleteAfter: 2
                            },
                            {
                                name: 'outlook.com',
                                autoCompleteAfter: 2,
                                misspelledVariations: ['outlok.com', 'outluk.com', 'outloook.com', 'outloo.com', 'outlouk.com', 'outluok.com', 'outlk.com', 'oulook.com', 'otlook.com', 'outlk.com', 'outlo.com', 'outllook.com', '0utlook.com', 'outl00k.com', 'outlo0k.com', 'out0olk.com']
                            },
                            {
                                name: 'protonmail.com',
                                autoCompleteAfter: 2,
                                misspelledVariations: ['protonmal.com', 'pr0tonmail.com', 'prot0nmail.com', 'pr0t0nmail.com', 'prtonmail.com', 'protnmail.com', 'prootonmail.com', 'protunmial.com', 'pr0tunmial.com', 'prootonmail.com', 'protoonmail.com']
                            },
                            {
                                name: 'zohocorp.com',
                                autoCompleteAfter: 2,
                                misspelledVariations: ['z0h0c0rp.com', 'zohocrp.com', 'zohocpr.com', 'zoh0crop.com']
                            },
                            {
                                name: 'aol.com',
                                autoCompleteAfter: 2,
                                misspelledVariations: ['aaol.com', 'aool.com', 'a0l.com']
                            },
                            {
                                name: 'hotmail.com',
                                autoCompleteAfter: 2,
                                misspelledVariations: ['h0tmail.com', 'hotmal.com', 'hotmial.com', 'hootmail.com']
                            }
                        ],
                        /**
                         * this subscribe method will be triggered when you receive any value by using dispatch method
                         */
                        subscribe(value){
                            jQ224(".poptin-input-msg").remove();
                            // showLog(value);
                            if(value.type == "auto-fill"){
                                var originalEmail = jQ224(emailInput);
                                if(!originalEmail.length) return;

                                var emailTextAlign = (originalEmail.css("text-align") || "start").toLowerCase();
                                var emailDir = (originalEmail.css("direction") || "ltr").toLowerCase();
                                if(emailDir !== "ltr" || (emailTextAlign !== "left" && emailTextAlign !== "start")) return;

                                var clonedEmail = originalEmail.clone();
                                var parentPadding = originalEmail.parent().css("padding-left") || 0;
                                clonedEmail.addClass("poptin-input-autofill").val('').attr("placeholder", value.outValue).attr("id", '').attr("data-name", '').attr("name", '').css({ 'left': parentPadding });
                                originalEmail.parent().prepend(clonedEmail);
                                clonedEmail = originalEmail.parent().find(".poptin-input-autofill");
                                if(clonedEmail.length && clonedEmail.get(0)){
                                    clonedEmail.get(0).style.setProperty('width', 'calc(100% - ' + parentPadding + ' - ' + parentPadding + ')', 'important');
                                    clonedEmail.get(0).style.setProperty('min-width', 'auto', 'important');
                                }

                                jQ224(document).off("keydown", emailInput).on("keydown", emailInput, function(e){
                                    if(e.keyCode == 9 || e.keyCode == 39){
                                        if(originalEmail.attr('id') == 'poptinDesignInputTextFieldEmail'){
                                            if(
                                                clonedEmail.length &&
                                                originalEmail.val() != clonedEmail.attr("placeholder") &&
                                                clonedEmail.attr("placeholder").includes(originalEmail.val())
                                            ){
                                                originalEmail.val(clonedEmail.attr("placeholder"));
                                                clonedEmail.remove();
                                                return false;
                                            }
                                        }
                                    }
                                });
                            }
                            if(value.type == "suggestion"){
                                var randomId = parseInt(Math.random() * 10000000000);
                                var emailElement = jQ224(emailInput);
                                if(!emailElement.length) return;
                                const message = user_lang == "he" ? `האם התכוונת ל-<span>${value.outValue}</span>?` : `Did you mean <span>${value.outValue}</span>?`;
                                emailElement.parent().append(`<span id="m${randomId}" class="poptin-input-msg poptin-input-msg-1 poptin-input-info poptin-input-suggestion">${message}</span>`);
                                var container = emailElement.parents(".draggable-container");
                                var this_scale = parseFloat(this_pop.attr('data-scale')) || 1;
                                if(this_scale >= 1){
                                    container.addClass("has-poptin-input-msg");
                                    container.append(jQ224("#m" + randomId).clone().attr("id", "c" + randomId));
                                    var msgElement = jQ224("#m" + randomId);
                                    if(msgElement.length && container.length){
                                        jQ224("#c" + randomId).css({
                                            "top": ((msgElement.offset().top - container.offset().top) / this_scale) + 3,
                                            "left": ((msgElement.offset().left - container.offset().left) / this_scale),
                                            "width": parseInt(msgElement.css("width")) + 10,
                                            "height": parseInt(msgElement.css("height")),
                                        });
                                    }
                                } else {
                                    container.removeClass("has-poptin-input-msg");
                                }
                            }
                        }
                    });

                    jQ224(emailInput).off("keyup").on("keyup", function(e){
                        var email_address = jQ224(this).val();
                        jQ224(".poptin-input-autofill").remove();
                        if(e.keyCode == 13){
                            setTimeout(function(){
                                jQ224(".poptin-input-msg").remove();
                            }, 3000);
                        } else {
                            jQ224(".poptin-input-msg").remove();
                        }
                        poptin_eaf.dispatch('suggestion', email_address);
                        var poptin_lang = this_pop.find('#poptinDraggableContainer').attr('data-lang');
                        if(poptin_lang != "he"){
                            poptin_eaf.dispatch('auto-fill', email_address);
                        }
                    });

                    jQ224(emailInput).off("blur").on("blur", function(e){
                        jQ224(".poptin-input-autofill").remove();
                        setTimeout(function(){
                            jQ224(".poptin-input-msg").remove();
                        }, 3000);
                    });

                    jQ224(emailInput).off("focus").on("focus", function(e){
                        jQ224(".poptin-input-autofill").remove();
                        jQ224(".poptin-input-msg").remove();
                    });

                    jQ224(document).off('click', '.poptin-input-suggestion').on('click', '.poptin-input-suggestion', function(e){
                        e.preventDefault();
                        var suggestion = jQ224(this).find('span').text();
                        if(suggestion){
                            jQ224(emailInput).val(suggestion);
                        }
                        jQ224(this).remove();
                        return false;
                    });
                } catch (err){
                    showLog("Email validation error:", err);
                }
            }

            function poptinPhoneValidation(poptin){
                var this_pop = jQ224("[data-poptin-id=" + poptin.poptin_id + "]");
                if(!this_pop.length) return;

                var phoneInput = this_pop.find("input#poptinDesignInputTextFieldPhone").get(0);
                if(!phoneInput) return;
                if(jQ224(phoneInput).attr('data-action-validate') == "basic"){
                    function isValidPhoneNumber(str){
                        const regex = /^\+?[0-9-\s()]*$/;
                        return regex.test(str);
                    }

                    jQ224(phoneInput).off("blur").on("blur", function(){
                        jQ224(".poptin-input-msg").remove();
                        if(phoneInput.value && (!isValidPhoneNumber(phoneInput.value) || phoneInput.value.length > 15)){
                            var randomId = parseInt(Math.random() * 10000000000);
                            var validationMessage = ifUserlangIsHe() ? "יש להזין מספר טלפון תקין" : "Please enter a valid phone number";

                            jQ224(phoneInput).parent().append('<span id="m' + randomId + '" class="poptin-input-msg poptin-input-msg-2 poptin-input-error">' + validationMessage + '</span>');
                            var container = jQ224(phoneInput).parents(".draggable-container");
                            var this_scale = parseFloat(this_pop.attr('data-scale')) || 1;
                            if(this_scale >= 1){
                                container.addClass("has-poptin-input-msg");
                                container.append(jQ224("#m" + randomId).clone().attr("id", "c" + randomId));
                                var msgElement = jQ224("#m" + randomId);
                                if(msgElement.length && container.length){
                                    jQ224("#c" + randomId).css({
                                        "top": ((msgElement.offset().top - container.offset().top) / this_scale) + 3,
                                        "left": ((msgElement.offset().left - container.offset().left) / this_scale),
                                        "width": parseInt(msgElement.css("width")) + 10,
                                        "height": parseInt(msgElement.css("height")),
                                    });
                                }
                            } else {
                                container.removeClass("has-poptin-input-msg");
                            }
                        }
                    });

                    jQ224(phoneInput).off("input").on("input", function(e){
                        var sanitizedValue = phoneInput.value.replace(/[^\d()+\-\s]/g, '')
                        phoneInput.value = sanitizedValue;
                    });

                } else if(jQ224(phoneInput).attr('data-action-validate') == "international" && window.poptinValidationState.phoneValidationLoaded){
                    jQ224(phoneInput).removeAttr("required");
                    jQ224(phoneInput).off("open:countrydropdown close:countrydropdown focus blur");
                    var poptin_lang = jQ224(this_pop).find('#poptinDraggableContainer').attr('data-lang');
                    if(poptin_lang == "en"){
                        phoneInput.style.setProperty('padding-left', '70px', 'important');
                    } else {
                        phoneInput.style.setProperty('padding-right', '70px', 'important');
                    }

                    var formInput = jQ224(phoneInput).parents(".form-input-class").get(0);
                    if(formInput){
                        formInput.style.setProperty('z-index', '999998', 'important');
                    }

                    jQ224(phoneInput).on("open:countrydropdown", function(){
                        this_pop.find(".inputs-container").css("z-index", "999");
                    });

                    jQ224(phoneInput).on("close:countrydropdown", function(){
                        var container = this_pop.find(".inputs-container");
                        if(container.length){
                            container.css("z-index", container.attr("data-z-index"));
                        }
                    });

                    jQ224(phoneInput).on("focus", function(){
                        jQ224(".poptin-input-msg").remove();
                    });

                    if(jQ224(phoneInput).parents(".iti").length == 0 && window.intlTelInput){
                        try {
                            const itiEle = window.intlTelInput(phoneInput, {
                                initialCountry: pop_country_code.toLowerCase() !== "zz" ? pop_country_code : "us",
                                autoPlaceholder: "aggressive",
                                nationalMode: true,
                                utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js",
                            });

                            // Prevent automatic country switching when user types
                            let userSelectedCountry = itiEle.getSelectedCountryData().iso2;
                            let isManualChange = false;
                            let isReverting = false;

                            // Track clicks on country dropdown to detect manual selection
                            phoneInput.addEventListener('open:countrydropdown', function() {
                                isManualChange = true;
                            });

                            // Listen for country changes and revert automatic ones
                            phoneInput.addEventListener("countrychange", function() {
                                const newCountry = itiEle.getSelectedCountryData().iso2;

                                if (isManualChange) {
                                    // User manually selected a country - accept it
                                    userSelectedCountry = newCountry;
                                    isManualChange = false;
                                } else if (!isReverting) {
                                    // Automatic change detected - revert to user's selection
                                    isReverting = true;
                                    itiEle.setCountry(userSelectedCountry);
                                    isReverting = false;
                                }
                            });

                            if(itiEle && itiEle.promise){
                                itiEle.promise.then(() => {
                                    jQ224(phoneInput).off("blur").on("blur", function(){
                                        if(typeof intlTelInputUtils !== "undefined"){
                                            var currentFormat = (phoneInput.value[0] === "+") ? intlTelInputUtils.numberFormat.INTERNATIONAL : intlTelInputUtils.numberFormat.NATIONAL;
                                            var flagElement = this_pop.find(".iti__selected-flag .iti__flag");
                                            if(!flagElement.length) return;

                                            var flag = flagElement.attr("class").slice(-2);
                                            var formattedNumber = intlTelInputUtils.formatNumber(phoneInput.value, flag, currentFormat);
                                            phoneInput.value = formattedNumber;

                                            var intFormattedNumber = intlTelInputUtils.formatNumber(phoneInput.value, flag, intlTelInputUtils.numberFormat.INTERNATIONAL);
                                            jQ224(phoneInput).attr("data-int-phone", intFormattedNumber);

                                            var validationMessage = "";
                                            const iti = window.intlTelInputGlobals.getInstance(phoneInput);
                                            var isValidationError;
                                            if(!phoneInput.value){
                                                // validationMessage = "Please enter a valid number below";
                                            } else if(!iti.isValidNumber()){
                                                isValidationError = true;
                                                validationMessage = ifUserlangIsHe() ? "מספר לא תקין – יש לנסות שוב" : "Invalid number - please try again";
                                            }

                                            jQ224(".poptin-input-msg").remove();
                                            if(validationMessage != ""){
                                                var randomId = parseInt(Math.random() * 10000000000);
                                                jQ224(phoneInput).parent().append('<span id="m' + randomId + '" class="poptin-input-msg poptin-input-msg-3 poptin-input-error">' + validationMessage + '</span>');
                                                var container = jQ224(phoneInput).parents(".draggable-container");
                                                var this_scale = parseFloat(this_pop.attr('data-scale')) || 1;
                                                if(this_scale >= 1){
                                                    container.addClass("has-poptin-input-msg");
                                                    container.append(jQ224("#m" + randomId).clone().attr("id", "c" + randomId));
                                                    var msgElement = jQ224("#m" + randomId);
                                                    if(msgElement.length && container.length){
                                                        jQ224("#c" + randomId).css({
                                                            "top": ((msgElement.offset().top - container.offset().top) / this_scale) + 3,
                                                            "left": ((msgElement.offset().left - container.offset().left) / this_scale),
                                                            "width": parseInt(msgElement.css("width")) + 10,
                                                            "height": parseInt(msgElement.css("height")),
                                                        });
                                                    }
                                                } else {
                                                    container.removeClass("has-poptin-input-msg");
                                                }
                                            }
                                        }
                                    });
                                }).catch(err => {
                                    showLog("Phone validation initialization error:", err);
                                });
                            }
                        } catch (err){
                            showLog("Phone validation error:", err);
                        }
                    }

                    jQ224(phoneInput).off("input").on("input", function(e){
                        var sanitizedValue = phoneInput.value.replace(/[^0-9()\s-]/g, '');
                        phoneInput.value = sanitizedValue;
                    });
                }
            }

            function birthdayDateValidation(poptin) {
                var this_pop = jQ224("[data-poptin-id="+poptin.poptin_id+"]");
                var birthdayDateInput = this_pop.find("input#poptinDesignBirthdayField");

                birthdayDateInput.off('blur')
                birthdayDateInput.off('focus.validation')
                birthdayDateInput.on('focus.validation', function() {
                    jQ224(".poptin-input-msg").remove();
                })

                birthdayDateInput.off('blur.validation')
                birthdayDateInput.on('blur.validation', function() {
                    jQ224(".poptin-input-msg").remove();
                    var birthday = birthdayDateInput.val();
                    if(birthday) {
                        var birthdayDate = new Date(birthday);
                        var today = new Date();
                        if(birthdayDate >= today) {
                            var error_message = ifUserlangIsHe() ? "יש להזין תאריך לידה תקין." : "Please enter a valid birthday.";
                            var randomId = parseInt(Math.random()*10000000000);
                            birthdayDateInput.parent().append('<span id="m'+randomId+'" class="poptin-input-msg poptin-input-msg-7 poptin-input-error">'+error_message+'</span>');
                            var container = birthdayDateInput.parents(".draggable-container");
                            var this_scale = parseFloat(this_pop.attr('data-scale'));
                            if(this_scale >= 1){
                                container.addClass("has-poptin-input-msg");
                                container.append(jQ224("#m"+randomId).clone().attr("id", "c"+randomId));
                                jQ224("#c"+randomId).css({
                                    "top":((jQ224("#m"+randomId).offset().top - container.offset().top)/this_scale) + 3,
                                    "left":((jQ224("#m"+randomId).offset().left - container.offset().left)/this_scale),
                                    "width":parseInt(jQ224("#m"+randomId).css("width")) + 10,
                                    "height":parseInt(jQ224("#m"+randomId).css("height")),
                                });
                            } else {
                                container.removeClass("has-poptin-input-msg");
                            }
                            return false;
                        }
                    }
                })
            }

            function validatePoptinInputs(poptin){
                try {
                    poptinPhoneValidation(poptin);
                    poptinEmailValidation(poptin);
                    birthdayDateValidation(poptin);
                } catch (err){
                    showLog("Validation error:", err);
                }
            }

            if(window.poptinValidationState.loaded){
                validatePoptinInputs(poptin);
            }
        }

        /**
         * Trigger functions: initiatePullPoptinsRequest()
         * parameters       : Poptin -> Poptin Object
         * Desc             : Download & append poptin lightbox timer style only if poptin is timer type
         */
        function timerDownload(poptin){
            if (
                poptin.design_properties.timer_ver == 1 ||
                (
                    poptin.design_properties.timer_ver == 0 && (
                        poptin.poptin_type+'_'+poptin.poptin_format == "lightbox_format_5" ||
                        poptin.poptin_type+'_'+poptin.poptin_format == "lightbox_format_11" ||
                        poptin.poptin_type+'_'+poptin.poptin_format == "bar_format_5" ||
                        poptin.poptin_type+'_'+poptin.poptin_format == "bar_format_10"
                    )
                )
            ){
                // showLog('timerDownload');
                //jQ224('head').append('<script src="'+s3_link+'/js/timer.js" async=true></script>');
                if(jQ224("#poptin-timer-v1").length==0){
                    jQ224('head').append('<link rel="stylesheet" id="poptin-timer-v1" type="text/css" href="'+cdn_server+'/css/timer.css?ver=10" defer>');
                }

            }   else if(poptin.design_properties.timer_ver == 2) {
                if(jQ224("#poptin-timer-v2").length==0){
                    jQ224('head').append('<link rel="stylesheet" id="poptin-timer-v2" type="text/css" href="'+cdn_server+'/css/v_2/timer.css?ver=10" defer>');
                }
            }
        }

        /**
        * Trigger functions: initiatePullPoptinsRequest()
        * parameters       : Poptin -> Poptin Object
        * Desc             : Download & append poptin wheel style only if poptin is wheel type
        */
        function wheelDownload(poptin) {
            if (poptin.poptin_type + '_' + poptin.poptin_format == "gamified_format_3") {
                // showLog('wheelDownload');
                jQ224('head').append('<link rel="stylesheet" id="poptin-timer-v1" type="text/css" href="' + css_link + '/css/v_2/spin-wheel.css" defer>');
            }
        };

        /**
         * Trigger functions: initiatePullPoptinsRequest()
         * Desc             : Download & append jQueryui
         */
        // function downloadJqueryUi(){
        //     if (jQ224 && !jQ224.ui) {
        //         showLog('downloadJqueryUi');
        //         jquery_link = '<script src="https://cdnjs.cloudflare.com/ajax/libs/jqueryui/1.12.0/jquery-ui.min.js" defer></script>';
        //         try{
        //             jQ224('head').append(jquery_link);
        //         }catch(err){
        //             showLog(err);
        //         }
        //     }
        // }

        // function downloadPoptinBackground(poptin){
        //     // Inject poptin to DOM
        //     jQ224("body").append(poptin.poptin);
        //     jQ224("[data-poptin-id="+poptin.poptin_id+"]").css('display','none').addClass('poptin_background_'+poptin.poptin_id);
        //     jQ224('.poptin_background_'+poptin.poptin_id).attr('data-poptin-id','');
        //     poptin_type_format = poptin.poptin_type+'_'+poptin.poptin_format;
        //     $class = ( ( poptin_type_format == 'lightbox_format_3' || poptin_type_format == 'lightbox_format_9' ) ? '.alternative-background' : '#poptinDraggableContainer' );
        //     $this = jQ224(".poptin_background_"+poptin.poptin_id+" "+$class).css('background-image');
        //     if ($this != undefined && $this != 'none' && $this.indexOf('data:image') == -1 ){
        //         var downloadingImage = new Image();
        //         downloadingImage.onload = function(){
        //             showLog('*****************loadimage***************');
        //             //jQ224("[data-poptin-id="+poptin.poptin_id+"] "+$class).css('background-image','url('+this.src+')');
        //             jQ224(".poptin_background_"+poptin.poptin_id).remove();
        //         };
        //         image_url = $this.replace('url(','').replace(')','').replace(/\"/gi, "");
        //         downloadingImage.src = image_url;
        //     }else{
        //         jQ224(".poptin_background_"+poptin.poptin_id).remove();
        //     }
        // }

        function downloadPoptinTemplateFromS3(poptin){
            showLog('downloadPoptinTemplateFromS3-poptin_id: '+ poptin.poptin_id);
            // Inject poptin to DOM
            if (window.all_poptins[poptin.poptin_id].poptin == ''){
                jQ224.when( jQ224.ajax(poptin.poptin_url)).then(function( data, textStatus, jqXHR ) {

                    showLog('downloadPoptinTemplateFromS3->status: '+ textStatus);

                    poptin.poptin = data;
                    window.all_poptins[poptin.poptin_id].poptin = data
                    if (window.poptins[poptin.poptin_id] != undefined){
                        window.poptins[poptin.poptin_id].poptin = data;
                    }

                    if (typeof window.wixDevelopersAnalytics !='undefined') {
                        if( jQ224(poptin.poptin).find("input#wixProductsJSON").length > 0 ){
                            var wixProductsJSON = JSON.parse( jQ224(poptin.poptin).find("input#wixProductsJSON").val() );
                            if(wixProductsJSON && (wixProductsJSON.category == "last_visited" || wixProductsJSON.category == "product_in_cart") ){
                                getWixRecommendedProducts(poptin, wixProductsJSON).then(function(data) {
                                    if(data.display == true){
                                        showLog('show teasers if products available');
                                        extractTeaser(poptin,0);
                                    }
                                });
                            }else{
                                showLog('show teasers if products available for collections and manual_products');
                                extractTeaser(poptin,0);
                            }
                        }
                    }

                    if(window.Shopify !== undefined && window.Shopify.shop){

                        if( jQ224(poptin.poptin).find("input#shopifyProductsJSON").length > 0 ){
                            setShopifyRecentlyViewedProduct();

                            var shopifyProductsJSON = JSON.parse( jQ224(poptin.poptin).find("input#shopifyProductsJSON").val() );
                            if( shopifyProductsJSON && (shopifyProductsJSON.category == "last_visited" || shopifyProductsJSON.category == "product_in_cart") ){
                                getShopifyRecommendedProducts(poptin, shopifyProductsJSON).then(function(data) {
                                    if(data.display == true){
                                        showLog('show teasers if products available');
                                        extractTeaser(poptin,0);
                                    }
                                });
                            }else{
                                showLog('show teasers if products available for collections and manual_products');
                                extractTeaser(poptin,0);
                            }
                        }else{
                            extractTeaser(poptin,0);
                        }
                    }else{
                        extractTeaser(poptin,0);
                    }

                    // Download poptin timer css & js
                    timerDownload(poptin);
                    wheelDownload(poptin);
                    setPoptinsArray(poptin.poptin_id);

                    //window.poptins[poptin.poptin_id].data_point = new DataPoint();
                    //window.poptins[poptin.poptin_id].data_point.onLoad(poptin.poptin_id);

                    setPoptinSize(poptin);
                    setAutoPilot(poptin);
                    if (poptin.display){
                        setPoptinTrigger(poptin);
                    }

                },function( data, textStatus, jqXHR) {
                    showLog('downloadPoptinTemplateFromS3->error: '+data);
                });
            }
        }

        /**
         * Trigger functions: initiatePullPoptinsRequest()
         * parameters       : Poptin -> Poptin Object
         * Desc             : set trigger per poptin
         * Desc             : Run setPoptin() if trigger is activated
         * trigger1         : Reaching to close tab
         * trigger2         : After 'X' seconds
         * trigger3         : After 'X' page scrolled
         * trigger4         : After 'X' click on page
         * trigger5         : After 'X' page visit
         */

        var wix_cart_trigger_poptins = [];
        function setPoptinTrigger(poptin) {

            showLog('setPoptinTrigger for: ' + poptin.poptin_id);
            var isEmbeddedPoptin = poptin.poptin_type == "embedded";
            //appendPoptin(poptin);

            // Immediately add embedded forms
            poptin.display_after_sec_active = isEmbeddedPoptin ? 0 : poptin.display_after_sec_active;

            // Set default triggers values
            window.poptins[poptin.poptin_id].poptin_trigger = {
                convert: false,
                poptin_active: true,
                scroll_flag: true,
                mouse_leave_flag: true,
                click_counter: 0,
                trigger: '',
                close_trigger: '',
                shown: false
            };

            if (previewPoptinId === poptin.poptin_id) {
                const newPoptin = setPreviewPoptin(poptin);

                appendPoptin(newPoptin);
            } else {
                // trigger if User close tab
                if (poptin.display_after_exit_website_active == "yes") {
                    // Track pages only if on mobile
                    if (ifMobilePoptin) {

                        // Check if window history is available
                        if (window.history && window.history.pushState) {

                            function whenGoingBack(poptin) {
                                showLog("going back "+pop_urls.length);
                                if(pop_urls.length < 1){
                                    var hashLocation = location.hash;
                                    var hashSplit = hashLocation.split("#!/");
                                    var hashName = hashSplit[1];
                                    if (hashName !== '') {
                                        var hash = window.location.hash;
                                        if (hash === '') {
                                            if (EngagementWithOtherPoptins(poptin) && sourceCodeTarget(poptin)) {
                                                if (PQ.ifActive() && PQ.ifRelevent(poptin)) {
                                                    showLog('load after back button trigger');
                                                    return false
                                                } else if ((window.poptins[poptin.poptin_id] && window.poptins[poptin.poptin_id].poptin_trigger?.mouse_leave_flag && window.poptins[poptin.poptin_id].poptin_trigger?.poptin_active) || !window.poptins[poptin.poptin_id].poptin_trigger?.shown) {
                                                    ensurePoptinTrigger(poptin.poptin_id);
                                                    showLog('load after back button trigger');
                                                    window.poptins[poptin.poptin_id].poptin_trigger.poptin_active = false;
                                                    window.poptins[poptin.poptin_id].poptin_trigger.trigger = "close tab";
                                                    //setPoptin(poptin);
                                                    appendPoptin(poptin, (isEmbeddedPoptin ? true : null));
                                                    ensurePoptinTrigger(poptin.poptin_id);
                                                    window.poptins[poptin.poptin_id].poptin_trigger.mouse_leave_flag = false;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            // Don't create fake histroy states if on SPA because they create their own
                            if(!poptin_single_page_app){
                                var pageState = 100;
                                if (window.history.state && window.history.state.page) {
                                    pageState = window.history.state.page;
                                }
                                window.history.pushState({page: pageState + 1}, '');
                            }
                            // Slide back to previous page
                            window.addEventListener('popstate', function () {
                                whenGoingBack(poptin);
                            });

                        }

                    } else {
                        jQ224(document).mouseleave(function (e) {
                            // showLog('e: ', e.target);
                            if (EngagementWithOtherPoptins(poptin) && sourceCodeTarget(poptin)) {
                                var top = e.clientY;
                                var right = document.body.clientWidth - e.pageX;
                                var bottom = jQ224(window).height() - e.clientY;
                                var left = e.pageX;
                                // showLog('top: '+top);
                                // showLog('right: '+right);
                                // showLog('bottom: '+bottom);
                                // showLog('left: '+left);
                                var this_tag = e.target.tagName;
                                if (this_tag.toLowerCase() == "select") {
                                    return false;
                                }
                                if (right > 0 && bottom > 0 && top <= 0) {
                                    showLog('load after mouse leave trigger: ' + poptin.poptin_id);
                                    if (PQ.ifActive() && PQ.ifRelevent(poptin)) {
                                        showLog('not');
                                        return false
                                    } else if ((window.poptins[poptin.poptin_id] && window.poptins[poptin.poptin_id].poptin_trigger?.mouse_leave_flag && window.poptins[poptin.poptin_id].poptin_trigger?.poptin_active) || !window.poptins[poptin.poptin_id].poptin_trigger?.shown) {
                                        showLog('yes');
                                        ensurePoptinTrigger(poptin.poptin_id);
                                        window.poptins[poptin.poptin_id].poptin_trigger.poptin_active = false;
                                        window.poptins[poptin.poptin_id].poptin_trigger.trigger = "close tab";
                                        //setPoptin(poptin);
                                        appendPoptin(poptin);
                                        ensurePoptinTrigger(poptin.poptin_id);
                                        window.poptins[poptin.poptin_id].poptin_trigger.mouse_leave_flag = false;
                                    }
                                }
                            }
                        });
                    }
                }

                // trigger if 5 seconds was passed after page load
                if (poptin.display_after_sec_active != "no") {
                    // Only set website time tracker cookie if one of the poptins has active on website
                    if (poptin.display_after_sec_active_on == 'website') {
                        // Tracking how much time the user has spent on the client website in total, on all pages where pixel is installed
                        if (!poptinCheckCookie('poptin_session_account_time_' + poptin.account_id)) {
                            // Set the timer cookie if not set
                            var data = {
                                set_at: Date.now(),
                                expiry_at: Date.now() + 60 * 1000
                            };
                            poptinSetCookie('poptin_session_account_time_' + poptin.account_id, JSON.stringify(data), ((1 / 24) / 60));
                        }

                        // After the cookie is set, increase the timer to expire in a minute every 20 secs
                        var poptin_session_account_timer = setInterval(function () {
                            if (poptinGetCookie('poptin_session_account_time_' + poptin.account_id)) {
                                var cookie = JSON.parse(poptinGetCookie('poptin_session_account_time_' + poptin.account_id));
                                if (((cookie.expiry_at - Date.now()) / 1000) < 60) {
                                    var data = {
                                        set_at: cookie.set_at,
                                        expiry_at: Date.now() + 60 * 1000
                                    };
                                    poptinSetCookie('poptin_session_account_time_' + poptin.account_id, JSON.stringify(data), ((1 / 24) / 60));
                                }
                            } else { // In some cases, inactive tabs might be causing set interval to stop and cookie to expire
                                var data = {
                                    set_at: Date.now(),
                                    expiry_at: Date.now() + 60 * 1000
                                };
                                poptinSetCookie('poptin_session_account_time_' + poptin.account_id, JSON.stringify(data), ((1 / 24) / 60));
                            }
                        }, 1000 * 20);

                        var user_arrival_time = JSON.parse(poptinGetCookie('poptin_session_account_time_' + poptin.account_id)).set_at / 1000;
                        var user_time_spent = (Date.now() / 1000) - user_arrival_time;
                    }

                    // ETA
                    // If timer set to page, show after timer itself
                    // If timer set to website, subtract time spent already
                    // on the website from the timer
                    // Multiply by 1000 to get secs in both cases
                    var eta = poptin.display_after_sec_active_on === 'page' ?
                        poptin.display_after_sec_active * 1000 :
                        (poptin.display_after_sec_active - user_time_spent) * 1000;

                    // Give "before_show" teasers time to appear before an instant popup
                    var tabshowForDelay = jQ224(poptin.poptin).attr("data-tabshow");
                    if (tabshowForDelay === 'before_show' && eta < 800) {
                        eta = 800;
                    }

                    poptinTimeDelayTrigger = window.setTimeout(function() {
                        showLog('load after '+poptin.display_after_sec_active+' seconds trigger on '+poptin.display_after_sec_active_on);
                        if (EngagementWithOtherPoptins(poptin) && sourceCodeTarget(poptin)) {
                            if (PQ.ifActive() && PQ.ifRelevent(poptin)){
                                return false;
                            } else if (window.poptins[poptin.poptin_id].poptin_trigger?.poptin_active || !window.poptins[poptin.poptin_id].poptin_trigger?.shown) {
                                ensurePoptinTrigger(poptin.poptin_id);
                                // insert popup into body tag
                                window.poptins[poptin.poptin_id].poptin_trigger.poptin_active = false;
                                window.poptins[poptin.poptin_id].poptin_trigger.trigger = "after " + poptin.display_after_sec_active + " seconds";
                                //setPoptin(poptin);
                                appendPoptin(poptin);
                                ensurePoptinTrigger(poptin.poptin_id);
                            }
                        }
                        //}, (poptin.display_after_sec_active==0 ? 0.3 : display_after_sec_active)*1000);
                    }, eta);
                }

                // trigger if user scroll down 25% of the page
                if (poptin.display_after_scroll_active != "no" && !scratchPopupActive) {
                    showLog(poptin.display_after_scroll_active);

                    // var pageHeight = jQ224(document).height() - jQ224(window).height();
                    var pageHeight = jQ224(document).height() - window.innerHeight;

                    var scrolToTrigger = pageHeight * poptin.display_after_scroll_active * 0.01;
                    jQ224(window).on('scroll.poptinTriggerScrollEvent', function() {
                        // var pageHeight = jQ224(document).height() - jQ224(window).height();
                        var pageHeight = jQ224(document).height() - window.innerHeight;
                        var scrolToTrigger = pageHeight * poptin.display_after_scroll_active * 0.01;
                        var if_trigred;

                        // Ensure poptin_trigger object exists
                        ensurePoptinTrigger(poptin.poptin_id);

                        if (jQ224(window).scrollTop() >= scrolToTrigger && window.poptins[poptin.poptin_id].poptin_trigger.scroll_flag) {

                            window.poptins[poptin.poptin_id].poptin_trigger.scroll_flag = false;

                            if ((window.poptins[poptin.poptin_id].poptin_trigger.poptin_active) || !window.poptins[poptin.poptin_id].poptin_trigger.shown) {
                                showLog('load after ' + poptin.display_after_scroll_active + ' scroll page trigger');
                                if(EngagementWithOtherPoptins(poptin) && sourceCodeTarget(poptin)) {
                                    if (PQ.ifActive() && PQ.ifRelevent(poptin)) {
                                        return false
                                    } else
                                        // insert popup into body tag
                                        window.poptins[poptin.poptin_id].poptin_trigger.poptin_active = false;
                                    window.poptins[poptin.poptin_id].poptin_trigger.trigger = "after " + poptin.display_after_scroll_active + "% scrolling";
                                    //setPoptin(poptin);
                                    appendPoptin(poptin);
                                    ensurePoptinTrigger(poptin.poptin_id);
                                    window.poptins[poptin.poptin_id].poptin_trigger.scroll_flag = false;
                                }
                            }
                        }

                        setTimeout(function () {
                            ensurePoptinTrigger(poptin.poptin_id);
                            window.poptins[poptin.poptin_id].poptin_trigger.scroll_flag = true;
                        }, 300)
                    });
                }

                // trigger if user click X time in the page
                if (poptin.display_after_page_click_number_active != "no") {
                    jQ224(document).on('click tap', function () {
                        ensurePoptinTrigger(poptin.poptin_id);
                        window.poptins[poptin.poptin_id].poptin_trigger.click_counter++;
                        if (window.poptins[poptin.poptin_id].poptin_trigger.click_counter == poptin.display_after_page_click_number_active) {
                            if (window.poptins[poptin.poptin_id].poptin_trigger.poptin_active || !window.poptins[poptin.poptin_id].poptin_trigger.shown) {
                                if(EngagementWithOtherPoptins(poptin) && sourceCodeTarget(poptin)) {
                                    showLog('load after ' + poptin.display_after_page_click_number_active + ' clicks page trigger');
                                    // insert popup into body tag
                                    window.poptins[poptin.poptin_id].poptin_trigger.trigger = "after " + poptin.display_after_page_click_number_active + " clicks";
                                    //setPoptin(poptin);
                                    if (PQ.ifActive() && PQ.ifRelevent(poptin)) {

                                    } else {
                                        window.poptins[poptin.poptin_id].poptin_trigger.poptin_active = false;
                                        appendPoptin(poptin);
                                    }
                                    ensurePoptinTrigger(poptin.poptin_id);
                                    window.poptins[poptin.poptin_id].poptin_trigger.click_counter = 0;
                                }
                            }
                        }
                    });
                }

                // trigger if user visit X pages
                if (poptin.display_after_visit_page_active != "no") {
                    if (typeof (Storage) !== "undefined") {
                        // If not triggred yet
                        if (window.sessionStorage.getItem("display_after_visit_page_active_" + poptin.poptin_id) != "disactive") {

                            // Check if url was changed and not just page reloaded
                            if (window.sessionStorage.getItem("page_url_" + poptin.poptin_id) != window.location.href) {
                                var counter = (window.sessionStorage.getItem("page_visit_" + poptin.poptin_id) ? Number(window.sessionStorage.getItem("page_visit_" + poptin.poptin_id)) : 0) + 1;
                                // set page visit counter
                                window.sessionStorage.setItem("page_visit_" + poptin.poptin_id, counter);
                            }

                            // If page visit counter = client display_after_visit_page_active value && not same page
                            if (window.sessionStorage.getItem("page_visit_" + poptin.poptin_id) == poptin.display_after_visit_page_active && window.sessionStorage.getItem("page_url_" + poptin.poptin_id) != window.location.href) {
                                showLog('load after ' + poptin.display_after_visit_page_active + ' clicks page trigger');
                                if(EngagementWithOtherPoptins(poptin) && sourceCodeTarget(poptin)) {
                                    //setPoptin(poptin);
                                    if (PQ.ifActive() && PQ.ifRelevent(poptin)) {
                                        //window.poptins[poptin.poptin_id].poptin_trigger.poptin_active = true;
                                        //window.sessionStorage.setItem("display_after_visit_page_active_"+poptin.poptin_id, "active");
                                    } else {
                                        appendPoptin(poptin);
                                        ensurePoptinTrigger(poptin.poptin_id);
                                        window.poptins[poptin.poptin_id].poptin_trigger.poptin_active = false;

                                        if (!poptin.d_f_r.includes("display_everytime_everypage_5")){
                                            // disable repop
                                            window.sessionStorage.setItem("display_after_visit_page_active_" + poptin.poptin_id, "disactive");
                                        }
                                    }
                                    // refresh values
                                    window.sessionStorage.setItem("page_visit_" + poptin.poptin_id, 0);
                                    // set page new url
                                    window.sessionStorage.setItem("page_url_" + poptin.poptin_id, window.location.href);
                                }

                            } else {
                                // set page new url
                                window.sessionStorage.setItem("page_url_" + poptin.poptin_id, window.location.href);
                            }
                        }
                    } else {
                        showLog('Sorry! No Web Storage support..');
                    }
                }

                if (poptin.display_after_inactive_seconds_active != "no") {
                    function inactivity() {
                        var triggered = false;
                        var inactivity_timer;
                        window.onload = resetInactivityTimer(); // Not sure why this needs () syntax to work
                        window.onmousemove = resetInactivityTimer;
                        window.onmousedown = resetInactivityTimer;  // catches touchscreen presses as well
                        window.ontouchstart = resetInactivityTimer; // catches touchscreen swipes as well
                        window.onclick = resetInactivityTimer;      // catches touchpad clicks as well
                        window.onkeypress = resetInactivityTimer;
                        window.addEventListener('scroll', resetInactivityTimer, true); // improved; see comments

                        function triggerPoptin() {
                            triggered = true;
                            if (EngagementWithOtherPoptins(poptin) && sourceCodeTarget(poptin)) {
                                appendPoptin(poptin);
                                ensurePoptinTrigger(poptin.poptin_id);
                                window.poptins[poptin.poptin_id].poptin_trigger.poptin_active = false;
                            }
                        }

                        function resetInactivityTimer() {
                            clearTimeout(inactivity_timer);
                            inactivity_timer = triggered ? null : setTimeout(triggerPoptin, poptin.display_after_inactive_seconds_active * 1000);
                        }
                    }

                    inactivity();
                }

                if (poptin.shopify_cart_trigger_active) {
                    if (!poptinCheckCookie('poptin_fetch_initial_shopify_cart')) {
                        jQ224.ajax({
                            url: shopifylanguageRoute()+"cart.js",
                            type: 'get',
                            dataType: 'json',
                            async: true,
                        }, "json")
                            .done(function (data) {
                                var productId = []
                                jQ224.each(data.items, function (index, item) {
                                    productId.push(item.variant_id);
                                });
                                poptinSetCookie('poptin_fetch_initial_shopify_cart', true);
                                poptinSetCookie('poptin_shopify_cart_product_id', productId.join(','));
                            });
                    }

                    (function (ns, fetch) {
                        if (typeof fetch !== 'function') return;

                    ns.fetch = function () {
                        const response = fetch.apply(this, arguments);
                        response.then(res => {

                            var shopify_lang_route = shopifylanguageRoute();

                            // if ([
                            //     `${window.location.origin}`+shopify_lang_route+`cart/add.js`,
                            //     `${window.location.origin}`+shopify_lang_route+`cart/add`,
                            //     `${window.location.origin}`+shopify_lang_route+`cart/update.js`,
                            //     `${window.location.origin}`+shopify_lang_route+`cart/update`,
                            //     `${window.location.origin}`+shopify_lang_route+`cart/change.js`,
                            //     `${window.location.origin}`+shopify_lang_route+`cart/change`,
                            //     `${window.location.origin}`+shopify_lang_route+`cart/clear.js`,
                            //     `${window.location.origin}`+shopify_lang_route+`cart/clear`,
                            // ].includes(res.url)) {
                            console.log("AJAX URL: ")
                            console.log(res.url)
                            if ([
                                `${window.location.origin}${shopify_lang_route}cart/add.js`,
                                `${window.location.origin}${shopify_lang_route}cart/add`,
                                `${window.location.origin}${shopify_lang_route}cart/update.js`,
                                `${window.location.origin}${shopify_lang_route}cart/update`,
                                `${window.location.origin}${shopify_lang_route}cart/change.js`,
                                `${window.location.origin}${shopify_lang_route}cart/change`,
                                `${window.location.origin}${shopify_lang_route}cart/clear.js`,
                                `${window.location.origin}${shopify_lang_route}cart/clear`
                            ].some(url => res.url.startsWith(url))) {
                                res.clone().json().then((data) => {
                                    listenToGlobalXhr(res, poptin, 'fetch', data)
                                });

                                }
                            });

                            return response;
                        }

                    }(window, window.fetch));

                    //initXHRListener()
                    initXHRListener(poptin);
                }

                if (poptin.wix_cart_trigger_active) {
                    wix_cart_trigger_poptins.push(poptin);
                    if (localStorage.getItem('poptin_wix_cart_id')) {
                        getCartDetails(localStorage.getItem('poptin_wix_cart_id'), true)
                    }
                }
            }
        }


        /**
         * Set preview mode for poptin.
         *
         * @param {object} poptin Poptin
         * @returns object
         */
        function setPreviewPoptin(poptin) {
            let div = document.createElement('div');
            div.innerHTML = poptin.poptin;

            let divPopup = div.querySelector('.poptin-popup');
            let poptinType = divPopup.getAttribute('data-poptin-type');
            let poptinLocation = divPopup.getAttribute('data-poptin-location');

            let indicatorParentMaxWidth = "100%";
            let indicatorTopOffset = "0";
            let indicatorRightOffset = "unset";
            let indicatorParentPosition = "relative";
            let indicatorLeftOffset = "0";
            let topPx = "-50px";
            let contentMinWidth = "300px"

            const fixedNotificationTypes = ['browsing', 'bside', 'sside', 'bar']
            if (fixedNotificationTypes.includes(poptinType)) {
                topPx = 0;
                indicatorParentPosition = "fixed";
                indicatorTopOffset = "20px";
                indicatorLeftOffset = "50%";
                contentMinWidth = "460px";
            }

            switch (poptinType) {
                case 'fullpage':
                    topPx = "10px";
                    indicatorParentMaxWidth = "100vw";
                    break;
                case 'mobile':
                    if (poptinLocation.includes('top')) {
                        topPx = poptin.field_poptin_height + 10 + "px";
                    }
                    break;
                case "social":
                    indicatorRightOffset = 0;
                    break;
                default:
                    break;
            }

            let popupPreviewMessage = `
                <div style="position: ${indicatorParentPosition}; top: ${indicatorTopOffset}; left: ${indicatorLeftOffset}; max-width: ${indicatorParentMaxWidth}; height: auto; display: flex; justify-content: center;">
                    <span style="height:auto !important;width:auto!important;min-width:${contentMinWidth}; background:#fff !important;border-radius:4px !important;padding:5px !important;position:absolute !important;z-index: 9999999 !important;right:${indicatorRightOffset};font-size:12px !important;text-align:center !important;top:${topPx} !important;">${user_lang === "he" ? "זו תצוגה מקדימה של הפופאפ. יש לשים לב כי שליחה לא תהיה פעילה.": "This is a preview of your popup. Please note that submission will not be functional."}</span>
            </div>`;
            // const popupPreviewMessage = '<span style="height:auto!important;width: auto !important;background: #fff !important;border-radius: 4px !important;padding: 5px 10px !important;position: fixed !important;z-index: 9999999 !important;top:50px !important;left: 50%!important;transform: translateX(-50%)!important;font-size: 12px !important;text-align: center;!important;">This is a preview of your pop-up. Please note that submission will not be functional.</span>'

            if (fixedNotificationTypes.includes(poptinType)) {
                jQ224("body").append(popupPreviewMessage)
            } else {
                divPopup.innerHTML = popupPreviewMessage + divPopup.innerHTML;
            }

            poptin.poptin = div.innerHTML;
            return poptin;
        }

        function shopifylanguageRoute(){
            var shopify_lang_route = "/";
            if (typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root) {
                shopify_lang_route = Shopify.routes.root;
            }
            return shopify_lang_route;
        }

        function wixlanguageRoute(){
            return '/';
        }

        function initXHRListener(poptin)
        {
            showLog('Initialized XHR Listener')
            // var s_ajaxListener = new Object();

            // // Added for IE support
            // if (typeof XMLHttpRequest === "undefined") {
            //     XMLHttpRequest = function () {
            //         try { return new ActiveXObject("Msxml2.XMLHTTP.6.0"); }
            //         catch (e) {}
            //         try { return new ActiveXObject("Msxml2.XMLHTTP.3.0"); }
            //         catch (e) {}
            //         try { return new ActiveXObject("Microsoft.XMLHTTP"); }
            //         catch (e) {}
            //         throw new Error("This browser does not support XMLHttpRequest.");
            //     };
            // }

            // s_ajaxListener.tempOpen = XMLHttpRequest.prototype.open;
            // s_ajaxListener.tempSend = XMLHttpRequest.prototype.send;
            // s_ajaxListener.callback = function (th) {
            //     var _url = "";
            //     if (th.hasOwnProperty('_url')) {
            //          _url = th._url;
            //     } else if(th.hasOwnProperty('url')){
            //         _url = th.url;
            //     }
            //     if ([
            //         '/cart/add.js',
            //         '/cart/add',
            //         '/cart/update.js',
            //         '/cart/update',
            //         '/cart/change.js',
            //         '/cart/change',
            //         '/cart/clear.js',
            //         '/cart/clear',
            //     ].includes(_url)) {
            //         showLog('add-to-cart url found, call global listener')
            //         //showLog('listen now')
            //         listenToGlobalXhr(th, poptin,'xhr')
            //     }


            //     // this.method :the ajax method used
            //     // this.url    :the url of the requested script (including query string, if any) (urlencoded)
            //     // this.data   :the data sent, if any ex: foo=bar&a=b (urlencoded)
            // }

            // XMLHttpRequest.prototype.open = function(a,b) {
            //     if (!a) var a='';
            //     if (!b) var b='';
            //     s_ajaxListener.tempOpen.apply(this, arguments);
            //     s_ajaxListener.method = a;
            //     s_ajaxListener.url = b;
            //     if (a.toLowerCase() == 'get') {
            //         s_ajaxListener.data = b.split('?');
            //         s_ajaxListener.data = s_ajaxListener.data[1];
            //     }
            // }

            // XMLHttpRequest.prototype.send = function(a,b) {
            //     if (!a) var a='';
            //     if (!b) var b='';
            //     s_ajaxListener.tempSend.apply(this, arguments);
            //     if(s_ajaxListener.method.toLowerCase() == 'post')s_ajaxListener.data = a;
            //     s_ajaxListener.callback(this);
            // }

            xhook.after(function (request, response) {
                _url = request.url;
                // if (['/cart/add.js', '/cart/add', '/cart/update.js', '/cart/update', '/cart/change.js', '/cart/change', '/cart/clear.js', '/cart/clear'].includes(_url)) {
                if (['/cart/add.js', '/cart/add', '/cart/update.js', '/cart/update', '/cart/change.js', '/cart/change', '/cart/clear.js', '/cart/clear']
                    .some(url => _url.startsWith(url))) {
                    showLog('add-to-cart url found, call global listener'); //showLog('listen now')
                    listenToGlobalXhr(request, poptin, 'xhr',response);
                }
            });

        }


        function initXHRListener2() {
            var open = window.XMLHttpRequest.prototype.open,
                send = window.XMLHttpRequest.prototype.send;

            function openReplacement(method, url, async, user, password) {
                this._url = url;
                return open.apply(this, arguments);
            }

            function sendReplacement(data) {
                if(this.onreadystatechange) {
                    this._onreadystatechange = this.onreadystatechange;
                }
                /**
                 * PLACE HERE YOUR CODE WHEN REQUEST IS SENT
                 */
                this.onreadystatechange = onReadyStateChangeReplacement;
                return send.apply(this, arguments);
            }

            function onReadyStateChangeReplacement() {
                if(this.readyState == 4) {
                    return listenToGlobalXhr(this, poptin, 'xhr', null)
                }
                if(this._onreadystatechange) {
                    return this._onreadystatechange.apply(this, arguments);
                }
            }

            window.XMLHttpRequest.prototype.open = openReplacement;
            window.XMLHttpRequest.prototype.send = sendReplacement;
        }

        function listenToGlobalXhr(request, poptin, type, data=null) {
            shopify_cart_cache = null;
            var shopifyCartUri = [];
            var requestUrl = null;
            var response = null;

            if(typeof request.isFetch !='undefined'){
            type = "fetch";
            }

            if(type == 'fetch') {
                var shopify_lang_route = shopifylanguageRoute();
                shopifyCartUri = [
                    `${window.location.origin}${shopify_lang_route}cart/add.js`,
                    `${window.location.origin}${shopify_lang_route}cart/add`,
                    `${window.location.origin}${shopify_lang_route}cart/update.js`,
                    `${window.location.origin}${shopify_lang_route}cart/update`,
                    `${window.location.origin}${shopify_lang_route}cart/change.js`,
                    `${window.location.origin}${shopify_lang_route}cart/change`,
                    `${window.location.origin}${shopify_lang_route}cart/clear.js`,
                    `${window.location.origin}${shopify_lang_route}cart/clear`
                ]
                requestUrl = request.url;
                response = data;
                var readyState = 4;
            } else {
                shopifyCartUri = [
                    '/cart/add.js',
                    '/cart/add',
                    '/cart/update.js',
                    '/cart/update',
                    '/cart/change.js',
                    '/cart/change',
                    '/cart/clear.js',
                    '/cart/clear',
                ]
                requestUrl = request._url;
                var readyState = 0;
            }
                var checkInterval = setInterval(function() {
                    if (type == 'xhr') {
                    //  readyState = request.readyState;
                        requestUrl = request.url;
                        readyState = typeof request.xhr.readyState != "undefined" ? request.xhr.readyState : request.readyState;
                    }
                    if (readyState ==  4) {
                        clearInterval(checkInterval);
                        //if (shopifyCartUri.includes(requestUrl) && requestUrl != "/cart.js") {
                        if (shopifyCartUri.some(url => requestUrl.startsWith(url)) && requestUrl != "/cart.js") {
                            jQ224.ajax({
                                url: "/cart.js",
                                type: 'get',
                                dataType: 'json',
                                async: true,
                            }, "json")
                                .done(function(data){
                                    console.log("Poptin Data Checking: ", poptin)
                                    if (poptin.shopify_cart_trigger_action == "added_product" && poptin.shopify_cart_trigger_products != null) {
                                        //if((requestUrl == shopifyCartUri[0]) || (requestUrl == shopifyCartUri[1])) {
                                        if (requestUrl.startsWith(shopifyCartUri[0]) || requestUrl.startsWith(shopifyCartUri[1])) {
                                            if (type == 'xhr')  {
                                            //  response = JSON.parse(request.response);
                                                response = JSON.parse(typeof request.xhr.response != "undefined" ? request.xhr.response : request.response);
                                                response = response?.items?.[0] || response;
                                            }
                                            else{
                                                response = response?.items?.[0] || response;
                                            }
                                            if (poptin.shopify_cart_trigger_products == "any_product") {
                                                appendPoptin(poptin)
                                            } else if (poptin.shopify_cart_trigger_type == "specific_category") {

                                                var productId = response.product_id;
                                                jQ224.ajax({
                                                    url: api_link+"/api/display/shopify/check-product-collection/"+poptin.poptin_id,
                                                    type: 'POST',
                                                    data: {
                                                        product_id: productId,
                                                        is_variant: 0
                                                    },
                                                    success: function(result) {
                                                        if (result.belongs_to_collection) {
                                                            appendPoptin(poptin);
                                                        }
                                                    }
                                                });
                                            } else {
                                                var specifiedProductsArr = poptin.shopify_cart_trigger_products.split(',');
                                                var responseProductId = (response.variant_id.toString() || response.product_id.toString());
                                                if (specifiedProductsArr.includes(responseProductId)) {
                                                    appendPoptin(poptin)
                                                }
                                            }
                                        }
                                    } else if(poptin.shopify_cart_trigger_action == "removed_product") {
                                        if((requestUrl != shopifyCartUri[0]) && (request != shopifyCartUri[1])) {
                                            var oldCartProductIds = poptinCheckCookie('poptin_shopify_cart_product_id') ?
                                                poptinGetCookie('poptin_shopify_cart_product_id').split(',') : [];

                                            var newProductIds = [];
                                            jQ224.each(data.items, function(index,item) {
                                                newProductIds.push((item.variant_id.toString() || item.product_id.toString()));
                                            });

                                            if ((poptin.shopify_cart_trigger_products == "any_product") && (newProductIds.length < oldCartProductIds.length)) {
                                                appendPoptin(poptin);
                                            } else if((poptin.shopify_cart_trigger_products == "empty_cart") && (data.item_count < 1)) {
                                                appendPoptin(poptin);
                                            } else if (poptin.shopify_cart_trigger_type == "specific_category") {
                                                if (oldCartProductIds.length > 0) {
                                                    jQ224.each(oldCartProductIds, function(index, oldProductId) {
                                                        if (!newProductIds.includes(oldProductId)) {
                                                            jQ224.ajax({
                                                                url: api_link+"/api/display/shopify/check-product-collection/"+poptin.poptin_id,
                                                                type: 'POST',
                                                                data: {
                                                                    variant_id: oldProductId,
                                                                    is_variant: 1
                                                                },
                                                                success: function(result) {
                                                                    if (result.belongs_to_collection) {
                                                                        appendPoptin(poptin);
                                                                    }
                                                                }
                                                            });
                                                        }
                                                    });
                                                }
                                            } else {
                                                var oldCartProductIds = poptinCheckCookie('poptin_shopify_cart_product_id') ?
                                                    poptinGetCookie('poptin_shopify_cart_product_id').split(',') : [];

                                                if (oldCartProductIds.length > 0) {
                                                    jQ224.each(oldCartProductIds, function(index,OldproductId) {
                                                        if (!newProductIds.includes(OldproductId)) {
                                                            var specifiedRemovedProducts = poptin.shopify_cart_trigger_products.split(',');
                                                            if (specifiedRemovedProducts.includes(OldproductId)) {
                                                                appendPoptin(poptin);
                                                            }
                                                        }
                                                    });
                                                }
                                            }
                                        }
                                    } else if ((poptin.shopify_cart_trigger_action == "cart_item" || poptin.shopify_cart_trigger_action == "cart_value") &&
                                        poptin.shopify_cart_trigger_cart_spec_filter != null &&
                                        poptin.shopify_cart_trigger_cart_spec_value != null) {

                                        var cartSpecFilter = poptin.shopify_cart_trigger_cart_spec_filter;
                                        var cartSpecValue = poptin.shopify_cart_trigger_cart_spec_value;

                                        var cartItemOrValueCount = poptin.shopify_cart_trigger_action == "cart_item" ? data.item_count : (data.total_price / 100);

                                        switch (cartSpecFilter) {
                                            case 'greater_than':
                                                if(cartItemOrValueCount > cartSpecValue) {
                                                    appendPoptin(poptin);
                                                }
                                                break;
                                            case 'equal':
                                                if(cartItemOrValueCount == cartSpecValue) {
                                                    appendPoptin(poptin);
                                                }
                                                break;
                                            case 'greater_than_or_equal':
                                                if(cartItemOrValueCount >= cartSpecValue) {
                                                    appendPoptin(poptin);
                                                }
                                                break;
                                        }

                                    }

                                    //If the request was an ADD TO CART
                                    /*if((requestUrl == shopifyCartUri[0]) || (requestUrl == shopifyCartUri[1])) {
                                        var newAddedProductId = response.product_id.toString();
                                        var cartProductIds = poptinCheckCookie('poptin_shopify_cart_product_id') ?
                                            poptinGetCookie('poptin_shopify_cart_product_id').split(',') : [];
                                        if (!cartProductIds.includes(newAddedProductId)) {
                                            cartProductIds.push(newAddedProductId);
                                        }
                                        poptinSetCookie('poptin_shopify_cart_product_id', cartProductIds.join(','));
                                    }*/
                                    var newProductIds = [];
                                    jQ224.each(data.items, function(index,item) {
                                        newProductIds.push(item.variant_id.toString());
                                    });

                                    poptinSetCookie('poptin_shopify_cart_product_id', newProductIds.join(','));

                                })
                                .fail(function (xhr, status, error) {
                                    showLog('Cart Error');
                                });
                        }
                    }
                }, 100)

        }

        // Get IE Version
        function GetIEVersion() {
            var sAgent = window.navigator.userAgent;
            var Idx = sAgent.indexOf("MSIE");

            // If IE, return version number.
            if (Idx > 0) {
                return parseInt(sAgent.substring(Idx+ 5, sAgent.indexOf(".", Idx)));
            }

            // If IE 11 then look for Updated user agent string.
            else if (!!navigator.userAgent.match(/Trident\/7\./)) {
                return 11;
            }

            else {
                return 0; //It is not IE
            }
        }


        function setPoptinStyle(){
            // Set style per poptin and append to DOM
            // TODO: Move to poptin-style-he/en.css
            showLog('setPoptinStyle()');
            clearTimeout(poptinTimeDelayTrigger);
            poptinTimeDelayTrigger = null;
            //jQ224("#setPoptinStyle").remove();
            if(jQ224("#setPoptinStyle").length==0){
                poptin_style = '<style type="text/css" id="setPoptinStyle">.poptin-popup .close-x-button{min-height: initial;background-color:initial;}.draggable-container form{display:initial;background-color:initial;width: initial;height: initial;top: initial;position: initial;}.draggable-container:not(.poptin-tab-container) .draggable{border: none;}.draggable-container:not(.poptin-tab-container) .inputs-container input{background-image:none;background-color:#ffffff;background:#ffffff;border-radius:0px;}.empty-field{border:2px solid red !important}.empty-field::-webkit-input-placeholder{color:red;}.empty-field::-moz-placeholder{color:red;}.draggable-container:not(.poptin-tab-container) input, .draggable-container:not(.poptin-tab-container) button{background-image: none;padding: 0px;margin: 0px;box-sizing: border-box;-webkit-box-sizing: border-box;-moz-box-sizing: border-box;}.draggable-container:not(.poptin-tab-container) p{box-sizing: initial;-webkit-box-sizing: initial;-moz-box-sizing: initial;}.poptin-popup a{text-decoration: none;}.poptin-popup a:hover{text-decoration: underline;}</style>';
                if(user_lang == "he"){
                    poptin_style += '.draggable-container:not(.poptin-tab-container) p, .draggable-container:not(.poptin-tab-container) .inputs-container input{font-family: "Open Sans Hebrew !important";}';
                }
                jQ224("head").append(poptin_style);
            }


            // Add Animation Classes
            // ToDo: Keep Used Animated Classes
            var elAni = document.getElementById('poptin_animations');
            if (!elAni) {
                var poptin_animations ='';
                if(api_link.indexOf('dev')>=0){
                    if(jQ224("#poptin_animations_preload").length==0){
                        poptin_animations = '<link rel="preload" id="poptin_animations_preload" as="style"  href="'+css_link+'/css/poptin-animations.css?ver=10">';
                    }
                    if(jQ224("#poptin_animations").length==0){
                        poptin_animations+= '<link rel="stylesheet" type="text/css" id="poptin_animations" href="'+css_link+'/css/poptin-animations.css?ver=10"  defer>';
                    }
                } else {
                    if(jQ224("#poptin_animations_preload").length==0){
                        poptin_animations = '<link rel="preload" id="poptin_animations_preload" as="style"  href="'+cdn_server+'/css/poptin-animations.css?ver=10">';
                    }
                    if(jQ224("#poptin_animations").length==0){
                        poptin_animations+= '<link rel="stylesheet" type="text/css" id="poptin_animations" href="'+cdn_server+'/css/poptin-animations.css?ver=10"  defer>';
                    }
                }
                if(poptin_animations){
                    jQ224("head").append(poptin_animations);
                }
            }

        }

        /**
         * Trigger functions: poptinJsFilter()
         * Desc             : Return array of all browser js variables
         */
        function getAllJsVariables(){
            array = []
            for (var js_variable_name in this){
                if (jQ224.inArray(typeof this[js_variable_name],['number','string','boolean']) > -1)
                    array.push({key:js_variable_name,value: String(this[js_variable_name])}) ;
            }
            return array;
        }

        /**
         * Trigger functions: appendPoptin()
         * parameters       : poptin:object | click:Boolean -> (if poptin click trigger)
         * Desc             : If js in the rules -> Show poptin
         */
        function poptinJsFilter(poptin,click){

            // If cookies filter is active
            if (poptin.js_filter.display_if_specific_js_active){

                // Get all browser js variables
                $js_array = getAllJsVariables();

                $result_array = [];

                // If browser js variables is availbe
                if ($js_array.length > 0){

                    // For each js variable filter rule that tha poptin have
                    jQ224.each(poptin.js_filter.display_if_specific_js,function(index){

                        // Check if paramter are set
                        if (this.js_name_pair.length > 0 &&  this.js_value_pair.length > 0 && this.js_show_pair.length >0 ){

                            // Parse and set parameters
                            $js_name_role_pair  = this.js_name_pair.split('|:|');
                            $js_name_role       = $js_name_role_pair[0] != undefined ? $js_name_role_pair[0]: "";
                            $js_name_value      = $js_name_role_pair[1] != undefined ? $js_name_role_pair[1]: "";

                            $js_value_role_pair = this.js_value_pair.split('|:|');
                            $js_value_role      = $js_value_role_pair[0] != undefined ? $js_value_role_pair[0]: "";
                            $js_value_value     = $js_value_role_pair[1] != undefined ? $js_value_role_pair[1]: "";

                            $js_show_value      = this.js_show_pair;

                            if (window.Function("return typeof " + $js_name_value)() !== "undefined"){
                                if ($js_name_value.indexOf('.')>-1){ // type of Objact
                                    $js_name        = true;
                                    $js_value       = jsFilterCheckIfInRoles($js_value_role,window.Function("return " + $js_name_value)(),$js_value_value);
                                    $result_array.push({'rule':($js_name && $js_value), 'show':$js_show_value});
                                }else if (jQ224.inArray(window.Function("return typeof " + $js_name_value)(),['number','string','boolean']) > -1){
                                    jQ224.each($js_array,function(index){
                                        $js_name        = jsFilterCheckIfInRoles($js_name_role,this.key,$js_name_value);
                                        $js_value       = jsFilterCheckIfInRoles($js_value_role,this.value,$js_value_value);

                                        // If  js variable filter - save
                                        //if ($c_name && $c_value)
                                        $result_array.push({'rule':($js_name && $js_value), 'show':$js_show_value});
                                    })
                                }else if (window.Function("typeof "+$js_name_value)() == "object"){
                                    $js_name        = true;
                                    $js_value       = jsFilterCheckIfInRoles($js_value_role,JSON.stringify(window.Function("return typeof " + $js_name_value)()),$js_value_value);
                                    // If  js variable filter - save
                                    //if ($c_name && $c_value)
                                    $result_array.push({'rule':($js_name && $js_value), 'show':$js_show_value});
                                }

                            }else{
                                // Check  js variables filter against website js variables
                                jQ224.each($js_array,function(index){
                                    $js_name        = jsFilterCheckIfInRoles($js_name_role,this.key,$js_name_value);
                                    $js_value       = jsFilterCheckIfInRoles($js_value_role,this.value,$js_value_value);

                                    // If  js variable filter - save
                                    //if ($c_name && $c_value)
                                    $result_array.push({'rule':($js_name && $js_value), 'show':$js_show_value});
                                })
                            }
                        }
                    })

                    //showLog($result_array);

                    // If cookie filter array - check for can show or not
                    if ($js_array.length > 0){

                        $flag       = false;
                        $dont_show  = false;

                        // showLog($result_array)
                        // if dont_show exist
                        jQ224.each($result_array,function(index){
                            if (this.rule && this.show == 'dont_show'){
                                $flag       = false;
                                $dont_show  = true;
                                return false;
                            }else{
                                $flag       = true;
                            }

                        })

                        if (!$dont_show){
                            jQ224.each($result_array,function(index){
                                if (this.rule && this.show == 'show'){
                                    $flag = true;
                                    return false;
                                }else if(this.show == 'show'){
                                    $flag = false;
                                }
                            })
                        }
                        // 'show' exist
                        return $flag;

                    }else{
                        return false;
                    }
                }else{
                    return false;
                }
            }else{
                return true;
            }
        }

        /**
         * Trigger functions: appendPoptin()
         * parameters       : poptin:object | click:Boolean -> (if poptin click trigger)
         * Desc             : If cookies in the rules -> Show poptin
         */
        function poptinCookiesFilter(poptin,click){
            // If cookies filter is active
            if (poptin.cookie_filter.display_if_specific_cookie_active){

                // Get all browser cookies
                $cookies_array = getAllCookies();

                $result_array = [];

                // If browser cookie is availbe
                if ($cookies_array.length > 0){

                    // For each cookie filter rule that tha poptin have
                    jQ224.each(poptin.cookie_filter.display_if_specific_cookie,function(index){

                        // Check if paramter are set
                        if (this.cookie_name_pair.length > 0 &&  this.cookie_value_pair.length > 0 && this.cookie_show_pair.length >0 ){

                            // Parse and set parameters
                            $cookie_name_role_pair  = this.cookie_name_pair.split('|:|');
                            $cookie_name_role       = $cookie_name_role_pair[0] != undefined ? $cookie_name_role_pair[0]: "";
                            $cookie_name_value      = $cookie_name_role_pair[1] != undefined ? $cookie_name_role_pair[1]: "";

                            $cookie_value_role_pair = this.cookie_value_pair.split('|:|');
                            $cookie_value_role      = $cookie_value_role_pair[0] != undefined ? $cookie_value_role_pair[0]: "";
                            $cookie_value_value     = $cookie_value_role_pair[1] != undefined ? $cookie_value_role_pair[1]: "";

                            $cookie_show_value      = this.cookie_show_pair;

                            // Check cookie filter against website cookies
                            jQ224.each($cookies_array,function(index){

                                $c_name         = cookiesFilterCheckIfInRoles($cookie_name_role,this.key,$cookie_name_value);
                                $c_value        = cookiesFilterCheckIfInRoles($cookie_value_role,this.value,$cookie_value_value);
                                // If cookie filter - save
                                //if ($c_name && $c_value)
                                $result_array.push({'rule':($c_name && $c_value), 'show':$cookie_show_value});
                            })
                        }
                    })

                    // showLog($result_array);

                    // If cookie filter array - check for can show or not
                    if ($cookies_array.length > 0){

                        $flag       = false;
                        $dont_show  = false;

                        // showLog($result_array)
                        // if dont_show exist
                        jQ224.each($result_array,function(index){
                            if (this.rule && this.show == 'dont_show'){
                                $flag       = false;
                                $dont_show  = true;
                                return false;
                            }else{
                                $flag       = true;
                            }

                        })

                        if (!$dont_show){
                            jQ224.each($result_array,function(index){
                                if (this.rule && this.show == 'show'){
                                    $flag = true;
                                    return false;
                                }else if(this.show == 'show'){
                                    $flag = false;
                                }
                            })
                        }
                        // 'show' exist
                        return $flag;

                    }else{
                        return false;
                    }
                }else{
                    return false;
                }
            }else{
                return true;
            }
        }

        function cookiesFilterCheckIfInRoles($role,$father,$son){

            $flag = false;
            if ($role != ""){
                switch ($role) {
                    case 'contain':
                        $flag = $father.indexOf($son) > -1 ;
                        break;
                    case 'exact':
                        $flag = ($father==$son);
                        break;
                    case 'start':
                        $flag = $father.startsWith($son);
                        break;
                    case 'end':
                        $flag = $father.endsWith($son);
                        break;
                    case 'greater_than':
                        $flag = parseFloat($father) > parseFloat($son);
                        break;
                    case 'less_than':
                        $flag = parseFloat($father) < parseFloat($son);
                        break;
                    case 'any_value':
                        $flag = true;
                        break;
                    default:
                        return true;
                }
            }
            return $flag;
        }

        function jsFilterCheckIfInRoles($role,$father,$son){

            $flag = false;
            $father = $father=="[]" ? "" : String($father).toLowerCase()
            $son    = $son=="[]" ? "" : String($son).toLowerCase()
            if ($role != ""){
                switch ($role) {
                    case 'contain':
                        $flag = $father.indexOf($son) > -1 ;
                        break;
                    case 'exact':
                        $flag = ($father==$son);
                        break;
                    case 'start':
                        $flag = $father.startsWith($son);
                        break;
                    case 'end':
                        $flag = $father.endsWith($son);
                        break;
                    case 'greater_than':
                        $flag = parseFloat($father) > parseFloat($son);
                        break;
                    case 'less_than':
                        $flag = parseFloat($father) < parseFloat($son);
                        break;
                    case 'any_value':
                        $flag = true;
                        break;
                    default:
                        return true;
                }
            }
            return $flag;
        }
        /*function getTabPosition(poptin,location,id){
            var poptin_selector=jQ224(id);
                var tab_ohtm = jQ224('#poptinDraggableContainer-tab').get(0).outerHTML;
                var tab_ohtm_new = tab_ohtm.replace('display: block !important;','display: block !important;'),
                tabshow= jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").attr("data-tabshow");

                    jQ224('#poptinDraggableContainer-tab').remove();
                    jQ224('body').append(tab_ohtm_new);
                    jQ224("#poptinDraggableContainer-tab").find('.draggable').each(function(e){
                        jQ224(this).get(0).style.setProperty('position','absolute');
                        jQ224(this).get(0).style.setProperty('cursor','pointer');
                        jQ224(this).find('.fr-box').css('position','relative');
                    });

                    jQ224("#poptinDraggableContainer-tab").css("cursor","pointer");

                    jQ224("#poptinDraggableContainer-tab").attr("data-load-poptin",poptin.poptin_id);

                jQ224("#poptinDraggableContainer-tab:not(#closeTabXButton)").on("click",function(){
                    if(jQ224("#poptinDraggableContainer-tab").is(":visible")){
                        showEffect(poptin);
                    }
                });
        }
        function generatePoptinTab(poptin){
            var tab_id="#poptinDraggableContainer-tab",
            tab_location= jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").attr("data-poptin-tablocation"),
            tabshow= jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").attr("data-tabshow");
            getTabPosition(poptin,tab_location,tab_id);
        } */

        function extractTeaser(poptin,fshow){
            //is_teasers_on
            var ct_jt_check= false;
            var isMobileContainerAvailable =false;
            if(poptin.display){
                if (poptinCookiesFilter(poptin,false) && poptinJsFilter(poptin,false) && EngagementWithOtherPoptins(poptin)){
                    ct_jt_check = true;
                }
            }
            showLog('fshow:'+fshow);

            if (poptin.is_teasers_on && poptin.display && ct_jt_check){
                showLog("extractTeaser");
                if (poptin.poptin == ''){
                    jQ224.when( jQ224.ajax(poptin.poptin_url)).then(function( data, textStatus, jqXHR ) {
                        poptin.poptin = data
                        poptin_data = poptin.poptin == '' ? window.all_poptins[poptin.poptin_id].poptin : poptin.poptin;
                        var tab_ohtm = jQ224(poptin.poptin).find('#poptinDraggableContainer-tab').get(0).outerHTML;
                        var temp_html_teaser = tab_ohtm.replace('id="poptinDraggableContainer-tab"', 'id="poptinDraggableContainer-tab" data-load-poptin="' + poptin.poptin_id + '"');
                        var font_style_css =  jQ224(poptin.poptin).find(".poptin-custom-font").get(0).outerHTML;
                        jQ224('body').append(font_style_css);
                        var stop_show_conv_user = poptin.stop_showing_to_converted_users,
                            check_conversion_cookie = poptinGetCookie('poptin_conversion_' + poptin.poptin_id),
                            loadTeaser = true;
                            // isMobileContainerAvailable = (jQ224(poptin.poptin).find("#poptinMobileContainer").length) ? 1 : 0;
                            isMobileContainerAvailable = poptin.design_properties.switch_mobile_editor;




                        if (stop_show_conv_user == 1 && check_conversion_cookie != "") {
                        loadTeaser = false;
                        }

                        if(poptin.x_close_button == 0 && poptinGetCookie('poptin_c_p_o_x_c_' + poptin.poptin_id) && poptin.d_f_r=='all@display_everytime_everypage_5') {
                            loadTeaser = false;
                        }
                        if(landing_page_teaser_on && typeof poptin_landing_page!='undefined'){
                            loadTeaser = true;
                        }


                        if (isTabEnable(poptin) && loadTeaser) {
                            var fcheck = typeof jQ224(poptin.poptin).attr("data-tabshow")!='undefined' ? jQ224(poptin.poptin).attr("data-tabshow"): 'always';
                            var popup_view_check = hasSeenAPoptin(poptin);
                        if(landing_page_teaser_on==1){
                            popup_view_check = false;
                        }
                        if(fcheck == 'after_close' && landing_page_teaser_on==1){
                            fshow = 1;
                        }

                        if (fcheck == 'always') {
                            loadPoptinTeaser(fshow, poptin, temp_html_teaser,isMobileContainerAvailable);
                        } // else if(fcheck=='before_show' && (popup_view_check==null || popup_view_check==0)){
                        else if (fcheck == 'before_show') {
                            // Show teaser before this page's popup; hide-on-show + no close restore enforce "only before"
                            loadPoptinTeaser(fshow, poptin, temp_html_teaser,isMobileContainerAvailable);
                        } else if (fcheck == 'after_close' && fshow == 1) {
                                if (landing_page_teaser_on == 1) {
                                    showPoptinOnClick(poptin.poptin_id);
                                }else{
                                loadPoptinTeaser(fshow, poptin, temp_html_teaser,isMobileContainerAvailable);
                                }
                        }
                        }
                    },function( data, textStatus, jqXHR) {
                    });

                }else{

                    poptin_data = (poptin.poptin == '' ? window.all_poptins[poptin.poptin_id].poptin : poptin.poptin);
                    var tab_ohtm = jQ224(poptin.poptin).find('#poptinDraggableContainer-tab').get(0).outerHTML;
                    var temp_html_teaser=tab_ohtm.replace('id="poptinDraggableContainer-tab"', 'id="poptinDraggableContainer-tab" data-load-poptin="'+poptin.poptin_id+'"');
                    var font_style_css =  jQ224(poptin.poptin).find(".poptin-custom-font").get(0).outerHTML;
                    jQ224('body').append(font_style_css);

                    var stop_show_conv_user = poptin.stop_showing_to_converted_users,
                    check_conversion_cookie= poptinGetCookie('poptin_conversion_' + poptin.poptin_id),
                    loadTeaser=true;
                    // isMobileContainerAvailable = (jQ224(poptin.poptin).find("#poptinMobileContainer").length) ? 1 : 0;
                    isMobileContainerAvailable = poptin.design_properties.switch_mobile_editor;


                    if(stop_show_conv_user==1 && check_conversion_cookie!=""){
                        loadTeaser=false;
                    }
                    if(poptin.x_close_button==0 && poptinGetCookie('poptin_c_p_o_x_c_' + poptin.poptin_id) && poptin.d_f_r=='all@display_everytime_everypage_5'){
                        loadTeaser=false;
                    }
                    if (landing_page_teaser_on && typeof poptin_landing_page != 'undefined') {
                        loadTeaser = true;
                    }
                    if(isTabEnable(poptin)  && loadTeaser){
                        var fcheck = typeof jQ224(poptin.poptin).attr("data-tabshow")!='undefined' ? jQ224(poptin.poptin).attr("data-tabshow"): 'always';
                        var popup_view_check = hasSeenAPoptin(poptin);
                        if(landing_page_teaser_on==1){
                            popup_view_check = false;
                        }
                        if(fcheck == 'after_close' && landing_page_teaser_on==1){
                            fshow = 1;
                        }

                        if(fcheck=='always'){
                            loadPoptinTeaser(fshow,poptin,temp_html_teaser,isMobileContainerAvailable);
                        }
                        // else if(fcheck=='before_show' && (popup_view_check==null || popup_view_check==0)){
                        else if(fcheck=='before_show') {
                            // Show teaser before this page's popup; hide-on-show + no close restore enforce "only before"
                            loadPoptinTeaser(fshow,poptin,temp_html_teaser,isMobileContainerAvailable);
                        }
                        else if (fcheck == 'after_close' && fshow==1) {
                            isMobileContainerAvailable = isMobileContainerAvailableObj[poptin.poptin_id]  ? 1 : 0;
                            loadPoptinTeaser(fshow, poptin, temp_html_teaser,isMobileContainerAvailable);
                        }


                    }

                }
            }

        }

        function hideTeaserOnPopupShow(poptin){
            if (poptinTeaserShowTimeout[poptin.poptin_id] !== undefined) {
                clearTimeout(poptinTeaserShowTimeout[poptin.poptin_id]);
                delete poptinTeaserShowTimeout[poptin.poptin_id];
            }
            if (typeof jQ224(".poptin-popup[data-poptin-id=" + poptin.poptin_id + "]").attr("data-hastab") != "undefined" && jQ224(".poptin-popup[data-poptin-id=" + poptin.poptin_id + "]").attr("data-hastab") == 1) {
                jQ224('#poptinDraggableContainer-tab[data-load-poptin="'+ poptin.poptin_id +'"]').addClass("popup-loaded");
                showTeaserEffect(poptin, 'exit');
            }

        }

        function animateTab(poptin){
            var teaser_selector = '#poptinDraggableContainer-tab[data-load-poptin="'+ poptin.poptin_id +'"]';
            var poptinTab = jQ224(teaser_selector);
            if(typeof jQ224(poptin.poptin).attr("data-tabeffect")!== "undefined"){
            if(poptinTab.attr("data-poptin-animate") != null && poptinTab.attr("data-poptin-animate")!=''){
                if(poptinAnimateTab[poptin.poptin_id] !== undefined) {
                    clearInterval(poptinAnimateTab[poptin.poptin_id]);
                }
                poptinAnimateTab[poptin.poptin_id] = setInterval(function(){
                    var tabAnimate = poptinTab.attr("data-poptin-animate");
                    poptinTab.toggleClass("no-animated");
                    poptinTab.toggleClass('poptin__animated animate__'+tabAnimate);
                    //    console.log("data-poptin-animate",tabAnimate);
                }, 3000);
            }else{
                    jQ224(teaser_selector).get(0).style.setProperty('display','block','important');
            }
            }
        }

        function loadPoptinTeaser(fshow,poptin,teaser_html,isMobileContainerAvailable){
            var tab_id = "#poptinDraggableContainer-tab",
            this_pop = poptin.poptin,
            this_pop = this_pop.trim(),
            tabshow = jQ224(poptin.poptin).attr("data-tabshow"),
            tab_variations = JSON.parse(jQ224(this_pop).find(" #tab_variations_hidden").val()),
            teaser_mobile_view_type = jQ224(this_pop).attr("data-teaser-mobile-view"),
            teaser_desktop_view_type = jQ224(this_pop).attr("data-teaser-desktop-view"),
            mobile_view_teaser_html = tab_variations[teaser_mobile_view_type + "-mobile"];
            //Making sure its getting teaser atribute values

            if(typeof teaser_mobile_view_type == 'undefined' && poptin.poptin_type != "mobile" && isMobileContainerAvailable){
                this_pop =  jQ224(this_pop).get(1).outerHTML;
                teaser_mobile_view_type = jQ224(this_pop).attr("data-teaser-mobile-view");
                mobile_view_teaser_html = tab_variations[teaser_mobile_view_type + "-mobile"];
            }
            var teaser_selector = '#poptinDraggableContainer-tab[data-load-poptin="'+ poptin.poptin_id +'"]';
            // showLog("tab_variations:"+tab_variations);
            // showLog("teaser_mobile_view_type:"+teaser_mobile_view_type);
            // showLog("teaser_desktop_view_type:"+teaser_desktop_view_type);
            // showLog("mobile_view_teaser_html:"+mobile_view_teaser_html);
            jQ224(this_pop + "#poptinMobileContainer-tab").remove();
            jQ224(this_pop + "#poptinDesktopContainer-tab").remove();
            if (ifMobilePoptin && poptin.poptin_type != "mobile" && isMobileContainerAvailable) {
                mobile_view_teaser_html = mobile_view_teaser_html.replace('id="poptinDraggableContainer-tab"', 'id="poptinDraggableContainer-tab" data-load-poptin="' + poptin.poptin_id + '"');
                mobile_view_teaser_html = mobile_view_teaser_html.replace('onclick="closeTabPoptinOnXclick();"', "onclick=\"closeTabPoptinOnXclick(this,'" + poptin.poptin_id + "');\"");

                if (jQ224(teaser_selector).length > 0) {
                    jQ224(teaser_selector).remove();
                }
                jQ224("body").append(mobile_view_teaser_html);

            } else {
                teaser_html = teaser_html.replace('onclick="closeTabPoptinOnXclick();"', "onclick=\"closeTabPoptinOnXclick(this,'" + poptin.poptin_id + "');\"");
                //showLog('teaser_html:'+teaser_html);
                if (jQ224(teaser_selector).length > 0) {
                    jQ224(teaser_selector).remove();
                }

                jQ224("body").append(teaser_html);
            }
            cssFixTeasers(poptin);

            jQ224(teaser_selector).css('cursor', "pointer");
            jQ224(teaser_selector+' .handle-icon').remove();
            jQ224(teaser_selector+' .pos-helper').remove();
            jQ224(teaser_selector+' .handle-icon-wrapper').remove();
            jQ224(teaser_selector).attr('data-load-poptin', poptin.poptin_id);
            // jQ224(teaser_selector).find('[contenteditable="true"]').removeAttr("contenteditable");
            jQ224(teaser_selector).find('[contenteditable="true"]').prop("contenteditable", false);
            var tab_location = jQ224(teaser_selector).attr("data-poptin-tablocation");
            jQ224(teaser_selector).get(0).style.setProperty('position', 'fixed', 'important');
            jQ224(teaser_selector).get(0).style.setProperty('z-index', '999998', 'important');

            jQ224(teaser_selector).find('.draggable').each(function(e){
                jQ224(this).get(0).style.setProperty('position','absolute');
                jQ224(this).get(0).style.setProperty('cursor','pointer');
                jQ224(this).find('.fr-box').css('position','relative');
            });

            jQ224(teaser_selector).css("cursor","pointer");
            jQ224(teaser_selector).get(0).style.setProperty('display', 'none');
            jQ224(teaser_selector).get(0).style.setProperty('opacity', '1');


            // if (tabshow == 'always') {
            //     showTeaserEffect(poptin, 'entry');
            // }
            if (poptinTeaserShowTimeout[poptin.poptin_id] !== undefined) {
                clearTimeout(poptinTeaserShowTimeout[poptin.poptin_id]);
            }
            // before_show: show immediately so teaser wins the race vs short/0s popup triggers
            var teaserEntryDelay = (tabshow === 'before_show') ? 0 : 500;
            poptinTeaserShowTimeout[poptin.poptin_id] = setTimeout(() => {
                delete poptinTeaserShowTimeout[poptin.poptin_id];
                var $teaser = jQ224(teaser_selector);
                if (!$teaser.length || $teaser.hasClass('popup-loaded') ||
                    jQ224(".poptin-popup.poptin-live[data-poptin-id=" + poptin.poptin_id + "]").length) {
                    return;
                }
                if(jQ224(teaser_selector+' #closeTabXButton').length>0){
                    jQ224(teaser_selector+' #closeTabXButton').get(0).style.setProperty('z-index', '99', 'important');
                }
                animateTab(poptin);
                showTeaserEffect(poptin, 'entry');
            }, teaserEntryDelay);

            jQ224('#poptinDraggableContainer-tab[data-load-poptin="'+ poptin.poptin_id +'"]:not(#closeTabXButton),#poptinDraggableContainer-tab[data-load-poptin="'+ poptin.poptin_id +'"]:not(#poptinFormCloseText)').on("click",function(event){
                if(jQ224('#poptinDraggableContainer-tab[data-load-poptin="'+ poptin.poptin_id +'"]').is(":visible") && jQ224(event.target).attr("class")!='close-icon'){
                    if(jQ224('#poptinDraggableContainer-tab[data-load-poptin="'+ poptin.poptin_id +'"]').hasClass('triangleTab')){
                        jQ224('#poptinDraggableContainer-tab[data-load-poptin="'+ poptin.poptin_id +'"]').hide();
                    }
                    var popup_check = jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]");
                    jQ224('#poptinDraggableContainer-tab[data-load-poptin="'+ poptin.poptin_id +'"]').removeClass('poptin__animated');
                    if(popup_check.length==0){
                        showPoptinOnClick(poptin.poptin_id, true, poptin);
                    }else{
                        showEffect(poptin);
                    }
                }
            });
        }

        function cssFixTeasers(poptin){
            var teaser_selector = '#poptinDraggableContainer-tab[data-load-poptin="'+ poptin.poptin_id +'"]';

            jQ224("[data-load-poptin="+poptin.poptin_id+"] .froala-image-wrapper").each(function(){
                jQ224(this).find('img').css("width",jQ224(this).css("width"));
                jQ224(this).find('img').css("height",jQ224(this).css("height"));
                jQ224(this).find('img').attr("alt",poptin.poptin_name);
            });


            jQ224(teaser_selector).find('p, span, div:not(.poptin-credit), button, label, ul, ol, li, img, strong, i').each(function(e){
                var css_string_teasers = '';
                jQ224.each(this.attributes, function($this) {
                    if(this.specified) {
                        if (this.name == 'style') {
                            css_string_teasers = this.value;
                            css_string_teasers = css_string_teasers.replace(/ ?!important/g,'');
                            css_string_teasers = css_string_teasers.replace(/\;base64/g,':base64');
                            css_string_teasers = css_string_teasers.replace(/\;/g,' !important;');
                            css_string_teasers = css_string_teasers.replace(/\:base64/g,';base64');
                            // Download font file from google
                            if (this.value.indexOf('font-family') !==-1){
                                try{
                                    getFont(this.value);
                                }catch(err){
                                    showLog(err);
                                }
                            }
                        }
                    }
                });
                jQ224(this).attr('style',css_string_teasers);

            });

        }

        function showTeaserEffect(poptin, etype){

            var this_effect_poptin_teaser_selector = jQ224('#poptinDraggableContainer-tab[data-load-poptin="'+ poptin.poptin_id +'"]');

            if(this_effect_poptin_teaser_selector.length){
                var teaser_entry_effect="entry_effect-up";
                var teaser_exit_effect="exit_effect-none";
                this_effect_poptin_teaser_selector.removeClass('poptin__animated');
                var teaser_effect="";

            if(etype=='entry'){
                teaser_effect = (typeof jQ224(this_effect_poptin_teaser_selector).attr("data-teaser-entry")!= 'undefined') ? jQ224(this_effect_poptin_teaser_selector).attr("data-teaser-entry") : "entry_effect-up";
            }else{
                teaser_effect = (typeof jQ224(this_effect_poptin_teaser_selector).attr("data-teaser-exit")!= 'undefined') ? jQ224(this_effect_poptin_teaser_selector).attr("data-teaser-exit") : "exit_effect-none";
            }

                //"effect": effects from animate.css
                //"speed": animation speed(default = 1s; slow = 2s; slower = 3s; fast = 800 ms; faster = 500 ms)
                //"delay": animation delay(default = 0 seconds; 1s = 1 seconds; 2s = 2 seconds; 3s = 3 seconds; 4s = 4 seconds; 5s = 5 seconds)
                var animateClass = {"effect":null, "speed":"_default", "delay":"-default"};
                var selectedEffect = teaser_effect.split('-')[1];


                switch(selectedEffect){
                    case "none" :
                        animateClass.effect = "_none";
                        break;
                    case "up" :
                        animateClass.effect = "_slideInDown";
                        break;
                    case "down" :
                        animateClass.effect = "_slideInUp";
                        break;
                    case "left" :
                        animateClass.effect = "_slideInLeft";
                        break;
                    case "right" :
                        animateClass.effect = "_slideInRight";
                        break;
                    case "blind" : //Removed Fold EntryEffect
                        animateClass.effect = "_flipInX";
                        break;
                    case "bounce" :
                        animateClass.effect = "_bounceIn";
                        break;
                    case "clip" :
                        animateClass.effect = "_zoomIn";
                        break;
                    case "explode" : //Removed Puzzle EntryEffect
                        animateClass.effect = "_fadeIn";
                        break;
                    case "fade" :
                        animateClass.effect = "_fadeIn";
                        break;
                    case "fold" :
                        animateClass.effect = "_flipInX";
                        break;
                    case "highlight" :
                        animateClass.effect = "_tada";
                        break;
                    case "puff" :
                        animateClass.effect = "_pulse";
                        break;
                    case "pulsate" :
                        animateClass.effect = "_flash";
                        break;
                    case "scale" :
                        animateClass.effect = "_heartBeat";
                        break;
                    case "shake" :
                        animateClass.effect = "_shakeX";
                        break;
                    case "size" : //Removed Resize EntryEffect
                        animateClass.effect = "_zoomIn";
                        break;
                    case "scale-out" :
                        animateClass.effect = "_zoomIn";
                        break;
                }

                var drag_cont = this_effect_poptin_teaser_selector;

                if( etype == "exit" ){
                    var exitOut = animateClass.effect;
                    animateClass.effect = exitOut.replace("In","Out");
                    jQ224(this_effect_poptin_teaser_selector).addClass('poptin__animated');
                    if( animateClass.effect.indexOf('slide') !== -1  ){
                        jQ224(this_effect_poptin_teaser_selector).addClass('animate__faster');
                    }
                    jQ224(this_effect_poptin_teaser_selector).addClass('animate_'+animateClass.effect);

                }else{

                    try{
                        showLog('Entry Animate');
                        jQ224(this_effect_poptin_teaser_selector).addClass('poptin-visible poptin__animated');
                        if( animateClass.effect.indexOf('slide') !== -1  ){
                            jQ224(this_effect_poptin_teaser_selector).addClass('animate__faster');
                        }
                        jQ224(this_effect_poptin_teaser_selector).addClass('animate_'+animateClass.effect);
                        jQ224(this_effect_poptin_teaser_selector).css({"display": "block"});

                    }catch(err){
                        showLog('Entry Animate err3');
                        jQ224(this_effect_poptin_teaser_selector).addClass('poptin-visible poptin__animated');
                        if( animateClass.effect.indexOf('slide') !== -1  ){
                            jQ224(this_effect_poptin_teaser_selector).addClass('animate__faster');
                        }
                        jQ224(this_effect_poptin_teaser_selector).css({"display": "block"});
                    }


                }

                // Remove animation classes after 1sec
                setTimeout(function(){
                    jQ224(this_effect_poptin_teaser_selector).removeClass('poptin__animated');
                    jQ224(this_effect_poptin_teaser_selector).removeClass (function (index, className) {
                        return (className.match (/\banimate_\S+/g) || []).join(' ');
                    });
                    if( etype == "exit" ){
                        jQ224(this_effect_poptin_teaser_selector).css({"display": "none"});
                    }
                    if( etype == "entry" && jQ224(this_effect_poptin_teaser_selector).is(":hidden") &&
                        !jQ224(this_effect_poptin_teaser_selector).hasClass('popup-loaded')){
                        jQ224(this_effect_poptin_teaser_selector).addClass('poptin__animated');
                        showLog("animateClass.effect:"+animateClass.effect);
                        jQ224(this_effect_poptin_teaser_selector).addClass('animate_'+animateClass.effect);
                        jQ224(this_effect_poptin_teaser_selector).css({"display": "block"});
                    }

                },1000);
            }
        }




        function removeTabhtml(poptin){
            jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] #poptinMobileContainer-tab").remove();
            jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] #poptinDesktopContainer-tab").remove();
            jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] #poptinDraggableContainer-tab").remove();
        }



        function appendPoptin(poptin,click){

            showLog('Adblock trigger:'+poptin.display_if_adblock_active);

            if (poptin.display_if_adblock_active == "yes"){
                jQ224.when(jQ224.getScript("https://display.popt.in/js/webads.js")).then(function() { }).fail( appendPoptinInternal );
            }else {
                appendPoptinInternal();
            }

            function appendPoptinInternal() {
                showLog('appendPoptin');
                showLog('appendPoptin:' +click);
                showLog('poptin.poptin_type:' +poptin.poptin_type);



                if (click!=undefined){

                    if (poptin.poptin == '' && window.all_poptins[poptin.poptin_id].poptin == ''){
                        jQ224.when( jQ224.ajax(poptin.poptin_url)).then(function( data, textStatus, jqXHR ) {
                            // showLog('appendPoptin ajax:' +data);
                            poptin.poptin = data;
                            if (poptin.poptin_type == 'embedded') {
                                var poptin_container_form = jQ224(".poptin-embedded[data-id='" + poptin.poptin_id + "']");
                                poptin_container_form.append(poptin.poptin);
                            } else {
                                jQ224("body").append(poptin.poptin);
                            }
                            window.poptins[poptin.poptin_id].poptin        = poptin.poptin;
                            window.all_poptins[poptin.poptin_id].poptin    = poptin.poptin;
                            setPoptin(poptin, click)
                        },function( data, textStatus, jqXHR) {
                            showLog(data);
                        });
                    }else{
                        poptin_data = (poptin.poptin == '' ? window.all_poptins[poptin.poptin_id].poptin : poptin.poptin);
                        if (poptin.poptin_type == 'embedded') {
                            var poptin_container_form = jQ224(".poptin-embedded[data-id='" + poptin.poptin_id + "']");
                            poptin_container_form.append(poptin.poptin);
                        } else {
                            jQ224("body").append(poptin.poptin);
                        }
                        window.poptins[poptin.poptin_id].poptin = poptin.poptin;
                        setPoptin(poptin, click)
                    }

                }else{

                    if (poptinCookiesFilter(poptin,click) && poptinJsFilter(poptin,click)){

                        if (poptin.poptin == '' && window.all_poptins[poptin.poptin_id].poptin == ''){
                            jQ224.when( jQ224.ajax(poptin.poptin_url)).then(function( data, textStatus, jqXHR ) {
                                // Do notting
                                // showLog(data);
                                poptin.poptin = data
                                window.all_poptins[poptin.poptin_id].poptin = data;
                                PQ.checkQueue(poptin,click);
                            },function( data, textStatus, jqXHR) {
                                showLog(data);
                                //monitorError('appendPoptin()->error()','Error get poptin from cloudfront',textStatus,jqXHR.responseText,poptin);
                            });
                        }else{
                            poptin.poptin = (poptin.poptin == '' ? window.all_poptins[poptin.poptin_id].poptin : poptin.poptin);
                            PQ.checkQueue(poptin,click)
                        }
                    }
                }
            }
        }

        function hasSeenAPoptin(poptin){
            return poptinCheckCookie('poptin_o_a_d_'+poptin.poptin_id);
        }

        function hasNotSeenAPoptin(poptin){
            return !poptinCheckCookie('poptin_o_a_d_'+poptin.poptin_id);
        }

        function hasClosedAPoptin(poptin) {
            return poptinCheckCookie('poptin_c_p_o_x_c_'+poptin.poptin_id);
        }

        function hasConvertedAPoptin(poptin) {
            return poptinCheckCookie('poptin_conversion_' + poptin.poptin_id);
        }

        function EngagementWithOtherPoptins(poptin)
        {
            var flag = true;

            if ((!poptin.engagement_with_other_poptin_filter_active) || (poptin.engagement_with_other_poptin_filter == null)) {
                return true;
            }


            var explode = poptin.engagement_with_other_poptin_filter.split('|');

            // show || dont_show
            var showValue = explode ? explode[0] : false;

            // seen_poptin || not_seen || closed || converted
            var conditionOne = explode ? explode[1] : false;

            // seen_poptin || popup || form
            var conditionTwo = explode ? explode[2] : false;

            // any ||  window.all_poptins
            var conditionThree = explode ? explode[3] : false;

            var clientPoptins = [];
            if (conditionTwo == "embedded") {
                jQ224.each(window.all_poptins, function(key, index) {
                    if (poptin.poptin_id != this.poptin_id) {
                        if (this.poptin_type == "embedded") {
                            if (conditionThree != "any") {
                                if (this.poptin_id == conditionThree) {
                                    clientPoptins.push(this)
                                }
                            } else {
                                clientPoptins.push(this)
                            }
                        }
                    }
                });
            } else {
                jQ224.each(window.all_poptins, function(key, index) {
                    if (poptin.poptin_id != this.poptin_id) {
                        if (this.poptin_type != "embedded") {
                            if (conditionThree != "any") {
                                if (this.poptin_id == conditionThree) {
                                    clientPoptins.push(this)
                                }
                            } else {
                                clientPoptins.push(this)
                            }
                        }
                    }
                });
            }

            var conditionMet = false;

            if (clientPoptins.length > 0) {
                switch (conditionOne) {
                    case 'seen_poptin':
                        jQ224.each(clientPoptins, function(key, index) {
                            if (hasSeenAPoptin(this)) {
                                conditionMet = true;
                            }
                        });
                        break;
                    case 'not_seen':
                        jQ224.each(clientPoptins, function(key, index) {
                            if (hasNotSeenAPoptin(this)) {
                                conditionMet = true;
                            }
                        });
                        break;
                    case 'closed':
                        jQ224.each(clientPoptins, function(key, index) {
                            if (hasClosedAPoptin(this)) {
                                conditionMet = true;
                            }
                        });
                        break;
                    case 'converted':
                        jQ224.each(clientPoptins, function(key, index) {
                            if (hasConvertedAPoptin(this)) {
                                conditionMet = true;
                            }
                        });
                        break;
                }
            }

            if (conditionMet) {
                if (showValue == "show") {
                    flag = true;
                } else {
                    flag = false;
                }
            } else {
                if (showValue == "show") {
                    flag = false;
                } else {
                    flag = true;
                }
            }

            return flag;
        }

        function sourceCodeTarget(poptin)
        {
            var flag = true;
            if ((!poptin.source_code_target_active) || (poptin.source_code_target_html == null)) {
                return true;
            }

            var source_code = jQ224("html").html();

            source_code = source_code.replace(/(<!--.*?-->)|(<!--[\S\s]+?-->)|(<!--[\S\s]*?$)/g,'')

            var trimmedSourceCode = source_code.replace(/\s/g,'').toLowerCase();
            var trimmedCodeTarget = poptin.source_code_target_html.replace(/\s/g,'').toLowerCase();

            if((trimmedSourceCode.includes(trimmedCodeTarget)) && (poptin.source_code_target_role == "show")) {
                flag = true;
            } else if ((trimmedSourceCode.includes(trimmedCodeTarget)) && (poptin.source_code_target_role == "dont_show")) {
                flag = false;
            } else if ((!trimmedSourceCode.includes(trimmedCodeTarget)) && (poptin.source_code_target_role == "show")) {
                flag = false;
            } else if((!trimmedSourceCode.includes(trimmedCodeTarget)) && (poptin.source_code_target_role == "dont_show")) {
                flag = true;
            }

            return flag;

        }

        /**
         * Trigger functions: setPoptin(), poptinFormValidations()
         * parameters       : poptin:object
         * Desc             : Change input attributes to support validation
         */
        function getQueryString(e, landing = false){
            var path = landing ? getOriginLandingPage() : window.location.href;
            if(path){
                var n=new RegExp("[?&]"+e+"=([^&#]*)","i").exec(path);
                return n?decodeURI(n[1]):null
            } else {
                return null;
            }
        };

        /**
         * Trigger functions: poptinFormValidations()
         * parameters       : poptin:object
         * Desc             : Fix radio and checkbox child options
         */
        function fixChildOptions(poptin) {

            const popupSelector = `[data-poptin-id="${poptin.poptin_id}"]`;

            // Fix radio options
            const radioContainers = jQ224(popupSelector + " .inputs-container .form-input-class.field-radio");
            radioContainers.each(function() {
                const radioInputs = jQ224(this).find('input[type="radio"]');
                if (radioInputs.length > 0) {
                    const firstInputName = jQ224(radioInputs[0]).attr('name');
                    radioInputs.attr('name', firstInputName);
                }
            });

            // Fix checkbox options
            const checkboxContainers = jQ224(popupSelector + " .inputs-container .form-input-class:has(input[type='checkbox'])");
            const usedNames = {};
            checkboxContainers.each(function() {
                const checkboxInputs = jQ224(this).find('input[type="checkbox"]');

                checkboxInputs.each(function(index) {
                    const currentName = jQ224(this).attr('name');

                    if (usedNames[currentName]) {
                        // Name already exists, add _n to make it unique
                        jQ224(this).attr('name', currentName + '_' + index);
                    } else {
                        // Mark this name as used
                        usedNames[currentName] = true;
                    }
                });
            });

        }

        /**
         * Trigger functions: setPoptin(), showPoptin()
         * parameters       : poptin:object
         * Desc             : Change input attributes to support validation
         */
        function poptinFormValidations(poptin){
            var this_pop = ".poptin-popup[data-poptin-id='"+poptin.poptin_id+"'] ";

            // Add maxlength to email and name fields
            jQ224(this_pop + "input#poptinDesignInputTextFieldEmail, " +
                this_pop + "input#poptinDesignInputTextFieldName, " +
                this_pop + "input#poptinDesignInputTextFieldFirstName, " +
                this_pop + "input#poptinDesignInputTextFieldLastName").each(function() {
                jQ224(this).attr('maxlength', '254');
            });

            var pop_lang = jQ224(this_pop).attr("data-pop-lang");
            if(jQ224(this_pop).length){

                // Grouping child fields if they have different name attribute
                jQ224(this_pop).find(".field-radio, .field-checkbox").each(function(){
                    var parentId = jQ224(this).attr("id");
                    if(parentId) {
                        jQ224(this).find("input").attr({
                            "name": parentId,
                        });
                    }
                });

                // Block merge tags on free account
                if(!if_freemium) {
                    var dt_obj = new Array();
                    var dt = jQ224(this_pop).find('.dynamic-text-tags-input');

                    if(dt.length){
                        dt = dt.first().text();
                        dt_obj = (dt != undefined && dt != '') ? JSON.parse(dt) : new Array();
                    }
                    defined_tag_arr.push({tag_input:'country', pre:1, value:pop_country});

                    dt_obj = dt_obj.concat(defined_tag_arr);
                    jQ224(dt_obj).each(function(i){
                        var tag_input = dt_obj[i]['tag_input'];
                        var pre = dt_obj[i]['pre'];
                        if(tag_input != ''){
                            var value_input;
                            var tag_input = tag_input.replace(/[()]/g, '');
                            if(tag_input.substring(0, 1) == '?'){
                                value_input = getQueryString(tag_input.substring(1));
                                value_input = value_input != null ? value_input : dt_obj[i]['class_input'];
                                tag_input = '\\'+tag_input;
                            } else if(pre) {
                                value_input = dt_obj[i]['value'];
                                if(pre == 2) {
                                    value_input = value_input[(pop_lang ? pop_lang : "en")];
                                }
                            } else {
                                value_input = jQ224(dt_obj[i]['class_input']).text();
                            }
                            tag_input = '{{'+tag_input+'}}';
                            jQ224(this_pop).find('.froala-editor-text, .froala-editor-ticker').each(function(){
                                var dtRegExp = new RegExp(tag_input,'gm');
                                jQ224(this).find('.fr-marker').remove();
                                jQ224(this).html(jQ224(this).html().replace(dtRegExp, value_input));
                            });
                        }
                    });

                    var dt = jQ224(this_pop).find('.dynamic-input-tags-input');
                    if(dt.length){
                        var dt = dt.first().text();
                        dt_obj = (dt != undefined && dt != '') ? JSON.parse(dt) : new Array();
                        jQ224(dt_obj).each(function(i){
                            var tag_input = dt_obj[i]['tag_input'];
                            var class_input = dt_obj[i]['class_input'];

                            // Check if class_input is empty and tag_input starts with UTM patterns
                            if(class_input === '' &&
                            (tag_input.startsWith('poptinDesignInputCustomField-CUSTOM_UTM_') ||
                                tag_input.startsWith('poptinDesignInputCustomField-UTM_'))) {

                                // Extract the UTM parameter name
                                var utmParam = '';
                                if(tag_input.startsWith('poptinDesignInputCustomField-CUSTOM_UTM_')) {
                                    utmParam = tag_input.substring('poptinDesignInputCustomField-CUSTOM_UTM_'.length).toLowerCase();
                                } else if(tag_input.startsWith('poptinDesignInputCustomField-UTM_')) {
                                    utmParam = tag_input.substring('poptinDesignInputCustomField-UTM_'.length).toLowerCase();
                                }

                                // Set class_input to the UTM parameter format
                                class_input = '?utm_' + utmParam;
                                dt_obj[i]['class_input'] = class_input;
                            }

                            if(class_input != ''){
                                var tag_label = (dt_obj[i]['tag_label'] || '').replace(/[.#?]/g, '');

                                var tag_label_upper = '';
                                var tag_input_custom = '';
                                var tag_input_custom_by_name = '';

                                if(tag_label != '') {
                                    // Remove ., #, ? from tag_label and then convert to uppercase for old UTM fields
                                    var tag_label_check = tag_label.toUpperCase();
                                    if(tag_label_check.startsWith("UTM_")){
                                        tag_label_upper = tag_label_check;
                                        tag_input_custom = "poptinDesignInputCustomField-CUSTOM_"+tag_label_upper;
                                        tag_input_custom_by_name = 'input[name="'+tag_label+'"]';
                                    }
                                }

                                var value_input = null;
                                var class_input = class_input.replace(/[()]/g, '');

                                if(class_input.substring(0, 1) == '?'){
                                    value_input = getQueryString(class_input.substring(1));
                                } else if(class_input.substring(0, 1) == '.' || class_input.substring(0, 1) == '#'){
                                    value_input = jQ224(dt_obj[i]['class_input']).text();
                                }

                                if(value_input){
                                    // Build base selector for standard inputs
                                    var selector = 'input#' + tag_input + ', textarea#' + tag_input + ', select#' + tag_input;

                                    // Only add custom selectors if tag_label exists
                                    if(tag_input_custom != '') {
                                        selector += ', input#' + tag_input_custom + ', textarea#' + tag_input_custom + ', select#' + tag_input_custom;
                                    }

                                    var selected_input = jQ224(this_pop).find(selector);
                                    selected_input.val(value_input);
                                    selected_input.addClass("has-updated");

                                    // Handle custom name inputs if tag_label exists
                                    if(tag_input_custom_by_name != '' && jQ224(this_pop).find(tag_input_custom_by_name).length) {
                                        jQ224(this_pop).find(tag_input_custom_by_name).val(value_input).addClass("has-updated");
                                    }

                                    // Handle radio and checkbox inputs
                                    var sub_fields = jQ224(this_pop).find('[name="'+tag_input+'"]');
                                    if(sub_fields.length){
                                        if(sub_fields.attr('type') == "radio" || sub_fields.attr('type') == "checkbox"){
                                            if(tag_input != 'poptinDesignInputTextFieldCheckbox'){
                                                var selected_child_input = jQ224(this_pop).find('[name="'+tag_input+'"][value="'+value_input+'"]');
                                                selected_child_input.addClass("has-updated");
                                                selected_child_input.length ? selected_child_input.get(0).checked = true : 1;
                                            } else if (tag_input == 'poptinDesignInputTextFieldCheckbox' && value_input == 'true'){
                                                var selected_child_input = jQ224(this_pop).find('[name="'+tag_input+'"]');
                                                selected_child_input.addClass("has-updated");
                                                selected_child_input.length ? selected_child_input.get(0).checked = true : 1;
                                            }
                                        }
                                    }
                                } else {
                                    // jQ224(this_pop).find('input#'+tag_input+', textarea#'+tag_input+', select#'+tag_input).val(class_input);
                                }
                            }
                        });
                    }

                    jQ224(this_pop).find('.froala-image-wrapper').each(function(){
                        var $selector = jQ224(this).attr('data-selector');
                        if($selector != undefined && $selector != ''){
                            jQ224(this).find('img').attr('src', jQ224($selector).attr('src'));
                        }
                    });
                }

                jQ224(this_pop + " > div:not(.poptin-tab-container) .inputs-container select option[value='child-default']").val('');
                jQ224(this_pop + " > div:not(.poptin-tab-container) .inputs-container input[type='number']").attr("step", "0.01");
                jQ224(this_pop + " > div:not(.poptin-tab-container) .inputs-container input[type='number']").on('keydown', function(event) {
                    // Allow: backspace, delete, tab, escape, enter, decimal point, minus sign
                    if (event.keyCode === 8 || event.keyCode === 9 || event.keyCode === 46 || event.keyCode === 110 || event.keyCode === 190 || event.keyCode === 189 || event.keyCode === 109 ||
                        // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
                        (event.ctrlKey === true && (event.keyCode === 65 || event.keyCode === 67 || event.keyCode === 86 || event.keyCode === 88)) ||
                        // Allow: home, end, left, right, up, down
                        (event.keyCode >= 35 && event.keyCode <= 40)) {
                        // Let it happen, don't do anything
                        return true;
                    } else {
                        // Ensure that it is a number and stop the keypress if not
                        if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) && (event.keyCode < 96 || event.keyCode > 105)) {
                            event.preventDefault();
                        }
                    }
                });
                jQ224(this_pop + " > div:not(.poptin-tab-container) .inputs-container input[type='number']").on('blur',function(event){
                    var value = jQ224(this).val();
                    if (value === '.') {
                        jQ224(this).val('0');
                        return;
                    }
                    var num = parseFloat(value);
                    if (isNaN(num)) {
                        jQ224(this).val('');
                        return;
                    }
                    if (Number.isInteger(num)) {
                        jQ224(this).val(num.toString());
                    } else {
                        var rounded = Math.round((num + Number.EPSILON) * 100) / 100;
                        jQ224(this).val(rounded.toString());
                    }
                });
                jQ224(this_pop + " > div:not(.poptin-tab-container) [name='poptinDesignInputTextFieldCheckbox'][data-action-validate='true']").each(function(){
                    jQ224(this).prop('checked', true);
                    this.checked = true;
                });

                // Select a radio or checkbox input by default
                jQ224(this_pop + ".inputs-container .form-input-class.field-checkbox[data-action-required='true'] .checkbox-child-field:first-child input").each(function(){
                    jQ224(this).prop('required', true).attr('required', true);
                    this.required = true;
                });

                //Add pattern to name fields (full, first, last) if required
                var required_name_fields = jQ224(this_pop + ".inputs-container input[name='poptinDesignInputTextFieldName'][required='required'], " +
                    this_pop + ".inputs-container input[name='poptinDesignInputTextFieldFirstName'][required='required'], " +
                    this_pop + ".inputs-container input[name='poptinDesignInputTextFieldLastName'][required='required']");
                required_name_fields.attr('pattern', '^(?=.[^\\d^<>]{1,40}$).*\\S+.*$');
                required_name_fields.attr('title', ifUserlangIsHe() ? "יש להזין לפחות 2 תווים" : "Please enter at least 2 or more characters");

                jQ224(this_pop + ".inputs-container input[name='poptinDesignInputTextFieldEmail'][data-action-validate]").not('[data-action-validate="no-validation"]').attr('type', 'email');
                jQ224(this_pop + ".inputs-container input[data-name='poptinDesignWebsiteField'][data-action-validate]").attr('type', 'url');
                jQ224(this_pop + ".inputs-container input[data-input-type='url'][data-action-validate]").attr('type', 'url');
                var tel_field = jQ224(this_pop + ".inputs-container input[name='poptinDesignInputTextFieldPhone'][data-action-validate='true'], "+this_pop + ".inputs-container input[name='poptinDesignInputTextFieldPhone'][data-action-validate='basic']");
                tel_field.attr('pattern', '^[\\+\\(\\)\\-\\d](?:[\\+\\(\\)\\-\\d]| (?![ ])){5,13}[\\+\\(\\)\\-\\d]$');  // accepts digits and chars +,(,),- and inner space minlength 7, maxlength 15
                //tel_field.attr('maxlength', '15');
                //tel_field.attr('minlength', '7');
                tel_field.attr('title', ifUserlangIsHe() ? "יש להזין בין 7 ל-15 ספרות ,ולהימנע משימוש באותיות או סימנים"  : "Please enter 7 to 15 digits and avoid using letters or symbols");
                var checkbox_inputs = "[data-poptin-id="+poptin.poptin_id+"]  > div:not(.poptin-tab-container) .inputs-container .form-input-class.field-checkbox[data-action-required='true'] input";
                jQ224(document).on('change', checkbox_inputs, function(){
                    var field_wrapper = jQ224(this).parent().parent();
                    if( field_wrapper.find('input').is(':checked') ) {
                        // field_wrapper.find('input').removeAttr('required');
                        field_wrapper.find('input').prop('required', false);
                    } else {
                        field_wrapper.find(".checkbox-child-field:first-child input").attr('required', true).attr('required', true);
                    }
                });
                jQ224(this_pop + " > div:not(.poptin-tab-container) .facebook-messanger-conversion-wrap").remove();
                var date_field = jQ224(this_pop + ".inputs-container").find("input[data-name='poptinDesignDateField'], input[data-input-type='date']");

                if (isIphonePoptin) {
                    if (date_field.length > 0) {
                        // Append CSS only if not already added
                        if (!document.querySelector('link[href*="datepicker.min.css"]')) {
                            let datepicker_style = document.createElement('link');
                            datepicker_style.rel = 'stylesheet';
                            datepicker_style.type = 'text/css';
                            datepicker_style.href = 'https://cdn.jsdelivr.net/npm/vanillajs-datepicker@1.3.4/dist/css/datepicker.min.css';
                            document.head.appendChild(datepicker_style);
                        }

                        // Append JS only if not already loaded
                        if (!document.querySelector('script[src*="datepicker-full.min.js"]')) {
                            let scriptNode = document.createElement("script");
                            scriptNode.type = "text/javascript";
                            scriptNode.src = "https://cdn.jsdelivr.net/npm/vanillajs-datepicker@1.3.4/dist/js/datepicker-full.min.js";

                            scriptNode.onload = function () {
                                for (let i = 0; i < date_field.length; i++) {
                                    jQ224(date_field[i]).attr('readonly', true);
                                    new Datepicker(date_field[i], {
                                        format: 'dd/mm/yyyy',
                                        autohide: true,
                                        enableOnReadonly: true
                                    });
                                }
                            };

                            document.body.appendChild(scriptNode);
                        } else {
                            // If already loaded, just initialize Datepicker
                            for (let i = 0; i < date_field.length; i++) {
                                jQ224(date_field[i]).attr('readonly', true);
                                new Datepicker(date_field[i], {
                                    format: 'dd/mm/yyyy',
                                    autohide: true,
                                    enableOnReadonly: true
                                });
                            }
                        }

                        date_field.on('focus', function(){
                            jQ224(this).parents('.form-input-class').css('z-index', '999');
                            jQ224(this).parents('.inputs-container').attr('style', function(i, style) {
                                return (style || '') + '; z-index: 999 !important;';
                            });
                        });
                        date_field.on('blur', function(){
                            jQ224(this).parents('.form-input-class').css('z-index', '');
                        });
                    }

                } else {
                    setTimeout(() => {
                        var date_field = jQ224(this_pop + ".inputs-container").find("input[data-name='poptinDesignDateField'], input[data-input-type='date']");
                        if(date_field.length){
                            var datepickerHeight =  date_field.css("height");
                            date_field.css("line-height", datepickerHeight);
                            date_field.on('focus', function(){
                                if(jQ224(this).attr('type') == "text"){
                                    jQ224(this).attr('type', 'date');
                                    jQ224(this).focus().click();
                                }
                            });
                            if (!isFirefoxPoptin) {
                                date_field.on('blur', function(){
                                    jQ224(this).attr('type', (jQ224(this).val() == "" ? 'text' : 'date'));
                                });
                            }
                        }
                    }, 500);
                }
                // If the field is searchable or multi select
                jQ224.each(["custom", "multiple", "default", "single"], function(select_idx, select_type) {
                    var is_custom = select_type == "custom";
                    var is_single = select_type == "single";
                    var search_term = is_custom ? "action-search" : "multiple";
                    var search_query = is_single ? "" : "[data-"+search_term+"='true']";
                    var selects = jQ224(this_pop + ".inputs-container select" + search_query + ', ' + this_pop + " > div:visible .inputs-container select" + search_query);
                    jQ224(selects).each(function () {
                        var select = jQ224(this);
                        var is_multipe =  select.data('multiple') // Check if dropdown is multiple
                        jQ224(this_pop + ".inputs-container" + ', ' + this_pop + " > div:visible .inputs-container").css("z-index", "9999999");
                        var select_id = select.get(0).id;
                        // If the dropdown hasn't been built already
                        if (document.querySelectorAll(".wrapper-" + select_id).length == 0) {
                            // Build the custom dropdown
                            var select_parent = select.parent();
                            var search_text = user_lang == "he" ? "חיפוש" : "Search...";
                            var search_no_result_text = user_lang == "he" ? "לא נמצאו תוצאות" : "No results found";
                            if(is_custom){
                                if(is_multipe) {
                                    select_parent.prepend('<div class="poptin-custom-select wrapper-' + select_id + '"><input type="text" data-select-type="' + select_type + '" placeholder="' + search_text + '" class="poptin-multi-select-input poptin-custom-select-input" data-gramm_editor="false" autocomplete="off" data-select="' + select_id + '" autocomplete="off"><div class="poptin-opt-group-wrapper"><div class="poptin-opt-group"></div></div></div>');
                                } else {
                                    select_parent.prepend('<div class="poptin-custom-select wrapper-' + select_id + '"><input type="text" data-select-type="' + select_type + '" placeholder="' + search_text + '" class="poptin-custom-select-input" data-gramm_editor="false" autocomplete="off" data-select="' + select_id + '" autocomplete="off"><div class="poptin-opt-group-wrapper"><div class="poptin-opt-group"></div></div></div>');
                                }
                            } else if(is_single){
                                select_parent.prepend('<div class="poptin-single-select wrapper-' + select_id + '"><input type="text" data-select-type="' + select_type + '" placeholder="' + (select.attr("data-placeholder") || '') + '" class="poptin-single-select-input" data-gramm_editor="false" autocomplete="new-email" data-select="' + select_id + '" autocomplete="new-email"><div class="poptin-opt-group-wrapper"><div class="poptin-opt-group"></div></div></div>');
                            } else {
                                select_parent.prepend('<div class="poptin-multi-select wrapper-' + select_id + '"><input type="text" data-select-type="' + select_type + '" placeholder="' + (select.attr("data-placeholder") || '') + '" class="poptin-multi-select-input" data-gramm_editor="false" autocomplete="new-email" data-select="' + select_id + '" autocomplete="new-email"><div class="poptin-opt-group-wrapper"><div class="poptin-opt-group"></div></div></div>');
                            }
                            var wrapper = document.querySelectorAll(".wrapper-" + select_id)[0];
                            var poptin_opt_group = jQ224(wrapper).find(".poptin-opt-group");
                            select.find("option").each(function () {
                                if (this.value == "child-default") {
                                    this.value = "";
                                }
                                if (this.value != "") {
                                    if(is_custom){
                                        if(is_multipe) {
                                            poptin_opt_group.append('<label class="poptin-custom-option"><input type="checkbox" value="' + this.value + '" id="' + this.id + '"><span>' + this.innerText + '</span></label>');
                                        } else {
                                            poptin_opt_group.append('<span class="poptin-custom-option" data-value="' + this.value + '">' + this.innerText + "</span>");
                                        }
                                    } else if(is_single){
                                        poptin_opt_group.append('<span class="poptin-custom-option" data-value="' + this.value + '">' + this.innerText + "</span>");
                                    } else {
                                        poptin_opt_group.append('<label class="poptin-custom-option"><input type="checkbox" value="' + this.value + '" id="' + this.id + '"><span>' + this.innerText + '</span></label>');
                                    }
                                }
                            });
                            if(is_custom){
                                poptin_opt_group.append('<span class="poptin-custom-option no-result" data-value="">' + search_no_result_text + "</span>");
                            }

                            select_parent.find(".poptin-custom-select, .poptin-single-select, .poptin-multi-select, .poptin-opt-group-wrapper").css({
                                "padding-right": select_parent.css("padding-right"),
                                "padding-left": select_parent.css("padding-left")
                            });

                            // Get minimum padding of the select
                            var paddingLeft = parseInt(select.css('padding-left'), 10);
                            var paddingRight = parseInt(select.css('padding-right'), 10);
                            var minPadding = Math.min(paddingLeft, paddingRight);
                            jQ224(wrapper).find("input").attr("style", select.attr("style")).css({
                                "padding-right": minPadding+"px",
                                "padding-left": minPadding+"px"
                            });

                            function getExplicitCSSProperty(element, property) {
                                var value = element.css(property);
                                var defaultValue = getDefaultCSSProperty(element, property);
                                return (value !== defaultValue) ? value : null;
                            }

                            function getDefaultCSSProperty(element, property) {
                                var tempElement = jQ224('<div style="opacity:0;width:0px;height:0px;overflow:hidden;"></div>').appendTo('body');
                                var defaultValue = tempElement.css(property);
                                tempElement.remove();
                                return defaultValue;
                            }

                            poptin_opt_group.css({
                                "font-family": getExplicitCSSProperty(select, "font-family"),
                                "font-size": getExplicitCSSProperty(select, "font-size"),
                                "color": getExplicitCSSProperty(select, 'color'),
                                "background": "#ffffff",
                                "color": "#000000",
                                "direction": getExplicitCSSProperty(select, 'direction'),
                                "text-align": getExplicitCSSProperty(select, 'text-align')
                            });

                            var hasBorderRadius = select.css("border-radius");
                            if (hasBorderRadius && parseInt(hasBorderRadius) > 0) {
                                poptin_opt_group.css("border-radius", "10px");
                            }
                        }
                    });
                });

                // Function to handle dropdown functionality including keyboard navigation
                function handleDropdownFunctionality() {
                    // Keyboard navigation
                    jQ224(document).off('keydown.dropdownNav').on('keydown.dropdownNav', '.poptin-custom-select-input, .poptin-single-select-input, .poptin-multi-select-input', function(e) {
                        if (!['ArrowDown', 'ArrowUp', 'Enter'].includes(e.key)) return;

                        e.preventDefault();

                        var select_parent = jQ224(this).parents('.form-input-class');
                        var optGroup = select_parent.find('.poptin-opt-group');
                        var visibleOptions = optGroup.find('.poptin-custom-option:visible');

                        var focusedIndex = visibleOptions.index(visibleOptions.filter('.focused'));

                        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                            visibleOptions.removeClass('focused');

                            if (focusedIndex === -1) {
                                focusedIndex = e.key === 'ArrowDown' ? 0 : visibleOptions.length - 1;
                            } else {
                                focusedIndex = e.key === 'ArrowDown'
                                    ? (focusedIndex + 1) % visibleOptions.length
                                    : (focusedIndex - 1 + visibleOptions.length) % visibleOptions.length;
                            }

                            visibleOptions.eq(focusedIndex).addClass('focused');
                        } else if (e.key === 'Enter') {
                            var focusedOption = visibleOptions.filter('.focused');
                            if (focusedOption.length) {
                                if (select_parent.find('.poptin-multi-select').length) {
                                    var checkbox = focusedOption.find('input[type="checkbox"]');
                                    checkbox.prop('checked', !checkbox.prop('checked')).trigger('change');
                                } else {
                                    focusedOption.click();
                                }
                            }
                        }

                        // Ensure the focused option is visible
                        var focusedOption = visibleOptions.filter('.focused');
                        if (focusedOption.length) {
                            optGroup.scrollTop(optGroup.scrollTop() + focusedOption.position().top - optGroup.height()/2 + focusedOption.height()/2);
                        }
                    });

                    // Reopen dropdown on input click
                    jQ224(document).off('click.reopenDropdown').on('click.reopenDropdown', '.poptin-custom-select-input, .poptin-single-select-input, .poptin-multi-select-input', function(e) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        var select_parent = jQ224(this).parents('.form-input-class');
                        if(!select_parent.hasClass('opened')){
                            jQ224('.form-input-class.opened').removeClass('opened');
                        }
                        if(jQ224(this).hasClass('poptin-custom-select-input')) {
                            select_parent.addClass('opened');
                        } else
                            select_parent.toggleClass('opened', !select_parent.first().hasClass("opened"));

                        if(!jQ224(select_parent).find('.poptin-custom-option').is(':visible')){
                            jQ224(select_parent).find('.no-result').css('display', 'block');
                        } else {
                            jQ224(select_parent).find('.no-result').css('display', 'none');
                        }
                        jQ224(".inputs-container").addClass("opened");

                    });

                    // Close dropdown when clicking outside
                    jQ224(document).off('click.closeDropdown').on('click.closeDropdown', function(e) {
                        if (!jQ224(e.target).closest('.form-input-class').length) {
                            jQ224(".form-input-class, .inputs-container").removeClass("opened");
                            jQ224(".poptin-custom-select-input, .poptin-multi-select-input").removeAttr("disabled");
                        }
                    });
                }

                // Call the function to set up the keyboard navigation
                jQ224(document).ready(handleDropdownFunctionality);

                // Search for options on keyup
                jQ224(document).on('keyup', '.poptin-custom-select-input', function(e){
                    var select_id = jQ224(e.target).attr('data-select');
                    var wrapper = document.querySelectorAll('.wrapper-'+select_id)[0];
                    var opts = wrapper.querySelectorAll(".poptin-custom-option");
                    var optLen = opts.length;
                    var filter = e.target.value.toUpperCase();
                    jQ224(wrapper).find('.no-result, .poptin-custom-option').hide();
                    for (var i = 0; i < optLen; i++) {
                        var txtValue = opts[i].textContent || opts[i].innerText;
                        var optClass = true;
                        try{
                            if(jQ224(wrapper).attr('data-current-parent') != undefined){
                                optClass = false;
                                if(opts[i].getAttribute('class') != undefined && opts[i].getAttribute('class').indexOf('custom-opt-') > -1){
                                    optClass = opts[i].getAttribute('class').split("custom-opt-")[1].split(" ")[0] == jQ224(wrapper).attr('data-current-parent');
                                }
                            }
                        }catch(err){showLog(err);}
                        if (optClass && txtValue.toUpperCase().indexOf(filter) > -1) {
                            opts[i].style.display = "";
                        } else {
                            opts[i].style.display = "none";
                        }
                    }
                    if(!jQ224(wrapper).find('.poptin-custom-option').is(':visible')){
                        jQ224(wrapper).find('.no-result').css('display', 'block');
                    }
                });

                // Hide dropdown options
                jQ224(document).on("click", function (e) {
                    var this_el = jQ224(e.target);
                    var select_parent = this_el.parents(".form-input-class");
                    if (select_parent.length == 0) {
                        jQ224(".form-input-class, .inputs-container").removeClass("opened");
                        jQ224(".poptin-custom-select-input, .poptin-multi-select-input").removeAttr("disabled");
                        jQ224('.poptin-multi-select input[type="checkbox"], .poptin-custom-select input[type="checkbox"]').trigger('change')
                    }
                    if (
                        (select_parent.find(".poptin-custom-select").length || select_parent.find(".poptin-single-select").length)
                        && this_el.hasClass("poptin-custom-option")
                    ) {
                        select_parent.find("select").val(this_el.attr("data-value"));
                        // Check if the custom select is also a multi select
                        if(!select_parent.find(".poptin-multi-select-input").length){
                            jQ224(".form-input-class, .inputs-container").removeClass("opened");
                            jQ224(".poptin-custom-select-input, .poptin-multi-select-input").removeAttr("disabled");
                        }
                    }
                    if (select_parent.find(".poptin-multi-select").length) {
                        select_parent.find("select").val(this_el.attr("data-value"));
                        // jQ224(".form-input-class, .inputs-container").removeClass("opened");
                        jQ224(".poptin-custom-select-input, .poptin-multi-select-input").removeAttr("disabled");
                    }
                    // if(select_parent.length && !select_parent.hasClass("opened")) {
                    //     jQ224(".form-input-class, .inputs-container").removeClass("opened");
                    //     jQ224(".poptin-custom-select-input, .poptin-multi-select-input").removeAttr("disabled");
                    // }
                    // jQ224('.poptin-input-msg').remove();
                });

                // Open dropdown options
                var customSelectors = ".poptin-single-select-input, .poptin-multi-select-input";
                jQ224(document).on("focus", '.poptin-custom-select-input', function () {
                    var select_parent = jQ224(this).parents(".form-input-class");
                    jQ224(".form-input-class").not(select_parent).removeClass("opened");
                    select_parent.toggleClass("opened", !select_parent.first().hasClass("opened"));
                    jQ224(".inputs-container").addClass("opened");
                });

                // jQ224(document).on("click", customSelectors, function () {
                //     jQ224(customSelectors).removeAttr("disabled");
                //     var select_parent = jQ224(this).parents(".form-input-class");
                //     jQ224(".form-input-class").not(select_parent).removeClass("opened");
                //     console.log("this one is getting called", select_parent.hasClass('ope'))
                //     select_parent.toggleClass("opened", !select_parent.first().hasClass("opened"));
                //     jQ224(".inputs-container").addClass("opened");
                //     if(["default", "multiple"].includes(jQ224(this).attr("data-select-type"))){
                //         jQ224(this).attr("disabled", true);
                //     }
                // });

                // Multi select dropdown
                jQ224(document).on('change', '.poptin-multi-select input[type="checkbox"], .poptin-custom-select input[type="checkbox"]', function(e){
                    var selectedInputParent = jQ224(e.target).parents(".field-multi-select");
                    var selectedInput = selectedInputParent.attr("id");
                    selectedInput = selectedInput.includes("poptinDesignInputCustomField-") ? selectedInput.split("poptinDesignInputCustomField-")[1] : selectedInput;
                    poptinMultiSelectTexts[selectedInput] = [];
                    poptinMultiSelectValues[selectedInput] = [];
                    // showLog(selectedInput, e.target);
                    selectedInputParent.find('.poptin-multi-select input[type="checkbox"]:checked, .poptin-custom-select input[type="checkbox"]:checked').each(function() {
                        poptinMultiSelectTexts[selectedInput].push(jQ224(this).parent().text().trim());
                        poptinMultiSelectValues[selectedInput].push(jQ224(this).val());
                    });
                    // showLog(poptinMultiSelectTexts);
                    // showLog(poptinMultiSelectValues);
                    selectedInputParent.find('.poptin-multi-select-input').val(poptinMultiSelectTexts[selectedInput].join(', '));
                    selectedInputParent.find('.poptin-design-fields-form').val(poptinMultiSelectValues[selectedInput][0]);
                    selectedInputParent.find('.poptin-custom-select-input').val(poptinMultiSelectTexts[selectedInput].join(', '));

                    if(poptinMultiSelectTexts[selectedInput].length){
                        selectedInputParent.addClass("has-values");
                    } else {
                        selectedInputParent.removeClass("has-values");
                    }
                });

                // Open dropdown options
                jQ224(document).on('focus', '.poptin-custom-select-input', function(){
                    var select_parent = jQ224(this).parents('.form-input-class');
                    select_parent.addClass('opened');
                    if(!jQ224(select_parent).find('.poptin-custom-option').is(':visible')){
                        jQ224(select_parent).find('.no-result').css('display', 'block');
                    } else {
                        jQ224(select_parent).find('.no-result').css('display', 'none');
                    }
                });

                jQ224(this_pop + ".inputs-container").find("input, textarea, select").each(function(){
                    if(jQ224(this).attr('required')){
                        jQ224(this).attr('aria-required', 'true');
                    }
                });

                jQ224(this_pop + ".inputs-container [data-action-default-hidden-value]").each(function(){
                    // showLog(jQ224(this), jQ224(this).attr('data-action-default-hidden-value'));
                    jQ224(this).val(jQ224(this).attr('data-action-default-hidden-value'));
                });

            }

        }

        // Switch attributes of autoplay items
        function autoplayAttrSwitch(att1, att2, container){
            jQ224(container).find('audio, video').each(function(){
                if(jQ224(this).attr(att1)){
                    // jQ224(this).removeAttr(att1);
                    jQ224(this).prop(att1, false);
                    jQ224(this).attr(att2, true);
                    if(att2 == "autoplay"){
                        jQ224(this).get(0).play();
                    } else {
                        jQ224(this).get(0).pause();
                    }
                }
            });
        }

        // Update phone inuput inline style based on language
        function updatePhoneInputInlineStyle(poptin, lang) {
            var phoneInput =jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] #poptinDesignInputTextFieldPhone input")
            if(user_lang === "en") {
                phoneInput.css('padding-left', '');
            } else {
                phoneInput.css('padding-right', '');
            }
        }

        /**
         * Trigger functions: setPoptinTrigger(), initiatePullPoptinsRequestOnClick()
         * parameters       : poptin:object | click:Boolean -> (if poptin click trigger)
         * Desc             : Set style, position and function per poptin
         */
        function setPoptin(poptin, click){
            // Preserve existing properties like redirect_target and redirect_url
            if (window.poptins[poptin.poptin_id]) {
                const existingProps = window.poptins[poptin.poptin_id];
                showLog('setPoptin - preserving existing properties:', existingProps);

                // Merge the new poptin object with existing properties
                window.poptins[poptin.poptin_id] = { ...poptin, ...existingProps };

                // Ensure redirect properties are preserved
                if (existingProps.redirect_target) {
                    window.poptins[poptin.poptin_id].redirect_target = existingProps.redirect_target;
                    showLog('setPoptin - preserved redirect_target:', existingProps.redirect_target);
                }
                if (existingProps.redirect_url) {
                    window.poptins[poptin.poptin_id].redirect_url = existingProps.redirect_url;
                    showLog('setPoptin - preserved redirect_url:', existingProps.redirect_url);
                }
                if (existingProps._persistent_redirect) {
                    window.poptins[poptin.poptin_id]._persistent_redirect = existingProps._persistent_redirect;
                    showLog('setPoptin - preserved _persistent_redirect:', existingProps._persistent_redirect);
                }
            } else {
                window.poptins[poptin.poptin_id] = poptin;
            }
            // checkForEmailPhoneValidations(window.poptins);
            showLog('setPoptin poptinid: '+poptin.poptin_id);
            var isEmbeddedPoptin = poptin.poptin_type == "embedded";
            if (isEmbeddedPoptin && typeof poptin_landing_page != "undefined") {
                var windowHt = jQ224( window ).height();
                jQ224('body').css({
                    'height' : windowHt - 20
                });
            }

            // Show Mobile poptin in mobile mode
            var this_pop = ".poptin-popup[data-poptin-id='"+poptin.poptin_id+"'] ";
            /*if(jQ224(this_pop).find("#closeXButton").length){
                jQ224(this_pop).find("#closeXButton").attr("onclick","closePoptinOnXclick(this);");
            }*/

            // Copy the redirect link from dekstop view to parent div
            var redirect_url_blank = jQ224(this_pop).find(".draggable-container:not(.poptin-tab-container) .redirect-url-blank");
            var redirect_url_html = redirect_url_blank.length ? redirect_url_blank.get(0).outerHTML : '';
            if(jQ224(this_pop + "#poptinMobileContainer").length){
                isMobileContainerAvailableObj[poptin.poptin_id] = true;
                if(ifMobilePoptin && poptin.poptin_type != "mobile"){
                    // jQ224(this_pop + "#poptinDraggableContainer").attr('id', 'poptinDraggableContainerTemp');
                    // jQ224(this_pop + "#poptinThankYouScreen").attr('id', 'poptinThankYouScreenTemp');
                    // jQ224(this_pop + "#poptinMobileContainer").attr('id', 'poptinDraggableContainer');
                    // jQ224(this_pop + "#poptinMobileThankYouScreen").attr('id', 'poptinThankYouScreen');
                    // jQ224(this_pop + "#poptinDraggableContainerTemp, #poptinThankYouScreenTemp").remove();
                    if(jQ224(this_pop + "#poptinMobileContainer").length){
                        jQ224(this_pop + "#poptinDraggableContainer").replaceWith(jQ224(this_pop + "#poptinMobileContainer").get(0).outerHTML.replace(/poptinMobileContainer/gm, 'poptinDraggableContainer'));
                    }
                    if(jQ224(this_pop + "#poptinMobileThankYouScreen").length){
                        jQ224(this_pop + "#poptinThankYouScreen").replaceWith(jQ224(this_pop + "#poptinMobileThankYouScreen").get(0).outerHTML.replace(/poptinMobileThankYouScreen/gm, 'poptinThankYouScreen'));
                    }
                    if(jQ224(this_pop + "#poptinMobilePlayScreen").length){
                        jQ224(this_pop + "#poptinPlayScreen").replaceWith(jQ224(this_pop + "#poptinMobilePlayScreen").get(0).outerHTML.replace(/poptinMobilePlayScreen/gm, 'poptinPlayScreen'));
                    }
                    if(jQ224(this_pop + "#poptinMobileWinningScreen").length){
                        jQ224(this_pop + "#poptinWinningScreen").replaceWith(jQ224(this_pop + "#poptinMobileWinningScreen").get(0).outerHTML.replace(/poptinMobileWinningScreen/gm, 'poptinWinningScreen'));
                    }
                    if(jQ224(this_pop + "#poptinMobileLosingScreen").length){
                        jQ224(this_pop + "#poptinLosingScreen").replaceWith(jQ224(this_pop + "#poptinMobileLosingScreen").get(0).outerHTML.replace(/poptinMobileLosingScreen/gm, 'poptinLosingScreen'));
                    }
                    jQ224(this_pop + "#poptinMobileContainer").remove();
                    jQ224(this_pop + "#poptinMobileThankYouScreen").remove();
                    jQ224(this_pop + "#poptinMobilePlayScreen").remove();
                    jQ224(this_pop + "#poptinMobileWinningScreen").remove();
                    jQ224(this_pop + "#poptinMobileLosingScreen").remove();

                    // Update poptin HTML after switching modes
                    poptin.poptin = jQ224(this_pop).get(0).outerHTML;
                } else {
                    jQ224(this_pop + "#poptinMobileContainer, #poptinMobileThankYouScreen, #poptinMobilePlayScreen, #poptinMobileWinningScreen, #poptinMobileLosingScreen").remove();
                }
            }

            jQ224(this_pop).append(redirect_url_html);

            if(jQ224(this_pop + "#poptinDesktopContainer").length){
                jQ224(this_pop + "#poptinDesktopContainer").remove();
            }

            if(jQ224(this_pop).find("#poptinEncPze").length == 0 && jQ224(this_pop).find("#gamifiedPrizeJSON").length){
                jQ224(this_pop).find("#gamifiedPrizeJSON").attr("id", "poptinEncPze");
                jQ224(this_pop).find("#poptinEncPze").removeAttr("class");
                jQ224(this_pop).find("#poptinEncPze").val(poptinEnc(jQ224(this_pop).find("#poptinEncPze").val()));
            }

            if(jQ224(this_pop).find(".bg-stripes").length){
                jQ224(this_pop).find(".bg-stripes title").remove();
            }
            autoplayAttrSwitch("autoplay", "data-autoplay", this_pop + "#poptinThankYouScreen");

            var poptin_data_width_height = getDataWidthHeight(poptin.poptin);

            // var poptin_width, poptin_height;

            var this_poptin_width = poptin_data_width_height['width'];
            var this_poptin_height = poptin_data_width_height['height'];

            // Set global poptin size
            // If not click pull reqiuest
            if (click == undefined){
                poptin_width =  this_poptin_width || window.poptins[poptin.poptin_id].poptin_size.width;
                poptin_height = this_poptin_height || window.poptins[poptin.poptin_id].poptin_size.height;
                window.poptins[poptin.poptin_id].poptin_area_flag = false;
                getPoptinPosition(poptin);
                // if (poptin.poptin_type == "bar" || poptin.poptin_type == "lightbox" || (poptin.poptin_type == "mobile" && (poptin.poptin_format== "format_3" || poptin.poptin_format== "format_7")) ){
                //  poptin_position_center_up = window.poptins[poptin.poptin_id].position_center.up;
                //  poptin_position_center_left = window.poptins[poptin.poptin_id].position_center.left
                // }
                showLog('click undefined:'+click);
            }else{
                showLog('click true:'+click);
                poptin_width =  this_poptin_width || poptin_size.width;
                poptin_height = this_poptin_height || poptin_size.height;
                poptin_area_flag = false;

                getPoptinPosition(poptin,true);
                // if (poptin.poptin_type == "bar" || poptin.poptin_type == "lightbox" || (poptin.poptin_type == "mobile" && (poptin.poptin_format== "format_3" || poptin.poptin_format== "format_7") )){
                //  poptin_position_center_up = poptin_position.up;
                //  poptin_position_center_left = poptin_position.left;
                // }
            }
            // showLog('setPoptin', poptin_width, poptin_height);
            // Inject poptin to DOM
            //jQ224("body").append(poptin.poptin);
            //jQ224("body").append(appendPoptin(poptin.poptin_url));
            //appendPoptin(poptin);

            // Set Form wrapper
            jQ224(this_pop + "#poptinThankYouScreen").addClass('poptin_thank_you_screen').removeClass('draggable-container');
            jQ224(this_pop + "#poptinPlayScreen").addClass('poptin_play_screen').removeClass('draggable-container');
            jQ224(this_pop + "#poptinWinningScreen").addClass('poptin_winning_screen').removeClass('draggable-container');
            jQ224(this_pop + "#poptinLosingScreen").addClass('poptin_losing_screen').removeClass('draggable-container');
            var validation_honeypot_field = '<div class="poptin-form-field" style="display:none !important;"><input type="text" name="poptin_field_company_website" tabindex="-1" autocomplete="off"/></div>';
            if(poptin.poptin_type == "gamified" && (poptin.poptin_format == "format_1" || poptin.poptin_format == "format_2" || (poptin.poptin_format == "format_3" && !poptin.design_properties.disable_post_play_screen))){
                jQ224(this_pop + ".poptin_play_screen").html('<form method="POST" action="#" id="poptinFormSubmit'+poptin.poptin_id+'">' + validation_honeypot_field + jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_play_screen").html() + "</form>");
            }else{
                jQ224(this_pop + ".draggable-container:not(.poptin-tab-container)").html('<form method="POST" action="#" id="poptinFormSubmit'+poptin.poptin_id+'">' + validation_honeypot_field + jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container:not(.poptin-tab-container)").html() + "</form>");
            }
            jQ224(this_pop + ".poptin_thank_you_screen").hide();
            jQ224(this_pop + ".poptin_play_screen").hide();
            jQ224(this_pop + ".poptin_winning_screen").hide();
            jQ224(this_pop + ".poptin_losing_screen").hide();

            jQ224(this_pop).find('.froala-editor-link').each(function(){
                // .poptin-form-link-button has own click event so skip the event in its child elements
                if(!jQ224(this).parent().hasClass("poptin-form-link-button")){
                    jQ224(this).on('click', function(){
                        setTimeout(function(){
                            closePoptin(poptin.poptin_id);
                        },500);
                    });
                }
            })

            // Form validations
            poptinFormValidations(poptin);

            // Enable spin for wheel
            if (poptin.poptin_type == "gamified"){
                if (poptin.poptin_format == "format_3") {
                    poptin.wheel_has_coupon = jQ224(this_pop + ".poptin_winning_screen").find('.froala-editor-coupon').length ? true : false;
                    if(!poptin.design_properties.disable_post_play_screen || jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] #poptinDraggableContainer #poptinFormSubmitText").length == 0) {
                        poptinSpinWheelInit(poptin);
                    }
                }
            }

            // Hover effect on buttons
            if(jQ224(this_pop).find('.submitDarkColor').length){
                jQ224('.froala-editor-button').each(function(){
                    jQ224(this).parent().attr('data-bg', jQ224(this).css('background-color'));
                });
                jQ224('div.poptin-form-submit-button').mouseenter(function(){
                    jQ224(this).find('.froala-editor-button').css('background-color', '');
                }).mouseleave(function(){
                    if(jQ224(this).find('.froala-editor-button').length){
                        jQ224(this).find('.froala-editor-button').get(0).style.setProperty('background-color', jQ224(this).attr('data-bg'), 'important');
                    }
                });
            }

            if(jQ224(this_pop).find('.closeDarkColor').length){
                jQ224('.froala-editor-button').each(function(){
                    jQ224(this).parent().attr('data-bg', jQ224(this).css('background-color'));
                });
                jQ224('div.poptin-form-close-button').mouseenter(function(){
                    jQ224(this).find('.froala-editor-button').css('background-color', '');
                }).mouseleave(function(){
                    if(jQ224(this).find('.froala-editor-button').length){
                        jQ224(this).find('.froala-editor-button').get(0).style.setProperty('background-color', jQ224(this).attr('data-bg'), 'important');
                    }
                });
            }
            //Set Conversion Path And Links
            var convUrl = window.location.href;
            var convPath = window.location.pathname + window.location.search;
            convPath = convPath[0] == '/' ? convPath.substr(1) : convPath;
            if(jQ224(".redirect-url-blank").length>0){
                jQ224(".redirect-url-blank").each(function(){
                    var targetHref = jQ224(this).attr("href");
                    if(targetHref && convUrl){
                        var convHref = targetHref.replace("{conversion_url}",'conversion_url='+encodeURI(convUrl));
                            convHref = convHref.replace("%7Bconversion_url%7D",'conversion_url='+encodeURI(convUrl));
                            convHref = convHref.replace("{path_url}",'path_url='+encodeURI(convPath));
                            convHref = convHref.replace("%7Bpath_url%7D",'path_url='+encodeURI(convPath));

                        jQ224(this).attr("href",convHref);
                    }
                });
                jQ224(document).on("click", ".redirect-url-blank", function(e){
                    e.preventDefault(); // Prevent immediate redirect
                    var $clickedLink = jQ224(this);
                    setTimeout(function(){
                        var $popup = $clickedLink.parents(".poptin-popup");
                        let poptin_id = $popup.attr("data-poptin-id");
                        window.poptins[poptin_id].redirect_url = $clickedLink.attr("href");
                        // Store the target attribute to preserve _blank behavior
                        window.poptins[poptin_id].redirect_target = $clickedLink.prop("target");
                        showLog('Click handler - redirect_target set to:', $clickedLink.prop("target"));
                        showLog('Click handler - redirect_url set to:', $clickedLink.attr("href"));

                        if($popup.find(".poptin-form-submit-button").length){
                            $popup.find(".poptin-form-submit-button").trigger("click");
                        } else if($popup.find(".poptin-form-link-button").length){
                            $popup.find(".poptin-form-link-button").trigger("click");
                        }
                    }, 1500);
                    return false; // Additional prevention of default behavior
                });
            }
            if(jQ224(".poptin-form-link-button").length>0){
                jQ224(".poptin-form-link-button").each(function(){
                    var link_selector=jQ224(this).attr("id");
                    var linkbtn_sr=link_selector.substring(11,10);
                    var link_button_css_class = (link_selector == 'poptinForm2ndlinkbtnText') ? 'btn2ndDarkColor' : (link_selector == 'poptinForm3ndlinkbtnText') ? 'btn3rdDarkColor' : (link_selector == 'poptinForm4thlinkbtnText') ? 'btn4thDarkColor' : (link_selector == 'poptinForm5thlinkbtnText') ? 'btn5thDarkColor' :'btn6thDarkColor';

                    var targetHref=jQ224(this).attr("data-btnurl");
                    if(targetHref && convUrl){
                        var convHref = targetHref.replace("{conversion_url}",'conversion_url='+encodeURI(convUrl));
                            convHref = convHref.replace("%7Bconversion_url%7D",'conversion_url='+encodeURI(convUrl));
                            convHref = convHref.replace("{path_url}",'path_url='+encodeURI(convPath));
                            convHref = convHref.replace("%7Bpath_url%7D",'path_url='+encodeURI(convPath));

                        jQ224(this).attr("data-btnurl",convHref);
                    }

                    if(jQ224(this_pop).find('.'+link_button_css_class).length){
                        jQ224('#'+link_selector+' .froala-editor-link').each(function(){
                            jQ224(this).parent().attr('data-bg-'+linkbtn_sr+'color', jQ224(this).css('background-color'));
                        });
                        jQ224('#'+link_selector).mouseenter(function(){
                            jQ224(this).find('.froala-editor-link').css('background-color', '');
                        }).mouseleave(function(){
                            if(jQ224(this).find('.froala-editor-link').length){
                                jQ224(this).find('.froala-editor-link').get(0).style.setProperty('background-color', jQ224(this).attr('data-bg-'+linkbtn_sr+'color'), 'important');
                            }
                        });
                    }

                });
            }

            if(poptin.poptin_type == "lightbox" || poptin.poptin_type == "gamified"){
                if (click == undefined){
                    if(window.poptins[poptin.poptin_id].poptin_size == undefined){
                        window.poptins[poptin.poptin_id].poptin_size = {};
                    }
                    window.poptins[poptin.poptin_id].poptin_size.height = this_poptin_height;
                    window.poptins[poptin.poptin_id].poptin_size.width = this_poptin_width;
                }
                poptin_width = this_poptin_width || 800;
                poptin_height = this_poptin_height || 500;
                if(
                    (poptin.poptin_format == "format_3" || poptin.poptin_format == "format_9") && !poptin_height
                ) {
                    poptin_width = poptin_height;
                }
            }

            jQ224('.froala-editor-text, .froala-editor-ticker, .froala-editor-link').each(function(){
                var str = jQ224(this).get(0).innerText.replace(/&nbsp;/gi," ");
                jQ224(this).parents(".draggable").attr('aria-label', str);
            });

            jQ224('.froala-editor-button').each(function(){
                var str = jQ224(this).get(0).innerText.replace(/&nbsp;/gi," ");
                var input = jQ224(this).parent().find('input');
                if(input.length) {
                    input.attr('aria-label', str);
                } else {
                    jQ224(this).parent().attr('aria-label', str);
                }
            });

            jQ224(this_pop).attr('data-poptin-type',poptin.poptin_type).attr('data-poptin-format',poptin.poptin_format).attr('data-poptin-type-format',poptin.poptin_type+'_'+poptin.poptin_format);
            if(poptin.design_properties){
                jQ224(this_pop).attr('data-poptin-location',poptin.design_properties.poptin_location);
            }
            jQ224(this_pop).addClass('poptin-live');
            jQ224(this_pop).css({
                "display": "none",
                "margin": "0px auto",
                "transform":"translate(0,0)",
                "transition":"transform .3s ease-out",
                "min-width":poptin_width+"px",
                "max-width":poptin_width+"px",
                "width":poptin_width+"px",
                "min-height":poptin_height+"px",
                "max-height":poptin_height+"px",
                "height":poptin_height+"px",
                "z-index": "999999999999999",
                "position": (isEmbeddedPoptin?"absolute":"fixed"),
                "overflow": "visible",
                "left": "0px",
                "top": "0px",
                "bottom": "0px",
                "right": "0px",
                "line-height": "normal",
                "transform-origin": "bottom"
            });
            jQ224(this_pop + ".draggable-container:not(.poptin-tab-container)").css({"width": poptin_width+"px","background-clip":"padding-box"});
            jQ224(this_pop + ".alternative-background").css('box-shadow', '0 3px 12px rgba(0,0,0,.5)');
            jQ224(".poptin-popup.no-box-shadow .alternative-background").css('box-shadow', '');

            // Fallback background for circular thank you screens copied from main screens
            if(jQ224(this_pop + " #poptinDraggableContainer .alternative-background").length && !jQ224(this_pop + " #poptinThankYouScreen .alternative-background").length && jQ224(this_pop + " #poptinThankYouScreen").attr("data-thank-bg-cleared") != "1"){
                jQ224(this_pop + " #poptinThankYouScreen").prepend(jQ224(this_pop + " #poptinDraggableContainer .alternative-background").clone());
            }
            if(jQ224(this_pop + " #poptinMobileContainer .alternative-background").length && !jQ224(this_pop + " #poptinMobileThankYouScreen .alternative-background").length && jQ224(this_pop + " #poptinMobileThankYouScreen").attr("data-thank-bg-cleared") != "1"){
                jQ224(this_pop + " #poptinMobileThankYouScreen").prepend(jQ224(this_pop + " #poptinMobileContainer .alternative-background").clone());
            }

            // Not needed as we are using aria-label above
            var close_string = this_pop + ".close-icon, .poptin-popup[data-poptin-id="+poptin.poptin_id+"] #closeXButton, .poptin-popup[data-poptin-id="+poptin.poptin_id+"] #poptinFormCloseText";
            jQ224(close_string).attr('title', ( ifUserlangIsHe() ? "סגור" : "Close" )).attr('data-title', ( ifUserlangIsHe() ? "סגור" : "Close" ));
            jQ224(close_string).mouseenter(function(e){
                jQ224(close_string).attr('title', '');
            });
            jQ224(close_string).mouseleave(function(e){
                jQ224(close_string).attr('title', jQ224(close_string).attr('data-title'));
            });

            var submit_string = this_pop + "#poptinFormSubmitText";
            jQ224(submit_string).attr('title', ( ifUserlangIsHe() ? "שלח" : "Submit" )).attr('data-title', ( ifUserlangIsHe() ? "שלח" : "Submit" ));
            jQ224(submit_string).find('#poptinFormSubmitButton').val(( ifUserlangIsHe() ? "שלח" : "Submit" ));
            jQ224(submit_string).mouseenter(function(e){
                jQ224(submit_string).attr('title', '');
            });
            jQ224(submit_string).mouseleave(function(e){
                jQ224(submit_string).attr('title', jQ224(submit_string).attr('data-title'));
            });

            jQ224('.redirect-url-blank').each(function(){
                jQ224(this).html(jQ224(this).attr('href'));
            });

            if(poptin.poptin_type == "embedded"){
                var this_parent = jQ224(this_pop).parent();
                if( (jQ224(this_pop).parent().height() == 0) || (this_parent.css('height') == this_parent.css('line-height')) ) {
                    jQ224(this_pop).parent().css({'height': poptin_height+'px'});
                    jQ224(this_pop + "#closeXButton, "+this_pop + "#closeSkipButton").remove();
                    jQ224(this_pop).css('transform', 'scale(1, 0)');
                    jQ224(this_pop).attr('data-scale', 1);
                }
            }

            jQ224(this_pop + '.froala-image-wrapper').each(function(){
                var img_link = jQ224(this).find('a');
                if(img_link.length){
                    var overlay_clone = jQ224(this).find('.froala-img-overlay').clone();
                    jQ224(this).find('.froala-img-overlay').remove();
                    img_link.prepend(overlay_clone);
                }
            });

            if(poptin.poptin_type == "social" && ( poptin.poptin_format == "format_3" || poptin.poptin_format == "format_6") || (poptin.poptin_type == "sside" && poptin.poptin_format == "format_19") ){
                jQ224('.poptin-credit').css({'bottom':'auto','bottom':''})
            }

            // Add poptin-form-submit-button class to all draggable in mobile_format_6
            if (poptin.poptin_type == "mobile" && poptin.poptin_format == "format_6"){
                jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container:not(.poptin-tab-container) .draggable:not(#closeXButton)").addClass('poptin-form-submit-button');
            }

            // Remove X or Skip based on design settings
            if(poptin.design_properties != undefined){
                if(poptin.design_properties.poptin_design_close_options_type == "closing_options-x"){
                    jQ224(this_pop).find('[id="closeSkipButton"]').remove();
                } else if(poptin.design_properties.poptin_design_close_options_type == "closing_options-button"){
                    jQ224(this_pop).find('[id="closeXButton"]').remove();
                } else if(poptin.design_properties.poptin_design_close_options_type == "closing_options-"){
                    jQ224(this_pop).find('[id="closeXButton"], [id="closeSkipButton"]').remove();
                }
            }

            jQ224(this_pop).find('[id="closeXButton"], [id="closeSkipButton"]').each(function(){
                this_close_icon = jQ224(this).find('.close-icon');
                this_close_icon_width = parseInt(this_close_icon.css('width'));
                if(!this_close_icon.hasClass('updated') && this_close_icon_width == 32){
                    this_close_icon_width = 44;
                    this_close_icon.addClass('updated');
                    var x_width = this_close_icon_width + 'px';
                    var new_data = {
                        'width' : x_width,
                        'height' : x_width,
                        'line-height' : x_width,
                        'font-size' : x_width
                    }
                    this_close_icon.css(new_data);
                    jQ224(this).css(new_data);
                    if( (parseInt(jQ224(this).css('left')) + this_close_icon_width) > poptin_width ) {
                        jQ224(this).css('left', (poptin_width-this_close_icon_width)+'px' );
                    }
                }
            });

            // Make bar's parent height equal to bar
            if(poptin.poptin_type == "bar"){
                jQ224(this_pop).css({
                    'width': '1920px',
                    'max-width': '1920px',
                    'height': jQ224(this_pop + "#poptinDraggableContainer").height(),
                    'max-height': jQ224(this_pop + "#poptinDraggableContainer").height()
                });
            }

            // Remove shadow from flip timer
            if(isSafariPoptin || ifMobilePoptin){
                jQ224(this_pop).addClass('clean-timer');
            }

            // For whatsapp template in mobile
            if(ifMobilePoptin && jQ224(this_pop).length){
                // showLog( jQ224(this_pop).html() );
                jQ224(this_pop).html( jQ224(this_pop).html().replace(/(web.whatsapp.com)/g, "api.whatsapp.com") );
            }

            // Is new editor?
            if( poptin.poptin_type in fr_templates && fr_templates[poptin.poptin_type] >= parseInt(poptin.poptin_format.split('_')[1]) ){
                jQ224(this_pop).addClass('old-popup').removeClass('new-popup');
            } else {
                jQ224(this_pop).addClass('new-popup').removeClass('old-popup');
                var poptin_lang = jQ224(this_pop).find('#poptinDraggableContainer').attr('data-lang');
                var is_eng = poptin_lang && poptin_lang == "he" ? false : true;
                if(is_eng && user_lang == "en"){
                    if (!poptin_disable_fonts) {
                        jQ224(this_pop).css('font-family', 'Poppins');
                        if(jQ224("#poptin_poppins_font_preload").length==0){
                            jQ224('head').append('<link rel="preload" id="poptin_poppins_font_preload" as="style" href="https://fonts.popt.in?family=Poppins&display=swap">');
                        }
                        if(jQ224("#poptin_poppins_font_link").length==0){
                            jQ224('head').append('<link rel="stylesheet" id="poptin_poppins_font_link" href="https://fonts.popt.in?family=Poppins&display=swap">');
                        }
                    }
                } else {
                    jQ224(this_pop).css('font-family', 'Open Sans Hebrew');
                    if(jQ224("#poptin_opensanshebrew_font_preload").length==0){
                        jQ224('head').append('<link rel="preload" id="poptin_opensanshebrew_font_preload" as="style" href="https://fonts.popt.in/?family=Open%20Sans%20Hebrew&display=swap">');
                    }
                    if(jQ224("#poptin_opensanshebrew_font_link").length==0){
                    jQ224('head').append('<link rel="stylesheet" id="poptin_opensanshebrew_font_link" href="https://fonts.popt.in/?family=Open%20Sans%20Hebrew&display=swap">');
                    }
                }

            }

            // Keep z-index highest via css
            jQ224('.poptin-popup #closeXButton').css({'z-index':''});
            jQ224('.poptin-popup.old-popup #closeXButton').css({'left':'auto','right':'auto'});

            jQ224(".no-show-icon").css('position', 'relative');
            jQ224(".flip .no-show-icon").css('position', 'absolute');

            if ( field_desing[poptin.poptin_type + '_' + poptin.poptin_format] != undefined && field_desing[poptin.poptin_type + '_' + poptin.poptin_format].type == "vertical" ) {
                jQ224(this_pop + ".inputs-container input:not([type='checkbox'])").css('width','');
            }

            // For really old poptins
            if( poptin.poptin_type == 'lightbox' || poptin.poptin_type == 'gamified' ) {
                this_pop_width = jQ224(this_pop + ".draggable-container:not(.poptin-tab-container)").attr('data-width');
                if( this_pop_width == undefined || this_pop_width == '' ) {
                    jQ224(this_pop).css({
                        "right": "0",
                        "left": "0",
                        "top": (jQ224(window).height() - 500)/2
                    })
                    jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"], .poptin-popup[data-poptin-id="+poptin.poptin_id+"] .draggable-container:not(.poptin-tab-container)").css('width', 800);
                    jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"], .poptin-popup[data-poptin-id="+poptin.poptin_id+"] .draggable-container:not(.poptin-tab-container)").css('height', 500);
                }
            }

            if(poptin.design_properties.field_checkbox_required == 'on'){
                jQ224('[data-poptin-id='+poptin.poptin_id+'] input[name="poptinDesignInputTextFieldCheckbox"]').prop('required', true );
            }

            if(poptin.design_properties.field_checkbox_default_marked == 'on'){
                jQ224('[data-poptin-id='+poptin.poptin_id+'] input[name="poptinDesignInputTextFieldCheckbox"]').prop('checked', true );
            }

            // Close poptin when close button is clicked
            jQ224('.poptin-form-close-button').click(function(){

                var closeBtnAttr = jQ224(this).data();
                var parentPoptinId = jQ224(this).parents('.poptin-popup').attr('data-poptin-id');

                if(!checkPoptinCloseCriteria(parentPoptinId)){
                    setClosePoptinOnXCookie(parentPoptinId);
                }


                if(closeBtnAttr['countConversion'] && closeBtnAttr['countConversion'] === true) {
                    var btn_conv_type = jQ224(this).attr("id");
                    if(btn_conv_type === "poptinFormCloseText") {
                        btn_conv_type = "close_btn";
                        poptinConversion(poptin, null, btn_conv_type, this);
                    }
                }else{
                    if(closeBtnAttr["linkUrl"] && closeBtnAttr["linkUrl"] == true){
                        closePoptin( parentPoptinId, true );
                        if(closeBtnAttr["btnurl"]) {
                            if(closeBtnAttr["btnurl"].indexOf('tel:')!='-1' || closeBtnAttr["btnurl"].indexOf('sms:')!='-1' || closeBtnAttr["btnurl"].indexOf('mailto:')!='-1'){
                                window.location.href = closeBtnAttr["btnurl"];
                                closePoptin( parentPoptinId );
                            }else{
                                if( !(closeBtnAttr["btnurl"].indexOf("http://") != -1 || closeBtnAttr["btnurl"].indexOf("https://") != -1 ) ) {
                                    closeBtnAttr["btnurl"] = "//" + closeBtnAttr["btnurl"];
                                }
                                if( !closeBtnAttr["btntarget"] ){
                                    window.location.href = closeBtnAttr["btnurl"];
                                }else{
                                    simpleButtonRedirect(closeBtnAttr["btnurl"], true);
                                }
                            }
                        }
                    }else if(closeBtnAttr["launchPoptin"] && closeBtnAttr["launchPoptin"] == true){
                        closePoptin( parentPoptinId, true);
                        var poptin_redirect ={};
                        poptin_redirect.redirectFromBtns = true;
                        poptin_redirect.poptin_from = parentPoptinId;
                        poptin_redirect.poptin_to = closeBtnAttr["launchPoptinId"];
                        if(closeBtnAttr["launchPoptinId"]){
                            redirectToPoptin(poptin_redirect);
                        }
                    }else{
                        closePoptin( parentPoptinId );
                    }
                }
            });
            jQ224('.poptin-form-close-button').on("keydown",function(e){
                if (e.keyCode === 32 || e.keyCode === 13) {
                    jQ224(e.target).click();
                }
            });

            // Add left css property to old timer poptins
            timer_container = jQ224('.timer-container');
            timer_container.css({'position':''});
            if(timer_container && timer_container.attr('style') && timer_container.attr('style').indexOf('left') == -1) {
                points_count = 0;
                jQ224('.timer-points').each(function(){
                    if( jQ224(this).is(':visible') ){ points_count++ }
                });
                timer_left = '260px';
                if(points_count > 1){ timer_left = '114px' }
                timer_container.css({'left': timer_left});
            }

            // Change phone input type from 'text' to 'tel'
            setTelForMobile(poptin);
            // Copy background to '.poptin_thank_you_screen' element
            if (poptin.poptin_type == "lightbox" && (poptin.poptin_format == "format_3" || poptin.poptin_format == "format_9") ){
                jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_thank_you_screen").filter(function(){ return jQ224(this).attr("data-thank-bg-cleared") != "1"; }).prepend(jQ224("[data-poptin-id="+poptin.poptin_id+"] #liteboxFormat3Circle").clone( true ));
            }else{
                var draggable_container = jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container:not(.poptin-tab-container)");
                jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_thank_you_screen:not('.edited')").filter(function(){ return jQ224(this).attr("data-thank-bg-cleared") != "1"; }).css({
                    'height':draggable_container.css('height'),
                    'background-image': draggable_container.css('background-image'),
                    'background-size': draggable_container.css('background-size'),
                    'background-color':draggable_container.css('background-color'),
                    'background': (draggable_container.css('background-image')!="none"? draggable_container.css('background-image') : '')+' '+draggable_container.css('background-color')
                });
                jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_play_screen:not('.edited')").css({
                    'height':draggable_container.css('height'),
                    'background-image': draggable_container.css('background-image'),
                    'background-size': draggable_container.css('background-size'),
                    'background-color':draggable_container.css('background-color'),
                    'background': (draggable_container.css('background-image')!="none"? draggable_container.css('background-image') : '')+' '+draggable_container.css('background-color')
                });
                jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_winning_screen:not('.edited')").css({
                    'height':draggable_container.css('height'),
                    'background-image': draggable_container.css('background-image'),
                    'background-size': draggable_container.css('background-size'),
                    'background-color':draggable_container.css('background-color'),
                    'background': (draggable_container.css('background-image')!="none"? draggable_container.css('background-image') : '')+' '+draggable_container.css('background-color')
                });
                jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_losing_screen:not('.edited')").css({
                    'height':draggable_container.css('height'),
                    'background-image': draggable_container.css('background-image'),
                    'background-size': draggable_container.css('background-size'),
                    'background-color':draggable_container.css('background-color'),
                    'background': (draggable_container.css('background-image')!="none"? draggable_container.css('background-image') : '')+' '+draggable_container.css('background-color')
                });
                draggable_container.css({
                    'background': (draggable_container.css('background-image')!="none"? draggable_container.css('background-image') : '')+' '+draggable_container.css('background-color')
                });
                // draggable_container.attr('background', draggable_container.css('background'));
            }

            jQ224(".poptin-form-submit-button *, .poptin-form-close-button *, [data-poptin-id="+poptin.poptin_id+"] .o-close, [data-poptin-id="+poptin.poptin_id+"] .o-close *").css('cursor', 'pointer');
            // Append special style for poptin mobile type
            if (
                poptin.poptin_type == "mobile" && (poptin.poptin_format == "format_1" || poptin.poptin_format == "format_6")
            ){
                poptin_style = '<style type="text/css">.draggable-container:not(.poptin-tab-container) .fa-phone-square:before{color:'+jQ224("[data-poptin-id="+poptin.poptin_id+"] .fa-phone-square").css('color')+' !important}</style>';
                jQ224("body").append(poptin_style);
            }
            ifAndroidPoptinKeyborad(poptin,click);

            // if (poptin.poptin_type == "mobile"){
            //  // showLog('mobile');
            //  var fixed = document.getElementById('mobileFormat2');

            //  fixed.addEventListener('touchmove', function(e) {
            //          // showLog(e.target);
            //          e.preventDefault();
            //  }, false);
            // }

            updateStylesForDirection(user_lang, poptin);
            updatePhoneInputInlineStyle(poptin, user_lang);
            checkForEmailPhoneValidations(window.poptins);

            direction = poptin.design_properties.poptin_design_entry_effect.split('-')[1];

            // if not content lock
            if (!parseInt(poptin.design_properties.poptin_design_content_lock)){

                // If poptin auto close is on
                // -> set timeout
                if (poptin.design_properties.poptin_design_auto_close != undefined){
                    setTimeout(function() {
                        showLog('close poptin auto after '+poptin.design_properties.poptin_design_auto_close_sec+' seconds');
                        ensurePoptinTrigger(poptin.poptin_id);
                        window.poptins[poptin.poptin_id].poptin_trigger.close_trigger = "auto_close";
                        closePoptin(poptin.poptin_id);
                    },  parseInt(poptin.design_properties.poptin_design_auto_close_sec)*1000);
                }
                // If poptin close on screen is on
                if (parseInt(poptin.design_properties.poptin_design_close_on_screen_click)){
                    // Set mouse event
                    // Set flag
                    var poptin_area_flag = false;
                    jQ224(this_pop).on("mouseenter",function(event) {
                        if (click == undefined){
                            ensurePoptinTrigger(poptin.poptin_id);
                            window.poptins[poptin.poptin_id].poptin_trigger.poptin_area_flag = true;
                        }else{
                            poptin_area_flag = true;
                        }
                    }).on("mouseleave",function(event) {
                        if (click == undefined){
                            ensurePoptinTrigger(poptin.poptin_id);
                            window.poptins[poptin.poptin_id].poptin_trigger.poptin_area_flag = false;
                        }else{
                            poptin_area_flag = false;
                        }
                    });
                    // set click event on document
                        jQ224(window).click(function(event) {
                            // if click on screen
                            if (!(poptin.poptin_type == "lightbox" || poptin.poptin_type == "gamified") ){
                                if(!jQ224(event.target).closest(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").length && !(!click ? (typeof window.poptins[poptin.poptin_id].poptin_area_flag != 'undefined' ? window.poptins[poptin.poptin_id].poptin_area_flag : poptin_area_flag ) : poptin_area_flag)) {
                                    if(jQ224(this_pop).is(":visible")) {
                                            showLog('close poptin poptin_design_close_on_screen_click1');
                                            ensurePoptinTrigger(poptin.poptin_id);
                                            window.poptins[poptin.poptin_id].poptin_trigger.close_trigger = "bg_click";
                                            closePoptin(poptin.poptin_id,false,true);
                                            setTimeout(() => {
                                                setClosePoptinOnXCookie(poptin.poptin_id);
                                            }, 1000);
                                    }
                                }
                            }else{
                                var evt_poptin_id=jQ224(event.target).closest('.poptin-popup').attr('data-poptin-id');
                                // Skip if event target is from iti--container
                                if(jQ224(event.target).closest(".iti--container").length) {
                                    return;
                                }
                                if(!jQ224(event.target).closest(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").length && (evt_poptin_id==poptin.poptin_id || typeof evt_poptin_id=='undefined')) {
                                    if ( (click == undefined ? !(poptins?.[poptin?.poptin_id]?.poptin_trigger?.poptin_area_flag ?? poptin_area_flag) : !poptin_area_flag ) ){
                                        if(jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").is(":visible")) {
                                            showLog('close poptin'+poptin.poptin_id+' poptin_design_close_on_screen_click2');
                                            ensurePoptinTrigger(poptin.poptin_id);
                                            window.poptins[poptin.poptin_id].poptin_trigger.close_trigger = "bg_click";
                                            closePoptin(poptin.poptin_id,false,true);
                                            setTimeout(() => {
                                                setClosePoptinOnXCookie(poptin.poptin_id);
                                            }, 1000);
                                        }
                                    }
                                }
                            }
                        });

                }
                // Set poptin close option
                if (poptin.design_properties.poptin_design_close_options_type != "closing_options-"){
                    if (poptin.design_properties.poptin_design_close_options_type == "closing_options-x"){
                        jQ224("[data-poptin-id="+poptin.poptin_id+"] #closeSkipButton").remove();
                        if( poptin.poptin_type in fr_templates && fr_templates[poptin.poptin_type] >= parseInt(poptin.poptin_format.split('_')[1]) ){
                            jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container:not(.poptin-tab-container), .poptin-popup[data-poptin-id="+poptin.poptin_id+"] .poptin_thank_you_screen, .poptin-popup[data-poptin-id="+poptin.poptin_id+"] .poptin_play_screen, .poptin-popup[data-poptin-id="+poptin.poptin_id+"] .poptin_winning_screen, .poptin-popup[data-poptin-id="+poptin.poptin_id+"] .poptin_losing_screen").prepend(html_poptin_x_button);
                        } else {
                            jQ224('[data-poptin-id="'+poptin.poptin_id+'"] #closeXButton').on("mouseenter", function () {
                                jQ224(this).removeAttr("onclick");
                            });
                            jQ224(document).on('click', '[data-poptin-id="'+poptin.poptin_id+'"] #closeXButton', function() {
                                // if (!jQ224('#closeXButton').attr('onclick') || !jQ224('#closeXButton').attr('onclick').includes('closePoptinOnXclick')) {
                                //     closePoptinOnXclick(jQ224(this).get(0));
                                // }
                                closePoptinOnXclick(jQ224(this).get(0));
                            });
                        }
                        if (poptin.design_properties.poptin_design_show_x_comment != null && !ifMobilePoptin){
                            // showLog('show poptin x comment: '+poptin.design_properties.poptin_design_show_x_comment);
                            if (poptin.design_properties.poptin_design_show_x_comment.length >=1){
                                jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container:not(.poptin-tab-container)").prepend(html_button_note);
                                $note = jQ224("[data-poptin-id="+poptin.poptin_id+"] .close-button-note");
                                $note.text(poptin.design_properties.poptin_design_show_x_comment);
                                if (poptin.design_properties.poptin_location.indexOf('right') > -1 || poptin.poptin_type=='bar'){
                                    jQ224("[data-poptin-id="+poptin.poptin_id+"] .close-button-note").css('right','0px');
                                }

                                if (poptin.design_properties.poptin_location.indexOf('top') > -1){
                                    jQ224("[data-poptin-id="+poptin.poptin_id+"] .close-button-note").css('top','0px');
                                }else{
                                    setTimeout(function(){
                                        $margin = parseInt($note.css('top'))*(-1) >= $note.height() ? $note.css('top') : '-'+($note.height()+(parseInt($note.css('top'))*(-1))/1.5)+'px'
                                        // $note.css('top',$margin);
                                        // showLog('$margin', $margin);
                                        $note.css('top','-65px');
                                    },100);
                                }
                                initializeCloseButtonNote(poptin);
                            }
                        }
                    }else if (poptin.design_properties.poptin_design_close_options_type == "closing_options-button"){
                        jQ224("[data-poptin-id="+poptin.poptin_id+"] #closeXButton").remove();
                        if( poptin.poptin_type in fr_templates && fr_templates[poptin.poptin_type] >= parseInt(poptin.poptin_format.split('_')[1]) ){
                            if (poptin.design_properties.poptin_design_show_x_comment != null){
                                jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container:not(.poptin-tab-container), .poptin-popup[data-poptin-id="+poptin.poptin_id+"] .poptin_thank_you_screen, .poptin-popup[data-poptin-id="+poptin.poptin_id+"] .poptin_play_screen, .poptin-popup[data-poptin-id="+poptin.poptin_id+"] .poptin_winning_screen, .poptin-popup[data-poptin-id="+poptin.poptin_id+"] .poptin_losing_screen").prepend('<button type="button" id="closeXButton" onclick="closePoptinOnXclick(this);" class="close-x-button"  style="width: initial;text-align: right;display:none; margin-top: -2px;-webkit-appearance: none;padding: 5px;cursor: pointer;background: 0 0;border: 0;float: right;font-size: 25px;line-height: 0.5;color: #000;text-shadow: 0 1px 0 #fff;filter: alpha(opacity=20);opacity: 0.7;text-transform: none;overflow: visible;font-family: inherit;margin: 0;font: inherit;align-items: flex-start;text-align: center;text-indent: 0px;letter-spacing: normal;word-spacing: normal;text-rendering: auto;webkit-writing-mode: horizontal-tb;font-weight:bold;z-index: 9999;position: relative;">'+(poptin.design_properties.poptin_design_show_x_comment || (user_lang=="en"?skip_en:skip_he))+'</button>');
                            }else{
                                jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container:not(.poptin-tab-container)").prepend(html_poptin_skip_button);
                            }
                        } else {
                            jQ224(document).on('click', '[data-poptin-id="'+poptin.poptin_id+'"] #closeXButton', function(){
                                closePoptinOnXclick(jQ224(this).get(0));
                            });
                        }
                    }

                    // Set show 'x' button after 's' second
                    if (poptin.design_properties.poptin_design_show_x_after_sec != null && poptin.design_properties.poptin_design_show_x_after_sec != 0){
                        if (poptin.design_properties.poptin_design_close_options_type == "closing_options-button"){
                            jQ224("[data-poptin-id="+poptin.poptin_id+"] .close-x-button:not(#closeSkipButton)").remove();
                            ensurePoptinTrigger(poptin.poptin_id);
                            window.poptins[poptin.poptin_id].poptin_trigger.skip_button_sec_counter =  parseInt(poptin.design_properties.poptin_design_show_x_after_sec);
                            var first_close_button = '';
                            if(user_lang=="en"){
                                first_close_button = (poptin.design_properties.poptin_design_show_x_comment || (user_lang=="en"?skip_en:skip_he))+' ('+window.poptins[poptin.poptin_id].poptin_trigger?.skip_button_sec_counter+')'
                            } else {
                                first_close_button = '('+window.poptins[poptin.poptin_id].poptin_trigger?.skip_button_sec_counter+') '+(poptin.design_properties.poptin_design_show_x_comment || (user_lang=="en"?skip_en:skip_he))
                            }
                            jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container:not(.poptin-tab-container)").prepend('<button type="button" id="closeXButton" onclick="closePoptinOnXclick(this);" class="close-x-button"  style="width: initial;text-align: right;display:none; margin-top: -2px;-webkit-appearance: none;padding: 5px;cursor: pointer;background: 0 0;border: 0;float: right;font-size: 25px;line-height: 0.5;color: #000;text-shadow: 0 1px 0 #fff;filter: alpha(opacity=20);opacity: 0.7;text-transform: none;overflow: visible;font-family: inherit;margin: 0;font: inherit;align-items: flex-start;text-align: center;text-indent: 0px;letter-spacing: normal;word-spacing: normal;text-rendering: auto;webkit-writing-mode: horizontal-tb;font-weight:bold;z-index: 9999;position: relative;">'+first_close_button+'</button>');
                            jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container:not(.poptin-tab-container) .close-x-button").css({"display":"block","opacity":"0.5","cursor":"not-allowed"}).prop('disabled',true);
                            var interval = setInterval(function() {
                                if (window.poptins[poptin.poptin_id].poptin_trigger?.skip_button_sec_counter == 0) {
                                    clearInterval(interval);
                                    var close_text = '';
                                    if(poptin.design_properties.poptin_design_close_options_type == 'closing_options-x'){
                                        close_text = '&times;';
                                    } else if(poptin.design_properties.poptin_design_close_options_type == 'closing_options-button'){
                                        close_text = user_lang=="en"?skip_en:skip_he;
                                    }
                                    jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container:not(.poptin-tab-container) .close-x-button").html(close_text).css({"opacity":"1","cursor":"pointer"}).prop('disabled',false);
                                } else {
                                    ensurePoptinTrigger(poptin.poptin_id);
                                    window.poptins[poptin.poptin_id].poptin_trigger.skip_button_sec_counter--;
                                    // Display 'counter' wherever you want to display it.
                                    var close_timer_text = '';
                                    if(user_lang=="en"){
                                        close_timer_text = poptin.design_properties.poptin_design_show_x_comment + ' ('+window.poptins[poptin.poptin_id].poptin_trigger?.skip_button_sec_counter+')';
                                    } else {
                                        close_timer_text = '('+window.poptins[poptin.poptin_id].poptin_trigger?.skip_button_sec_counter+') '+poptin.design_properties.poptin_design_show_x_comment;
                                    }
                                    jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container:not(.poptin-tab-container) .close-x-button").html(close_timer_text);
                                }
                                if( jQ224("[data-poptin-id="+poptin.poptin_id+"]").attr("data-poptin-type") == "browsing" && jQ224("[data-poptin-id="+poptin.poptin_id+"]").attr("data-poptin-location") == "right-top" ) {
                                    jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container:not(.poptin-tab-container) .close-x-button").css('padding', '5px 5px 5px 20px');
                                }
                            }, 1000);
                        }else{
                            jQ224("[data-poptin-id="+poptin.poptin_id+"] #closeSkipButton").remove();
                            var these_x = jQ224(this_pop + ".draggable-container:not(.poptin-tab-container) .close-x-button, .poptin-popup[data-poptin-id="+poptin.poptin_id+"] > .close-x-button");
                            if( GetIEVersion() == 0 ) {
                                these_x.hide();
                            }
                            setTimeout(function() {
                                showLog('show poptin x button after '+poptin.design_properties.poptin_design_show_x_after_sec+' seconds');
                                these_x.show(100);
                            }, parseInt(poptin.design_properties.poptin_design_show_x_after_sec)*1000);
                        }
                    }else{
                        // Just show button
                        jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container:not(.poptin-tab-container) .close-x-button").show(100);
                    }
                } else {
                    jQ224("[data-poptin-id="+poptin.poptin_id+"] .close-x-button").remove();
                }
            }
            // Poptin show animation speed
            poptin_animation_speed = 300;

            // Set global poptin container
            var _this = jQ224(this_pop);

            // Set default poptin postion in the screen
            // Depend on poptin_type and poptin_format
            // Video for all poptins
            if(_this.find('.froala-editor-video').length || _this.find('.draggable.image-change-video').length){

                var video_parent_top = _this.find(".draggable-container").find(".froala-video-wrapper").css("top"),
                    video_parent_left = _this.find(".draggable-container").find(".froala-video-wrapper").css("left"),
                    video_parent_width = _this.find(".draggable-container").find(".froala-video-wrapper").css("width"),
                    video_parent_height = _this.find(".draggable-container").find(".froala-video-wrapper").css("height");

                var frameWrapper = _this.find(".draggable-container #poptin"+_this.data('source'));
                var videoDataFromElement = _this.find('.froala-editor-video .thumbnail-video').data();
                var videoDataFromAttribute = _this.data();
                frameWrapper.parent().css({
                    top:video_parent_top,
                    left:video_parent_left,
                    width:video_parent_width,
                    height:video_parent_height
                });

                var mute_video = '';
                var is_autoplay = videoDataFromElement.autoplay || videoDataFromAttribute.autoplay;
                var source = videoDataFromElement.source || videoDataFromAttribute.source;
                var url = videoDataFromElement.url || videoDataFromAttribute.url;
                if(!isFirefoxPoptin && (is_autoplay == "true" || is_autoplay == true)){mute_video = '&mute=1';}
                _this.find('#poptin'+source).attr('src',url+mute_video).parent().css('display','block');
                _this.find('.draggable.image-change-video').remove();
                _this.find('.froala-video-wrapper').css('display','none');
            }

            if( _this.find('.fr-shopify-products').length > 0 && _this.find('#shopifyProductsJSON').length > 0 ){
                jQ224(this_pop+' .fr-shopify-products .fr-shopify-item').css({
                    'position':'relative','z-index':2
                });
            }

            if( _this.find('.fr-wix-products').length > 0 && _this.find('#wixProductsJSON').length > 0 ){
                jQ224(this_pop+' .fr-wix-products .fr-wix-item').css({
                    'position':'relative','z-index':2
                });
            }

            if (poptin.poptin_type == "lightbox"){
                if (poptin.poptin_format == "format_3" || poptin.poptin_format == "format_9"){
                    jQ224(this_pop + ".draggable-container:not(.poptin-tab-container)").css({"box-shadow":"none"});
                }
                // _this.css({"top": poptin_position_center_up+"px",'margin':'0 auto'});
            }else if (poptin.poptin_type == "bar"){
                switch(poptin.design_properties.poptin_location) {
                    case "center-top":
                        _this.css({"top":"0px","bottom":""});
                        break;
                    default:
                        _this.css({"top": "","bottom":"0px"});
                        break;
                }
            }else if (poptin.poptin_type == "sside" || poptin.poptin_type == "social"){
                switch(poptin.design_properties.poptin_location){
                    case "left-top":
                        _this.css({'left':'0px','right':'','margin':'0px',"top":"0px","bottom":""});
                        break;
                    case "left-midlle":
                        _this.css({'left':'0px','right':'','margin':'0px',"top": (window.innerHeight-poptin_height)/2+"px","bottom":""});
                        break;
                    case "left-bottom":
                        // _this.css({'left':'0px','right':'','margin':'0px',"top": (window.innerHeight-poptin_height - ((poptin.poptin_type+'_'+poptin.poptin_format == "social_format_2" || poptin.poptin_type+'_'+poptin.poptin_format == "social_format_6")?40:0)) +"px"});
                        _this.css({'left':'0px','right':'','margin':'0px',"bottom":"0px","top":""});
                        break;
                    case "center-top":
                        _this.css({'left':(window.innerWidth-poptin_width)/2,'right':'','margin':'0px',"top":"0px","bottom":""});
                        break;
                    case "center-midlle":
                        _this.css({'left':(window.innerWidth-poptin_width)/2,'right':'','margin':'0px',"top": (window.innerHeight-poptin_height)/2+"px","bottom":""});
                        break;
                    case "center-bottom":
                        // _this.css({'left':(window.innerWidth-poptin_width)/2,'right':'','margin':'0px',"top": (window.innerHeight-poptin_height - ((poptin.poptin_type+'_'+poptin.poptin_format == "social_format_2" || poptin.poptin_type+'_'+poptin.poptin_format == "social_format_6")?40:0))+"px"});
                        _this.css({'left':(window.innerWidth-poptin_width)/2,'right':'','margin':'0px',"bottom":"0px","top":""});
                        break;
                    case "right-top":
                        _this.css({'left':'','right':'0px','margin':'0px',"top":"0px","bottom":""});
                        break;
                    case "right-midlle":
                        _this.css({'left':'','right':'0px','margin':'0px',"top": (window.innerHeight-poptin_height)/2+"px","bottom":""});
                        break;
                    case "right-bottom":
                        _this.css({'left':'','right':'0px',"bottom":"0px","top":""});
                        break;
                }
                if(poptin.poptin_type == "social"){
                    if (poptin.poptin_format == "format_1" || poptin.poptin_format == "format_5" )
                        _this.find('.close-x-button').css({'position':'absolute','top':'0px','right':'0px','z-index':'1','line-height':'26px'});
                    else if (poptin.poptin_format == "format_3" || poptin.poptin_format == "format_7"){
                        _this.css({"box-shadow":"none !important","opacity":"0","visability":"hidden"});
                        _this.find('img').first().remove();
                    }
                }
            }else if (poptin.poptin_type == "bside"){
                if (poptin.design_properties.poptin_location!=="left")
                    _this.css({"left":"","top":"","right":"0px",'bottom':'0px'});
                else
                    _this.css({"right":"","top":"","left":"0px",'bottom':'0px'});
            }else if (poptin.poptin_type == "browsing" || poptin.poptin_type == "fullpage" || poptin.poptin_type == "mobile"){
                _this.css({"bottom":"","right":""});
                if (poptin.poptin_type == "mobile"){
                    if (poptin.poptin_format == "format_3" || poptin.poptin_format == "format_8"){
                        jQ224(this_pop + ".draggable-container:not(.poptin-tab-container)").css({"box-shadow":"none"});
                        _this.css({"bottom":"0px","right":"0px"});
                    }
                }
                if (poptin.poptin_type == "fullpage"){
                    if (ifScrollVisible()){
                        jQ224(this_pop + ".draggable-container:not(.poptin-tab-container) .close-x-button").css({'padding-right':'25px'});
                    }
                    if (poptin.poptin_format == "format_3" || poptin.poptin_format == "format_7"){
                        jQ224(this_pop + ".poptin-popup > div").css({'background-image':''});
                    }
                }
                if (poptin.poptin_type == "browsing"){
                    jQ224(this_pop + ".draggable-container:not(.poptin-tab-container) .close-x-button").css({'padding-right':'15px'});
                    if (jQ224(this_pop).hasClass('old-popup') && poptin.design_properties.poptin_location=="right-top"){
                        _this.css({'left':'','right':'0px','-moz-transform': 'scaleX(-1)','-o-transform': 'scaleX(-1)','-webkit-transform':'scaleX(-1)','transform':'scaleX(-1)','filter': 'FlipH','-ms-filter': "FlipH"});
                        _this.find('p').css({'-moz-transform': 'scaleX(-1)','-o-transform': 'scaleX(-1)','-webkit-transform':'scaleX(-1)','transform':'scaleX(-1)','filter': 'FlipH','-ms-filter': "FlipH"});
                        setTimeout(function(){
                            _this.find('.poptin-credit').css('transform','scaleX(-1)');
                        },300);
                    }
                }
                if (poptin.poptin_type == "mobile"){
                    switch(poptin.design_properties.poptin_location){
                        case "center-top":
                            _this.css({"top": 0+"px"});
                            break;
                        case "center-midlle":
                            _this.css({"top": (window.innerHeight-poptin_height)/2+"px"});
                            break;
                        case "center-bottom":
                            _this.css({"top": (window.innerHeight-poptin_height)+"px"});
                            break;
                    }
                }else{
                    _this.css({"top":"0px"});
                }
            }else if (poptin.poptin_type == "gamified"){
                if (poptin.poptin_format == "format_1" ){
                // jQ224(this_pop + ".draggable-container").css({"box-shadow":"none"});

                    jQ224(this_pop+' .fr-giftbox-images .fr-giftbox').css({
                        'cursor': 'pointer','position':'relative','z-index':2
                    });
                    jQ224(this_pop+' .fr-giftbox-images .fr-giftbox img.giftbox-img').css({
                        'cursor': 'pointer'
                    });
                }
                // _this.css({"top": poptin_position_center_up+"px",'margin':'0 auto'});
            }

            if( jQ224(this_pop+' .fr-wix-products') && jQ224(this_pop+' .fr-wix-products').length > 0 ){
                if((typeof window.wixDevelopersAnalytics !== 'undefined') || (typeof poptin_landing_page!='undefined' && poptin_landing_page == true)){
                    // wait until ajax processed
                    showLog('process wix ajax');
                    setWixRecentlyViewedProduct();
                    wixProductRecommendations(poptin);
                    getWixRecommendedProducts(poptin).then(function(data) {
                        if(data.display == true){
                            showLog('show popup if products available');
                            showPoptinHook();
                        }
                    }).catch(function(err) {
                    console.log("Error while processing wix ajax: ",err);
                    })
                }
            }

            if( jQ224(this_pop+' .fr-shopify-products') && jQ224(this_pop+' .fr-shopify-products').length > 0 ){
                if((window.Shopify !== undefined && window.Shopify.shop) || (typeof poptin_landing_page!='undefined' && poptin_landing_page == true)){
                    // wait until ajax processed
                    showLog('process shopify ajax');
                    setShopifyRecentlyViewedProduct();
                    shopifyProductRecommendations(poptin);
                    getShopifyRecommendedProducts(poptin).then(function(data) {
                        if(data.display == true){
                            showLog('show popup if products available');
                            showPoptinHook();
                        }
                    }).catch(function(err) {
                    console.log("Error while processing shopify ajax: ",err);
                    })
                }
            }else{
                showPoptinHook();
            }

            function showPoptinHook(){
                if (poptin.poptin_type == "fullpage"){
                    // Display poptin
                    jQ224(this_pop).css('opacity', 0);
                    showPoptin(poptin, click,1);
                    // Set Accessibility
                    setTimeout(function(){
                        setAccessibility(poptin);
                    }, 300);
                }

                resize_delay = 100;
                // generator = jQ224('meta[name=generator]').attr("content");
                // if( generator && generator.toLowerCase().indexOf("wix") >= 0 ) {
                if (poptin.poptin_type == "fullpage"){
                    resize_delay = 350;
                }

                // Change poptin postion and size depend on screen size
                setTimeout(function() {
                    windowResize(poptin, click);
                    doResizePoptin(poptin, click);
                    if (poptin.poptin_type != "fullpage"){
                        // Display poptin
                        setTimeout(function(){
                            showPoptin(poptin, click,1);
                            //  Set Accessibility
                            setTimeout(function(){
                                setAccessibility(poptin);
                            }, 300);
                        }, 300);
                    }
                },resize_delay);
                // Reset relevat cookies to default value
                resetReleventCookie(poptin);
            } // showPoptinHook

            // disable scroll so touch event can work for mobile - scratch popup
            if (ifMobilePoptin && poptin.poptin_type+'_'+poptin.poptin_format == "gamified_format_2") {
                if (jQ224('[data-poptin-id="'+poptin.poptin_id+'"] #poptinDraggableContainer').length) {
                    // store the current scroll position
                    scratchPopupInitialScrollPosition = window.scrollY;
                    scratchPopupActive = true;
                    jQ224('html, body').css({
                        'overflow': 'hidden',
                        'height': '100vh'
                    });
                }
            }

            if (poptin.poptin_type+'_'+poptin.poptin_format == "gamified_format_2") {
                if (jQ224('[data-poptin-id="'+poptin.poptin_id+'"] #poptinDraggableContainer').length) {
                    jQ224('[data-poptin-id="'+poptin.poptin_id+'"] #poptinDraggableContainer .poptin-couponbg-wrapper').css({ position: 'absolute' })
                }
            }

        }

        function ifUserlangIsHe(){
            return user_lang=="he";
        }

        /**
         * Trigger functions: setPoptin()
         * parameters       : Poptin:Poptin Object
         * Desc             : set Phone input to 'tel' for mobile user
         */
        function setTelForMobile(poptin){
            if (ifMobilePoptin){
                showLog('setTelForMobile');
                jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] #poptinDesignInputTextFieldPhone").attr('type','tel');
            }
        }
        /**
         * Trigger functions: setPoptin()
         * parameters       : Poptin:Poptin Object
         * Desc             : set Accessibility tabindex and alt, title for the close 'x' button
         */
        function setAccessibility(poptin){

            jQ224('.poptin-popup [role="application"]').removeAttr("role");
            jQ224('.poptin-popup').attr("role", "application");
            jQ224('.poptin-popup form').attr("role", "form");

            var counter = 1;
            showPoptinCount++; // To make sure that two poptins dont have nearby tabindex
            var tabCount = 500 + ( showPoptinCount * 100 ); // We start with very high index so it wont clash with website's content

            // Check if we need to pull tabindex from poptin or add them automatically
            var this_pop = jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]");
            var hasTabIndex = this_pop.attr("data-has-tabindex") == 1;
            var lowest_tabindex = hasTabIndex ? tabCount + parseInt(this_pop.attr("data-lowest-tabindex")) : tabCount;

            jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] > *").each(function(){
                // Placeholder and lowest tabindex for inputs
                jQ224(this).find(".inputs-container input, .inputs-container select, .inputs-container textarea").each(function(e){
                    var placeholder_text = jQ224(this).attr('data-placeholder');
                    if(!placeholder_text) {
                        placeholder_text = jQ224(this).attr('placeholder');
                    }
                    if(jQ224(this).parent().hasClass("field-consent-checkbox")){
                        placeholder_text = ifUserlangIsHe() ? "צ'קבוקס לדיוור" : "Consent Checkbox";
                    }
                    if( placeholder_text != undefined ) {
                        var is_rtl = true;
                        var input_dir = jQ224(this).css('direction');
                        if(input_dir != undefined && input_dir == "ltr"){
                            is_rtl = false;
                        }
                        if( placeholder_text.indexOf('*') == -1 && jQ224(this).prop('required') ) {
                            if(ifUserlangIsHe() && is_rtl){
                                placeholder_text = '*' + placeholder_text;
                            } else {
                                placeholder_text = placeholder_text + '*';
                            }
                            jQ224(this).attr({
                                'aria-required':true,
                            });
                        }
                        var thisTabIndex = jQ224(this).attr('data-tabindex');
                        var newTabIndex = hasTabIndex ? (thisTabIndex ? tabCount + parseInt(thisTabIndex) : tabCount) : tabCount++;
                        jQ224(this).attr({
                            'tabindex':newTabIndex,
                            'aria-label':placeholder_text,
                            'placeholder':placeholder_text,
                        });
                    }
                });

                // Handle consent box's tabindex separately
                jQ224(this).find('.poptin-checkbox-wrapper input').each(function(e){
                    var thisTabIndex = jQ224(this).attr('data-tabindex');
                    var newTabIndex = hasTabIndex ? (thisTabIndex ? tabCount + parseInt(thisTabIndex) : tabCount) : tabCount++;
                    var placeholder_text = jQ224(this).parent().find(".froala-editor-text").text();
                    jQ224(this).attr({
                        'tabindex':newTabIndex,
                        'aria-label':placeholder_text,
                        'placeholder':placeholder_text,
                    });
                });

                // Let screen reader know there is a timer on this poptin
                jQ224(this).find('.flip-timer-container').each(function(e){
                    var thisTabIndex = jQ224(this).attr('data-tabindex');
                    var newTabIndex = hasTabIndex ? (thisTabIndex ? tabCount + parseInt(thisTabIndex) : tabCount) : tabCount++;
                    jQ224(this).attr({
                        'tabindex':newTabIndex
                    });
                });

                // Let screen reader know there is a coupon on this poptin
                jQ224(this).find('.froala-editor-coupon').each(function(e){
                    var cc = jQ224(this).text();
                    if(cc){
                        cc = cc.split("").join(",");
                        cc = ifUserlangIsHe() ? cc + ' קופון' : 'Coupon ' + cc;
                        var thisTabIndex = jQ224(this).parents('.poptin-coupon-element').attr('data-tabindex');
                        var newTabIndex = hasTabIndex ? (thisTabIndex ? tabCount + parseInt(thisTabIndex) : tabCount) : tabCount++;
                        jQ224(this).parents('.poptin-coupon-element').attr({
                            'tabindex':newTabIndex,
                            'aria-label': cc
                        });
                    }
                });

                // Let's read image alts
                jQ224(this).find('.froala-image-wrapper img').each(function(e){
                    var thisTabIndex = jQ224(this).attr('data-tabindex');
                    var newTabIndex = hasTabIndex ? (thisTabIndex ? tabCount + parseInt(thisTabIndex) : tabCount) : tabCount++;
                    jQ224(this).attr({
                        'tabindex':newTabIndex
                    });
                });

                // We should give these lowest tabindex but since we have autofocus on first input that's why we have to keep all the element's tabindex higher than the inputs
                jQ224(this).find('.froala-editor-text, .froala-editor-ticker').each(function(e){
                    if(jQ224(this).parents('.flip-timer-container, .poptin-checkbox-wrapper').length == 0) {
                        var thisTabIndex = jQ224(this).parents(".draggable").attr('data-tabindex');
                        var newTabIndex = hasTabIndex ? (thisTabIndex ? tabCount + parseInt(thisTabIndex) : tabCount) : tabCount++;
                        jQ224(this).parents(".draggable").attr({
                            'tabindex':newTabIndex
                        });
                    }
                });

                // Next is links and buttons. Higher than text but less than close button
                jQ224(this).find("input.poptin-form-submit-button").each(function(e){
                    jQ224(this).attr('role', 'button');
                    var thisTabIndex = jQ224(this).parent().find(".froala-editor-button").attr('data-tabindex');
                    var newTabIndex = hasTabIndex ? (thisTabIndex ? tabCount + parseInt(thisTabIndex) : tabCount) : tabCount++;
                    jQ224(this).attr({
                        'tabindex':newTabIndex
                    });
                });
                jQ224(this).find(".poptin-form-close-button, .poptin-form-link-button").each(function(e){
                    jQ224(this).attr('role', jQ224(this).get(0).className.includes("link") ? "link" : "button");
                    var thisTabIndex = jQ224(this).attr('data-tabindex');
                    var newTabIndex = hasTabIndex ? (thisTabIndex ? tabCount + parseInt(thisTabIndex) : tabCount) : tabCount++;
                    jQ224(this).attr({
                        'tabindex':newTabIndex
                    });
                });

                // Close button should be accessed at the end
                jQ224(this).find(".close-x-button").each(function(e){
                    jQ224(this).wrapInner('<span aria-hidden="true"></span>');
                    var title = (user_lang=="he" ? 'סגור פופאפ': 'Close popup');
                    var thisTabIndex = jQ224(this).attr('data-tabindex');
                    var newTabIndex = hasTabIndex ? (thisTabIndex ? tabCount + parseInt(thisTabIndex) : tabCount) : tabCount++;
                    jQ224(this).attr({
                        'tabindex':newTabIndex,
                        'aria-label':title,
                    });
                });
            });

            var highest_tabindex = hasTabIndex ? tabCount + parseInt(this_pop.attr("data-highest-tabindex")) : tabCount;

            // Set default focus on the first input fields if no custom tab index are there
            if(!hasTabIndex){
                const focusEmbedded = isPoptinLandingPage == true ? "" : ":not([data-poptin-type='embedded'])";
                var firstInput = jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]"+focusEmbedded+" .inputs-container input.poptin-design-fields-form").first();
                var isInputDate = firstInput.data('input-type') == 'date';
                if(!isInputDate) {
                    firstInput.focus();
                }
            }

            this_pop.append(`
                <span class="poptin-tabindex-start" tabindex="`+(lowest_tabindex-1)+`" aria-label="`+("Dialog popup start")+`"></span>
                <span class="poptin-tabindex-end" tabindex="`+(highest_tabindex+1)+`" aria-label="`+("Dialog popup end")+`"></span>
            `);

            // Set default focus on the first input fields if no custom tab index are there
            setTimeout(function(){
                // showLog(!hasTabIndex);
                // Check if the user has set focus on any of the input fields
                const isAnyInputFocused = jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] .inputs-container input:focus").length > 0;

                if(!hasTabIndex){
                    if(!isAnyInputFocused) {
                        var firstInput = jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]:not([data-poptin-type='embedded']) .inputs-container input.poptin-design-fields-form").first();
                        var isInputDate = firstInput.data('input-type') == 'date';
                        if(!isInputDate) {
                            firstInput.focus();
                        }
                    }
                } else {
                    jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]:not([data-poptin-type='embedded']) .poptin-tabindex-start").focus();
                }
                // showLog(document.activeElement);
            },2000);

            var isFullScreen = (jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").attr('data-poptin-type') == "fullpage");
            var poptinShiftHeld = false;
            jQ224(document).on('keyup keydown', function(e){
                if(e.type == "keydown" && e.keyCode == 16){ poptinShiftHeld = true; }
                if(e.type == "keyup" && e.keyCode == 16){ poptinShiftHeld = false; }
            });
            jQ224(document).on("keydown", ".poptin-popup[data-poptin-id="+poptin.poptin_id+"] .inputs-container .froala-editor-input > .form-input-class:first-child input:first-child, .poptin-popup[data-poptin-id="+poptin.poptin_id+"] .inputs-container .form-input-class:first-child select, .poptin-popup[data-poptin-id="+poptin.poptin_id+"] .inputs-container .form-input-class:first-child textarea", function(e){
                if(e.keyCode == 9){
                    if(poptinShiftHeld){
                        setTimeout(function(){
                            if(isFullScreen){
                                jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] > #closeXButton").focus();
                            } else {
                                jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] #poptinDraggableContainer #closeXButton").focus();
                            }
                        }, 100);
                        return false;
                    }
                }
            });
            jQ224(document).on("keydown", ".poptin-popup[data-poptin-id="+poptin.poptin_id+"] #closeXButton", function(e){
                if(e.keyCode == 13 || e.keyCode == 32){
                    jQ224(this).trigger('click');
                }
                if(e.keyCode == 9){
                    if(!poptinShiftHeld){
                        if(!hasTabIndex){ // Avoid going to first input after close button if custom tab indexes are used
                            setTimeout(function(){
                                var first_input_wrap = jQ224(".poptin-popup[data-poptin-id=" + poptin.poptin_id + "] .inputs-container");
                                first_input_wrap.find(".form-input-class:first-child").length ? first_input_wrap.find(".form-input-class:first-child").find("input.poptin-design-fields-form, textarea.poptin-design-fields-form").first().focus() : first_input_wrap.find("input.poptin-design-fields-form, textarea.poptin-design-fields-form").first().focus()
                            }, 100);
                            return false;
                        }
                    }
                }
            });
            jQ224(document).keyup(function(e) {
                if (e.key === "Escape" && poptin.poptin_type != "embedded") { // escape key maps to keycode `27`
                    var closeBtn = "#closeXButton";
                    if(jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] #closeSkipButton").length > 0){
                        closeBtn = "#closeSkipButton";
                    }
                    if(poptin && poptin.poptin_id && closeBtn){
                        setTimeout(function(){
                            closePoptinOnXclick(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] "+closeBtn);
                        }, 800);
                    }
                }
                if(e.keyCode == 9){
                    var activeEL = document.activeElement;
                    var lowest_tabindex_item = this_pop.find("[tabindex="+lowest_tabindex+"]");
                    var highest_tabindex_item = this_pop.find("[tabindex="+highest_tabindex+"]");
                    var is_poptin_end = jQ224(activeEL).hasClass("poptin-tabindex-end");
                    var is_poptin_start = jQ224(activeEL).hasClass("poptin-tabindex-start");
                    // showLog(is_poptin_end, is_poptin_start, !poptinShiftHeld, jQ224(activeEL));
                    if(!poptinShiftHeld){
                        if(is_poptin_end){
                            // showLog(lowest_tabindex_item);
                            lowest_tabindex_item.focus();
                        }
                    } else {
                        if(is_poptin_start){
                            // showLog(highest_tabindex_item);
                            highest_tabindex_item.focus();
                        }
                    }
                }
                // jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] .poptin-tabindex-end").on("focus", function(){
                // 	jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] .poptin-tabindex-start").focus();
                // });
            });
            // if (!ifUserlangIsHe()){
            //     var first_input = jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] .inputs-container .form-input-class:first-child").find("input, select, textarea").first().get(0);
            //     if(first_input !== undefined){
            //         first_input.style.setProperty('outline', '0px', 'important');
            //     }
            // }
        }

        function setAccessibilityThankAfterSubmit(poptin){
            if (poptin.poptin_target=="lead"){
                var message = ifUserlangIsHe() && ifHebrow() ? "נשלח בהצלחה!" : "Sent successfully!";
                var $div = jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]");
                var $btn = $div.find('#poptinFormSubmitText .froala-editor-button');
                var txt = $btn.find('p span');
                var style = 'inherit';
                var direction_style = 'direction:'+(ifUserlangIsHe() && ifHebrow() ? 'rtl' : 'ltr');
                if(txt.length > 0){ style = txt.css("color"); }
                if($btn.length == 0){ $btn = $div.find('#poptinFormSubmitText'); }
                var msgHtml = '<span role="alert" style="color:'+style+';font-size:18px;'+direction_style+'">'+message+'</span>';
                $btn.text('').append(msgHtml);
                $div.find('input.poptin-form-submit-button').hide();
            }
        }

        function ifHebrow(){
            var str = 'א';//Hebrew Character
            var position = str.search(/[\u0590-\u05FF]/);
            x = document.querySelector('meta[http-equiv="Content-Type"]');
            if(position >= 0){
                x = document.querySelector('meta[http-equiv="Content-Type"]');
                if (x== null || x.content.toLowerCase().indexOf('utf-8') >0){
                    return true;
                }
            }
            return false;
        }

        /**
         * Trigger functions: doResizePoptin(), paddingXButton(), setPoptin(), afterPoptinSubmit()
         * Desc             : Return boolean if browser scroll height is visible
         */
        function ifScrollVisible(){
            return (jQ224("body").get(0).scrollHeight > jQ224(window).height() ? true : false );
        }

        /**
         * Trigger functions: setPoptin()
         * parameters       : Poptin -> Poptin Object
         * Desc             : Set close button note per poptin
         */
        function initializeCloseButtonNote(poptin){
            var this_close_button = jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container:not(.poptin-tab-container) .close-x-button");
            var this_close_note = jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container:not(.poptin-tab-container) .close-button-note");
            if(this_close_note){
                this_close_button.on('mouseover', function(){
                    this_scale = window.poptins[poptin.poptin_id].poptin_scale;
                    if( poptin.poptin_type == 'lightbox' && fr_templates['lightbox'] <= parseInt(poptin.poptin_format.split('_')[1]) ){
                    } else {
                        if(this_close_button){
                            jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container:not(.poptin-tab-container) #closeButtonNote").css({
                                // 'left' : this_close_button.offset().left + (this_close_button.outerWidth() * this_scale) - (this_close_note.outerWidth() * this_scale),
                                'left' : (this_close_button.position().left / this_scale) + this_close_button.outerWidth() - this_close_note.outerWidth() + 1,
                                'top' : (this_close_button.position().top / this_scale) - this_close_note.outerHeight() - 3,
                                'right' : ''
                            });
                        }else{
                            var this_far_left = jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container:not(.poptin-tab-container)").attr('data-width');
                            jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container:not(.poptin-tab-container) #closeButtonNote").css({
                                // 'left' : this_close_button.offset().left + (this_close_button.outerWidth() * this_scale) - (this_close_note.outerWidth() * this_scale),
                                'left' : (this_far_left / this_scale) - this_close_note.outerWidth() + 1,
                                'top' : 3 - this_close_note.outerHeight(),
                                'right' : ''
                            });
                        }
                    }
                    this_close_note.css('display','block');
                }).on('mouseout', function(){
                    this_close_note.css('display','none');
                });
            }
        }

        /**
         * Trigger functions: initiatePullPoptinsRequestOnClick(), initiatePullPoptinsRequest()
         * parameters       : Poptin -> Poptin Object | click -> Boolean (if poptin click trigger)
         * Desc             : Set AutoPilot trigger
         * Desc             : Relevant for poptin with AutoPilot enable
         */
        function setAutoPilot(poptin,click){
            try{
                // If browser support Session Storage
                if (typeof(Storage) !== "undefined" && poptin){
                    showLog('setAutoPilot2');
                    if (poptin.auto_pilot_trigger !== undefined && (window.sessionStorage.getItem("apt_"+poptin.poptin_id) == null || window.sessionStorage.getItem("apt_"+poptin.poptin_id)== undefined)){
                        showLog(poptin.auto_pilot_trigger);
                        window.sessionStorage.setItem("apt_"+poptin.poptin_id, poptin.auto_pilot_trigger);
                    }
                } else {
                    showLog('Sorry! No Web Storage support add/or poptin..');
                }
            }catch(err){
                showLog(err);
            }
        }

        /**
         * Trigger functions: initiatePullPoptinsRequestOnClick(), initiatePullPoptinsRequest()
         * Desc             : Set user origin landing page in session
         */
        function setOriginLandingPage(){
            try{
                // If browser support Session Storage
                if (typeof(Storage) !== "undefined") {
                    if (window.sessionStorage.getItem("poptin_origin_landing_page") == null || window.sessionStorage.getItem("poptin_origin_landing_page") == undefined){
                        window.sessionStorage.setItem("poptin_origin_landing_page", window.location.href);
                    }
                } else {
                    showLog('Sorry! No Web Storage support..');
                }
            }catch(err){
                showLog(err);
            }
        }

        /**
         * Trigger functions: poptinView()
         * Desc             : Set poptin view url session
         */
        function setPoptinViewedUrl(poptin){
            try{
                // If browser support Session Storage
                if (typeof(Storage) !== "undefined") {
                    if (window.sessionStorage.getItem("poptin_viewed_url_"+poptin.poptin_id) == null || window.sessionStorage.getItem("poptin_viewed_url_"+poptin.poptin_id) == undefined){
                        window.sessionStorage.setItem("poptin_viewed_url_"+poptin.poptin_id, window.location.href);
                    }
                } else {
                    showLog('Sorry! No Web Storage support..');
                }
            }catch(err){
                showLog(err);
            }
        }

        /**
         * Trigger functions: initiatePullPoptinsRequestOnClick(), initiatePullPoptinsRequest
         * parameters       : Poptin -> Poptin Object | click -> Boolean (if poptin click trigger)
         * Desc             : Set poptin size to - height & width
         * Desc             : If click trigger set 'poptin_size' Object
         * Desc             : Else set 'window.poptins[poptin.poptin_id].poptin_size' Array
         */
        function setPoptinSize(poptin,click){

            var poptin_size = {};

            var poptin_data_width_height = getDataWidthHeight(poptin.poptin);

            var this_poptin_width = poptin_data_width_height['width'];
            var this_poptin_height = poptin_data_width_height['height'];

            //poptins_size = new Array();
            if (poptin !== undefined){
                // window.poptins[poptin.poptin_id].poptin_size = null;
                if (poptin.poptin_type == "lightbox"){
                    if (click == undefined){
                        if(window.poptins[poptin.poptin_id].poptin_size == undefined){
                            window.poptins[poptin.poptin_id].poptin_size = {};
                        }
                        window.poptins[poptin.poptin_id].poptin_size.height = this_poptin_height;
                        window.poptins[poptin.poptin_id].poptin_size.width = this_poptin_width;
                    }
                    // else {
                    //  poptin_size.height = this_poptin_height;
                    //  poptin_size.width = this_poptin_width;
                    // }
                    // showLog('setPoptinSize '+this_poptin_width+' '+this_poptin_height);
                    if(this_poptin_width != undefined && this_poptin_width != '' && this_poptin_width != "undefined"){
                        litghtbox_poptin_width = this_poptin_width;
                    }
                    if(this_poptin_height != undefined && this_poptin_height != '' && this_poptin_height != "undefined"){
                        litghtbox_poptin_height = this_poptin_height;
                        if(poptin.poptin_format == 'format_3' || poptin.poptin_format == 'format_9'){
                            litghtbox_poptin_width = litghtbox_poptin_height;
                        }
                    }
                    // showLog('setPoptinSize '+litghtbox_poptin_width+' '+litghtbox_poptin_height);
                    if (click==undefined)
                        window.poptins[poptin.poptin_id].poptin_size = {width: litghtbox_poptin_width, height: litghtbox_poptin_height};
                    poptin_size.width = litghtbox_poptin_width;
                    poptin_size.height = litghtbox_poptin_height;
                }else if (poptin.poptin_type == "bar"){
                    if (click==undefined)
                        window.poptins[poptin.poptin_id].poptin_size = {width: bar_poptin_width, height: bar_poptin_height};
                    poptin_size.width = bar_poptin_width;
                    poptin_size.height = bar_poptin_height;
                    if (poptin.poptin_format == 'format_1' || poptin.poptin_format == 'format_6'){
                        if (click==undefined)
                            window.poptins[poptin.poptin_id].poptin_size = {width: bar_poptin_width, height: bar_poptin_height};
                        poptin_size.height = bar_poptin_height;
                    }else if (poptin.poptin_format == 'format_2' || poptin.poptin_format == 'format_3' || poptin.poptin_format == 'format_7' || poptin.poptin_format == 'format_8'){
                        if (click==undefined)
                            window.poptins[poptin.poptin_id].poptin_size = {width: bar_poptin_width, height: bar_poptin_height_2};
                        poptin_size.height = bar_poptin_height_2;
                    }else if (poptin.poptin_format == 'format_4' || poptin.poptin_format == 'format_9'){
                        if (click==undefined)
                            window.poptins[poptin.poptin_id].poptin_size = {width: bar_poptin_width, height: bar_poptin_height_4};
                        poptin_size.height = bar_poptin_height_4;
                    }else if (poptin.poptin_format == 'format_5' || poptin.poptin_format == 'format_10'){
                        if (click==undefined)
                            window.poptins[poptin.poptin_id].poptin_size = {width: bar_poptin_width, height: bar_poptin_height_5};
                        poptin_size.height = bar_poptin_height_5;
                    }else if (poptin.poptin_format == 'format_18'){
                        if (click==undefined)
                            poptins[poptin.poptin_id].poptin_size = {width: bar_poptin_width, height: bar_poptin_height_18};
                        poptin_size.height = bar_poptin_height_18;
                    }
                }else if (poptin.poptin_type == "sside"){
                    if (poptin.poptin_format === 'format_1' || poptin.poptin_format === 'format_5'){
                        if (click==undefined)
                            window.poptins[poptin.poptin_id].poptin_size = {width: sside_poptin_width_2, height: sside_poptin_height};
                        poptin_size.width = sside_poptin_width;
                        poptin_size.height = sside_poptin_height;
                    }else if (poptin.poptin_format === 'format_4' || poptin.poptin_format === 'format_8'){
                        if (click==undefined)
                            window.poptins[poptin.poptin_id].poptin_size = {width: sside_poptin_width_4, height: sside_poptin_height_4};
                        poptin_size.width = sside_poptin_width_4;
                        poptin_size.height = sside_poptin_height_4;
                    }else if (poptin.poptin_format === 'format_19'){
                        if (click==undefined)
                            window.poptins[poptin.poptin_id].poptin_size = {width: sside_poptin_width_19, height: sside_poptin_height_19};
                        poptin_size.width = sside_poptin_width_19;
                        poptin_size.height = sside_poptin_height_19;
                    }else if (poptin.poptin_format === 'format_20'){
                        if (click==undefined)
                            poptins[poptin.poptin_id].poptin_size = {width: sside_poptin_width_20, height: sside_poptin_height_20};
                        poptin_size.width = sside_poptin_width_20;
                        poptin_size.height = sside_poptin_height_20;
                    }else if (poptin.poptin_format === 'format_21'){
                        if (click==undefined)
                            poptins[poptin.poptin_id].poptin_size = {width: sside_poptin_width_21, height: sside_poptin_height_21};
                        poptin_size.width = sside_poptin_width_21;
                        poptin_size.height = sside_poptin_height_21;
                    }else if (poptin.poptin_format === 'format_22'){
                        if (click==undefined)
                            poptins[poptin.poptin_id].poptin_size = {width: sside_poptin_width_22, height: sside_poptin_height_22};
                        poptin_size.width = sside_poptin_width_22;
                        poptin_size.height = sside_poptin_height_22;
                    }else if (poptin.poptin_format === 'format_23'){
                        if (click==undefined)
                            poptins[poptin.poptin_id].poptin_size = {width: sside_poptin_width_23, height: sside_poptin_height_23};
                        poptin_size.width = sside_poptin_width_23;
                        poptin_size.height = sside_poptin_height_23;
                    }else{
                        if (click==undefined)
                            window.poptins[poptin.poptin_id].poptin_size = {width: sside_poptin_width, height: sside_poptin_height};
                        poptin_size.width = sside_poptin_width_2;
                        poptin_size.height = sside_poptin_height;
                    }
                }else if (poptin.poptin_type == "bside"){
                    if (click==undefined)
                        window.poptins[poptin.poptin_id].poptin_size = {width: bside_poptin_width, height: bside_poptin_height};
                    poptin_size.width = bside_poptin_width;
                    poptin_size.height = bside_poptin_height;
                }else if (poptin.poptin_type == "browsing"){
                    if (click==undefined)
                        window.poptins[poptin.poptin_id].poptin_size = {width: browsing_poptin_width, height: browsing_poptin_height};
                    poptin_size.width = browsing_poptin_width;
                    poptin_size.height = browsing_poptin_height;
                }else if (poptin.poptin_type == "fullpage"){
                    if (click==undefined)
                        window.poptins[poptin.poptin_id].poptin_size = {width: fullpage_poptin_width, height: fullpage_poptin_height};
                    poptin_size.width = "100%"; //fullpage_poptin_width;
                    poptin_size.height = "100%"; //fullpage_poptin_height;
                    if (poptin.poptin_format === 'format_4' || poptin.poptin_format === 'format_8'){
                        if (click==undefined)
                            window.poptins[poptin.poptin_id].poptin_size = {width: fullpage_poptin_width_2, height: fullpage_poptin_height_2};
                        poptin_size.width = fullpage_poptin_width_2;
                        poptin_size.height = fullpage_poptin_height_2;
                    }
                }else if (poptin.poptin_type == "content"){
                    if (click==undefined)
                        window.poptins[poptin.poptin_id].poptin_size = {width: fullpage_poptin_width, height: fullpage_poptin_height};
                }else if (poptin.poptin_type == "social"){
                    if (poptin.poptin_format === 'format_1' || poptin.poptin_format === 'format_5'){
                        if (click==undefined)
                            window.poptins[poptin.poptin_id].poptin_size = {width: social_poptin_width, height: social_poptin_height};
                        poptin_size.width = social_poptin_width;
                        poptin_size.height = social_poptin_height;
                    }else if (poptin.poptin_format === 'format_2' || poptin.poptin_format === 'format_6'){
                        if (click==undefined)
                            window.poptins[poptin.poptin_id].poptin_size = {width: social_poptin_width_2, height: social_poptin_height_2};
                        poptin_size.width = social_poptin_width_2;
                        poptin_size.height = social_poptin_height_2;
                    }else if (poptin.poptin_format === 'format_4' || poptin.poptin_format === 'format_8'){
                        if (click==undefined)
                            window.poptins[poptin.poptin_id].poptin_size = {width: social_poptin_width_4, height: social_poptin_height_4};
                        poptin_size.width = social_poptin_width_4;
                        poptin_size.height = social_poptin_height_4;
                    }
                }else if (poptin.poptin_type == "mobile"){
                    if (click==undefined)
                        window.poptins[poptin.poptin_id].poptin_size = {width: mobile_poptin_width, height: mobile_poptin_height};
                    poptin_size.width = mobile_poptin_width;
                    poptin_size.height = mobile_poptin_height;
                    if (poptin.poptin_format === 'format_3' || poptin.poptin_format === 'format_8'){
                        if (click==undefined)
                            window.poptins[poptin.poptin_id].poptin_size = {width: mobile_poptin_width_2, height: mobile_poptin_height_2};
                        poptin_size.width = mobile_poptin_width_2;
                        poptin_size.height = mobile_poptin_height_2;
                    }else if (poptin.poptin_format === 'format_4' || poptin.poptin_format === 'format_9'){
                        if (click==undefined)
                            window.poptins[poptin.poptin_id].poptin_size = {width: mobile_poptin_width, height: mobile_poptin_height_4};
                        poptin_size.height = mobile_poptin_height_4;
                    }else if (poptin.poptin_format === 'format_5' || poptin.poptin_format === 'format_10'){
                        if (click==undefined)
                            window.poptins[poptin.poptin_id].poptin_size = {width: mobile_poptin_width, height: mobile_poptin_height_5};
                        poptin_size.height = mobile_poptin_height_5;
                    }
                }else if (poptin.poptin_type == "embedded"){
                    if (poptin.poptin_format === 'format_1'){
                        poptin_size.width = embedded_poptin_width_1;
                        poptin_size.height = embedded_poptin_height_1;
                    }else if (poptin.poptin_format === 'format_2'){
                        poptin_size.width = embedded_poptin_width_2;
                        poptin_size.height = embedded_poptin_height_2;
                    }else if (poptin.poptin_format === 'format_3'){
                        poptin_size.width = embedded_poptin_width_3;
                        poptin_size.height = embedded_poptin_height_3;
                    }else if (poptin.poptin_format === 'format_4'){
                        poptin_size.width = embedded_poptin_width_4;
                        poptin_size.height = embedded_poptin_height_4;
                    }else if (poptin.poptin_format === 'format_5'){
                        poptin_size.width = embedded_poptin_width_5;
                        poptin_size.height = embedded_poptin_height_5;
                    }else if (poptin.poptin_format === 'format_6'){
                        poptin_size.width = embedded_poptin_width_6;
                        poptin_size.height = embedded_poptin_height_6;
                    }else if (poptin.poptin_format === 'format_7'){
                        poptin_size.width = embedded_poptin_width_7;
                        poptin_size.height = embedded_poptin_height_7;
                    }else if (poptin.poptin_format === 'format_8'){
                        poptin_size.width = embedded_poptin_width_8;
                        poptin_size.height = embedded_poptin_height_8;
                    }else if (poptin.poptin_format === 'format_9'){
                        poptin_size.width = embedded_poptin_width_9;
                        poptin_size.height = embedded_poptin_height_9;
                    }
                    if (click==undefined)
                        window.poptins[poptin.poptin_id].poptin_size = {width: poptin_size.width, height: poptin_size.height};
                }else if (poptin.poptin_type == "gamified"){
                    if (click == undefined){
                        if(window.poptins[poptin.poptin_id].poptin_size == undefined){
                            window.poptins[poptin.poptin_id].poptin_size = {};
                        }
                        window.poptins[poptin.poptin_id].poptin_size.height = this_poptin_height;
                        window.poptins[poptin.poptin_id].poptin_size.width = this_poptin_width;
                    }
                    // else {
                    //  poptin_size.height = this_poptin_height;
                    //  poptin_size.width = this_poptin_width;
                    // }
                    // showLog('setPoptinSize '+this_poptin_width+' '+this_poptin_height);
                    if(this_poptin_width != undefined && this_poptin_width != '' && this_poptin_width != "undefined"){
                        litghtbox_poptin_width = this_poptin_width;
                    }
                    if(this_poptin_height != undefined && this_poptin_height != '' && this_poptin_height != "undefined"){
                        litghtbox_poptin_height = this_poptin_height;
                    }
                    // showLog('setPoptinSize '+litghtbox_poptin_width+' '+litghtbox_poptin_height);
                    if (click==undefined)
                        window.poptins[poptin.poptin_id].poptin_size = {width: litghtbox_poptin_width, height: litghtbox_poptin_height};
                    poptin_size.width = litghtbox_poptin_width;
                    poptin_size.height = litghtbox_poptin_height;
                }

                window.poptins[poptin.poptin_id].poptin_size = poptin_size;

            }
        }

        /**
         * Trigger functions: initiatePullPoptinsRequestOnClick(),initiatePullPoptinsRequest()
         * parameters       : poptin_id:string
         * Desc             : Set window.poptins[poptin_id] skeleton object per poptin
         */
        function setPoptinsArray(poptin_id){
            window.poptins[poptin_id] = {
                poptin_size:{},
                poptin_trigger:{},
                poptin_center:{}
            }
        }

        /**
         * Trigger functions: initiatePullPoptinsRequestOnClick(),initiatePullPoptinsRequest()
         * parameters       : poptin_id:stirng
         * Desc             : Set window.poptins[poptin_id] skeleton object per poptin
         */
        function setPoptinsOnClickArray(poptin_id){
            window.poptins[poptin_id] = {
                poptin_size:{},
                poptin_trigger:{},
                poptin_center:{}
            }
        }

        /**
         * Trigger functions: initiatePullPoptinsRequest()
         * parameters       : poptin:object | click:Boolean -> (if poptin click trigger)
         * Desc             : Set special style for poptin postion if android phone due to keyboard issuse when tapping on field
         */
        function ifAndroidPoptinKeyborad(poptin,click){
            // Set default trigger to false
            var keyboard =false;
            // Get poptin top postion by px
            var o_top = jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").css('top');
            // Get poptin bottom postion by px
            var o_bottom = jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").css('bottom');
            // if android phone and poptin type in array
            var lightbox_padd = "10px";
            var gamified_padd = "10px";
            var mobile_padd = "10px";
            var sside_padd = "0px";
            var padding_o = {"lightbox":lightbox_padd,"mobile":mobile_padd,"sside":sside_padd,"gamified":gamified_padd};
            if (ifAndroidPoptin && jQ224.inArray(poptin.poptin_type,["lightbox","mobile","sside","gamified"]) >-1){
                try{
                    // off all click event
                    jQ224('[data-poptin-id='+poptin.poptin_id+'] .inputs-container input').off("click");
                    //jQ224("[data-poptin-id="+poptin.poptin_id+"]").off("click");
                    jQ224(window).off("click");
                }catch(err){
                    showLog(err);
                }

                //Set poptin field click event
                // Push poptin up
                jQ224("[data-poptin-id="+poptin.poptin_id+"] .inputs-container input").on('click', function(e) {
                    // If poptin postion is not top
                    if (!keyboard) {
                        if (poptin.poptin_type == "sside" && (poptin.poptin_format === 'format_4' || poptin.poptin_format === 'format_8')){
                            jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").animate({'top':"-100px"},300);
                        }else if(poptin.design_properties.poptin_location.indexOf('top') == -1){
                            if (poptin.design_properties.poptin_location.indexOf('bottom') > -1){
                                jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").animate({'top':padding_o[poptin.poptin_type]},300);
                            }else{
                                jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").animate({'top':parseInt(jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").css('top')) - 100 +'px'},300);
                            }
                        }
                        keyboard = true;
                        // off window poptin resize function()
                        //jQ224(window).off("resize");
                    }
                });

                //Set window click event
                // Push poptin down - default position
                jQ224(window).on('click', function(e) {
                    // if not clicked outside poptin inputs fields container
                    if (jQ224(e.target).parents('.inputs-container').length == 0){
                        if (keyboard) {
                            if (poptin.design_properties.poptin_location.indexOf('top') == -1 || (poptin.poptin_type == "sside" && (poptin.poptin_format === 'format_4' || poptin.poptin_format === 'format_8'))){
                                if (poptin.design_properties.poptin_location.indexOf('bottom') > -1){
                                    jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").css('top','');
                                    jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").animate({'bottom':o_bottom},300);
                                }else{
                                    jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").animate({'top':parseInt(jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").css('top')) + 100 +'px'},300);
                                }
                            }
                            keyboard = false;

                            // Set poptin window resize back to on
                            //windowResize(poptin,click);
                        }
                    }
                });
            }
        }


        /**
         * Trigger functions: showPoptin()
         * parameters       : poptin:object
         * Desc             : If poptin client is not freemium -> remove poptin credit
         * Desc             : Else -> Add poptin credit if freemium and credit div not exist
         */
        function clearPoptinCredit(poptin){
            jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin-credit").remove();
            showLog('clearPoptinCredit1');
            if (poptin.if_poptin_credit){
                insertPoptinCredit(poptin)
            }
        }

        /**
         * Trigger functions: clearPoptinCredit()
         * parameters       : poptin:object
         * Desc             : Insert credit
         */
        function insertPoptinCredit(poptin){
            showLog('insertPoptinCredit');
            jQ224("[data-poptin-id="+poptin.poptin_id+"]").children('div, form').append(html_credit);
            jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin-credit a").attr('href',(user_lang=="en"?poptin_com_url:poptin_il_url)+'?src='+window.location.host);
        }


        /**
         * Trigger functions: closePoptin()
         * parameters       : poptin_id:string
         * Desc             : If poptin type is 'bar' and location is 'top' and type is not down -> clode padding gap
         */
        function fixHtmlPadding(){
            if (if_html_pad)
                jQ224("html").animate({"padding-top": '0px'},500);
        }

        /**
         * String formatter functions: formatStringToSlug()
         * parameters       : Text:string
         * Desc             : this function makes removes spaces and adds - on string also removes special characters
         */

        function formatStringToSlug(Text) {
            return Text
                    .toLowerCase()
                    .replace(/[^\w ]+/g, '')
                    .replace(/ +/g, '-');
        }

        /**
         * Trigger functions: cssFix()
         * parameters       : value:string(font-family string like 'David')
         * Desc             : Download & append font file from google if font-family !== 'Open Sans'
         */
        var poptin_fonts = ["Verdana,+Geneva,+sans-serif","Arial,+Helvetica,+sans-serif","Arial+Black,+Gadget,+sans-serif","Comic+Sans+MS,+cursive,+sans-serif","Georgia,+serif","Impact,+Charcoal,+sans-serif","Lucida+Sans+Unicode,+Lucida+Grande,+sans-serif","Palatino+Linotype,+Book+Antiqua,+Palatino,+serif","Tahoma,+Geneva,+sans-serif","Times+New+Roman,+Times,+serif","Trebuchet+MS,+Helvetica,+sans-serif"];
        var poptin_google_fonts = ["ABeeZee","Abhaya Libre","Aclonica","Acme","Alef","Allan","Allerta Stencil","Allerta","Amaranth","Amatica SC","Annie Use Your Telescope","Anonymous Pro","Anton","Architects Daughter","Archivo Narrow","Arima","Arimo","Artifika","Arvo","Asap","Asset","Assistant","Astloch","Bangers","Bentham","Bevan","Bigshot One","Black Han Sans","Bowlby One SC","Bowlby One","Brawler","Cabin","Calligraffitti","Candal","Cantarell","Cardo","Carter One","Caudex","Caveat Brush","Cedarville Cursive","Cherry Cream Soda","Chewy","Coda","Coming Soon","Copse","Corben","Cousine","Covered By Your Grace","Crafty Girls","Creepster","Crimson Text","Crushed","Cuprum","Damion","Dancing Script","David Libre","Dawning of a New Day","Didact Gothic","DM Sans","Dosis","Droid Sans","Droid Sans Mono","Droid Serif","DM Serif Display","EB Garamond","Exo","Expletus Sans","Fontdiner Swanky","Forum","Francois One","Frank Ruhl Libre","Geo","Girassol","Give You Glory","Goblin One","Goudy Bookletter 1911","Gravitas One","Gruppo","Hammersmith One","Heebo","Holtwood One SC","Homemade Apple","Inconsolata","Indie Flower","Inter",
        "IM Fell DW Pica","IM Fell DW Pica SC","IM Fell Double Pica","IM Fell Double Pica SC","IM Fell English","IM Fell English SC","IM Fell French Canon","IM Fell French Canon SC","IM Fell Great Primer","IM Fell Great Primer SC","Irish Grover","Irish Growler","Istok Web","Josefin Sans","Josefin Slab","Judson","Jura","Just Another Hand","Just Me Again Down Here","Kameron","Kenia","Kranky","Kreon","Kristi","La Belle Aurore","Lato","League Script","Lekton","Libre Baskerville","Limelight", "Lobster","Lobster Two","Lora","Love Ya Like A Sister","Loved by the King","Luckiest Guy","Maiden Orange","Mako","Maven Pro","Meddon","MedievalSharp","Megrim","Merriweather","Metrophobic","Michroma","Miltonian Tattoo","Miltonian","Miriam Libre","Modern Antiqua","Molengo","Monofett","Montserrat","Mountains of Christmas","Muli","Neucha","Neuton","News Cycle","Nixie One","Nobile","Noto Sans","Nova Cut","Nova Flat","Nova Mono","Nova Oval","Nova Round","Nova Script","Nova Slim","Nova Square","Nunito","Nunito Sans","OFL Sorts Mill Goudy TT",
        "Old Standard TT","Open Sans","Open Sans Condensed","Open Sans Hebrew","Orbitron","Oswald","Over the Rainbow","Pacifico","Patrick Hand","Paytone One","Permanent Marker","Philosopher","Play","Playfair Display","Podkova","Poppins","PT Sans","PT Sans Narrow","PT Serif","PT Serif Caption","Puritan","Quattrocento","Quattrocento Sans","Quicksand","Radley","Raleway","Redressed","Reenie Beanie","Rock Salt","Rokkitt","Roboto","Rubik","Rubik Glitch","Ruslan Display","Schoolbell","Secular One","Seaweed Script","Shadows Into Light","Shanti","Sigmar One","Six Caps","Slackey","Smythe","Source Sans Pro","Special Elite","Stardos Stencil","Sue Ellen Francisco","Suez One","Sunshiney","Swanky and Moo Moo","Syncopate","Tangerine","Tenor Sans","Terminal Dosis Light","The Girl Next Door","Tinos","Ubuntu","Ultra","Unkempt","UnifrakturCook","UnifrakturMaguntia","Varela","Varela Round","Vibur","Vollkorn","VT323","Waiting for the Sunrise","Wallpoet","Walter Turncoat","Water Brush","Wire One","Yanone Kaffeesatz","Yeseva One","Yellowtail","Zeyada","Zilla Slab"];
        function getFont(value){
            if (!value || value.indexOf('font-family') === -1) {
                return false;
            }
            var decodedValue = value
                .replace(/&quot;/g, '"')
                .replace(/&#39;/g, "'")
                .replace(/&amp;/g, '&');
            split = decodedValue.split('font-family')[1].split(';')[0];
            var font_name = split.replace('!important','').replace(/\:/g,'').replace(/\"/g,'').replace(/\'/g,'').trim();
            if (font_name.indexOf(',') > -1) {
                font_name = font_name.split(',')[0].trim();
            }
            if (!font_name) {
                return false;
            }
            var customFonts = jQ224(".poptin-popup").attr("data-custom-fonts");
            if(customFonts != undefined && customFonts.split(",").includes(font_name)){
                return false;
            }
            var _font = font_name.replace(/\s/g, '+');
            if (poptin_fonts.indexOf(_font) !== -1) {
                return false;
            }
            poptin_fonts.push(_font);
            if(_font=="Open+Sans+Hebrew"){
                if(jQ224("#poptin_opensanshebrew_font_preload").length==0){
                    jQ224('head').append('<link rel="preload" id="poptin_opensanshebrew_font_preload" as="style" href="https://fonts.popt.in/?family=Open%20Sans%20Hebrew&display=swap">');
                }
                if(jQ224("#poptin_opensanshebrew_font_link").length==0){
                    jQ224('head').append('<link rel="stylesheet" id="poptin_opensanshebrew_font_link" href="https://fonts.popt.in/?family=Open%20Sans%20Hebrew&display=swap">');
                }
                return;
            }
            if(!poptin_google_fonts.includes(font_name)){
                return false;
            }
            var formatted_slug=formatStringToSlug(_font),
                font_preload_id="poptin-preload-"+formatted_slug,
                font_link_id="poptin-link-"+formatted_slug,
                font_href="https://fonts.googleapis.com/css2?family="+_font+"&display=swap";
            if(!poptin_disable_fonts){
                if(jQ224('#'+font_preload_id).length==0){
                    jQ224('head').append('<link rel="preload" id="'+font_preload_id+'" as="style" href="'+font_href+'">');
                }
                if(jQ224('#'+font_link_id).length==0){
                    jQ224('head').append('<link rel="stylesheet" id="'+font_link_id+'" href="'+font_href+'" type="text/css">');
                }
            }else if(poptin_disable_fonts){
                if(formatted_slug!=='poppins'){
                    if(jQ224('#'+font_preload_id).length==0){
                        jQ224('head').append('<link rel="preload" id="'+font_preload_id+'" as="style" href="'+font_href+'">');
                    }
                    if(jQ224('#'+font_link_id).length==0){
                        jQ224('head').append('<link rel="stylesheet" id="'+font_link_id+'" href="'+font_href+'" type="text/css">');
                    }
                }
            }
        }

        function loadScratchCardFunctionality(poptin) {
            if (poptin.poptin_type+'_'+poptin.poptin_format == "gamified_format_2") {
                window.countScratchProgress = function (percent) {
                    if (Number(percent) <= 50) {
                        jQ224("[data-poptin-id="+poptin.poptin_id+"] #poptinScratchArea").hide()
                        getIntlPhoneValidation(poptin);
                        setTimeout(() => {
                            jQ224('[data-poptin-id="'+poptin.poptin_id+'"] #poptinDraggableContainer').removeClass("poptin-visible poptin__animated animate__fadeIn animate__faster");
                            if(poptin['design_properties'] && poptin['design_properties']['disable_post_play_screen'] && poptin['design_properties']['disable_post_play_screen'] == true){
                                show_winning_screen(poptin);
                                ifLinkConversion(poptin);
                            }else{
                                jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_play_screen").addClass("poptin-visible poptin__animated animate__fadeIn animate__faster");
                                setTimeout(function(){
                                    jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_play_screen").removeClass('poptin__animated animate__fadeIn animate__faster');
                                },800);
                            }
                        }, 3000)
                    }
                }
                poptinScratchCardInit('', poptin.poptin_id);
            }
        }

        /*Manage Poptin Tab*/
        function isTabEnable(poptin){
            //if( jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"][data-hastab='1']").length > 0 && poptin.is_teasers_on){
            if(poptin.is_teasers_on){
                return true;
            }else{
                return false;
            }
        }

        /*Poptin News Ticker*/
        function loadpoptinNewsTicker(poptin){
            if(jQ224("[data-poptin-id="+poptin.poptin_id+"] .froala-editor-ticker").length>0){
                setTimeout(function(){
                    jQ224("[data-poptin-id="+poptin.poptin_id+"] .froala-editor-ticker").each(function (e) {
                        var part_width=jQ224(this).parent('.poptin-newsticker-element').width();
                        var ntData = jQ224(this).data();
                        var ntSpeed = ntData['duration'] ? ntData['duration'] : 7000;
                        var ntDuration = ntSpeed / 400;
                        var ntDirection = ntData['direction'] ? ntData['direction'] : "left" ;

                        jQ224(this).css({"overflow":"hidden","width":part_width+"px","position":"relative"});
                        jQ224(this).wrapInner('<div class="js-poptinNewsTicker-wrapper dir-'+ntDirection+'"><div class="js-poptinNewsTicker" style="margin-right: 0px;margin-left: 0px;;white-space: nowrap;"></div></div>');
                        jQ224(this).find('.js-poptinNewsTicker-wrapper').css({"animation-duration": ntDuration+'s', "-moz-animation-duration":ntDuration+'s', "-webkit-animation-duration":ntDuration+'s'});

                    });
                },100);
            }
        }

        /**
         * Trigger functions: poptinViewed(), poptinConversion, closePoptin()
         * parameters       : poptin:object
         * Desc             : It builds the poptin object that is to be sent in DOM events
         */
        function poptinEventDetails(poptin, extras){
            extras = extras ? extras : {};
            var poptinDetails = Object.assign({
                "poptin_id" : poptin.poptin_id,
                "poptin_name" : poptin.poptin_name,
                "poptin_target" : poptin.poptin_target,
                "poptin_type" : poptin.poptin_type,
                "account_id" : poptin.account_id
            }, extras);
            return poptinDetails;
        }

        /**
         * Trigger functions: setPoptin()
         * parameters       : poptin:object | click:Boolean (if poptin click trigger)
         * Desc             : Make the poptin visible
         */
        function showPoptin(poptin, click,tab){
            if ( poptinTimer(poptin) ){
                showLog('showPoptin: '+poptin.poptin_id);
                //setJqueryUiShakeAnimation();
                cssFix(poptin);
                clearPoptinCredit(poptin);
                //jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"], .poptin-popup-background[data-poptin-id="+poptin.poptin_id+"]").css("display","block");
                if ( poptin.poptin_target == "social_proof" ){
                    setSocialProofBehaverInterval(poptin, click)
                }else{
                    removeTabhtml(poptin);
                    showEffect(poptin,"entry");
                    ensurePoptinTrigger(poptin.poptin_id);
                    window.poptins[poptin.poptin_id].poptin_trigger.shown = true;
                }
                injectFacebookPlugin(poptin);
                animateButton(poptin);

                // Enable spin for wheel
                if (poptin.poptin_type == "gamified"){
                    if (poptin.poptin_format == "format_1") {
                        animateGiftbox(poptin);
                        gamifiedGiftbox(poptin);
                    }
                }

                if( !(poptin.poptin_type == 'embedded' || poptin.poptin_type == 'fullpage') ){
                    loadbgAnimationOverlay(poptin);
                }

                loadpoptinNewsTicker(poptin);
                loadScratchCardFunctionality(poptin)
                loadcouponbutton(poptin);
                readylinkbuttons(poptin);
                //showEffect(poptin);
                pushHtmlDown(poptin);
                paddingXButton(poptin);
                poptinFormClickSubmit(poptin, click);
                //window.poptins[poptin.poptin_id].data_point.onShow(poptin);
                if(!poptin.is_teasers_on){
                    poptinViewed(poptin);
                }else if(poptin.is_teasers_on && jQ224('div#poptinDraggableContainer-tab[data-load-poptin="' + poptin.poptin_id + '"]').length > 0){
                    if(typeof jQ224(".poptin-popup[data-poptin-id=" + poptin.poptin_id + "]").attr("data-tabshow") != 'undefined' && jQ224(".poptin-popup[data-poptin-id=" + poptin.poptin_id + "]").attr("data-tabshow") != 'after_close'){
                        poptinViewed(poptin);
                    }
                }
                else if(poptin.is_teasers_on && jQ224('div#poptinDraggableContainer-tab[data-load-poptin="' + poptin.poptin_id + '"]').length == 0 && jQ224('.poptin-popup.poptin-live[data-poptin-id="' + poptin.poptin_id + '"]').length > 0){
                    poptinViewed(poptin);
                }

            }
        }

        // async function setSocialProofBehaver(poptin, click,$sleep){
        //  var i = 0;
        //  for(i ; i<poptin.social_proof.length; i++){
        //      if (socialProofInterval[poptin.poptin_id].active){
        //          review = poptin.social_proof[i]
        //          setSocialProofReview(poptin,review);
        //          await sleep($sleep)
        //          hideEffect(poptin);
        //          await sleep($sleep);
        //      }
        //     };
        // }

        // function setSocialProofBehaverInterval(poptin, click){
        //  showLog('setSocialProofBehaverInterval')

        //  if (poptin.social_proof.length>0){
        //      insertPoptinCredit(poptin);
        //      var $poptin  = jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]")
        //      var $sleep = $poptin.attr('data-review-loop') == undefined ? 5000 :  $poptin.attr('data-review-loop')*1000
        //      socialProofInterval[poptin.poptin_id] = {active:true, interval:null};
        //      setSocialProofBehaver(poptin, click,$sleep)
        //      // showLog($sleep)
        //      socialProofInterval[poptin.poptin_id].interval = setInterval(function(){
        //          setSocialProofBehaver(poptin, click,$sleep)
        //      },$sleep*poptin.social_proof.length*2)
        //  }
        // }

        // function cancelSocialProofInterval(poptin_id){
        //  if (socialProofInterval[poptin_id] !== undefined){
        //      socialProofInterval[poptin_id].active = false;
        //      clearInterval(socialProofInterval[poptin_id].interval);
        //  }
        // }

        // function setSocialProofReview(poptin,review){
        //  showLog('setSocialProofReview')
        //  jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").css('box-shadow','none')
        //  $this = jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] #socialProofContainer")
        //  $this.find('#spText').html(review.text)
        //  $this.find('#spCreated').html(review.created_at)
        //  $this.find('#spRating').html(review.rating)
        //  $this.find('#spName').html(review.reviewer_name)
        //  $this.find('#spProfileImg img').attr('src',review.reviewer_img)

        //  setTimeout(function(){
        //      showEffect(poptin);
        //  },200)
        // }

        // function sleep(ms) {
        //      return new Promise(resolve => setTimeout(resolve, ms));
        // }

        /**
         * Trigger functions: showPoptin()
         * parameters       : poptin:object
         * Desc             : inject facebook chat plugin code to DOM
         */
        function injectFacebookPlugin(poptin){
            if (poptin.poptin_type+"_"+poptin.poptin_format == "social_format_3" || poptin.poptin_type+"_"+poptin.poptin_format == "social_format_7"){
                showLog('ingectFacebookChat');
                inject_chat_sdk = jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] .facebook-plugin").attr('data-facebook-chat-plugin');
                if (inject_chat_sdk.indexOf('sdk.js') >0){
                    inject_chat_sdk = inject_chat_sdk.replace("sdk.js", "sdk/xfbml.customerchat.js");
                }
                jQ224('body').append(inject_chat_sdk);
            }else if(poptin.poptin_type+"_"+poptin.poptin_format == "social_format_4" || poptin.poptin_type+"_"+poptin.poptin_format == "social_format_8"){
                showLog('ingectFacebookSendToMessangerPlugin');
                //facebook_messanger_data_ref = 'poptin-'+poptin.poptin_id+'|client-'+getClientId()+'|uniqe-'+Math.random().toString(36);
                facebook_messanger_data_ref = poptin.poptin_id+'-'+getClientId()+'-'+Math.random().toString(36);
                jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] .facebook-plugin .fb-send-to-messenger").attr('data-ref',facebook_messanger_data_ref);
                jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] .ui-wrapper").remove();

                if (!jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] .facebook-plugin").is(':empty')){
                    jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] .facebook-messanger-conversion-img").remove();
                }

                setTimeout(function(){
                    jQ224('body').append(jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] .facebook-plugin").attr('data-facebook-send-to-messanger-plugin'));
                },750)
            }
        }
        /**
         * Trigger functions: setPoptin()
         * parameters       : poptin:object
         * Desc             : Push html down
         */
        function pushHtmlDown(poptin){
            showLog('pushHtmlDown');
            if ((poptin.poptin_type == "bar" && poptin.design_properties.poptin_location == "center-top") || jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").attr('data-wellcome-screen')=='1'){
                jQ224("html").animate({"padding-top": jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]")[0].getBoundingClientRect().height+"px"}, 300);
                if_html_pad = true;
            }
        }
        /**
         * Trigger functions: showPoptin()
         * parameters       : poptin:object
         * Desc             : Add padding-right to poptin 'X' button if poptin type in ['bar','fullpage']
         */
        function paddingXButton(poptin){
            if (ifScrollVisible()){
                if (poptin.poptin_type == "fullpage" ){
                    setTimeout(function(){
                        jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] .draggable-container:not(.poptin-tab-container) .close-x-button").css('padding-right',(screen.width==1920 ? '46px': '20px'));
                    },300)
                }
            }
        }


        /**
         * Trigger functions: showPoptin()
         * parameters       : poptin:Object
         * Desc             : Make all css properties !important so website css won't change the poptin style
         * Desc             : Download poptin text font
         */
        function cssFix(poptin){
            jQ224("[data-poptin-id="+poptin.poptin_id+"] .froala-image-wrapper").each(function(){
                var img = jQ224(this).find('img');
                img.css("width",jQ224(this).css("width"));
                img.css("height",jQ224(this).css("height"));
                img.attr("alt", (img.attr("alt") || poptin.poptin_name) );
                img.css("max-width", jQ224(this).css("width"));
            });

            jQ224('.froala-editor-button').css('width', '100%');

            jQ224("[data-poptin-id="+poptin.poptin_id+"] > *:not(.poptin-tab-container)").find('p, input, a, span, div, button, label, ul, ol, li, img, strong, i').each(function(e){

                // Keep cursor always as pointer
                if(jQ224(this).is('a')){
                    jQ224(this).css('cursor','pointer');
                }

                if(jQ224(this).parents('a').length){
                    jQ224(this).css('cursor','');
                }
                if(!poptin_loadcontrol_fix){
                    var this_width = jQ224(this).get(0).style.width;
                    var is_close_button = (jQ224(this).attr('id') == 'closeXButton') ? true : false;
                    if(this_width != '' && !is_close_button){
                        if(this_width.indexOf('px') > -1){
                            this_width = parseInt(this_width);
                            var poptin_data_width_height = getDataWidthHeight(poptin.poptin);
                            var data_width = poptin_data_width_height.width;
                            if(data_width){ this_width = Math.min(data_width, this_width); }
                            this_width = this_width+'px';
                        }
                        if (poptin.poptin_type+'_'+poptin.poptin_format != 'social_format_6' && poptin.poptin_type+'_'+poptin.poptin_format != 'sside_format_19'){
                            if(!jQ224(this).is('img')){
                                //jQ224(this).css({'max-width':this_width});
                            }
                        }
                    }
                }

                var css_string = '';
                jQ224.each(this.attributes, function($this) {
                    if(this.specified) {
                        if (this.name == 'style') {
                            css_string = this.value;
                            css_string = css_string.replace(/ ?!important/g,'');
                            css_string = css_string.replace(/\;base64/g,':base64');
                            if(!poptin_strip_font_imp){
                            css_string = css_string.replace(/\;/g,' !important;');
                            }
                            css_string = css_string.replace(/\:base64/g,';base64');
                            // Download font file from google
                            if (this.value.indexOf('font-family') !==-1){
                                try{
                                    getFont(this.value);
                                }catch(err){
                                    showLog(err);
                                }
                            }
                        }
                    }
                });
                jQ224(this).attr('style',css_string);

            });



            jQ224('#poptinDesignInputTextFieldCheckbox .form-input-class, .poptin-popup input[type="radio"], .poptin-popup input[type="checkbox"]').css({'width':'','max-width':''});

            jQ224("[data-poptin-id="+poptin.poptin_id+"] .froala-editor-text, [data-poptin-id="+poptin.poptin_id+"] .froala-editor-ticker, [data-poptin-id="+poptin.poptin_id+"] .froala-editor-link, [data-poptin-id="+poptin.poptin_id+"] .froala-editor-close").each(function(){
                var styleVal = jQ224(this).attr('style') || '';
                if (styleVal.indexOf('font-family') !== -1) {
                    try {
                        getFont(styleVal);
                    } catch(err) {
                        showLog(err);
                    }
                }
            });


            jQ224('.field-consent-checkbox input').each(function() {
                jQ224(this).css('width', jQ224(this).css('height'))
            })
        }

        /****************************************************************************/
        /***************************** poptin timer  ********************************/
        /****************************************************************************/


        /**
         * Trigger functions: setPoptin()
         * parameters       : poptin:Object
         * Desc             : If poptin type == 'timer' -> Set poptin 'timer' properties
         */
        function secondPlay(time, poptin_id) {
            var timer_poptin = jQ224(".poptin-popup[data-poptin-id="+poptin_id+"]");
            timer_poptin.find(".flip-timer-container").removeClass("play");
            var aa = timer_poptin.find(".secondPlay .flip-item.active");
            if (aa.html() == undefined) {
                aa = timer_poptin.find(".secondPlay .flip-item").eq(0);
                aa.addClass("before")
                    .removeClass("active")
                    .next(".flip-item")
                    .addClass("active")
                    .closest(".flip-timer-container")
                    .addClass("play");
            } else if (aa.is(":last-child")) {
                timer_poptin.find(".secondPlay .flip-item").removeClass("before");
                aa.addClass("before").removeClass("active");
                aa = timer_poptin.find(".secondPlay .flip-item").eq(0);
                aa.addClass("active")
                    .closest(".flip-timer-container")
                    .addClass("play");
            } else {
                timer_poptin.find(".secondPlay .flip-item").removeClass("before");
                aa.addClass("before")
                    .removeClass("active")
                    .next(".flip-item")
                    .addClass("active")
                    .closest(".flip-timer-container")
                    .addClass("play");
            }
        }

        function minutePlay(time, poptin_id) {
            var timer_poptin = jQ224(".poptin-popup[data-poptin-id="+poptin_id+"]");
            timer_poptin.find(".flip-timer-container").removeClass("play");
            var aa = timer_poptin.find(".minutePlay .flip-item.active");
            if (aa.html() == undefined) {
                aa = timer_poptin.find(".minutePlay .flip-item").eq(0);
                aa.addClass("before")
                    .addClass("perspective")
                    .removeClass("active")
                    .next(".flip-item")
                    .addClass("active")
                    .addClass("perspective")
                    .closest(".flip-timer-container")
                    .addClass("play");
            } else if (aa.is(":last-child")) {
                timer_poptin.find(".minutePlay .flip-item").removeClass("before");
                aa.addClass("before").removeClass("active");
                aa = timer_poptin.find(".minutePlay .flip-item").eq(0);
                aa.addClass("active")
                    .addClass("perspective")
                    .closest(".flip-timer-container")
                    .addClass("play");
            } else {
                timer_poptin.find(".minutePlay .flip-item").removeClass("before");
                aa.addClass("before")
                    .addClass("perspective")
                    .removeClass("active")
                    .next(".flip-item")
                    .addClass("active")
                    .addClass("perspective")
                    .closest(".flip-timer-container")
                    .addClass("play");
            }
            setTimeout(function () {
                timer_poptin.find(".minutePlay .flip-item.perspective").removeClass('perspective');
            }, 1000);
        }

        function hoursPlay(time, poptin_id) {
            var timer_poptin = jQ224(".poptin-popup[data-poptin-id="+poptin_id+"]");
            timer_poptin.find(".flip-timer-container").removeClass("play");
            var aa = timer_poptin.find(".hoursPlay .flip-item.active");
            if (aa.html() == undefined) {
                aa = timer_poptin.find(".hoursPlay .flip-item").eq(0);
                aa.addClass("before")
                    .addClass("perspective")
                    .removeClass("active")
                    .next(".flip-item")
                    .addClass("active")
                    .addClass("perspective")
                    .closest(".flip-timer-container")
                    .addClass("play");
            } else if (aa.is(":last-child")) {
                timer_poptin.find(".hoursPlay .flip-item").removeClass("before");
                aa.addClass("before").removeClass("active");
                aa = timer_poptin.find(".hoursPlay .flip-item").eq(0);
                aa.addClass("active")
                    .addClass("perspective")
                    .closest(".flip-timer-container")
                    .addClass("play");
            } else {
                timer_poptin.find(".hoursPlay .flip-item").removeClass("before");
                aa.addClass("before")
                    .addClass("perspective")
                    .removeClass("active")
                    .next(".flip-item")
                    .addClass("active")
                    .addClass("perspective")
                    .closest(".flip-timer-container")
                    .addClass("play");
            }
            setTimeout(function () {
                timer_poptin.find(".hoursPlay .flip-item.perspective").removeClass('perspective');
            }, 1000);
        }

        function daysPlay(time, poptin_id) {
            var timer_poptin = jQ224(".poptin-popup[data-poptin-id="+poptin_id+"]");
            timer_poptin.find(".flip-timer-container").removeClass("play");
            var aa = timer_poptin.find(".daysPlay .flip-item.active");
            if (aa.html() == undefined) {
                aa = timer_poptin.find(".daysPlay .flip-item").eq(0);
                aa.addClass("before")
                    .addClass("perspective")
                    .removeClass("active")
                    .next(".flip-item")
                    .addClass("active")
                    .addClass("perspective")
                    .closest(".flip-timer-container")
                    .addClass("play");
            } else if (aa.is(":last-child")) {
                timer_poptin.find(".daysPlay .flip-item").removeClass("before");
                aa.addClass("before").removeClass("active");
                aa = timer_poptin.find(".daysPlay .flip-item").eq(0);
                aa.addClass("active")
                    .addClass("perspective")
                    .closest(".flip-timer-container")
                    .addClass("play");
            } else {
                timer_poptin.find(".daysPlay .flip-item").removeClass("before");
                aa.addClass("before")
                    .addClass("perspective")
                    .removeClass("active")
                    .next(".flip-item")
                    .addClass("active")
                    .addClass("perspective")
                    .closest(".flip-timer-container")
                    .addClass("play");
            }
            setTimeout(function () {
                timer_poptin.find(".daysPlay .flip-item.perspective").removeClass('perspective');
            }, 1000);
        }

        function poptinTimer(poptin){
            var timer_cont = jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+'] .timer-container');
            if(timer_cont.length && timer_cont.hasClass('.timer-started')){
                return false;
            } else {
                timer_cont.addClass('.timer-started');
                // If poptin type 'timer'
                if (
                    poptin.design_properties.timer_ver == 1 ||
                    poptin.design_properties.timer_ver == 2 ||
                    (
                        poptin.design_properties.timer_ver == 0 && (
                            poptin.poptin_type+'_'+poptin.poptin_format == "embedded_format_5" ||
                            poptin.poptin_type+'_'+poptin.poptin_format == "lightbox_format_5" ||
                            poptin.poptin_type+'_'+poptin.poptin_format == "lightbox_format_11" ||
                            poptin.poptin_type+'_'+poptin.poptin_format == "bar_format_5" ||
                            poptin.poptin_type+'_'+poptin.poptin_format == "bar_format_10"
                        )
                    )
                ){
                    var timer_ver = 1;
                    if(poptin.design_properties.timer_ver == 2){
                        timer_ver = 2;
                    }
                    var role = poptin.design_properties.timer.split('@'); // timerTime / timerDate
                    var time = role[1].split('|'); // 01/21/2019 date | 10:45 PM Time | +2 GMT
                    // If role is time
                    if (role[0] == 'timerTime'){
                        var seconds = parseInt(time[0])*60+parseInt(time[1]);
                        // seconds = seconds % 60 == 1 ? seconds + 1 : seconds;
                        var count_down = new Date((new Date()).getTime() + (seconds * 1000));
                        // set the timer date

                        initializeClock(poptin.poptin_id,count_down,poptin,timer_ver);
                        // If role is date
                    }else{
                        //var count_down = new Date(time[0]+' '+(time[1].split(' '))[0]+' GMT'+time[2]);
                        var count_down = new Date(time[0]+' '+time[1]+' GMT'+(time[2]=="0" ?'+0':time[2]));
                        // if(count_down.getSeconds() == 1){ count_down = new Date(count_down.getTime() + 1000); }
                        showLog(time[0]+' '+time[1]+' GMT'+time[2]);
                        showLog(time[2]=="0" ?'yes':'no');
                        showLog(count_down);
                        // If date have not passed
                        if (checkIfTimer(poptin,count_down)){
                            // set the timer date
                            initializeClock(poptin.poptin_id,count_down,poptin,timer_ver);
                        }else{
                            // Don't show poptin
                            if(timer_cont.length){
                                return false;
                            }else{
                                return true;
                            }
                        }
                    }
                }
            }
            return true;
        }

        /**
         * Trigger functions: poptinTimer()
         * parameters       : poptin_id:string | endtime: Date()
         * Desc             : initialize the poptin timer clock
         */
        function resetClock(endtime, poptin_id, caller){
            if(typeof endtime !== "undefined"){
                var timer_poptin = jQ224(".poptin-popup[data-poptin-id="+poptin_id+"]");
                timer_poptin.find('.flip-timer-container').addClass('play');
                var t = getTimeRemaining(endtime);
                var currentSec = parseInt(timer_poptin.find('.secondPlay .flip-item.active .up .inn').text());
                var secTimeDiff = Math.abs( (isNaN(currentSec) ? 0 : currentSec) - t.seconds);
                showLog('secTimeDiff', secTimeDiff, currentSec);

                if(secTimeDiff || caller == 'program'){
                    timer_poptin.find(".secondPlay .flip-item").removeClass("before");
                    timer_poptin.find(".secondPlay .flip-item").removeClass("active");
                    timer_poptin.find('.secondPlay .flip-item .up .inn').each(function(){
                        if(parseInt(jQ224(this).text()) == t.seconds){
                            var flip_item = jQ224(this).closest('.flip-item').prev();
                            flip_item.addClass("before")
                                .next(".flip-item")
                                .addClass("active");
                        }
                    });
                }
                var currentMin = parseInt(timer_poptin.find('.minutePlay .flip-item.active .up .inn').text());
                var minTimeDiff = Math.abs( (isNaN(currentMin) ? 0 : currentMin) - t.minutes);
                showLog('minTimeDiff', minTimeDiff, currentMin);
                if(minTimeDiff || caller == 'program'){
                    timer_poptin.find(".minutePlay .flip-item").removeClass("before");
                    timer_poptin.find(".minutePlay .flip-item").removeClass("active");
                    timer_poptin.find('.minutePlay .flip-item .up .inn').each(function(){
                        if(parseInt(jQ224(this).text()) == t.minutes){
                            var flip_item = jQ224(this).closest('.flip-item').prev();
                            flip_item.addClass("before")
                                .next(".flip-item")
                                .addClass("active");
                        }
                    });
                }
                var currentHr = parseInt(timer_poptin.find('.hoursPlay .flip-item.active .up .inn').text());
                var hrTimeDiff = Math.abs( (isNaN(currentHr) ? 0 : currentHr) - t.hours);
                showLog('hrTimeDiff', hrTimeDiff, currentHr);
                if(hrTimeDiff || caller == 'program'){
                    timer_poptin.find(".hoursPlay .flip-item").removeClass("before");
                    timer_poptin.find(".hoursPlay .flip-item").removeClass("active");
                    timer_poptin.find('.hoursPlay .flip-item .up .inn').each(function(){
                        if(parseInt(jQ224(this).text()) == t.hours){
                            var flip_item = jQ224(this).closest('.flip-item').prev();
                            flip_item.addClass("before")
                                .next(".flip-item")
                                .addClass("active");
                        }
                    });
                }
                var currentDay = parseInt(timer_poptin.find('.daysPlay .flip-item.active .up .inn').text());
                var dayTimeDiff = Math.abs( (isNaN(currentDay) ? 0 : currentDay) - t.days);
                showLog('dayTimeDiff', dayTimeDiff, currentDay);
                if(dayTimeDiff != 0){
                    if(dayTimeDiff || caller == 'program'){
                        jQ224("#poptinDraggableContainer .daysPlay .flip-item").removeClass("before");
                        jQ224("#poptinDraggableContainer .daysPlay .flip-item").removeClass("active");
                        jQ224('#poptinDraggableContainer .daysPlay .flip-item .up .inn').each(function(){
                            if(parseInt(jQ224(this).text()) == t.days){
                                showLog(parseInt(jQ224(this).text()), t.days);
                                var flip_item = jQ224(this).closest('.flip-item').prev();
                                flip_item.addClass("before")
                                    .next(".flip-item")
                                    .addClass("active");
                            }
                        });
                    }
                }else{
                    var prev_timer_type = jQ224('.poptin-popup[data-poptin-id='+poptin_id+'] .timer-container').attr("data-timer-type");
                    console.log(prev_timer_type);
                    jQ224('.poptin-popup[data-poptin-id='+poptin_id+'] #timerDays').css("display", "none");
                    jQ224('.poptin-popup[data-poptin-id='+poptin_id+'] .timer-container').attr("data-timer-type", "hours");
                    if(prev_timer_type == 'date'){
                        centerTimerElement(poptin_id);
                    }

                }
            }
        }
        function prefix0(num){
            return ('0'+num).slice(-2);
        }
        function centerTimerElement(poptin_id) {
            setTimeout(function () {
                var this_parent = jQ224('.poptin-popup[data-poptin-id='+poptin_id+'] .timer-container');
                var this_left =  jQ224('.poptin-popup[data-poptin-id='+poptin_id+']').width() - this_parent.width();
                this_parent.css({ left: this_left / 2 + "px" });
            }, 10);
        }

        function initializeClock(poptin_id,endtime,poptin,timer_ver) {
            //var clock = jQ224('.timer-container');
            var timer_poptin = jQ224(".poptin-popup[data-poptin-id="+poptin_id+"]");
            showLog('initializeClock() | endtime: '+endtime+', poptin_id: '+poptin_id);
            // get timer container
            jQ224('.poptin-popup[data-poptin-id='+poptin_id+']').show();

            if(timer_ver == 2) {

                jQ224(window).on("blur focus hover", function(e) {
                    var prevType =  timer_poptin.find('.flip-timer-container').attr("data-prev-type");
                    if (prevType != e.type) {   //  reduce double fire issues
                        switch (e.type) {
                            case "focus":
                                resetClock(endtime,poptin_id,'window');
                                break;
                        }
                    }
                    timer_poptin.find('.flip-timer-container').attr("data-prev-type", e.type);
                });

                jQ224('.poptin-popup[data-poptin-id='+poptin_id+'] .timer-container').addClass('timer-started');
                var t = getTimeRemaining(endtime);
                showLog('getTimeRemaining', t);
                var flip_cont = jQ224('.poptin-popup[data-poptin-id='+poptin_id+'] .flip-timer-container');
                var flip_wrap = flip_cont.find('.daysPlay, .hoursPlay, .minutePlay, .secondPlay');
                flip_wrap.find('.flip-item').after('<div class="flip-item-holder"></div>');
                flip_wrap.find('.flip-item').remove();
                for (var idx = t.days; idx >= 0; idx--) {
                    var showtime = prefix0(idx);
                    flip_cont.find('.daysPlay .flip-item-holder').append('<div class="flip-item"><div class="anim-wrap"><div class="up"><div class="shadow"></div><div class="inn">'+showtime+'</div></div><div class="down"><div class="shadow"></div><div class="inn">'+showtime+'</div></div></div></div>')
                }
                for (var idx = 23; idx >= 0; idx--) {
                    var showtime = prefix0(idx);
                    flip_cont.find('.hoursPlay .flip-item-holder').append('<div class="flip-item"><div class="anim-wrap"><div class="up"><div class="shadow"></div><div class="inn">'+showtime+'</div></div><div class="down"><div class="shadow"></div><div class="inn">'+showtime+'</div></div></div></div>')
                }
                for (var idx = 59; idx >= 0; idx--) {
                    var showtime = prefix0(idx);
                    flip_cont.find('.minutePlay .flip-item-holder').append('<div class="flip-item"><div class="anim-wrap"><div class="up"><div class="shadow"></div><div class="inn">'+showtime+'</div></div><div class="down"><div class="shadow"></div><div class="inn">'+showtime+'</div></div></div></div>')
                }
                for (var idx = 59; idx >= 0; idx--) {
                    var showtime = prefix0(idx);
                    flip_cont.find('.secondPlay .flip-item-holder').append('<div class="flip-item"><div class="anim-wrap"><div class="up"><div class="shadow"></div><div class="inn">'+showtime+'</div></div><div class="down"><div class="shadow"></div><div class="inn">'+showtime+'</div></div></div><div>')
                }
                var timer_bg_flip_color = ( flip_wrap.css('background-color')=='rgba(0, 0, 0, 0)' ? 'rgb(255, 255, 255)' : flip_wrap.css('background-color'));
                showLog("flip_wrap",timer_bg_flip_color);

                flip_cont.find('.flip-item').css('border-radius', flip_wrap.css('border-radius'));
                flip_cont.find('.flip-item .anim-wrap > div').css('background-color', timer_bg_flip_color);
                // Update timer clock
                // Run every second
                function updateClock() {
                    if(jQ224('.poptin-popup[data-poptin-id='+poptin_id+'] .flip-timer-container').length>0){
                        // get time remaining
                        var t = getTimeRemaining(endtime);
                        // showLog('getTimeRemaining', t);

                        // If countdown  - if timer finished
                        // -> close poptin
                        // -> clear interval
                        if (t == false || t.total < 1000) {
                            ensurePoptinTrigger(poptin_id);
                            window.poptins[poptin_id].poptin_trigger.close_trigger = "timer";
                            closePoptin(poptin_id);
                            try{clearInterval(updateClockInterval);}catch(err){}
                        } else {

                            // showLog('Play seconds');
                            secondPlay(t, poptin_id);

                            if(t.seconds == 0 && t.minutes >= 0){
                                showLog('Play minutes');
                                minutePlay(t, poptin_id);
                            }
                            if(t.seconds == 0 && t.minutes == 0 && t.hours >= 0){
                                showLog('Play hours');
                                hoursPlay(t, poptin_id);
                            }
                            if(t.seconds == 0 && t.minutes == 0 && t.hours >= 0 && t.days >= 0){
                                showLog('Play days',t);
                                daysPlay(t, poptin_id);
                                if(t.seconds == 0 && t.minutes == 0 && t.hours == 0 && (t.days == 1) ){
                                    jQ224('.poptin-popup[data-poptin-id='+poptin_id+'] #timerDays').css("display", "none");
                                    jQ224('.poptin-popup[data-poptin-id='+poptin_id+'] .timer-container').attr("data-timer-type", "hours");
                                    centerTimerElement(poptin_id);
                                }
                            }

                        }
                        var time_str = '';
                        //showLog(timer_poptin.find('#hoursPlay'));
                        if(timer_poptin.find('#timerHours').is(':visible')){
                            var days_str = timer_poptin.find(".daysPlay");
                            time_str += (days_str.find(".flip-item.active .up").text() || days_str.find(".flip-item:first-child .up").text() )+' '+days_str.find(".froala-editor-text").text() + ', ';
                            var hours_str = timer_poptin.find(".hoursPlay");
                            time_str += (hours_str.find(".flip-item.active .up").text() || 24)+' '+hours_str.find(".froala-editor-text").text() + ', ';
                        }
                        var minute_str = timer_poptin.find(".minutePlay");
                        time_str += (minute_str.find(".flip-item.active .up").text() || 59 )+' '+minute_str.find(".froala-editor-text").text() + ', ';
                        var second_str = timer_poptin.find(".secondPlay");
                        time_str += second_str.find(".flip-item.active .up").text()+' '+second_str.find(".froala-editor-text").text();
                        time_str = ifUserlangIsHe() ? time_str + ' טיימר' : 'Timer ' + time_str;
                        flip_cont.attr('aria-label', time_str);
                    }else{
                        clearInterval(updateClockInterval);
                    }

                }

                jQ224('.poptin-popup[data-poptin-id='+poptin_id+'] .flip-timer-container').addClass('reset');
                resetClock(endtime, poptin_id, 'program');


                updateClock();

                // Run every second
                try{clearInterval(updateClockInterval);}catch(err){}

                if(jQ224('.poptin-popup[data-poptin-id='+poptin_id+'] .flip-timer-container').length>0){
                    updateClockInterval = setInterval(updateClock, 1000);
                }


                setTimeout(function(){
                    jQ224('.poptin-popup[data-poptin-id='+poptin_id+'] .flip-timer-container').removeClass('reset');
                },1000);

            } else {

                var clock = jQ224('.poptin-popup[data-poptin-id='+poptin_id+'] .timer-container');

                // Update timer clock
                // Run every second
                function updateClock() {
                    // get time remaining
                    var t = getTimeRemaining(endtime);

                    /**
                     * set timer new date date
                     */
                    if(jQ224('.poptin-popup[data-poptin-id='+poptin_id+'] .flip-timer-container').length>0){

                        var  days       = ('0' + t.days).slice(-2);
                        var  hours      = ('0' + t.hours).slice(-2);
                        var  minutes    = ('0' + t.minutes).slice(-2);
                        var  seconds    = ('0' + t.seconds).slice(-2);

                        clock.find('#timerDays .first').text(days[0]);
                        clock.find('#timerDays .second').text(days[1]);
                        clock.find('#timerHours .first').text(hours[0]);
                        clock.find('#timerHours .second').text(hours[1]);
                        clock.find('#timerMinutes .first').text(minutes[0]);
                        clock.find('#timerMinutes .second').text(minutes[1]);
                        clock.find('#timerSeconds .first').text(seconds[0]);
                        clock.find('#timerSeconds .second').text(seconds[1]);

                        // If countdown  - if timer finished
                        // -> close poptin
                        // -> clear interval
                        if (t == false || t.total < 1000) {
                            ensurePoptinTrigger(poptin_id);
                            window.poptins[poptin_id].poptin_trigger.close_trigger = "timer";
                            closePoptin(poptin_id);
                            try{clearInterval(updateClockInterval);}catch(err){}
                        }
                    }else{
                        clearInterval(updateClockInterval);
                    }
                }
                // Run once
                updateClock();

                if(jQ224('.poptin-popup[data-poptin-id='+poptin_id+'] .flip-timer-container').length>0){
                    var updateClockInterval = setInterval(updateClock, 1000);
                }

                // Run every second
            }
        }

        /**
         * Trigger functions: updateClock()
         * parameters       : endtime: Date()
         * Desc             : Return timer object with updated timer time
         */
        function getTimeRemaining(endtime) {
            var t = endtime.getTime() - (new Date()).getTime();
            return {
                'total': t,
                'days':  Math.floor(t / (1000 * 60 * 60 * 24)),
                'hours': Math.floor((t / (1000 * 60 * 60)) % 24),
                'minutes': Math.floor((t / 1000 / 60) % 60),
                'seconds': Math.floor((t / 1000) % 60)
            };
        }

        /**
         * Trigger functions: poptinTimer()
         * parameters       : poptin:object | endtime: Date()
         * Desc             : Return boolean if timer end or not
         */
        function checkIfTimer(poptin,endtime){
            var t = endtime.getTime() - (new Date()).getTime();
            return (t <= 0 || endtime== "Invalid Date" ? false : true );
        }

        /**
         * Trigger functions: showPoptin()
         * parameters       : poptin:object | click:Boolean (if poptin click trigger)
         * Desc             : Set poptin form submit events
         */
        function poptinFormClickSubmit(poptin, click){

            showLog('poptinFormClickSubmit: '+poptin.poptin_id);

            try{
                jQ224('[data-poptin-id="'+poptin.poptin_id+'"] [id="poptinFormSubmit'+poptin.poptin_id+'"]').off("click");
            }catch(err){
                showLog(err)
            }

            // // Set cursor to 'pointer' if enter and 'auto' if out of form container
            // jQ224('[data-poptin-id='+poptin.poptin_id+'] #poptinFormSubmit'+poptin.poptin_id+'').on('mouseenter', function(e){
            //  if ( jQ224(e.target).hasClass('poptin-form-submit-button') || jQ224(e.target).parents('.poptin-form-submit-button').length > 0){
            //      jQ224('[data-poptin-id='+poptin.poptin_id+'] .poptin-form-submit-button').css('cursor', 'pointer').children().css('cursor', 'pointer');
            //  }
            //  if ( jQ224(e.target).hasClass('poptin-form-close-button') || jQ224(e.target).parents('.poptin-form-close-button').length > 0){
            //      jQ224('[data-poptin-id='+poptin.poptin_id+'] .poptin-form-close-button').css('cursor', 'pointer').children().css('cursor', 'pointer');
            //  }
            // }).on('mouseout', function(e){
            //  if ( !jQ224(e.target).hasClass('poptin-form-submit-button') && !(jQ224(e.target).parents('.poptin-form-submit-button').length > 0)){
            //      jQ224(jQ224.target).css('cursor', 'auto').children().css('cursor', 'auto');
            //  }
            //  if ( !jQ224(e.target).hasClass('poptin-form-close-button') && !(jQ224(e.target).parents('.poptin-form-close-button').length > 0)){
            //      jQ224(jQ224.target).css('cursor', 'auto').children().css('cursor', 'auto');
            //  }
            // });

            // Set poptin click event
            jQ224('[data-poptin-id="'+poptin.poptin_id+'"] [id="poptinFormSubmit'+poptin.poptin_id+'"]').on('click',function (e) {
                try{
                    jQ224('[data-poptin-id="'+poptin.poptin_id+'"] [id="poptinFormSubmit'+poptin.poptin_id+'"]').off("submit");
                }catch(err){
                    showLog(err)
                }
                // if click event  have class ',poptin-form-submit-button'
                if ( jQ224(e.target).hasClass('poptin-form-submit-button') || jQ224(e.target).parents('.poptin-form-submit-button').length > 0){

                    // if click event on tag 'P' || 'DIV' || 'IMG'
                    // showLog(jQ224(e.target).prop('tagName'));
                    if (
                        jQ224(e.target).prop('tagName') == "P" ||
                        jQ224(e.target).parents('.poptin-form-submit-button').prop('tagName') == "P" ||
                        ( jQ224(e.target).prop('tagName') == "DIV" && jQ224(e.target).hasClass('draggable') ) ||
                        ( jQ224(e.target).parents('.poptin-form-submit-button').prop('tagName') == "DIV" && jQ224(e.target).parents('.poptin-form-submit-button').hasClass('draggable') ) ||
                        jQ224(e.target).prop('tagName') == "IMG" ||
                        (poptin.poptin_type== "mobile" && poptin.poptin_format== "format_1") ||
                        (poptin.poptin_type== "mobile" && poptin.poptin_format== "format_2") ||
                        (poptin.poptin_type== "mobile" && poptin.poptin_format== "format_6") ||
                        (poptin.poptin_type== "mobile" && poptin.poptin_format== "format_7") ||
                        (poptin.poptin_type== "mobile" && poptin.poptin_format== "format_11")
                    ){

                        try{
                            showLog('poptinFormTriggerSubmit - Function called for poptin_id:', poptin.poptin_id);
                            showLog('poptinFormTriggerSubmit - send_form_data enabled:', poptin.design_properties.poptin_design_redirect_send_form_data);

                            var this_pop = jQ224("[data-poptin-id="+poptin.poptin_id+"]");
                            var this_form = jQ224(e.target).parents('[data-poptin-id="'+poptin.poptin_id+'"].poptin-popup');

                            jQ224('.poptin-popup').remove('active');
                            this_form.addClass('active');

                            // Disable default submit event
                            e.preventDefault();

                            // set redirect link to redirect array after poptin form submit
                            if (
                                ( poptin.poptin_type== "mobile" && poptin.poptin_format== "format_1" ) ||
                                ( poptin.poptin_type== "mobile" && poptin.poptin_format== "format_6" ) ||
                                ( poptin.poptin_type== "mobile" && poptin.poptin_format== "format_11" )
                            ) {
                                if( jQ224('[data-poptin-id="'+poptin.poptin_id+'"] a').hasClass('fa-phone-square') ) {
                                    window.poptins[poptin.poptin_id].redirect_url = jQ224('[data-poptin-id="'+poptin.poptin_id+'"] .fa-phone-square').attr('href');
                                    window.poptins[poptin.poptin_id].redirect_target = jQ224('[data-poptin-id="'+poptin.poptin_id+'"] .fa-phone-square').prop('target');
                                    showLog('Phone redirect - redirect_target set to:', jQ224('[data-poptin-id="'+poptin.poptin_id+'"] .fa-phone-square').prop('target'));
                                } else if( jQ224('[data-poptin-id="'+poptin.poptin_id+'"] a.call-link').length ) {
                                    window.poptins[poptin.poptin_id].redirect_url = jQ224('[data-poptin-id="'+poptin.poptin_id+'"] .call-link').attr('href');
                                    window.poptins[poptin.poptin_id].redirect_target = jQ224('[data-poptin-id="'+poptin.poptin_id+'"] .call-link').prop('target');
                                    showLog('Call link redirect - redirect_target set to:', jQ224('[data-poptin-id="'+poptin.poptin_id+'"] .call-link').prop('target'));
                                } else if( jQ224('[data-poptin-id="'+poptin.poptin_id+'"] .fa-phone').length ) {
                                    window.poptins[poptin.poptin_id].redirect_url = jQ224('[data-poptin-id="'+poptin.poptin_id+'"] .fa-phone').parent().attr('href');
                                    window.poptins[poptin.poptin_id].redirect_target = jQ224('[data-poptin-id="'+poptin.poptin_id+'"] .fa-phone').parent().prop('target');
                                    showLog('Phone icon redirect - redirect_target set to:', jQ224('[data-poptin-id="'+poptin.poptin_id+'"] .fa-phone').parent().prop('target'));
                                } else {
                                    window.poptins[poptin.poptin_id].redirect_url = jQ224('[data-poptin-id="'+poptin.poptin_id+'"] .fa-phone-square').parent().attr('href');
                                    window.poptins[poptin.poptin_id].redirect_target = jQ224('[data-poptin-id="'+poptin.poptin_id+'"] .fa-phone-square').parent().prop('target');
                                    showLog('Phone square parent redirect - redirect_target set to:', jQ224('[data-poptin-id="'+poptin.poptin_id+'"] .fa-phone-square').parent().prop('target'));
                                }
                            }

                            const redirectLink = this_pop.find(".redirect-url-blank");
                            if(!window.poptins[poptin.poptin_id]?.redirect_url && redirectLink.length) {
                                window.poptins[poptin.poptin_id].redirect_url = redirectLink.attr("href");
                                // Store the target attribute to preserve _blank behavior
                                window.poptins[poptin.poptin_id].redirect_target = redirectLink.prop("target");
                                showLog('poptinFormTriggerSubmit - redirect_target set to:', redirectLink.prop("target"));
                                showLog('poptinFormTriggerSubmit - redirect_url set to:', redirectLink.attr("href"));

                                // Store the values in a more persistent way
                                if (!window.poptins[poptin.poptin_id]._persistent_redirect) {
                                    window.poptins[poptin.poptin_id]._persistent_redirect = {};
                                }
                                window.poptins[poptin.poptin_id]._persistent_redirect.target = redirectLink.prop("target");
                                window.poptins[poptin.poptin_id]._persistent_redirect.url = redirectLink.attr("href");
                                showLog('poptinFormTriggerSubmit - persistent values stored:', window.poptins[poptin.poptin_id]._persistent_redirect);
                            }

                            showLog('poptinFormTriggerSubmit'+poptin.poptin_id+' submit');

                            var hiddenFields = jQ224('[data-poptin-id="'+poptin.poptin_id+'"] .inputs-container [data-name="poptinDesignHiddenField"]');
                            hiddenFields.each(function(){
                                jQ224(this).val(jQ224(this).val() || ' ');
                            });

                            // start submit poptin function
                            if(poptin.poptin_type == "gamified" && !poptin.design_properties.disable_post_play_screen){
                                var this_js_form = jQ224('[data-poptin-id="'+poptin.poptin_id+'"] #poptinPlayScreen form');
                            }else{
                                var this_js_form = this_form.find('#poptinDraggableContainer form');
                            }

                            // Get all inputs in sequence
                            var inputs = this_js_form.find('.inputs-container').find('.form-input-class');

                            // First validate all fields in sequence
                            inputs.each(function() {
                                // Checkbox validation
                                if(jQ224(this).hasClass('field-checkbox')) {
                                    // Skip consent checkbox as it's handled separately
                                    if(!jQ224(this).hasClass('field-consent-checkbox')) {
                                        var checkbox_validity = jQ224(this).find('.checkbox-child-field input:checked');
                                        var default_checkbox = jQ224(this).find('.checkbox-child-field input').first();

                                        // Check if this checkbox group is required
                                        if(jQ224(this).attr('data-action-required') == 'true' && checkbox_validity.length == 0) {
                                            default_checkbox.prop('required', true).attr('required', true);

                                            // Show validation message
                                            if(!this_js_form[0].checkValidity()) {
                                                try {
                                                    this_js_form[0].reportValidity();
                                                } catch(e) {
                                                    default_checkbox[0].checkValidity();
                                                }
                                                return false; // Stop validation sequence here
                                            }
                                        }
                                    }
                                }
                                // Radio validation
                                else if(jQ224(this).hasClass('field-radio')) {
                                    var radio_validity = jQ224(this).find('.radio-child-field input:checked');
                                    var default_radio = jQ224(this).find('.radio-child-field input').first();
                                    if(jQ224(this).attr('data-action-required') == 'true' && radio_validity.length == 0) {
                                        default_radio.prop('required', true).attr('required', true);
                                    }
                                }
                                // Phone validation
                                else if(jQ224(this).find('input#poptinDesignInputTextFieldPhone').length) {
                                    var phone_field = jQ224(this).find('input#poptinDesignInputTextFieldPhone');

                                    if(phone_field.length && phone_field.attr('data-action-validate') == 'advanced'){
                                        var report_number = true;
                                        jQ224(".poptin-input-msg").remove();
                                        var phone_number = phone_field.val();
                                        if(phone_number && phone_number.length){
                                            if(null == phone_number.match(/--+/g) && 0 == phone_number.replace(/(\d+|-)/g , '').length){
                                                phone_number = phone_number.replace(/-/g , '').toString();
                                                var first_2 = phone_number.substring(0, 2);
                                                var first_3 = phone_number.substring(0, 3);
                                                if( ['02','03','04','08','09'].includes(first_2) && null != phone_number.match(/^\w{3}\w{3}\w{3}$/g) ) {
                                                    report_number = false;
                                                } else if( ['050','051','052','053','054','055','058','072','073','074','076','077','079'].includes(first_3) && null != phone_number.match(/^\w{3}\w{3}\w{4}$/g) ){
                                                    report_number = false;
                                                }
                                            }
                                        }
                                        if(report_number){
                                            var randomId = parseInt(Math.random()*10000000000);
                                            jQ224(phone_field).parent().append('<span id="m'+randomId+'" class="poptin-input-msg poptin-input-msg-4 poptin-input-error">מספר הטלפון שגוי</span>');
                                            var container = jQ224(phone_field).parents(".draggable-container");
                                            var this_scale = parseFloat(this_pop.attr('data-scale'));
                                            if(this_scale >= 1){
                                                container.addClass("has-poptin-input-msg");
                                                container.append(jQ224("#m"+randomId).clone().attr("id", "c"+randomId));
                                                jQ224("#c"+randomId).css({
                                                    "top":((jQ224("#m"+randomId).offset().top - container.offset().top)/this_scale) + 3,
                                                    "left":((jQ224("#m"+randomId).offset().left - container.offset().left)/this_scale),
                                                    "width":parseInt(jQ224("#m"+randomId).css("width")) + 10,
                                                    "height":parseInt(jQ224("#m"+randomId).css("height")),
                                                });
                                            } else {
                                                container.removeClass("has-poptin-input-msg");
                                            }
                                            return false;
                                        }
                                    } else if(phone_field.length && phone_field.attr('data-action-validate') == 'international'){
                                        jQ224(".poptin-input-msg").remove();
                                        var phone_number = phone_field.val();
                                        var phoneInput = phone_field.get(0);

                                        // Check if the input has been initialized with intl-tel-input
                                        if (phoneInput._iti && phoneInput._utilsLoaded && window.intlTelInputUtils) {
                                            var validationMessage = "";
                                            const iti = phoneInput._iti;
                                            // Format the number
                                            try {
                                                // Required + empty check (must happen before format/validate)
                                                if (!phoneInput.value && phone_field.attr('data-action-required') == "true") {
                                                    validationMessage = ifUserlangIsHe() ? "יש להזין מספר טלפון תקין" : "Please enter a valid phone number";
                                                } else if (phoneInput.value.length) {
                                                    var currentFormat = (phoneInput.value[0] === "+") ? intlTelInputUtils.numberFormat.INTERNATIONAL : intlTelInputUtils.numberFormat.NATIONAL;
                                                    var selectedFlag = jQ224(phoneInput).parents(".iti").find(".iti__selected-flag .iti__flag");
                                                    if (selectedFlag.length) {
                                                        var flag = selectedFlag.attr("class").slice(-2);
                                                        phoneInput.value = intlTelInputUtils.formatNumber(phoneInput.value, flag, currentFormat);
                                                    }

                                                    // Validate
                                                    if (!iti.isValidNumber()) {
                                                        validationMessage = ifUserlangIsHe() ? "מספר לא תקין – יש לנסות שוב." : "Invalid number - please try again";
                                                    }
                                                }
                                            } catch(err) {
                                                showLog("Phone validation error:", err);
                                                validationMessage = ifUserlangIsHe() ? "יש להזין מספר טלפון תקין" : "Please enter a valid phone number";
                                            }
                                            jQ224(".poptin-input-msg").remove();
                                            if(validationMessage){
                                                var randomId = parseInt(Math.random()*10000000000);
                                                jQ224(phoneInput).parent().append('<span id="m'+randomId+'" class="poptin-input-msg poptin-input-msg-5 poptin-input-error">'+validationMessage+'</span>');
                                                var container = jQ224(phoneInput).parents(".draggable-container");
                                                var this_scale = parseFloat(this_pop.attr('data-scale'));
                                                if(this_scale >= 1){
                                                    container.addClass("has-poptin-input-msg");
                                                    container.append(jQ224("#m"+randomId).clone().attr("id", "c"+randomId));
                                                    jQ224("#c"+randomId).css({
                                                        "top":((jQ224("#m"+randomId).offset().top - container.offset().top)/this_scale) + 3,
                                                        "left":((jQ224("#m"+randomId).offset().left - container.offset().left)/this_scale),
                                                        "width":parseInt(jQ224("#m"+randomId).css("width")) + 10,
                                                        "height":parseInt(jQ224("#m"+randomId).css("height")),
                                                    });
                                                } else {
                                                    container.removeClass("has-poptin-input-msg");
                                                }
                                                return false;
                                            }
                                        } else {
                                            // Fallback to basic validation if intl-tel-input isn't ready
                                            if (!phoneInput.value && phone_field.attr('data-action-required') == "true") {
                                                var validationMessage = ifUserlangIsHe() ? "יש להזין מספר טלפון תקין" : "Please enter a valid phone number";
                                                return false;
                                            }
                                        }
                                    }
                                }
                                // Email validation
                                else if(jQ224(this).find('input#poptinDesignInputTextFieldEmail').length) {
                                    var email_field = jQ224(this).find('input#poptinDesignInputTextFieldEmail');
                                    if(email_field.length){

                                        var validateAction = email_field.attr('data-action-validate');
                                        validateAction = validateAction ? validateAction : "check-typos";
                                        var check_typos = validateAction.includes('typos');
                                        var check_business_email = validateAction.includes('business');

                                        function isValidEmail(email){
                                            return /^[a-zA-Z0-9+._/\\\-@ ()\[\]]+$/.test(email) && /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})*$/.test(email);
                                        }

                                        function isBusinessEmail(email){
                                            var emailDomain = email.split('@')[1];
                                            return window.fakeEmailDomains && !(window.fakeEmailDomains.includes(emailDomain));
                                        }

                                        if(check_typos || check_business_email){
                                            var report_email = false;
                                            jQ224(".poptin-input-msg").remove();
                                            var email_address = email_field.val();
                                            var error_message = "";
                                            if(email_address && email_address.length){
                                                if(check_typos && !isValidEmail(email_address)){
                                                    error_message = ifUserlangIsHe() ?  "יש שגיאות כתיב במייל." : "There are typos in the email";
                                                    report_email = true;
                                                }
                                                if(check_business_email && !isBusinessEmail(email_address)){
                                                    error_message = ifUserlangIsHe() ? "רק מיילים עסקיים מותרים." : "Only business emails are allowed";
                                                    report_email = true;
                                                }
                                            }
                                            if(report_email){
                                                var randomId = parseInt(Math.random()*10000000000);
                                                jQ224(email_field).parent().append('<span id="m'+randomId+'" class="poptin-input-msg poptin-input-msg-6 poptin-input-error">'+error_message+'</span>');
                                                var container = jQ224(email_field).parents(".draggable-container");
                                                var this_scale = parseFloat(this_pop.attr('data-scale'));
                                                if(this_scale >= 1){
                                                    container.addClass("has-poptin-input-msg");
                                                    container.append(jQ224("#m"+randomId).clone().attr("id", "c"+randomId));
                                                    jQ224("#c"+randomId).css({
                                                        "top":((jQ224("#m"+randomId).offset().top - container.offset().top)/this_scale) + 3,
                                                        "left":((jQ224("#m"+randomId).offset().left - container.offset().left)/this_scale),
                                                        "width":parseInt(jQ224("#m"+randomId).css("width")) + 10,
                                                        "height":parseInt(jQ224("#m"+randomId).css("height")),
                                                    });
                                                } else {
                                                    container.removeClass("has-poptin-input-msg");
                                                }
                                                return false;
                                            }
                                        }
                                    }
                                }
                                // Birthday validation
                                else if(jQ224(this).find('input#poptinDesignBirthdayField').length) {
                                    var birthdayField = jQ224(this).find('input#poptinDesignBirthdayField');
                                    if(birthdayField.length) {
                                        jQ224(".poptin-input-msg").remove();
                                        var birthday = birthdayField.val();
                                        if(birthday) {
                                            var birthdayDate = new Date(birthday);
                                            var today = new Date();
                                            if(birthdayDate >= today) {
                                                var error_message = ifUserlangIsHe() ? "יש להזין תאריך לידה תקין." : "Please enter a valid birthday.";
                                                var randomId = parseInt(Math.random()*10000000000);
                                                birthdayField.parent().append('<span id="m'+randomId+'" class="poptin-input-msg poptin-input-msg-7 poptin-input-error">'+error_message+'</span>');
                                                var container = birthdayField.parents(".draggable-container");
                                                var this_scale = parseFloat(this_pop.attr('data-scale'));
                                                if(this_scale >= 1){
                                                    container.addClass("has-poptin-input-msg");
                                                    container.append(jQ224("#m"+randomId).clone().attr("id", "c"+randomId));
                                                    jQ224("#c"+randomId).css({
                                                        "top":((jQ224("#m"+randomId).offset().top - container.offset().top)/this_scale) + 3,
                                                        "left":((jQ224("#m"+randomId).offset().left - container.offset().left)/this_scale),
                                                        "width":parseInt(jQ224("#m"+randomId).css("width")) + 10,
                                                        "height":parseInt(jQ224("#m"+randomId).css("height")),
                                                    });
                                                } else {
                                                    container.removeClass("has-poptin-input-msg");
                                                }
                                                return false;
                                            }
                                        }
                                    }
                                }
                            });

                            // Then validate consent checkbox which is outside inputs container
                            var consent_checkbox = this_js_form.find("#poptinDesignInputTextFieldCheckbox[data-action-required='true']").not('.inputs-container #poptinDesignInputTextFieldCheckbox');
                            if(consent_checkbox.length && !consent_checkbox.is(':checked')) {
                                consent_checkbox.prop('required', true).attr('required', true);
                            }

                            if(this_form.find(".poptin-input-error").length){
                                return false;
                            }

                            if( this_js_form[0].checkValidity() ){
                                if(is_submit_poptin_run){
                                    is_submit_poptin_run = false;

                                    //Spint then wheel before submit if post_play_screen is disable
                                    if((poptin.poptin_type== "gamified" && poptin.poptin_format== "format_3") && poptin.design_properties.disable_post_play_screen){
                                        poptinSpinWheelInit(poptin, true);
                                    }

                                    submitPoptin(poptin, click, this_form);
                                    setTimeout(function(){
                                        is_submit_poptin_run = true;
                                    }, submit_poptin_disable_interval);
                                }
                            } else {
                                try {
                                    this_js_form[0].reportValidity();
                                } catch (e){ //for browsers that don't support reportValidity
                                    this_js_form.find('input, textarea').each(function(){
                                        jQ224(this)[0].checkValidity();
                                    });
                                }
                            }
                            return false;
                        }catch(err){
                            monitorError('poptinConversion()->call to mobile',err,'OK',false,poptin);
                        }
                    }else{
                        // If form submit
                        jQ224('[data-poptin-id="'+poptin.poptin_id+'"] [id="poptinFormSubmit'+poptin.poptin_id+'"]').on('submit',function(e){
                            e.preventDefault();
                            showLog('poptinFormClickSubmit'+poptin.poptin_id+' submit');
                            // start submit poptin function
                            if(is_submit_poptin_run){
                                is_submit_poptin_run = false;
                                submitPoptin(poptin, click, this_form);
                                setTimeout(function(){
                                    is_submit_poptin_run = true;
                                }, submit_poptin_disable_interval);
                            }
                            // disable page refresh
                            return false;
                        });
                    }
                }
            });
        }

        function shopifyProductRecommendations(poptin){
            jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+'] .fr-shopify-item-btn a').on('click', function(e) {
                var shopifyProductSettings = {};
                shopifyProductSettings["button_text"] = jQ224(this).text();
                shopifyProductSettings["product_url"] = jQ224(this).attr("data-url");
                shopifyProductSettings["product_name"] = jQ224(this).attr("data-product-name");
                shopifyProductSettings["product_id"] = jQ224(this).attr("data-product-id");
                shopifyProductSettings["variant_id"] = jQ224(this).attr("data-variant-id");
                shopifyProductSettings["buttons_action"] = jQ224(this).attr("data-buttons-action");
                poptin["shopify_product_settings"] = shopifyProductSettings;
                poptinConversion(poptin, null, "shopify_products", this);
            });
        }
        /*
        * Shopify recently viewed products
        * Desc              : Store shopify recently viewed product id
        */

        function setShopifyRecentlyViewedProduct() {
            if (window.ShopifyAnalytics) {
                var shopify_page_type = window.ShopifyAnalytics.meta.page.pageType;
                if (typeof shopify_page_type != 'undefined' && shopify_page_type == "product") {
                    var recent_product_ids = poptinCheckCookie('poptin_shopify_recent_product_id') ? poptinGetCookie('poptin_shopify_recent_product_id').split(",") : [];
                    if (ShopifyAnalytics.meta.product && (typeof ShopifyAnalytics.meta.selectedVariantId != 'undefined')) {
                        var selectedVariantId = ShopifyAnalytics.meta.selectedVariantId.toString();
                        if (!recent_product_ids.includes(selectedVariantId) || (recent_product_ids.length > 2 && recent_product_ids[2] == selectedVariantId)) {
                            recent_product_ids.unshift(selectedVariantId);
                        }
                        if (recent_product_ids.length > 3) {
                            recent_product_ids.pop();
                        }
                    }
                    poptinSetCookie("poptin_shopify_recent_product_id",recent_product_ids.join(","))
                }
            }
        }

        /**
        * Trigger functions: showPoptin()
        * parameters       : poptin
        * Desc             : This function will fetch shopify products if pixel run on Shopify
        */
    function getShopifyRecommendedProducts(poptin, sprJSON){

            return new Promise(function(resolve, reject) {

                var shopifyProductsJSON = {};
                var $shopifyProductsJSON = jQ224(poptin.poptin).find("input#shopifyProductsJSON");

                if ($shopifyProductsJSON.length > 0) {
                    shopifyProductsJSON = JSON.parse($shopifyProductsJSON.val());
                }
                // passing sprJSON for teasers
                if(sprJSON && sprJSON.category){
                    shopifyProductsJSON = sprJSON;
                }


                var param = {
                    "category":shopifyProductsJSON?.category,
                    "products":shopifyProductsJSON?.manual_products,
                    "limit": (shopifyProductsJSON?.category == "manual") ? shopifyProductsJSON?.manual_products.length : shopifyProductsJSON?.count
                };
                if( param.category == "last_visited" ){
                    var recent_product_ids = poptinCheckCookie('poptin_shopify_recent_product_id') ? poptinGetCookie('poptin_shopify_recent_product_id').split(",") : [];

                    param["products"] = recent_product_ids;
                    param["limit"] = (recent_product_ids.length <= shopifyProductsJSON?.count) ? recent_product_ids.length : shopifyProductsJSON?.count;
                    shopifyProductsJSON.category = "manual";
                    shopifyProductsJSON.category_original = "last_visited";
                    shopifyProductsJSON.manual_products = param["products"];



                    if( typeof poptin_landing_page!='undefined' && poptin_landing_page == true){
                        resolve({"display":true});
                    }
                    if( recent_product_ids.length <= 0 ){
                        resolve({"display":false});
                        return false;
                    }
                    if( recent_product_ids.length > 0 && sprJSON){
                        resolve({"display":true});
                    }

                    if(!sprJSON){
                        sendProductRecommendationRequest( poptin, shopifyProductsJSON , function(result) {
                            var prod = (result?.data?.products) ? result.data.products : [];
                            window.shopifyProductCurrency = result.currency ? result.currency : "USD";
                            displayShopifyProductData(poptin.poptin_id, prod, poptin );
                            resolve({"display":true});
                        });
                    }

                } else if (param.category == "product_in_cart") {

                    if(window.Shopify !== undefined && window.Shopify.shop){

                        jQ224.ajax({
                            url: shopifylanguageRoute()+"cart.js",
                            type: 'get',
                            dataType: 'json',
                            async: true,
                        }, "json")
                        .done(function(cart){
                        // displayShopifyProductData( poptin.poptin_id, cart.items);
                        // resolve({"display":true});
                            if (cart.items.length > 0) {
                                productVariantIds = [];
                                cart.items.forEach(item => productVariantIds.push(item.variant_id.toString()))
                                param["products"] = productVariantIds.reverse();

                                shopifyProductsJSON.category = "manual";
                                shopifyProductsJSON.manual_products = param["products"].slice(0, 3);
                                //sendProductRecommendationRequest(poptin, shopifyProductsJSON)
                                if(!sprJSON){
                                    sendProductRecommendationRequest( poptin, shopifyProductsJSON , function(result) {
                                        window.shopifyProductCurrency = result.currency ? result.currency : "USD";
                                        displayShopifyProductData(poptin.poptin_id, result.data.products, poptin, productVariantIds );
                                        resolve({"display":true});
                                    });
                                }else{
                                    resolve({"display":true});
                                }

                            }

                            //showing best sellers when no products in cart and teaser is on
                            if(cart.item_count == 0 && poptin?.is_teasers_on && !sprJSON){
                                shopifyProductsJSON.category = "product_collection";
                                sendProductRecommendationRequest( poptin, shopifyProductsJSON , function(result) {
                                    window.shopifyProductCurrency = result.currency ? result.currency : "USD";
                                    displayShopifyProductData(poptin.poptin_id, result.data.products, poptin );
                                    resolve({"display":true});
                                });
                            }

                        }).fail(function (data) {
                            console.log("Failed to fetch shopify data");
                            reject(data);
                            /*displayShopifyProductData( poptin.poptin_id, mocJSON.items );
                            resolve({"display":true});*/
                        });

                    }else if( typeof poptin_landing_page!='undefined' && poptin_landing_page == true ){
                        resolve({"display":true});
                    }

                } else if (param.category == "manual" || param.category == "product_collection") {
                    resolve({"display":true});
                    if( !sprJSON ){
                        sendProductRecommendationRequest( poptin, shopifyProductsJSON , function(result) {
                            var prod = (result?.data?.products) ? result.data.products : [];
                            window.shopifyProductCurrency = result.currency ? result.currency : "USD";
                            displayShopifyProductData(poptin.poptin_id, prod, poptin );
                            resolve({"display":true});
                        });
                    }

                }
            });

    }

    /**
        * Trigger functions: showPoptin()
        * parameters       : poptin
        * Desc             : This function will fetch wix products if pixel run on Wix
        */
        function getWixRecommendedProducts(poptin, wprJSON) {
            return new Promise(function(resolve, reject) {
                var wixProductsJSON = {};
                var $wixProductsJSON = jQ224(poptin.poptin).find("input#wixProductsJSON");

                if ($wixProductsJSON.length > 0) {
                    wixProductsJSON = JSON.parse($wixProductsJSON.val());
                }
                // passing wprJSON for teasers
                if(wprJSON && wprJSON.category){
                    wixProductsJSON = wprJSON;
                }

                var param = {
                    "category":wixProductsJSON?.category,
                    "products":wixProductsJSON?.manual_products,
                    "limit": (wixProductsJSON?.category == "manual") ? wixProductsJSON?.manual_products.length : wixProductsJSON?.count
                };
                if (param.category == "last_visited") {
                    var recent_product_ids = poptinCheckCookie('poptin_wix_recent_product_id') ? poptinGetCookie('poptin_wix_recent_product_id').split(",") : [];

                    param["products"] = recent_product_ids;
                    param["limit"] = (recent_product_ids.length <= wixProductsJSON?.count) ? recent_product_ids.length : shopifyProductsJSON?.count;
                    wixProductsJSON.category = "manual";
                    wixProductsJSON.category_original = "last_visited";
                    wixProductsJSON.manual_products = param["products"];

                    if( typeof poptin_landing_page!='undefined' && poptin_landing_page == true){
                        resolve({"display":true});
                    }
                    if( recent_product_ids.length <= 0 ){
                        resolve({"display":false});
                        return false;
                    }
                    if( recent_product_ids.length > 0 && wprJSON){
                        resolve({"display":true});
                    }

                    if(!wprJSON){
                        sendWixProductRecommendationRequest(poptin, wixProductsJSON, function(result) {
                            var products = result.data?.products || [];
                            window.wixProductCurrency = products[0]?.priceData?.currency || "USD";
                            displayWixProductData(poptin.poptin_id, products, poptin);
                            resolve({"display":true});
                        });
                    }

                } else if (param.category == "product_in_cart") {
                    if (window.wixDevelopersAnalytics !== undefined) {
                        jQ224.ajax({
                            url: wixlanguageRoute() + "cart.js",
                            type: 'get',
                            dataType: 'json',
                            async: true,
                        }, "json")
                            .done(function(cart){
                            // displayShopifyProductData( poptin.poptin_id, cart.items);
                            // resolve({"display":true});
                                if (cart.items.length > 0) {
                                    productVariantIds = [];
                                    cart.items.forEach(item => productVariantIds.push(item.variant_id.toString()))
                                    param["products"] = productVariantIds.reverse();

                                    wixProductsJSON.category = "manual";
                                    wixProductsJSON.manual_products = param["products"].slice(0, 3);
                                    //sendProductRecommendationRequest(poptin, wixProductsJSON)
                                    if(!wprJSON){
                                        sendWixProductRecommendationRequest( poptin, wixProductsJSON , function(result) {
                                            var products = result.data?.products || [];
                                            window.wixProductCurrency = products[0]?.priceData?.currency || "USD";
                                            displayWixProductData(poptin.poptin_id, products, poptin, productVariantIds);
                                            resolve({"display":true});
                                        });
                                    }else{
                                        resolve({"display":true});
                                    }

                                }

                                //showing best sellers when no products in cart and teaser is on
                                if(cart.item_count == 0 && poptin?.is_teasers_on && !wprJSON){
                                    wixProductsJSON.category = "product_collection";
                                    sendProductRecommendationRequest( poptin, wixProductsJSON , function(result) {
                                        window.wixProductCurrency = result.currency ? result.currency : "USD";
                                        displayWixProductData(poptin.poptin_id, result.data.products, poptin );
                                        resolve({"display":true});
                                    });
                                }

                            })
                            .fail(function (data) {
                                console.log("Failed to fetch wix data");
                                reject(data);
                            });

                    } else if (typeof poptin_landing_page!='undefined' && poptin_landing_page == true) {
                        resolve({"display":true});
                    }
                } else if (param.category == "manual" || param.category == "product_collection") {
                    resolve({"display":true});
                    if(!wprJSON) {
                        sendWixProductRecommendationRequest(poptin, wixProductsJSON, function(result) {
                            var products = result.data?.products || [];
                            window.wixProductCurrency = products[0]?.priceData?.currency || "USD";
                            displayWixProductData(poptin.poptin_id, products, poptin);
                            resolve({"display":true});
                        });
                    }
                } else if (param.category.startsWith("algorithm_id_")) {
                    resolve({"display":true});
                    if(!wprJSON) {
                        sendWixProductRecommendationRequest(poptin, wixProductsJSON, function(result) {
                            var products = result.data?.products || [];
                            window.wixProductCurrency = products[0]?.priceData?.currency || "USD";
                            displayWixProductData(poptin.poptin_id, products, poptin);
                            resolve({"display":true});
                        });
                    }
                }
            });
        }

    /*
        * Wix recently viewed products
        * Desc              : Store wix recently viewed product id
        */

        function setWixRecentlyViewedProduct() {
            if (window.wixDevelopersAnalytics !== undefined) {
                // var shopify_page_type = window.ShopifyAnalytics.meta.page.pageType;
                // if (typeof shopify_page_type != 'undefined' && shopify_page_type == "product") {
                //     var recent_product_ids = poptinCheckCookie('poptin_shopify_recent_product_id') ? poptinGetCookie('poptin_shopify_recent_product_id').split(",") : [];
                //     if (ShopifyAnalytics.meta.product && (typeof ShopifyAnalytics.meta.selectedVariantId != 'undefined')) {
                //         var selectedVariantId = ShopifyAnalytics.meta.selectedVariantId.toString();
                //         if (!recent_product_ids.includes(selectedVariantId) || (recent_product_ids.length > 2 && recent_product_ids[2] == selectedVariantId)) {
                //             recent_product_ids.unshift(selectedVariantId);
                //         }
                //         if (recent_product_ids.length > 3) {
                //             recent_product_ids.pop();
                //         }
                //     }
                //     poptinSetCookie("poptin_shopify_recent_product_id",recent_product_ids.join(","))
                // }
            }
        }

        function wixProductRecommendations(poptin) {
            jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+'] .fr-wix-item-btn a').on('click', function(e) {
                var wixProductSettings = {};
                wixProductSettings["button_text"] = jQ224(this).text();
                wixProductSettings["product_url"] = jQ224(this).attr("data-url");
                wixProductSettings["product_name"] = jQ224(this).attr("data-product-name");
                wixProductSettings["product_id"] = jQ224(this).attr("data-product-id");
                wixProductSettings["variant_id"] = jQ224(this).attr("data-variant-id");
                wixProductSettings["buttons_action"] = jQ224(this).attr("data-buttons-action");
                poptin["wix_product_settings"] = wixProductSettings;
                poptinConversion(poptin, null, "wix_products", this);
            });
        }

        function sendProductRecommendationRequest(poptin, payload, callback) {
        jQ224.ajax({
            url: api_link+"/api/display/shopify/product-recommendation/"+poptin.poptin_id,
            type: "post",
            data: payload,
            async: true,
        }, "json")
            .done(function (data) {
                if(data.success == true){
                    //displayShopifyProductData(poptin.poptin_id, data.data.products, poptin );
                    //resolve({"display":true});
                    callback(data);
                }
            })
            .fail(function (data) {
                console.log("Failed to fetch shopify data");
                reject(data);
            });
        }

        function sendWixProductRecommendationRequest(poptin, payload, callback) {
            jQ224.ajax({
                url: api_link+"/api/display/wix/product-recommendation/"+poptin.poptin_id,
                type: "post",
                data: payload,
                async: true,
            }, "json")
                .done(function (data) {
                    if(data.success == true){
                        callback(data);
                    }
                })
                .fail(function (data) {
                    console.log("Failed to fetch wix data");
                    reject(data);
                });
        }

        function displayShopifyProductData(poptinId, products, poptin, cartVariants){

            var shopifyLayoutWidth = {
                vertical:{1:[100,150,200,250,300]},
                horizontal:{
                    1:[150,180,200,280,350],
                    2:[200,300,400,550,750],
                    3:[400,450,620,680,800]
                }
            }

            if( poptin && poptin.poptin_type == "fullpage" ){
                shopifyLayoutWidth['horizontal'][1] = [150,180,200,400,600];
                shopifyLayoutWidth['horizontal'][2] = [250,300,400,800,100];
                shopifyLayoutWidth['horizontal'][3] = [400,500,620,900,1200];
            }

            var $shopifyProductsJSON = jQ224(".poptin-popup[data-poptin-id="+poptinId+"] #shopifyProductsJSON");
            if($shopifyProductsJSON.length > 0){
                var shopifyProductsJSON = JSON.parse($shopifyProductsJSON.val());
            }

            var cnt = 0;
            var prodToDisplay = [];
            var selectedProdsArr = [];
            if(shopifyProductsJSON.category == "last_visited"){
                selectedProdsArr = poptinCheckCookie('poptin_shopify_recent_product_id') ? poptinGetCookie('poptin_shopify_recent_product_id').split(",") : [];
            }else if(shopifyProductsJSON.category == "manual"){
                selectedProdsArr = shopifyProductsJSON.manual_products.length ? shopifyProductsJSON.manual_products : [];
            }else if(shopifyProductsJSON.category == "product_in_cart"){
                selectedProdsArr = (cartVariants?.length) ? cartVariants : [];
            }else{
                selectedProdsArr = [];
            }

            if(products.length > 0){

                products.forEach(function (item) {

                    if( item.variants && item.variants.length > 0 ){
                        item.variants.forEach(function (v) {
                            var settingObj = {}
                            if( selectedProdsArr.indexOf( v.id.toString() ) != -1 || selectedProdsArr == 0 ){
                                settingObj["product_id"] = item.id;
                                settingObj["variant_id"] = v.id;
                                settingObj["image"] = item.image;
                                settingObj["desc"] = item.body_html;
                                settingObj["title"] = item.title + ((v.title && v.title!='Default Title') ? " - "+v.title : "");
                                settingObj["handle"] = item.handle;
                                settingObj["inventory_quantity"] = v.inventory_quantity;
                                settingObj["price"] = ( v.presentment_prices && v.presentment_prices.length > 0 && v.presentment_prices[0].price && v.presentment_prices[0].price.amount ) ? v.presentment_prices[0].price.amount : v.price ;
                                settingObj["currency_symbol"] = window.shopifyProductCurrency ? window.shopifyProductCurrency : "USD" ;
                                settingObj["compare_at_price"] = v.compare_at_price;

                                //push max 3 products
                                if(prodToDisplay.length <= 3){
                                    prodToDisplay.push(settingObj);
                                }
                            }
                        });
                    }
                });

                setTimeout(function(){
                    var currSymbolObj = { AED: 'د.إ', AFN: '؋', ALL: 'L', AMD: '֏', ANG: 'ƒ', AOA: 'Kz', ARS: '$', AUD: '$', AWG: 'ƒ', AZN: '₼', BAM: 'KM', BBD: '$', BDT: '৳', BGN: 'лв', BHD: '.د.ب', BIF: 'FBu', BMD: '$', BND: '$', BOB: '$b', BOV: 'BOV', BRL: 'R$', BSD: '$', BTC: '₿', BTN: 'Nu.', BWP: 'P', BYN: 'Br', BYR: 'Br', BZD: 'BZ$', CAD: '$', CDF: 'FC', CHE: 'CHE', CHF: 'CHF', CHW: 'CHW', CLF: 'CLF', CLP: '$', CNY: '¥', COP: '$', COU: 'COU', CRC: '₡', CUC: '$', CUP: '₱', CVE: '$', CZK: 'Kč', DJF: 'Fdj', DKK: 'kr', DOP: 'RD$', DZD: 'دج', EEK: 'kr', EGP: '£', ERN: 'Nfk', ETB: 'Br', ETH: 'Ξ', EUR: '€', FJD: '$', FKP: '£', GBP: '£', GEL: '₾', GGP: '£', GHC: '₵', GHS: 'GH₵', GIP: '£', GMD: 'D', GNF: 'FG', GTQ: 'Q', GYD: '$', HKD: '$', HNL: 'L', HRK: 'kn', HTG: 'G', HUF: 'Ft', IDR: 'Rp', ILS: '₪', IMP: '£', INR: '₹', IQD: 'ع.د', IRR: '﷼', ISK: 'kr', JEP: '£', JMD: 'J$', JOD: 'JD', JPY: '¥', KES: 'KSh', KGS: 'лв', KHR: '៛', KMF: 'CF', KPW: '₩', KRW: '₩', KWD: 'KD', KYD: '$', KZT: '₸', LAK: '₭', LBP: '£',
                    LKR: '₨', LRD: '$', LSL: 'M', LTC: 'Ł', LTL: 'Lt', LVL: 'Ls', LYD: 'LD', MAD: 'MAD', MDL: 'lei', MGA: 'Ar', MKD: 'ден', MMK: 'K', MNT: '₮', MOP: 'MOP$', MRO: 'UM', MRU: 'UM', MUR: '₨', MVR: 'Rf', MWK: 'MK', MXN: '$', MXV: 'MXV', MYR: 'RM', MZN: 'MT', NAD: '$', NGN: '₦', NIO: 'C$', NOK: 'kr', NPR: '₨', NZD: '$', OMR: '﷼', PAB: 'B/.', PEN: 'S/.', PGK: 'K', PHP: '₱', PKR: '₨', PLN: 'zł', PYG: 'Gs', QAR: '﷼', RMB: '￥', RON: 'lei', RSD: 'Дин.', RUB: '₽', RWF: 'R₣', SAR: '﷼', SBD: '$', SCR: '₨', SDG: 'ج.س.', SEK: 'kr', SGD: 'S$', SHP: '£', SLL: 'Le', SOS: 'S', SRD: '$', SSP: '£', STD: 'Db', STN: 'Db', SVC: '$', SYP: '£', SZL: 'E', THB: '฿', TJS: 'SM', TMT: 'T', TND: 'د.ت', TOP: 'T$', TRL: '₤', TRY: '₺', TTD: 'TT$', TVD: '$', TWD: 'NT$', TZS: 'TSh', UAH: '₴', UGX: 'USh', USD: '$', UYI: 'UYI', UYU: '$U', UYW: 'UYW', UZS: 'лв', VEF: 'Bs', VES: 'Bs.S', VND: '₫', VUV: 'VT', WST: 'WS$', XAF: 'FCFA', XBT: 'Ƀ', XCD: '$', XOF: 'CFA', XPF: '₣', XSU: 'Sucre', XUA: 'XUA', YER: '﷼', ZAR: 'R', ZMW: 'ZK', ZWD: 'Z$', ZWL: '$' };
                    var inventory = ifUserlangIsHe() ? "יחידות במלאי" : "left"
                    prodToDisplay.forEach(function (item) {

                        var ele = jQ224(".poptin-popup[data-poptin-id="+poptinId+"] .fr-shopify-products .fr-shopify-item:nth-child("+(cnt+1)+")");
                        var currency_symbol = item.currency_symbol ? item.currency_symbol : "USD";
                        var currencySymbol = currSymbolObj[currency_symbol];

                        if ( item.image && item.image.src ) {
                            ele.find(".fr-shopify-item-img img").attr("src", item.image.src);
                        }else{
                            ele.find(".fr-shopify-item-img img").attr("src",  cdn_server + "/css/images/v_2/product-no-img.png");
                        }

                        if ( item.title ) {
                            if( item.title.length > 50){
                            item.title = item.title.substring(0, 50) + '...';
                            }
                            ele.find(".fr-shopify-item-title").text(item.title);
                        }else{
                            ele.find(".fr-shopify-item-title").css("display", "none");
                        }

                        if ( item.desc ) {
                            ele.find(".fr-shopify-item-desc").html(item.desc);
                        }else{
                            ele.find(".fr-shopify-item-desc").html("").css("display", "none");
                        }

                        if ( item.handle ) {
                            var shopify_prod_url = window.location.origin + "/products/" + item.handle;
                            if( item.variant_id ){
                                shopify_prod_url = shopify_prod_url + "?variant=" + item.variant_id;
                            }
                            ele.find(".fr-shopify-item-btn a").attr("data-url", shopify_prod_url);
                        }

                        if ( item.price ){
                            ele.find(".fr-shopify-item-price .before-disc").text( currencySymbol + item.price );
                        }else{
                            ele.find(".fr-shopify-item-price .before-disc").css("display", "none");
                        }
                        // Shopify compare_at is the original price; only show when higher than current price
                        if(item.price && item.compare_at_price && parseFloat(item.compare_at_price) > parseFloat(item.price)){
                            ele.find(".fr-shopify-item-price .after-disc").text( currencySymbol + item.compare_at_price );
                        }else{
                            ele.find(".fr-shopify-item-price .after-disc").text("").css("display", "none");
                        }
                        if(item.inventory_quantity){
                            ele.find(".fr-shopify-item-inventory-quantity").text( item.inventory_quantity + " " + inventory );
                        }else{
                            ele.find(".fr-shopify-item-inventory-quantity").css("display", "none");
                        }

                        ele.find(".fr-shopify-item-btn a").attr("data-product-name", item.title);
                        ele.find(".fr-shopify-item-btn a").attr("data-product-id", item.product_id);
                        ele.find(".fr-shopify-item-btn a").attr("data-variant-id", item.variant_id);
                        ele.find(".fr-shopify-item-btn a").attr("data-buttons-action", shopifyProductsJSON.buttons_action);

                        cnt = cnt+1;
                        // showLog(item);
                    });

                    var prodCount = 3;
                    if(shopifyProductsJSON.count < 3){
                        prodCount = shopifyProductsJSON.count;
                    }
                    if(shopifyProductsJSON.category == "manual" && prodToDisplay.length <= 3){
                        prodCount = prodToDisplay.length;
                    }else if(prodToDisplay.length < shopifyProductsJSON.count){
                        prodCount = prodToDisplay.length;
                    }
                    applyWidthToShopifyProducts("horizontal",prodCount);

                    function applyWidthToShopifyProducts(layout,len){
                        var size = jQ224(".poptin-popup[data-poptin-id="+poptinId+"]  .froala-shopify-wrapper").attr("data-size");
                        size = size ? size.split("-")[1] : "3";
                        if(len == 1){
                            jQ224(".poptin-popup[data-poptin-id="+poptinId+"] .fr-shopify-products .fr-shopify-item:not(:first-child)").remove();
                        }else if(len == 2){
                            jQ224(".poptin-popup[data-poptin-id="+poptinId+"] .fr-shopify-products .fr-shopify-item:not(:first-child):not(:nth-child(2))").remove();
                        }

                        jQ224(".poptin-popup[data-poptin-id="+poptinId+"]  .froala-shopify-wrapper").css( "width", shopifyLayoutWidth[layout][len][size-1] + "px" );

                        //align it center
                        if(prodToDisplay.length < shopifyProductsJSON.count && shopifyProductsJSON.category != "manual"){
                            var this_left = jQ224('[data-poptin-id='+poptin.poptin_id+']').width() - jQ224('[data-poptin-id='+poptin.poptin_id+'] .froala-shopify-wrapper').width();
                            jQ224('[data-poptin-id='+poptin.poptin_id+'] .froala-shopify-wrapper').css({'left':(this_left/2)+'px'});
                        }

                    }

                },500);

            }
        }

        function displayWixProductData(poptinId, products, poptin, cartVariants) {
            var wixLayoutWidth = {
                vertical:{1:[100,150,200,250,300]},
                horizontal:{
                    1:[150,180,200,280,350],
                    2:[200,300,400,550,750],
                    3:[400,450,620,680,800]
                }
            }

            if( poptin && poptin.poptin_type == "fullpage" ){
                wixLayoutWidth['horizontal'][1] = [150,180,200,400,600];
                wixLayoutWidth['horizontal'][2] = [250,300,400,800,100];
                wixLayoutWidth['horizontal'][3] = [400,500,620,900,1200];
            }

            var $wixProductsJSON = jQ224(".poptin-popup[data-poptin-id="+poptinId+"] #wixProductsJSON");
            if($wixProductsJSON.length > 0){
                var wixProductsJSON = JSON.parse($wixProductsJSON.val());
            }

            var cnt = 0;
            var prodToDisplay = [];
            var selectedProdsArr = [];
            if(wixProductsJSON.category === "last_visited"){
                selectedProdsArr = poptinCheckCookie('poptin_wix_recent_product_id') ? poptinGetCookie('poptin_wix_recent_product_id').split(",") : [];
            } else if(wixProductsJSON.category === "manual"){
                selectedProdsArr = wixProductsJSON.manual_products.length ? wixProductsJSON.manual_products : [];
            } else if(wixProductsJSON.category === "product_in_cart"){
                selectedProdsArr = (cartVariants?.length) ? cartVariants : [];
            } else{
                selectedProdsArr = [];
            }

            if (products.length > 0) {
                products.filter((product) => product.visible && product.inStock).forEach(function (item) {
                    let variants = item.variants?.filter((v) => v.visible && v.inStock && (selectedProdsArr.length ? selectedProdsArr.includes(v.id) : true)) || [];
                    if (item.hasVariants && variants.length) {
                        if (wixProductsJSON.category === "manual") {
                            variants.forEach((v) => {
                                let settingObj = {}
                                settingObj["product_id"] = item.id;
                                settingObj["variant_id"] = v.id;
                                settingObj["image"] = v.imageUrl
                                    ? {
                                        'src': v.imageUrl
                                    }
                                    : {
                                        'src': item.imageUrl
                                    };
                                settingObj["desc"] = item.description;
                                settingObj["title"] = `${item.name} - ${v.name}`;
                                settingObj["path"] = item.productUrl;
                                settingObj["inventory_quantity"] = v.quantity;
                                settingObj["price"] = v.price;
                                settingObj["currency_symbol"] = v.currency;
                                settingObj["compare_at_price"] = (v.discountedPrice || null) ? (v.discountedPrice < v.price ? v.discountedPrice : null) : null;

                                // push max 3 products
                                if (prodToDisplay.length < 3) {
                                    prodToDisplay.push(settingObj);
                                }
                            });
                        } else {
                            // For non-manual, pick only the first variant (if exists)
                            if (variants.length > 0) {
                                let v = variants[0];
                                let settingObj = {}
                                settingObj["product_id"] = item.id;
                                settingObj["variant_id"] = v.id;
                                settingObj["image"] = v.imageUrl
                                    ? {
                                        'src': v.imageUrl
                                    }
                                    : {
                                        'src': item.imageUrl
                                    };
                                settingObj["desc"] = item.description;
                                settingObj["title"] = `${item.name} - ${v.name}`;
                                settingObj["path"] = item.productUrl;
                                settingObj["inventory_quantity"] = v.quantity;
                                settingObj["price"] = v.price;
                                settingObj["currency_symbol"] = v.currency;
                                settingObj["compare_at_price"] = (v.discountedPrice || null) ? (v.discountedPrice < v.price ? v.discountedPrice : null) : null;

                                // push max 3 products
                                if (prodToDisplay.length < 3) {
                                    prodToDisplay.push(settingObj);
                                }
                            }
                        };
                    } else {
                        if (selectedProdsArr.length ? selectedProdsArr.includes(item.id) : true) {
                            let settingObj = {}

                            settingObj["product_id"] = item.id;
                            settingObj["variant_id"] = null;
                            settingObj["image"] = {
                                'src': item.imageUrl
                            };
                            settingObj["desc"] = item.description;
                            settingObj["title"] = item.name;
                            settingObj["path"] = item.productUrl;
                            settingObj["inventory_quantity"] = item.quantity;
                            settingObj["price"] = item.price;
                            settingObj["currency_symbol"] = item.currency;
                            settingObj["compare_at_price"] = (item.discountedPrice || null) ? (item.discountedPrice < item.price ? item.discountedPrice : null) : null;

                            //push max 3 products
                            if (prodToDisplay.length < 3) {
                                prodToDisplay.push(settingObj);
                            }
                        }
                    }
                });

                setTimeout(function(){
                    var currSymbolObj = { AED: 'د.إ', AFN: '؋', ALL: 'L', AMD: '֏', ANG: 'ƒ', AOA: 'Kz', ARS: '$', AUD: '$', AWG: 'ƒ', AZN: '₼', BAM: 'KM', BBD: '$', BDT: '৳', BGN: 'лв', BHD: '.د.ب', BIF: 'FBu', BMD: '$', BND: '$', BOB: '$b', BOV: 'BOV', BRL: 'R$', BSD: '$', BTC: '₿', BTN: 'Nu.', BWP: 'P', BYN: 'Br', BYR: 'Br', BZD: 'BZ$', CAD: '$', CDF: 'FC', CHE: 'CHE', CHF: 'CHF', CHW: 'CHW', CLF: 'CLF', CLP: '$', CNY: '¥', COP: '$', COU: 'COU', CRC: '₡', CUC: '$', CUP: '₱', CVE: '$', CZK: 'Kč', DJF: 'Fdj', DKK: 'kr', DOP: 'RD$', DZD: 'دج', EEK: 'kr', EGP: '£', ERN: 'Nfk', ETB: 'Br', ETH: 'Ξ', EUR: '€', FJD: '$', FKP: '£', GBP: '£', GEL: '₾', GGP: '£', GHC: '₵', GHS: 'GH₵', GIP: '£', GMD: 'D', GNF: 'FG', GTQ: 'Q', GYD: '$', HKD: '$', HNL: 'L', HRK: 'kn', HTG: 'G', HUF: 'Ft', IDR: 'Rp', ILS: '₪', IMP: '£', INR: '₹', IQD: 'ع.د', IRR: '﷼', ISK: 'kr', JEP: '£', JMD: 'J$', JOD: 'JD', JPY: '¥', KES: 'KSh', KGS: 'лв', KHR: '៛', KMF: 'CF', KPW: '₩', KRW: '₩', KWD: 'KD', KYD: '$', KZT: '₸', LAK: '₭', LBP: '£',
                    LKR: '₨', LRD: '$', LSL: 'M', LTC: 'Ł', LTL: 'Lt', LVL: 'Ls', LYD: 'LD', MAD: 'MAD', MDL: 'lei', MGA: 'Ar', MKD: 'ден', MMK: 'K', MNT: '₮', MOP: 'MOP$', MRO: 'UM', MRU: 'UM', MUR: '₨', MVR: 'Rf', MWK: 'MK', MXN: '$', MXV: 'MXV', MYR: 'RM', MZN: 'MT', NAD: '$', NGN: '₦', NIO: 'C$', NOK: 'kr', NPR: '₨', NZD: '$', OMR: '﷼', PAB: 'B/.', PEN: 'S/.', PGK: 'K', PHP: '₱', PKR: '₨', PLN: 'zł', PYG: 'Gs', QAR: '﷼', RMB: '￥', RON: 'lei', RSD: 'Дин.', RUB: '₽', RWF: 'R₣', SAR: '﷼', SBD: '$', SCR: '₨', SDG: 'ج.س.', SEK: 'kr', SGD: 'S$', SHP: '£', SLL: 'Le', SOS: 'S', SRD: '$', SSP: '£', STD: 'Db', STN: 'Db', SVC: '$', SYP: '£', SZL: 'E', THB: '฿', TJS: 'SM', TMT: 'T', TND: 'د.ت', TOP: 'T$', TRL: '₤', TRY: '₺', TTD: 'TT$', TVD: '$', TWD: 'NT$', TZS: 'TSh', UAH: '₴', UGX: 'USh', USD: '$', UYI: 'UYI', UYU: '$U', UYW: 'UYW', UZS: 'лв', VEF: 'Bs', VES: 'Bs.S', VND: '₫', VUV: 'VT', WST: 'WS$', XAF: 'FCFA', XBT: 'Ƀ', XCD: '$', XOF: 'CFA', XPF: '₣', XSU: 'Sucre', XUA: 'XUA', YER: '﷼', ZAR: 'R', ZMW: 'ZK', ZWD: 'Z$', ZWL: '$' };
                    var inventory = ifUserlangIsHe() ? "יחידות במלאי" : "left";
                    prodToDisplay.forEach(function (item) {
                        var ele = jQ224(".poptin-popup[data-poptin-id="+poptinId+"] .fr-wix-products .fr-wix-item:nth-child("+(cnt+1)+")");
                        var currency_symbol = item.currency_symbol ? item.currency_symbol : "USD";
                        var currencySymbol = currSymbolObj[currency_symbol];

                        if (item.image && item.image.src) {
                            ele.find(".fr-wix-item-img img").attr("src", item.image.src);
                        } else {
                            ele.find(".fr-wix-item-img img").attr("src",  cdn_server + "/css/images/v_2/product-no-img.png");
                        }

                        if (item.title) {
                            if( item.title.length > 18){
                            item.title = item.title.substring(0, 18) + '...';
                            }
                            ele.find(".fr-wix-item-title").text(item.title);
                        } else {
                            ele.find(".fr-wix-item-title").css("display", "none");
                        }

                        if (item.desc) {
                            let tempDiv = document.createElement('div');
                            tempDiv.innerHTML = item.desc
                            const descriptionPlain = tempDiv.textContent || tempDiv.innerText || '';
                            const descriptionPlainTruncated = descriptionPlain.length > 64 ? descriptionPlain.slice(0, 64) + "..." : descriptionPlain;
                            ele.find(".fr-wix-item-desc").text(descriptionPlainTruncated);
                        } else {
                            ele.find(".fr-wix-item-desc").text("").css("display", "none");
                        }

                        if (item.path) {
                            ele.find(".fr-wix-item-btn a").attr("data-url", item.path);
                        }

                        if (item.price){
                            ele.find(".fr-wix-item-price .before-disc").text( currencySymbol + item.price );
                            ele.find(".fr-wix-item-price .after-disc").text(item.compare_at_price ?  currencySymbol + item.compare_at_price : "");
                        } else {
                            ele.find(".fr-wix-item-price .before-disc").css("display", "none").text("")
                        }

                        if(item.inventory_quantity){
                            ele.find(".fr-wix-item-inventory-quantity").text( item.inventory_quantity + " " + inventory );
                        }else{
                            ele.find(".fr-wix-item-inventory-quantity").text( "0" + " " + inventory );
                        }

                        ele.find(".fr-wix-item-btn a").attr("data-product-name", item.title);
                        ele.find(".fr-wix-item-btn a").attr("data-product-id", item.product_id);
                        ele.find(".fr-wix-item-btn a").attr("data-variant-id", item.variant_id);
                        ele.find(".fr-wix-item-btn a").attr("data-buttons-action", wixProductsJSON.buttons_action);

                        cnt = cnt+1;
                        // showLog(item);
                    });

                    var prodCount = 3;
                    if(wixProductsJSON.count < 3){
                        prodCount = wixProductsJSON.count;
                    }
                    if(wixProductsJSON.category === "manual" && prodToDisplay.length <= 3){
                        prodCount = prodToDisplay.length;
                    }else if(prodToDisplay.length < wixProductsJSON.count){
                        prodCount = prodToDisplay.length;
                    }
                    applyWidthToWixProducts("horizontal",prodCount);

                    function applyWidthToWixProducts(layout,len){
                        var size = jQ224(".poptin-popup[data-poptin-id="+poptinId+"]  .froala-wix-wrapper").attr("data-size");
                        size = size ? size.split("-")[1] : "3";
                        if(len == 1){
                            jQ224(".poptin-popup[data-poptin-id="+poptinId+"] .fr-wix-products .fr-wix-item:not(:first-child)").remove();
                        }else if(len == 2){
                            jQ224(".poptin-popup[data-poptin-id="+poptinId+"] .fr-wix-products .fr-wix-item:not(:first-child):not(:nth-child(2))").remove();
                        }

                        jQ224(".poptin-popup[data-poptin-id="+poptinId+"] .froala-wix-wrapper").css( "width", wixLayoutWidth[layout][len][size-1] + "px" );

                        // align it center
                        if(prodToDisplay.length < wixProductsJSON.count && wixProductsJSON.category != "manual"){
                            var this_left = jQ224('[data-poptin-id='+poptin.poptin_id+']').width() - jQ224('[data-poptin-id='+poptin.poptin_id+'] .froala-wix-wrapper').width();
                            jQ224('[data-poptin-id='+poptin.poptin_id+'] .froala-wix-wrapper').css({'left':(this_left/2)+'px'});
                        }
                    }
                }, 500);
            }
        }

        /**
         * Trigger functions: poptinFormClickSubmit()
         * parameters       : poptin:object
         * Desc             : If poptin have a redirect to blank page... open page in new tab
         */
        function ifLinkConversion(poptin){
            showLog('ifLinkConversion');
            if (jQ224('[data-poptin-id='+poptin.poptin_id+']').find('#redirectBlank').length>0){
                showLog('ifLinkConversion1');

                //jQ224('[data-poptin-id='+poptin.poptin_id+']').find('#redirectBlank')[0].click();
                //window.poptins[poptin.poptin_id].redirect_flag=true;
                poptinRedirectToUrl(poptin,'click','#redirectBlank');

            }else if(jQ224('[data-poptin-id='+poptin.poptin_id+']').find('.redirect-url-blank').length>0){
                showLog('ifLinkConversion2');

                //jQ224('[data-poptin-id='+poptin.poptin_id+']').find('.redirect-url-blank')[0].click();
                //window.poptins[poptin.poptin_id].redirect_flag=true;
                poptinRedirectToUrl(poptin,'click','.redirect-url-blank');
            }else if(poptin.gamified_prize && poptin.gamified_prize.redirect_to == true && poptin.gamified_prize.redirect_to_options.redirect_to_url != undefined){
                // Wheel submission : Post-play is visible, Redirection on prize, No redirection delay set
                showLog('ifLinkConversion3');
                //jQ224('[data-poptin-id='+poptin.poptin_id+']').find('#redirectBlank')[0].click();
                //window.poptins[poptin.poptin_id].redirect_flag=true;
                poptinRedirectToUrl(poptin,'direct','gamified');
            }
        }

        /**
         * Trigger functions: submitPoptin()
         * parameters       : poptin:object | click:Boolean (if poptin click trigger)
         * Desc             : Return boolean if form is empty
         */
        function ifSubmitEmptyForm(poptin, click){
            // showLog('ifSubmitEmptyForm: '+poptin.poptin_id);
            var empty_flag = false;
            var has_value=0;
            var fieldsToCheck = jQ224( "[data-poptin-id="+poptin.poptin_id+"] #poptinFormSubmit"+poptin.poptin_id+" .poptin-design-fields-form:not(#poptinDesignInputTextFieldCheckbox)");
            if (fieldsToCheck.length > 0){
                fieldsToCheck.each(function($index){
                    var value = this.value;
                    if(has_value==0){
                        if(!jQ224("#"+this.id).is(":checked") && (jQ224("#"+this.id).attr("type")=="checkbox" || jQ224("#"+this.id).attr("type")=="radio")){
                            empty_flag = false;
                        } else if((jQ224("#"+this.id).attr("type")!="checkbox" || jQ224("#"+this.id).attr("type")!="radio") && value !== ''){
                            empty_flag = true;
                            has_value=1;
                        }
                    }
                });
            }else{
                empty_flag = true;
            }

            // Browser validation works without this
            // checkboxWrapper = jQ224( "[data-poptin-id="+poptin.poptin_id+"] #poptinDesignInputTextFieldCheckbox");
            // if (checkboxWrapper.length > 0){
            //  checkboxInput = checkboxWrapper.find('input');
            //  if( ( checkboxInput.prop('required') && checkboxInput.prop('checked') ) ) {
            //      empty_flag = true;
            //  }
            // }

            return empty_flag;
            //return true;
        }

        /**
         * Trigger functions: submitPoptin()
         * parameters       : poptin:object
         * Desc             : remove 'empty-field' class if poptin form input key down
         */
        function onInputKeyDown(poptin){
            try{
                jQ224("[data-poptin-id="+poptin.poptin_id+"] .inputs-container input").off("keyup keydown");
            }catch(err){
                showLog(err)
            }
            jQ224( "[data-poptin-id="+poptin.poptin_id+"] .inputs-container input").on('keyup',function(e){
                if (jQ224(this).hasClass('empty-field')){
                    jQ224(this).removeClass('empty-field');
                    var inputBorderAttr = jQ224(this).attr("data-border");
                    if(inputBorderAttr){
                        jQ224(this).css('border', inputBorderAttr);
                    }
                }
            });
        }

        /**
         * Trigger functions: poptinFormClickSubmit()
         * parameters       : poptin:object | click:Boolean (if poptin click trigger)
         * Desc             : remove 'empty-field' class if poptin form input key down
         */
        function submitPoptin(poptin, click, submitted_form){

            var $jQ224_div = jQ224('[data-poptin-id="'+poptin.poptin_id+'"] [id="poptinFormSubmit'+poptin.poptin_id+'"] .inputs-container');

            // if(!jQ224("[data-poptin-id="+poptin.poptin_id+"] #poptinFormSubmit"+poptin.poptin_id+"").get(0).reportValidity()){
            //  return false;
            // }

            // If form inputs empty
            // -> shake animation
            // -> Add '.empty-field' class
            if (!ifSubmitEmptyForm(poptin, click)){
                if (!ifMobilePoptin){
                    $jQ224_div.addClass('poptin__animated animate__shakeX');
                    setTimeout(function(){
                        $jQ224_div.removeClass('poptin__animated');
                        $jQ224_div.removeClass (function (index, className) {
                            return (className.match (/\banimate_\S+/g) || []).join(' ');
                        });
                    },1000);
                }

                // Add '.empty-field' class to email field
                // Else Add '.empty-field' class to first field
                var poptinSubmitted = jQ224('[data-poptin-id="'+poptin.poptin_id+'"] [id="poptinFormSubmit'+poptin.poptin_id+'"]')
                var poptinEmailField = (submitted_form || poptinSubmitted).find('input#poptinDesignInputTextFieldEmail');
                if (poptinEmailField.length==1){
                    poptinEmailField.attr("data-border", poptinEmailField.css("border"));
                    poptinEmailField.css('border','none').addClass('empty-field');
                    poptinEmailField[0].focus({ preventScroll: true }); // Add focus with preventScroll
                }else{
                    var poptinFirstField = poptinSubmitted.find('.inputs-container input').first();
                    poptinFirstField.attr("data-border", poptinFirstField.css("border"));
                    poptinFirstField.css('border','none').addClass('empty-field');
                }

                // Set input keydown event
                onInputKeyDown(poptin);
                // stop function
                return false;
            }

            showLog('submitPoptin: '+poptin.poptin_id);

            ensurePoptinTrigger(poptin.poptin_id);
            window.poptins[poptin.poptin_id].poptin_trigger.convert = true;

            try{
                // Initiate poptin convertion ajax call
                poptinConversion(poptin,click, '', submitted_form);
            }catch(err){
                // monitor error
                monitorError('submitPoptin()->poptinConversion()',err,'','',poptin);
                // redirect user to poptin redirect page
                redirectAfterConversion(poptin);
            }

            if (poptin.poptin_type+'_'+poptin.poptin_format != 'social_format_2' && poptin.poptin_type+'_'+poptin.poptin_format != "social_format_6" && poptin.poptin_type+'_'+poptin.poptin_format != "sside_format_19"){
                // Set actions after poptin submit successfully
                afterPoptinSubmit(poptin,click);
            }

            // Wheel submission : Post-play is visible, Redirection on prize, No redirection delay set
            if(poptin.poptin_type == "gamified") {
                if(poptin.gamified_prize && poptin.gamified_prize.redirect_to == true && poptin.gamified_prize.redirect_to_options.redirect_to_url != undefined){
                    showLog('ifLinkConversion3');
                    //jQ224('[data-poptin-id='+poptin.poptin_id+']').find('#redirectBlank')[0].click();
                    //window.poptins[poptin.poptin_id].redirect_flag=true;
                    if(poptin.poptin_format == "format_3" && poptin.design_properties.disable_post_play_screen){
                        var redirect_close_delay = poptin.gamified_prize.redirect_to_options.redirect_close_delay;
                        setTimeout(function(){
                            poptinRedirectToUrl(poptin,'direct','gamified');
                        }, redirect_close_delay ? (parseInt(redirect_close_delay) + (poptin.design_properties.disable_post_play_screen ? 8 : 0)) * 1000 : (poptin.wheel_has_coupon ? default_close_delay * 3 : default_close_delay) * 1000);
                    } else {
                        poptinRedirectToUrl(poptin,'direct','gamified');
                    }
                }
            }
        }

        /**
         * Helper function to get property name from poptin_fields
         * parameters: fieldId, fieldName, poptinFields
         * returns: label from poptin_fields or null
         */
        function getPropertyNameFromPoptinFields(fieldId, fieldName, poptinFields) {
            if (!poptinFields || !Array.isArray(poptinFields)) {
                return null;
            }

            var fieldTag = null;

            // Extract tag from field ID or name
            // For child fields (like CUSTOM_T2-child-0), use fieldName instead of fieldId
            var sourceToCheck = (fieldId && fieldId.indexOf('-child-') > -1) ? fieldName : fieldId;

            if (sourceToCheck && sourceToCheck.indexOf('poptinDesignInputCustomField-CUSTOM_') > -1) {
                var extracted = sourceToCheck.split('poptinDesignInputCustomField-CUSTOM_')[1];
                // Remove any child suffix (e.g., "-child-0") if present
                if (extracted.indexOf('-child-') > -1) {
                    extracted = extracted.split('-child-')[0];
                }
                // Prepend CUSTOM_ to match the tag format in poptin_fields
                fieldTag = 'CUSTOM_' + extracted;
            }

            if (fieldTag) {
                // Find matching field in poptin_fields by tag
                for (var i = 0; i < poptinFields.length; i++) {
                    if (poptinFields[i] && poptinFields[i].tag === fieldTag) {
                        return poptinFields[i].label || null;
                    }
                }
            }

            return null;
        }

        /**
         * Trigger functions: submitPoptin()
         * parameters       : poptin:object | click:Boolean (if poptin click trigger)
         * Desc             : Ajax call with conversion data
         */
        function poptinConversion(poptin, click, count_conversion = '', el = null){

            // Helper function to determine counting type
            function getCountingType(field) {
                var this_type = field.type;
                var this_name = field.name;

                // Handle select fields
                if (this_type.indexOf('select') > -1) {
                    this_type = 'select';
                }

                // Handle special field types
                if (this_name.indexOf('poptinDesignWebsiteField') > -1) {
                    this_type = 'url';
                }
                if (this_name.indexOf('poptinDesignDateField') > -1) {
                    this_type = 'date';
                }

                // Use original input type for base_fields counting if field was created in v9 or earlier
                var countingType = this_type;
                // showLog("field.created_as", field, field.created_as, field.created_version);
                if (field.created_as && field.created_version <= 9) {
                    countingType = field.created_as;
                }

                if (countingType.indexOf('select') > -1) {
                    countingType = 'select';
                }

                return countingType;
            }

            // Map of special field IDs to their desired name mappings
            const SPECIAL_FIELD_MAPPINGS = {
                'poptinDesignInputTextFieldFirstName': 'first_name',
                'poptinDesignInputTextFieldLastName': 'last_name',
                'poptinDesignGenderField': 'gender',
                'poptinDesignCountryField': 'country',
                'poptinDesignStateField': 'state',
                'poptinDesignCityField': 'city',
                'poptinDesignAddressField': 'address',
                'poptinDesignZipCodeField': 'zip_postal_code',
                'poptinDesignBirthdayField': 'birthday',
                'poptinDesignPreferenceField': 'preferences'
            };

            jQ224(".poptin-input-autofill").remove();
            jQ224(".poptin-input-suggestion").remove();

            showLog('poptinConversion: '+poptin.poptin_id);

            // Newer poptin submit event
            jQ224('[data-poptin-id="'+poptin.poptin_id+'"].poptin-popup').addClass('poptin-submitted');
            var poptinEventButton = jQ224('[data-poptin-id="'+poptin.poptin_id+'"].poptin-popup div#'+(count_conversion != '' ? count_conversion : 'poptinFormSubmitText'));
            var poptinEventButtonText = "";
            if(poptinEventButton.length && count_conversion != 'coupon'){
                poptinEventButton = poptinEventButton.first();
                poptinEventButtonText = poptinEventButton.text().trim();
            } else if(count_conversion == "shopify_products"){
                poptinEventButtonText = poptin["shopify_product_settings"]["button_text"];
            } else if(count_conversion == "wix_products"){
                poptinEventButtonText = poptin["wix_product_settings"]["button_text"];
            }

            var poptinEventExtras = {"event_name" : "poptinSubmit", "button_text": poptinEventButtonText};
            if(count_conversion == "shopify_products"){
                poptinEventExtras["shopify"] = poptin["shopify_product_settings"];
            }
            if(count_conversion == "wix_products"){
                poptinEventExtras["wix"] = poptin["wix_product_settings"];
            }

            if(count_conversion != 'coupon'){
                const onPoptinSubmitEvent = new CustomEvent("poptinSubmit", {bubbles: true, detail: poptinEventDetails(poptin, poptinEventExtras)});
                document.dispatchEvent(onPoptinSubmitEvent);

                // Older poptin submit event
                if (typeof onpoptinSubmit == 'function' ) {
                    onpoptinSubmit(poptin.poptin_id);
                }

                // set freeField value with placeholder attributes
                jQ224( "[data-poptin-id="+poptin.poptin_id+"] #poptinFormSubmit"+poptin.poptin_id+" .poptin-design-fields-form").each(function($index){
                    if (this.id.indexOf('FreeField') !== -1){
                        jQ224(this).css('display','none');
                        val = jQ224(this).val();
                        placeolder = jQ224(this).attr('placeholder');
                        jQ224(this).val("a:"+placeolder+"=&="+"b:"+val);
                    }
                })
            }

            var $honeyPotfield = jQ224('[data-poptin-id="' + poptin.poptin_id + '"] form input[name=poptin_field_company_website]');
            if ($honeyPotfield.length && typeof $honeyPotfield.val() !== "undefined" && $honeyPotfield.val() !== "") {
                showLog('Bot conversion');
                return false;
            }

            // Get AutoPilot trigger
            var auto_pilot_trigger_check = poptin.auto_pilot_trigger == undefined ? 'false' : poptin.auto_pilot_trigger;
            // Get submited form data
            // poptin_params = jQ224( "[data-poptin-id="+poptin.poptin_id+"] #poptinFormSubmit"+poptin.poptin_id ).serialize();

            checkbox_checked = jQ224('[data-poptin-id="'+poptin.poptin_id+'"] form > #poptinDesignInputTextFieldCheckbox input').prop('checked');

            poptin_params = {
                url: window.location.href,
                p_target: poptin.poptin_target,
                checkbox_checked: checkbox_checked,
                referrer: getReferrer(),
                previous_url: getPreviousUrl(),
                trigger: auto_pilot_trigger_check,
                poptin_id: poptin.poptin_id,
                title: document.title,
                client_id: getClientId(),
                visitor: ifMobilePoptin ? 'mobile' : 'desktop',
                facebook_messanger_data_ref: facebook_messanger_data_ref,
                origin_landing_page: getOriginLandingPage(),
                previous_visited_pages: getPreviousVisitedPages(),
                previous_visited_pages_with_current_page: getPreviousVisitedPagesWithCurrentPage(),
                previous_visited_pages_with_time_stamp: getPreviousVisitedPagesWithTimeStamp(),
                all_visited_pages: getAllVisitedPages(),
                store_integration: store_integration,
                store_integration_customer_id: store_integration_customer_id,
                browser_language: window.navigator.language,
                operating_system: window.navigator?.userAgentData?.platform || window.navigator?.platform || 'Unknown'
            };

            if (poptinCheckCookie('poptin_converted_email')) {
                poptin_params.last_converted_email = poptinGetCookie('poptin_converted_email');
            }

            var poptin_fields = new Array();
            var freeOptions = ["poptinDesignInputTextFieldName", "poptinDesignInputTextFieldEmail", "poptinDesignInputTextFieldPhone", "poptinDesignInputTextFieldMessage", "poptinDesignInputTextFieldCheckbox"];

            var new_extra_fields = {};
            var all_extra_fields = {};
            var is_active = jQ224("[data-poptin-id="+poptin.poptin_id+"].active").length ? ".active" : "";
            const excludedConversionsCases = [
                    'coupon',
                    'poptinForm2ndlinkbtnText',
                    'poptinForm3ndlinkbtnText',
                    'poptinForm4thlinkbtnText',
                    'poptinForm5thlinkbtnText',
                    'poptinForm6thlinkbtnText'
                ];

            if(!excludedConversionsCases.includes(count_conversion)){
                jQ224( "[data-poptin-id="+poptin.poptin_id+"]"+is_active+" #poptinFormSubmit"+poptin.poptin_id+" .poptin-design-fields-form").each(function(){
                    var skip = false;
                    var this_type = this.type;
                    var this_id = this.id;
                    var this_name = this.name;
                    var this_value = this.value;
                    var this_value = jQ224(this).attr('data-array-value') ? JSON.parse(this_value) : this_value;
                    var this_placeholder = jQ224(this).attr('data-placeholder') || jQ224(this).attr("placeholder") || this_name;

                    // Find parent elements with metadata - check parents FIRST, then element itself
                    var parentFormInput = jQ224(this).closest('.form-input-class');
                    var parentWithPropertyName = jQ224(this).closest('[data-property-name]');

                    var this_created_as = parentFormInput.attr('data-created-as') || parentWithPropertyName.attr('data-created-as') || jQ224(this).attr('data-created-as');
                    var this_created_ver = parentFormInput.attr('data-created-ver') || parentWithPropertyName.attr('data-created-ver') || jQ224(this).attr('data-created-ver');
                    showLog("parentWithPropertyName 2", parentWithPropertyName, this_created_as, this_created_ver);

                    // Get property name for version 9 and above
                    // First try data-property-name attribute, then fall back to poptin_fields JSON
                    var this_property_name = null;
                    if (parseInt(this_created_ver) >= 9) {
                        // Search all parent elements for non-empty data-property-name
                        var foundPropertyName = null;
                        jQ224(this).parents('[data-property-name]').each(function() {
                            var propValue = jQ224(this).attr('data-property-name');
                            if (propValue && propValue.trim() !== '') {
                                foundPropertyName = propValue.trim();
                                return false; // Stop iteration once found
                            }
                        });

                        // Fallback to element itself if no parent has it
                        if (!foundPropertyName) {
                            var elementProp = jQ224(this).attr('data-property-name');
                            if (elementProp && elementProp.trim() !== '') {
                                foundPropertyName = elementProp.trim();
                            }
                        }

                        // If data-property-name not found, try poptin_fields JSON
                        if (!foundPropertyName && poptin.poptin_fields) {
                            foundPropertyName = getPropertyNameFromPoptinFields(this_id, this_name, poptin.poptin_fields);
                        }

                        this_property_name = foundPropertyName;
                    }
                    if (this_type.indexOf('select') > -1) {
                        this_type = 'select';
                    }

                    // showLog("submission", jQ224(this), jQ224(this).get(0).checked, this_type, this_id, this_name, this_value, this_placeholder, this_created_as, this_created_ver);

                    if( jQ224.inArray(this_name, freeOptions) > -1 || ( this_name.indexOf('FreeField') > -1 && this.id.indexOf('poptinDesignInputTextFieldText') == -1 ) ){
                        // showLog("poptinMultiSelectValues", poptinMultiSelectValues);
                        var isMultiSelect = this_type === "checkbox" || (this_name == "poptinDesignInputTextFieldMessage" && (this_type === "select" || this_type === "select-multiple" || this_type === "select-one"));
                        if(isMultiSelect) {
                            if(!poptinMultiSelectValues[this_name]) {
                                poptinMultiSelectValues[this_name] = [];
                            }

                            if(this_type === "select") {
                                jQ224(this).find("option:selected").each(function(){
                                    var optionValue = jQ224(this).val();
                                    if(!poptinMultiSelectValues[this_name].includes(optionValue)) {
                                        poptinMultiSelectValues[this_name].push(optionValue);
                                    }
                                });
                            } else if(this_type === "checkbox" && jQ224(this).get(0).checked) {
                                if(!poptinMultiSelectValues[this_name].includes(this_value)) {
                                    poptinMultiSelectValues[this_name].push(this_value);
                                }
                            }
                            this_value = poptinMultiSelectValues[this_name];
                        } else if(this_type === "radio") {
                            if(jQ224(this).get(0).checked) {
                                this_value = this_value;
                            } else {
                                skip = true;
                            }
                        }

                        if(this_name == "poptinDesignInputTextFieldPhone" && undefined !== jQ224(this).attr("data-int-phone")){
                            this_value = jQ224(this).attr("data-int-phone");
                        }
                        if(!skip){
                            poptin_params[this_name] = this_value;
                            var this_name_lowercase = this_name.split('poptinDesignInput')[1].toLowerCase();
                            poptin_fields.push({
                                "type":this_type,
                                "name":this_name_lowercase,
                                "placeholder":this_placeholder,
                                "value":this_value,
                                "created_as":this_created_as,
                                "created_version":this_created_ver,
                                "property_name":this_property_name
                            });
                        }
                    } else {
                        // showLog("value", this_value);
                        if(this_type == "radio" || this_type == "checkbox") {
                            if(!this.checked) {
                                skip = true;
                            }
                            this_placeholder = jQ224(this).parentsUntil('.child-field-wrapper').parent().siblings('label.child-field-question').text();
                            this_value = jQ224(this).val();
                        }
                        if(jQ224(this).is('select')) {
                            this_placeholder = jQ224(this).attr('data-placeholder');
                            var selectedOption = jQ224(this).find(':selected');
                            if(selectedOption.length && selectedOption.attr("id") && selectedOption.attr("id").substr(-14) != "-child-default"){
                                this_value = jQ224(this).find(':selected').val();
                            } else {
                                skip = true;
                            }
                            if(jQ224(this).attr("data-multiple") == "true"){
                                jQ224(this).attr("multiple", "true");
                                var selectedInputParent = jQ224(this).parents(".field-multi-select");
                                // showLog("selectedInputParent", selectedInputParent);
                                var selectedInput = selectedInputParent.attr("id");
                                // showLog("selectedInput", selectedInput);
                                selectedInput = selectedInput.includes("poptinDesignInputCustomField-") ? selectedInput.split("poptinDesignInputCustomField-")[1] : selectedInput;
                                // showLog("selectedInput", selectedInput);
                                this_value = poptinMultiSelectValues[selectedInput];
                                // showLog("this_value", this_value);
                                skip = !this_value
                            }
                            // showLog("this_value", this_value);
                        }
                        // showLog("this_value", this_value);
                        if(skip == false && jQ224(this).parents(".form-input-class").hasClass('prop-boolean')){
                            this_value = this_value == "1" ? true : false;
                        }
                        // showLog("this_value", this_value);
                        // showLog("skip", skip);
                        if(jQ224(this).attr("data-input-type") == "date" && this_value == ""){
                            skip = true;
                        }
                        if(!skip){
                            if(this_type == "checkbox" || this_type == "radio") {
                                this_id = this_name;
                            }
                            if( new_extra_fields[this_name] == undefined ) {
                                this_value = (this_name=='poptinDesignInputTextFieldCheckbox') ? checkbox_checked : this_value;
                                new_extra_fields[this_name] = {
                                    "id":this_id,
                                    "type":this_type,
                                    "name":this_name,
                                    "placeholder":this_placeholder,
                                    "value":this_value,
                                    "created_as": this_created_as,
                                    "created_version": this_created_ver,
                                    "property_name":this_property_name
                                };
                                if(
                                    this_name.substring(0,40) == "poptinDesignInputCustomField-CUSTOM_UTM_"
                                    && !jQ224(this).hasClass("has-updated")
                                ){
                                    this_value = getQueryString(this_name.substring(36));
                                    if(this_value){
                                        new_extra_fields[this_name]["value"] = this_value;
                                    }
                                }
                            } else {
                                if(this_type == "checkbox") {
                                    if (!Array.isArray(new_extra_fields[this_name].value)) {
                                        new_extra_fields[this_name].value = [new_extra_fields[this_name].value];
                                    }
                                    new_extra_fields[this_name].value.push(this_value);
                                } else {
                                    new_extra_fields[this_name].placeholder = new_extra_fields[this_name].placeholder + ', ' + this_placeholder;
                                }
                                new_extra_fields[this_name]["created_as"] = this_created_as;
                                new_extra_fields[this_name]["created_version"] = this_created_ver;
                            }
                        }
                        if (!(this_name in all_extra_fields)) {
                            all_extra_fields[this_name] = {
                                "id":this_id,
                                "type":this_type,
                                "name":this_name,
                                "placeholder":this_placeholder,
                                "value":"",
                                "created_as": this_created_as,
                                "created_version": this_created_ver,
                                "property_name":this_property_name
                            };
                        }
                        poptin_fields.push(new_extra_fields[this_name]);
                    }
                });
                // showLog("poptin_fields", JSON.stringify(poptin_fields));

                // Update merge tags based on form data
                jQ224(poptin_fields).each(function(){
                    var value_input = this.value;
                    var tag_input = this.name.replace(/textfield/g, '');
                    tag_input = '{{_'+tag_input+'}}';
                    // showLog(this, tag_input, value_input);
                    jQ224("[data-poptin-id="+poptin.poptin_id+"]").find('.froala-editor-text, .froala-editor-ticker').each(function(){
                        var dtRegExp = new RegExp(tag_input,'gm');
                        jQ224(this).find('.fr-marker').remove();
                        jQ224(this).html(jQ224(this).html().replace(dtRegExp, value_input));
                    });
                });

                // showLog("poptin_fields", JSON.stringify(poptin_fields));
                // showLog("poptinMultiSelectValues", JSON.stringify(poptinMultiSelectValues));
                // showLog("all_extra_fields", JSON.stringify(all_extra_fields));
                // showLog("new_extra_fields", JSON.stringify(new_extra_fields));

                new_extra_fields = new_extra_fields || {};
                for (let field in all_extra_fields) {
                    if (!(field in new_extra_fields)) {
                        new_extra_fields[field] = all_extra_fields[field];
                    }
                }
                // showLog("new_extra_fields", JSON.stringify(new_extra_fields));

                try{
                    new_extra_fields = Object.values(new_extra_fields);
                }catch(err){
                    var new_extra_fields_values = Object.keys(new_extra_fields).map(function(e) {
                        return new_extra_fields[e];
                    });
                    new_extra_fields = new_extra_fields_values;
                }
                // showLog(new_extra_fields);

                var base_fields = {
                    text : 0,
                    number : 0,
                    textarea : 0,
                    date : 0,
                    url : 0,
                    radio : 0,
                    checkbox : 0,
                    hidden : 0,
                    tel : 0,
                    select : 0
                }
                // showLog('Logger new_extra_fields', new_extra_fields);

                // Track processed radio groups to avoid duplicates
                var processedRadioGroups = {};

                // Track processed checkbox groups
                var processedCheckboxGroups = {};

                // Handle split name
                var split_name_field = {}

                jQ224(new_extra_fields).each(function(i) {
                    // Skip if the field was deleted but preserve logging
                    if (!new_extra_fields[i]) {
                        showLog('Logger new_extra_fields at base_fields undefined');
                        return; // Continue to next iteration
                    }

                    var this_type = new_extra_fields[i].type;
                    var this_name = new_extra_fields[i].name;
                    var this_id = new_extra_fields[i].id;
                    var this_value = new_extra_fields[i].value;
                    var this_placeholder = new_extra_fields[i].placeholder;
                    var this_created_as = new_extra_fields[i].created_as;
                    var this_created_ver = parseInt(new_extra_fields[i].created_version) || 0;
                    var this_property_name = new_extra_fields[i].property_name;
                    var countingType = null;
                    var skipCountingType = false;
                    var isSpecialField = false;
                    // showLog(`Processing field ${i}:`, new_extra_fields[i]);

                    // Clean up ID - remove child suffix
                    if(this_id.includes('-child-')) {
                        this_id = this_id.split('-child-')[0];
                        // showLog(`Cleaned up ID to: ${this_id}`);
                    }

                    if (SPECIAL_FIELD_MAPPINGS.hasOwnProperty(this_id) && this_created_ver >= 6) {
                        isSpecialField = true;
                        const specialFieldName = SPECIAL_FIELD_MAPPINGS[this_id];
                        this_name = specialFieldName;

                        // Update the field properties
                        if(new_extra_fields[i]) {
                            new_extra_fields[i].id = this_id;
                            new_extra_fields[i].name = this_name;
                            new_extra_fields[i].type = this_type;
                            new_extra_fields[i].value = this_value;
                        }

                        // Handle special case for split name fields
                        if(this_id === "poptinDesignInputTextFieldFirstName" || this_id === "poptinDesignInputTextFieldLastName") {
                            split_name_field[this_name] = this_value;
                        }

                        // Increment the special field counter in base_fields
                        if (base_fields.hasOwnProperty(specialFieldName)) {
                            base_fields[specialFieldName]++;
                        }

                        skipCountingType = true; // Skip the regular field type counting
                        return; // Skip the rest of the processing for special fields
                    }

                    new_extra_fields[i].name = this_name;
                    countingType = getCountingType(new_extra_fields[i]) || this_type;

                    // Handle radio buttons
                    if(this_type === 'radio') {
                        var radioGroupName = this_name.includes('-child-') ?
                            this_name.split('-child-')[0] :
                            this_name;
                        // showLog(`Processing radio button in group: ${radioGroupName}`);

                        // If we haven't processed this group yet, initialize it
                        if(processedRadioGroups[radioGroupName] === undefined) {
                            // showLog(`Initializing new radio group: ${radioGroupName}`);
                            processedRadioGroups[radioGroupName] = {
                                "id": this_id,
                                "type": 'radio',
                                "name": radioGroupName,
                                "placeholder": this_placeholder,
                                "created_as": this_created_as,
                                "created_version": this_created_ver,
                                "value": '', // Default empty string
                                "property_name":this_property_name
                            };

                            // showLog("this_created_ver", this_created_ver, this_created_as, countingType, 'radio');

                            // Only increment checkbox count once per group
                            if (base_fields[countingType] !== undefined) {
                                base_fields[countingType]++;
                                skipCountingType = true;
                            }
                        } else if(this_property_name && !processedRadioGroups[radioGroupName].property_name && this_created_ver >= 9) {
                            // Update property_name if this element has it but the group doesn't yet (version 9+)
                            processedRadioGroups[radioGroupName].property_name = this_property_name;
                        }

                        // Check if this is a boolean field by field id AND class
                        var radioElement = jQ224('#' + new_extra_fields[i].id);
                        var radioParent = radioElement.closest('.form-input-class');
                        var isBooleanField = radioParent.length && radioParent.hasClass('prop-boolean');

                        // Get selected value by name
                        var radioGroup = jQ224(`input[name="${radioGroupName}"]`);
                        var selectedRadio = radioGroup.filter(':checked');
                        var isChecked = selectedRadio.length > 0;
                        var selectedValue = isChecked ? selectedRadio.val() : '';

                        // showLog(`Processing radio ${radioGroupName}:`, { isBooleanField, isChecked, selectedValue, parent: radioParent.length ? 'Found' : 'Not Found', hasClass: radioParent.length ? radioParent.hasClass('prop-boolean') : false });

                        if(isChecked) {
                            if(isBooleanField) {
                                // For boolean fields, ensure value is true/false, not "0"/"1"/"true"/"false"
                                processedRadioGroups[radioGroupName].value = selectedValue === "1" || selectedValue === "true";
                                // showLog(`Set boolean value for ${radioGroupName}:`, processedRadioGroups[radioGroupName].value);
                            } else {
                                // For non-boolean fields, use the value as is
                                processedRadioGroups[radioGroupName].value = selectedValue;
                                // showLog(`Set string value for ${radioGroupName}:`, processedRadioGroups[radioGroupName].value);
                            }
                        } else {
                            // If nothing selected, use empty string
                            processedRadioGroups[radioGroupName].value = '';
                            // showLog(`No selection for ${radioGroupName}, set empty value`);
                        }

                        // Remove individual radio button entry as we'll add the group summary later
                        delete new_extra_fields[i];
                    }

                    // Handle checkboxes
                    if(this_type === 'checkbox') {
                        var checkboxGroupName = this_name;
                        // showLog(`Processing checkbox in group: ${checkboxGroupName}`);

                        // Initialize group if not already done
                        if(processedCheckboxGroups[checkboxGroupName] === undefined) {
                            // showLog(`Initializing new checkbox group: ${checkboxGroupName}`);
                            processedCheckboxGroups[checkboxGroupName] = {
                                "id": this_id,
                                "type": 'checkbox',
                                "name": checkboxGroupName,
                                "placeholder": this_placeholder,
                                "created_as": this_created_as,
                                "created_version": this_created_ver,
                                "values": [],
                                "value": [], // Initialize as empty array
                                "property_name":this_property_name
                            };

                            // showLog("this_created_ver", this_created_ver, this_created_as, countingType, 'checkbox');

                            // Only increment checkbox count once per group
                            if (base_fields[countingType] !== undefined) {
                                base_fields[countingType]++;
                                skipCountingType = true;
                            }
                        } else if(this_property_name && !processedCheckboxGroups[checkboxGroupName].property_name && this_created_ver >= 9) {
                            // Update property_name if this element has it but the group doesn't yet (version 9+)
                            processedCheckboxGroups[checkboxGroupName].property_name = this_property_name;
                        }

                        // Handle case where value is already an array
                        if(Array.isArray(this_value)) {
                            // showLog(`Found existing checkbox values array:`, this_value);
                            processedCheckboxGroups[checkboxGroupName].values = this_value;
                        } else if(this_value) { // Add value if it exists, regardless of checked state
                            // showLog(`Adding value to group ${checkboxGroupName}:`, this_value);
                            processedCheckboxGroups[checkboxGroupName].values.push(this_value);
                        }

                        // Remove individual checkbox entry as we'll add the group summary later
                        delete new_extra_fields[i];
                    }

                    // Use original input type for base_fields counting if field was created in v7 or earlier
                    // showLog('Logger new_extra_fields at base_fields', JSON.stringify(new_extra_fields[i]));
                    if (!new_extra_fields[i]) {
                        // showLog('Logger new_extra_fields at base_fields undefined');
                        return; // Continue to next iteration
                    }
                    countingType = getCountingType(new_extra_fields[i]) || this_type;

                    // Only increment if we have a valid type and the field exists
                    if (base_fields[countingType] !== undefined && !skipCountingType) {
                        base_fields[countingType] = base_fields[countingType] + 1;
                    }

                    // showLog("this_name && countingType", this_name, countingType);
                    if(this_id == "poptinDesignInputTextFieldCheckbox"){
                        this_name = "consent";
                    } else if(this_id == "poptinDesignInputTextFieldFirstName"){
                        this_name = "first_name";
                        split_name_field[this_name] = this_value;
                    } else if(this_id == "poptinDesignInputTextFieldLastName"){
                        this_name = "last_name";
                        split_name_field[this_name] = this_value;
                    } else if(isSpecialField) {
                        // Do nothing; Already taken care of above.
                    } else {
                        this_name = (countingType)+"_"+base_fields[countingType];
                    }
                    // showLog("this_name && countingType", this_name, countingType);

                    // Only update if field wasn't deleted and isn't radio/checkbox
                    if(new_extra_fields[i] && this_type !== 'radio' && this_type !== 'checkbox') {
                        // showLog('Logger before fallback', JSON.stringify(new_extra_fields));
                        new_extra_fields[i].id = this_id;
                        new_extra_fields[i].name = this_name;
                        new_extra_fields[i].type = this_type;
                        new_extra_fields[i].value = this_value;
                        // showLog('Logger before fallback', JSON.stringify(new_extra_fields));
                    }

                    var isValueString = this_value && typeof this_value === 'string';

                    // For Gamfied Prize Code & Label Hidden Fields
                    if(this_type == "hidden" && isValueString && this_value.indexOf('{{prize_code}}') > -1){
                        new_extra_fields[i].name = "prize_code";
                        new_extra_fields[i].value = poptin.gamified_prize ? poptin.gamified_prize.code:"";
                    }
                    if(this_type == "hidden" && isValueString && this_value.indexOf('{{prize_label}}') > -1){
                        new_extra_fields[i].name = "prize_label";
                        new_extra_fields[i].value = poptin.gamified_prize ? poptin.gamified_prize.label:"";
                    }
                    // if(this_id == "poptinDesignPreferenceField" && this_value == ""){
                    //     new_extra_fields[i] = null;
                    // }
                });
                // showLog('Logger after loop', JSON.stringify(new_extra_fields));

                // showLog('Logger base_fields final_base_fields', JSON.stringify(base_fields));

                // Clean up the array by removing deleted entries
                new_extra_fields = new_extra_fields.filter(function(field) {
                    return field !== undefined;
                });
                // showLog('Logger after cleanup', JSON.stringify(new_extra_fields));

                // Add processed radio groups to new_extra_fields
                Object.values(processedRadioGroups).forEach(function(group) {

                    var isSpecialField = SPECIAL_FIELD_MAPPINGS.hasOwnProperty(group.id) && (group.created_version || 5 ) >= 6;
                    var countingType = getCountingType(group) || this_type;
                    if(group.id == "poptinDesignInputTextFieldCheckbox" || isSpecialField) {
                        // Do nothing; Already taken care of above.
                    } else {
                        group.name = (countingType)+"_"+base_fields[countingType];
                        base_fields[countingType]++;
                    }

                    // showLog(`Adding radio group back:`, group);
                    new_extra_fields.push(group);

                });
                // showLog('Logger after processedRadioGroups', JSON.stringify(new_extra_fields));

                // Add processed checkbox groups to new_extra_fields
                Object.values(processedCheckboxGroups).forEach(function(group) {

                    var isSpecialField = SPECIAL_FIELD_MAPPINGS.hasOwnProperty(group.id) && (group.created_version || 5 ) >= 6;
                    var countingType = getCountingType(group) || this_type;
                    if(group.id == "poptinDesignInputTextFieldCheckbox" || isSpecialField) {
                        // Do nothing; Already taken care of above.
                    } else {
                        group.name = (countingType)+"_"+base_fields[countingType];
                        base_fields[countingType]++;
                    }

                    // Keep the values array instead of joining
                    group.value = group.values.length > 0 ? group.values : [];
                    delete group.values; // Clean up temporary array
                    // showLog(`Adding checkbox group:`, group);
                    new_extra_fields.push(group);

                });
                // showLog('Logger after processedCheckboxGroups', JSON.stringify(new_extra_fields));

                // Fields from shopify products
                if( poptin["shopify_product_settings"] && poptin["shopify_product_settings"]["product_name"] ){
                    var objProd = { id: "poptinShopifyRecomProductName", name: "product_name", placeholder: "Product name", type: "hidden", value: poptin["shopify_product_settings"]["product_name"] }
                    new_extra_fields.push(objProd);
                }

                // Fields from wix products
                if( poptin["wix_product_settings"] && poptin["wix_product_settings"]["product_name"] ){
                    var objProd = { id: "poptinWixRecomProductName", name: "product_name", placeholder: "Product name", type: "hidden", value: poptin["wix_product_settings"]["product_name"] }
                    new_extra_fields.push(objProd);
                }

                if(split_name_field.first_name && split_name_field.last_name){
                    poptin_params['poptinDesignInputTextFieldName'] = split_name_field.first_name + " " + split_name_field.last_name;
                }

                // Check if country code is enabled and phone number is present
                var countryCodeContainer = jQ224('.iti__flag-container');
                if(countryCodeContainer.length > 0 && poptin_params['poptinDesignInputTextFieldPhone']){

                    var phoneInput = jQ224("input#poptinDesignInputTextFieldPhone").get(0);
                    if(el && el.find('input#poptinDesignInputTextFieldPhone').length > 0){
                        phoneInput = el.find('input#poptinDesignInputTextFieldPhone').get(0);
                    }
                    var selectedCountryCode = "";
                    if(phoneInput){
                        var iti = window.intlTelInputGlobals.getInstance(phoneInput);
                        if(iti){
                            var selectedCountry = iti.getSelectedCountryData();
                            if(selectedCountry && selectedCountry.dialCode){
                                selectedCountryCode = selectedCountry.dialCode;
                            }
                        }
                    }
                    var phoneNumber = poptin_params['poptinDesignInputTextFieldPhone'];
                    var phoneNumber = phoneNumber.replace(/[\(\)\s]/g, '');

                    // Only format phone number if we have a valid country code
                    if(selectedCountryCode && selectedCountryCode.length > 0){
                        if(phoneNumber && phoneNumber.startsWith('0')){
                            phoneNumber = phoneNumber.substring(1);
                        }
                        poptin_params['poptinDesignInputTextFieldPhone'] = phoneNumber;
                        if(!(phoneNumber.startsWith(selectedCountryCode) || phoneNumber.startsWith('+'+selectedCountryCode))){
                            poptin_params['poptinDesignInputTextFieldPhone'] = '+' + selectedCountryCode + ' ' + phoneNumber;
                        }
                        if(phoneNumber.startsWith(selectedCountryCode) && !phoneNumber.startsWith('+')){
                            poptin_params['poptinDesignInputTextFieldPhone'] = '+' + phoneNumber;
                        }
                    } else {
                        poptin_params['poptinDesignInputTextFieldPhone'] = phoneNumber;
                    }
                }

                // Fallback for property name to the generated inputType_count
                jQ224.each(new_extra_fields, function(i, field) {
                    if (!field.property_name || field.property_name === '') {
                        field.property_name = field.name;
                    }
                    if (!field.created_version) {
                        field.created_version = 5;
                    }
                });

                poptin_params['newExtraFields'] = JSON.stringify(new_extra_fields);
                poptin_params['leader_request_cookie'] = getLeaderCookie();
                poptin_params['extra_button'] = count_conversion;
                poptinSubmitted[poptin.poptin_id] = {
                    poptin_id: poptin_params['poptin_id'],
                    client_id: poptin_params['client_id'] !== undefined ? poptin_params['client_id'] : '',
                    referrer: poptin_params['referrer'],
                    previous_url: poptin_params['previous_url'],
                    page_title: poptin_params['title'],
                    page_url: poptin_params['url'],
                    consent: poptin_params['checkbox_checked'],
                    previous_visited_pages: poptin_params['previous_visited_pages'],
                    previous_visited_pages_with_current_page: poptin_params['previous_visited_pages_with_current_page'],
                    previous_visited_pages_with_time_stamp: poptin_params['previous_visited_pages_with_time_stamp'],
                    all_visited_pages: poptin_params['all_visited_pages'],
                    fields: poptin_fields
                };
            }else{
                poptin_params['extra_button'] = count_conversion;
            }
            if (poptinCheckCookie('poptin_converted_email')) {
                poptin_params['last_converted_email'] = poptinGetCookie('poptin_converted_email');
            }

            if(count_conversion == 'coupon'){
                poptin_params['coupon'] = poptin.design_properties.coupon;
                poptin_params['extra_button'] = 'coupon';
            }

            if (poptinViewdArr[poptin.poptin_id] && poptinViewdArr[poptin.poptin_id].poptin_view_id !== undefined) {
                poptin_params['poptin_view_id'] = poptinViewdArr[poptin.poptin_id].poptin_view_id;
            }

            // showLog("poptinSubmitted",poptinSubmitted);
            // return false;

            url_conversion_query = getPoptinConversionFields(poptin);
            showLog('poptinConversion - url_conversion_query set to:', url_conversion_query);
            // Get additional user data
            // poptin_params += '&url='+window.location.href+'&p_target='+poptin.poptin_target+'&referrer='+getReferrer()+'&trigger='+trigger+'&poptin_id='+poptin.poptin_id+'&title='+document.title;
            // Ajax call


            showLog(poptin_params);

            // Check for preview poptin ID
            if (previewPoptinId === poptin.poptin_id) {
                return;
            }
            jQ224.ajax({
                type: 'POST',
                async: true,
                cache: true,
                data: poptin_params,
                url: api_link+"/api/display/conversion/"+poptin.viewer_id,
                success: function(response) {
                    showLog('poptinConversion()->success()');
                    if (response['success']){
                        try{
                            handleConversionSuccess(poptin,response, count_conversion);
                            if (typeof poptin_params.poptinDesignInputTextFieldEmail != "undefined") {
                                //localStorage.setItem('poptin_converted_email', poptin_params.poptinDesignInputTextFieldEmail.toLowerCase());
                                poptinSetCookie('poptin_converted_email', poptin_params.poptinDesignInputTextFieldEmail.toLowerCase(), 30 / (60 * 24));
                            }
                            /*var closedCookiesArray = getCloseCookiesArray();
                            if(closedCookiesArray.length > 0) {
                                // console.log('closed_cookers', closedCookiesArray);
                                jQ224.each(closedCookiesArray, function(index, closedCookie) {
                                    // console.log('each_cookie_is: ', closedCookie);
                                    updateConversionActivities('closed', closedCookie.value);
                                });

                                /!*var closedCookiesArray = getCloseCookiesArray();
                                for(var i = 0; i < closedCookiesArray.length; i++) {
                                    // showLog('value is: ', closedCookiesArray[i].value);
                                }*!/
                            }*/
                        }catch(err){
                            monitorError('poptinConversion()->handleConversionSuccess',err,'OK',response,poptin,poptin_params);
                        }
                    }
                },
                error: function(XMLHttpRequest, textStatus, errorThrown) {
                    monitorError('poptinConversion()->error()',errorThrown,textStatus,XMLHttpRequest.responseText,poptin);
                },
                complete: function(response) {
                    if(count_conversion != 'coupon'){

                            showLog('poptinConversion()>complete()');

                            var _this = jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+']');
                            if (_this.attr('data-redirect-poptin') == "shopify"){
                                // If Shopify then check for add to cart
                                if(typeof Shopify != "undefined" && !( poptin["shopify_product_settings"] && poptin["shopify_product_settings"]["product_url"]) && (poptin.design_properties.poptin_design_thank_screen != 1)) {
                                    showLog("handeShopifyAddToCart()");
                                    handeShopifyAddToCart(poptin,true,'',count_conversion, el);
                                    // return false;
                                }
                            }

                            if( typeof Shopify != "undefined" && poptin["shopify_product_settings"] && poptin["shopify_product_settings"]["product_url"] && poptin["shopify_product_settings"]["buttons_action"] != "no_buttons" ) {
                                showLog("redirectShopifyProducts");
                                handelShopifyProdRedirects(poptin);
                                return false;
                            }

                            if (_this.attr('data-redirect-poptin') == "wix"){
                                // If Shopify then check for add to cart
                                if(typeof window.wixDevelopersAnalytics != "undefined" && !( poptin["wix_product_settings"] && poptin["wix_product_settings"]["product_url"]) && (poptin.design_properties.poptin_design_thank_screen != 1)) {
                                    showLog("handleWixAddToCart()");
                                    handleWixAddToCart(poptin,true,'',count_conversion, el);
                                    // return false;
                                }
                            }

                            if( typeof window.wixDevelopersAnalytics != "undefined" && poptin["wix_product_settings"] && poptin["wix_product_settings"]["product_url"] && poptin["wix_product_settings"]["buttons_action"] != "no_buttons" ) {
                                showLog("redirectWixProducts");
                                handleWixProdRedirects(poptin);
                                return false;
                            }


                            // redirect user to poptin redirect page
                            if(count_conversion !== "") {
                                // if(count_conversion === "close_btn") {
                                //     if (typeof poptin.design_properties.poptin_design_redirect != "undefined"){
                                //         redirectToPoptin(poptin);
                                //     }
                                // }else{
                                //     buttonRedirectAfterClick(el);
                                // }
                                buttonRedirectAfterClick(poptin,el);
                            }else{
                                redirectAfterConversion(poptin);
                            }
                    }

                }
            },"JSON");
            // DataPoint event
            //window.poptins[poptin.poptin_id].data_point.onConversion();

        }

        /**
         * Trigger functions: setPoptin(), initializeClock(), afterPoptinSubmit(), onTextClickClose(),closePoptinOnXclick()
         * parameters       : poptin_id:string
         * Desc             : handle close poptin and remove poptin from DOM
         */
        if (typeof closePoptin !== 'function') {
            window.closePoptin = function (poptin_id,x_close,bg_click=false) {
                jQ224("[data-poptin-id="+poptin_id+"]").find('audio, video').remove();

                if(jQ224("[data-poptin-id="+poptin_id+"]").length == 0){
                    return false;
                }

                var x_close = x_close ? x_close : false;
                showLog('closePoptin: '+poptin_id);

                //window.poptins[poptin_id].data_point.onClose(poptin_id);
                //hideEffect(window.all_poptins[poptin_id]);
                //jQ224(".poptin-popup[data-poptin-id="+poptin_id+"], .poptin-popup-background[data-poptin-id="+poptin_id+"]").fadeOut('fast');
                //jQ224('body').css("overflow","auto");
                var needsHtmlPaddingFix = (
                    jQ224(".poptin-popup[data-poptin-id="+poptin_id+"][data-poptin-location='center-top'][data-poptin-type='bar']").length > 0 ||
                    jQ224(".poptin-popup[data-poptin-id="+poptin_id+"]").attr('data-wellcome-screen') == '1'
                ) ? true : false;
                if(needsHtmlPaddingFix){ fixHtmlPadding(); }
                //cancelSocialProofInterval(poptin_id);
                jQ224(".poptin-embedded[data-id='"+poptin_id+"']").slideUp();
                try{clearInterval(submitBtnAnimationInterval);}catch(err){}
                try{clearInterval(closeBtnAnimationInterval);}catch(err){}
                try{clearInterval(giftboxAnimationInterval);}catch(err){}

                try{
                    var poptinlinkButton = jQ224(".poptin-popup[data-poptin-id="+poptin_id+"] .froala-editor-link");
                    if(poptinlinkButton.length && typeof poptinlinkButton.attr("data-poptin-animate") !== "undefined" && poptinlinkButton.attr("data-poptin-animate") != null){
                        jQ224(".poptin-popup[data-poptin-id="+poptin_id+"] .froala-editor-link").each(function(){
                            var linkbtn_id= jQ224(this).parent().attr("id");
                            clearInterval(link_interval_array[poptin_id+"_"+linkbtn_id]);
                        });
                    }
                }catch(err){

                }

                // setTimeout(function() {
                //  jQ224(".poptin-popup[data-poptin-id="+poptin_id+"], .poptin-popup-background[data-poptin-id="+poptin_id+"]").remove();
                // },300);

                if(landing_page_teaser_on==1){
                    if(jQ224('#poptinDraggableContainer-tab[data-load-poptin="'+ poptin.poptin_id +'"]').length>0){
                        if(jQ224(".poptin-popup[data-poptin-id=" + poptin_id + "]").attr("data-tabshow")!='before_show'){
                            showTeaserEffect(poptin, 'entry');
                            animateTab(poptin);
                        }
                    }else{
                        extractTeaser(poptin, 1);
                    }
                }else{
                    if (typeof jQ224(".poptin-popup[data-poptin-id=" + poptin_id + "]").attr("data-hastab") != "undefined" && jQ224(".poptin-popup[data-poptin-id=" + poptin_id + "]").attr("data-hastab") == 1) {
                        poptin = window.all_poptins[poptin_id];
                        if (jQ224(".poptin-popup[data-poptin-id=" + poptin_id + "]").attr("data-tabshow") == "after_close") {
                        if(jQ224('#poptinDraggableContainer-tab[data-load-poptin="'+ poptin.poptin_id +'"]').length>0 && jQ224('#poptinDraggableContainer-tab[data-load-poptin="'+ poptin.poptin_id +'"]').hasClass("popup-loaded")){
                            jQ224('#poptinDraggableContainer-tab[data-load-poptin="'+ poptin.poptin_id +'"]').removeClass("popup-loaded");
                                if(poptin.d_f_r=='all@display_everytime_everypage_5'){
                                    if(poptin.x_close_button!=0){
                                        showTeaserEffect(poptin, 'entry');
                                        animateTab(poptin);
                                    }
                                }else{
                                        showTeaserEffect(poptin, 'entry');
                                        animateTab(poptin);
                                }
                        }else{
                            extractTeaser(poptin, 1);
                        }
                        }else if (jQ224(".poptin-popup[data-poptin-id=" + poptin_id + "]").attr("data-tabshow") == "always"){

                            if(jQ224('#poptinDraggableContainer-tab[data-load-poptin="'+ poptin.poptin_id +'"]').length>0 && jQ224('#poptinDraggableContainer-tab[data-load-poptin="'+ poptin.poptin_id +'"]').hasClass("popup-loaded")){
                                jQ224('#poptinDraggableContainer-tab[data-load-poptin="'+ poptin.poptin_id +'"]').removeClass("popup-loaded");
                                if(poptin.d_f_r=='all@display_everytime_everypage_5'){
                                    if(poptin.x_close_button!=0){
                                        showTeaserEffect(poptin, 'entry');
                                        animateTab(poptin);
                                    }
                                }else{
                                    showTeaserEffect(poptin, 'entry');
                                    animateTab(poptin);
                                }

                            }else{
                                extractTeaser(poptin, 1);
                            }
                        }
                    }
                }

                poptin = window.all_poptins[poptin_id];
                var exitTimeOut = 0;
                if(poptin.poptin_type && poptin.poptin_type != "embedded" && poptin.poptin_type != "fullpage"){
                    if( (poptin.design_properties && poptin.design_properties.poptin_design_exit_effect && poptin.design_properties.poptin_design_exit_effect == "exit_effect-none") || !poptin.design_properties.poptin_design_exit_effect ){
                        exitTimeOut = 0;
                    }else{
                        showEffect(poptin,"exit");
                        exitTimeOut = 800;
                    }
                }

                setTimeout(function() {
                    if (x_close){
                        removePoptinHtml(poptin_id)
                    }else{
                        if(poptin.is_teasers_on){
                            setTimeout(function() {
                                removePoptinHtml(poptin_id)
                            },1500);
                        }else{
                            jQ224(".poptin-popup[data-poptin-id="+poptin_id+"], .poptin-popup-background[data-poptin-id="+poptin_id+"]").fadeOut('fast');
                            setTimeout(function() {
                                removePoptinHtml(poptin_id)
                            },bg_click ? 200 : 5000);
                        }

                    }
                    jQ224("#bgeffect_canvas_"+poptin_id).remove();
                }, exitTimeOut);

                PQ.firePoptin(poptin_id);

                // Don't fire close event if form was submitted
                let this_pop = jQ224(".poptin-popup[data-poptin-id=" + poptin_id + "]");
                if(
                    !(
                        this_pop.hasClass("poptin-submitted") ||
                        this_pop.hasClass("poptin-redirected")
                    )
                ){
                    const onPoptinCloseEvent = new CustomEvent("poptinClose", {bubbles: true, detail: poptinEventDetails(poptin, {"event_name" : "poptinClose"})});
                    document.dispatchEvent(onPoptinCloseEvent);
                    onpoptinClose(poptin_id);
                } else if(poptin.poptin_type == "gamified") {
                    jQ224(".poptin-popup[data-poptin-id=" + poptin_id + "]").removeClass("poptin-submitted poptin-redirected");
                }

                if (typeof poptin.design_properties.poptin_design_redirect != "undefined"){
                    ensurePoptinTrigger(poptin.poptin_id);
                    if (window.poptins[poptin.poptin_id].poptin_trigger.convert == true){
                        redirectToPoptin(poptin);
                    }
                }
            }
        }

        function removePoptinHtml(poptin_id){
        jQ224(".poptin-popup[data-poptin-id="+poptin_id+"], .poptin-popup-background[data-poptin-id="+poptin_id+"]").remove();
        }

        /**
         * Trigger functions: submitPoptin()
         * parameters       : poptin:object
         * Desc             : Add to cart/Redirect for shopify product
         */
        function handelShopifyProdRedirects(poptin){

            if( poptin["shopify_product_settings"]["buttons_action"] == "add_to_cart" || poptin["shopify_product_settings"]["buttons_action"] == "add_to_cart_redirect" ){
                jQ224.ajax({
                    url: '/cart/add.js',
                    type: "POST",
                    async: true,
                    data: {
                        items: [
                            {
                                quantity: 1,
                                id: poptin["shopify_product_settings"]["variant_id"]
                            }
                        ]
                    },
                    complete: function(resp) {
                        if(poptin["shopify_product_settings"]["buttons_action"] == "add_to_cart_redirect"){
                            window.location.href = window.location.origin + "/cart";
                        }else if(poptin["shopify_product_settings"]["buttons_action"] == "add_to_cart"){
                            window.location.reload();
                        }
                    }
                });

            }else if( poptin["shopify_product_settings"]["buttons_action"] == "redirect" || poptin["shopify_product_settings"]["buttons_action"] == "redirect_blank" ){
                if(poptin["shopify_product_settings"]["buttons_action"] == "redirect_blank"){
                    var tagRefId = "poptin_spr_"+poptin["shopify_product_settings"]["product_id"]+"_"+poptin["shopify_product_settings"]["variant_id"];
                    var tagToAppend = '<a id="'+tagRefId+'" href="'+poptin["shopify_product_settings"]["product_url"]+'" target="_blank"></a>';
                    jQ224( "body" ).append( tagToAppend );
                    jQ224( "#"+tagRefId )[0].click();
                    jQ224( "#"+tagRefId )[0].remove();
                }else{
                    window.location.href = poptin["shopify_product_settings"]["product_url"];
                }
            }

            closePoptin(poptin.poptin_id);
        }

        /**
         * Trigger functions: submitPoptin()
         * parameters       : poptin:object
         * Desc             : Add product to cart if wix add to cart is there
         */
        function handleWixAddToCart(poptin, addToCart, btn_id = '',count_conversion='',el = null){
            showLog('handleWixAddToCart: '+poptin.poptin_id);

            if(addToCart) {
                var add_to_cart = poptin.design_properties.wix_add_to_cart != null ? poptin.design_properties.wix_add_to_cart.split('@') : '';
            }else{
                if(btn_id === "poptinForm2ndlinkbtnText")
                    var add_to_cart = poptin.design_properties.wix_add_to_cart_2 != null ? poptin.design_properties.wix_add_to_cart_2.split('@') : '';
                else if(btn_id === "poptinForm3ndlinkbtnText")
                    var add_to_cart = poptin.design_properties.wix_add_to_cart_3 != null ? poptin.design_properties.wix_add_to_cart_3.split('@') : '';
                else if(btn_id === "poptinForm4thlinkbtnText")
                    var add_to_cart = poptin.design_properties.wix_add_to_cart_4 != null ? poptin.design_properties.wix_add_to_cart_4.split('@') : '';
                else if(btn_id === "poptinForm5thlinkbtnText")
                    var add_to_cart = poptin.design_properties.wix_add_to_cart_5 != null ? poptin.design_properties.wix_add_to_cart_5.split('@') : '';
                else if(btn_id === "poptinForm6thlinkbtnText")
                    var add_to_cart = poptin.design_properties.wix_add_to_cart_6 != null ? poptin.design_properties.wix_add_to_cart_6.split('@') : '';
            }

            if(add_to_cart && Array.isArray(add_to_cart)){
                var product_id = add_to_cart[0] || 0;
                var product_qty = add_to_cart[1] || 0;
                var reload_type = parseInt(add_to_cart[2]) || 0;
                var reload_page = add_to_cart[3] || '';

                sendWixProductRecommendationRequest(poptin, {
                    'category': 'manual',
                    'manual_products': [product_id],
                }, async function (result) {
                    let products = result.data.products || [];

                    // Find the product or variant in the products array
                    let product = products.find(p => {
                        if (p.id == product_id) {
                            return true;
                        }

                        if (Array.isArray(p.variants)) {
                            return p.variants.some(v => v.id == product_id);
                        }
                        return false;
                    });

                    if (product && poptinWixAuthorizedClient) {
                        switch (reload_type) {
                            case 1:
                                await wixAddToCurrentCart({
                                    lineItems: [
                                        {
                                            catalogReference: {
                                                appId: WIX_STORE_ID,
                                                catalogItemId: product.id,
                                                options: {
                                                    variantId: product.variants
                                                        ? (product.variants.filter((v) => v.id == product_id)[0]?.id || undefined)
                                                        : undefined,
                                                },
                                            },
                                            quantity: product_qty
                                        }
                                    ]
                                });
                                window.location.href = '/cart-page';
                                break;
                            default:
                                await wixAddToCurrentCart({
                                    lineItems: [
                                        {
                                            catalogReference: {
                                                appId: WIX_STORE_ID,
                                                catalogItemId: product.id,
                                                options: {
                                                    variantId: product.variants
                                                        ? (product.variants.filter((v) => v.id == product_id)[0]?.id || undefined)
                                                        : undefined,
                                                },
                                            },
                                            quantity: product_qty
                                        }
                                    ]
                                });
                                window.location.reload();
                                break;
                        }
                    }

                    resolve(true);
                });

            } else {
                // redirect user to poptin redirect page
                if(count_conversion !== "") {
                    buttonRedirectAfterClick(poptin, el);
                }else{
                    redirectAfterConversion(poptin);
                }
            }

            closePoptin(poptin.poptin_id);
        }

        /**
         * Trigger functions: submitPoptin()
         * parameters       : poptin:object
         * Desc             : Add to cart/Redirect for wix product
         */
        async function handleWixProdRedirects(poptin) {
            if(poptin["wix_product_settings"]["buttons_action"] == "add_to_cart" || poptin["wix_product_settings"]["buttons_action"] == "add_to_cart_redirect") {
                switch (poptin["wix_product_settings"]["buttons_action"]) {
                    case 'add_to_cart':
                        if (poptinWixAuthorizedClient) {
                            await wixAddToCurrentCart({
                                lineItems: [
                                    {
                                        catalogReference: {
                                            appId: WIX_STORE_ID,
                                            catalogItemId: poptin["wix_product_settings"]["product_id"],
                                            options: {
                                                variantId: poptin["wix_product_settings"]["variant_id"],
                                            },
                                        },
                                        quantity: 1
                                    }
                                ]
                            });
                            window.location.reload();
                        }
                        break;
                    case 'add_to_cart_redirect':
                        if (poptinWixAuthorizedClient) {
                            await wixAddToCurrentCart({
                                lineItems: [
                                    {
                                        catalogReference: {
                                            appId: WIX_STORE_ID,
                                            catalogItemId: poptin["wix_product_settings"]["product_id"],
                                            options: {
                                                variantId: poptin["wix_product_settings"]["variant_id"],
                                            },
                                        },
                                        quantity: 1
                                    }
                                ]
                            });
                            window.location.href = poptin["wix_product_settings"]["product_url"];
                        }
                        break;
                    default:
                        break;
                }
            } else if(poptin["wix_product_settings"]["buttons_action"] == "redirect" || poptin["wix_product_settings"]["buttons_action"] == "redirect_blank") {
                if (poptin["wix_product_settings"]["buttons_action"] == "redirect_blank") {
                var tagRefId = "poptin_spr_"+poptin["wix_product_settings"]["product_id"]+"_"+poptin["wix_product_settings"]["variant_id"];
                var tagToAppend = '<a id="'+tagRefId+'" href="'+poptin["wix_product_settings"]["product_url"]+'" target="_blank"></a>';
                jQ224( "body" ).append( tagToAppend );
                jQ224( "#"+tagRefId )[0].click();
                jQ224( "#"+tagRefId )[0].remove();
                } else {
                window.location.href = poptin["wix_product_settings"]["product_url"];
            }
            }

        closePoptin(poptin.poptin_id);
        }

        async function wixAddToCurrentCart(options) {
            try {
                const cart = await wixGetCurrentCart();

                if (cart == null) { // Create a new cart if one doesn't exist
                    const response = await poptinWixAuthorizedClient.fetchWithAuth('https://www.wixapis.com/ecom/v1/carts', {
                        method: 'POST',
                        body: JSON.stringify(options),
                    });
                    const createCartData = await response.json();
                    console.log({createCartData})
                    return createCartData;
                }

                const addToCartResponse = await poptinWixAuthorizedClient.fetchWithAuth(`https://www.wixapis.com/ecom/v1/carts/${cart.id}/add-to-cart`, {
                    method: 'POST',
                    body: JSON.stringify(options),
                });
                const addToCartData = await addToCartResponse.json();
                console.log({addToCartData});
                return addToCartData;
            } catch (error) {
                console.error('add to cart error', error);
            }
        }

        async function wixGetCurrentCart() {
            try {
                const response = await poptinWixAuthorizedClient.fetchWithAuth('https://www.wixapis.com/ecom/v1/carts/current', {
                    method: 'GET',
                });

                if (!response.ok) {
                    if (response.status === 404) {
                        return null;
                    }

                    throw new Error('Error getting current cart: ' + response.statusText);
                }

                const data = await response.json();
                return data.cart;
            } catch (error) {
                console.error('Error getting current cart:', error);
                throw error;
            }
        }

    /**
        * Trigger functions: submitPoptin()
        * parameters       : poptin:object
        * Desc             : Add product to cart if shopify add to cart is there
        */
    function handeShopifyAddToCart(poptin, addToCart, btn_id = '',count_conversion='',el = null){
        showLog('handeShopifyAddToCart: '+poptin.poptin_id);

        if(addToCart) {
            var add_to_cart = poptin.design_properties.add_to_cart != null ? poptin.design_properties.add_to_cart.split('@') : '';
        }else{
            if(btn_id === "poptinForm2ndlinkbtnText")
                var add_to_cart = poptin.design_properties.shopify_add_to_cart_2 != null ? poptin.design_properties.shopify_add_to_cart_2.split('@') : '';
            else if(btn_id === "poptinForm3ndlinkbtnText")
                var add_to_cart = poptin.design_properties.shopify_add_to_cart_3 != null ? poptin.design_properties.shopify_add_to_cart_3.split('@') : '';
            else if(btn_id === "poptinForm4thlinkbtnText")
                var add_to_cart = poptin.design_properties.shopify_add_to_cart_4 != null ? poptin.design_properties.shopify_add_to_cart_4.split('@') : '';
            else if(btn_id === "poptinForm5thlinkbtnText")
                var add_to_cart = poptin.design_properties.shopify_add_to_cart_5 != null ? poptin.design_properties.shopify_add_to_cart_5.split('@') : '';
            else if(btn_id === "poptinForm6thlinkbtnText")
                var add_to_cart = poptin.design_properties.shopify_add_to_cart_6 != null ? poptin.design_properties.shopify_add_to_cart_6.split('@') : '';
        }

        if(add_to_cart && Array.isArray(add_to_cart)){
            var product_id = add_to_cart[0] || 0;
            var product_qty = add_to_cart[1] || 0;
            var reload_type = parseInt(add_to_cart[2]) || 0;
            var reload_page = add_to_cart[3] || '';

            jQ224.ajax({
                url: '/cart/add.js',
                type: "POST",
                async: true,
                data: {
                    items: [
                        {
                            quantity: product_qty,
                            id: product_id
                        }
                    ]
                },
                statusCode: {
                    422: function(responseObject, textStatus, jqXHR) {
                        console.log("422 error");
                    }
                },
                complete: function(resp) {
                    if(reload_type === 1){
                        // window.location.href = reload_page;


                        // var ur_regex_check = /^(https?:\/\/)?([a-z0-9.-]+)\.([a-z]{2,})(:[0-9]{1,5})?(\/.*)?$/i;
                        //  if(ur_regex_check.test(reload_page)){
                        //     window.location.href = (reload_page);
                        //  }else{
                        //     var store_language_route = shopifylanguageRoute() == '/' ? '' : shopifylanguageRoute();
                        //     var cart_redirection_url =  window.location.protocol + "//" + Shopify.shop + store_language_route + reload_page;
                        //         window.location.assign(cart_redirection_url);
                        //  }

                        var store_language_route = shopifylanguageRoute() == '/' ? '' : shopifylanguageRoute();
                        var cart_redirection_url =  window.location.protocol + "//" + Shopify.shop + store_language_route + '/cart';
                        window.location.assign(cart_redirection_url);
                    }else{
                        window.location.reload();
                    }
                }
            });

        } else {
            // redirect user to poptin redirect page
            if(count_conversion !== "") {
                buttonRedirectAfterClick(poptin, el);
            }else{
                redirectAfterConversion(poptin);
            }
        }
    }

        /**
         * Utility function to check if a redirect should open in a new tab
         * parameters: poptin_id: string
         * returns: boolean (true if should open in new tab, false if should open in same tab)
         */
        function shouldOpenRedirectInNewTab(poptin_id) {
            // Primary check: stored redirect_target
            let shouldOpenInNewTab = window.poptins[poptin_id]?.redirect_target?.toLowerCase() === "_blank";

            // Fallback 1: check DOM element
            if (!shouldOpenInNewTab) {
                const redirectElement = jQ224('[data-poptin-id='+poptin_id+']').find('.redirect-url-blank');
                if (redirectElement.length > 0) {
                    const elementTarget = redirectElement.prop('target');
                    shouldOpenInNewTab = elementTarget && elementTarget.toLowerCase() === '_blank';
                    showLog('Fallback check - element target:', elementTarget);
                }
            }

            // Fallback 2: check persistent values
            if (!shouldOpenInNewTab && window.poptins[poptin_id]?._persistent_redirect?.target) {
                const persistentTarget = window.poptins[poptin_id]._persistent_redirect.target;
                shouldOpenInNewTab = persistentTarget && persistentTarget.toLowerCase() === '_blank';
                showLog('Persistent fallback check - target:', persistentTarget);
            }

            showLog('shouldOpenRedirectInNewTab result for poptin ' + poptin_id + ':', shouldOpenInNewTab);
            return shouldOpenInNewTab;
        }

        /**
         * Utility function to open a URL in a new tab with fallbacks
         * parameters: url: string, poptin_id: string, context: string
         * returns: boolean (true if successful, false if fallback needed)
         */
        function openUrlInNewTab(url, poptin_id, context = '') {
            showLog(context + ' - Attempting to open in new tab:', url);

            // Method 1: Try window.open
            let newWindow = null;
            try {
                newWindow = window.open(url, "_blank");
            } catch (e) {
                showLog(context + ' - window.open failed with error:', e);
            }

            // Method 2: If window.open failed, try creating a temporary anchor element
            if (!newWindow || newWindow.closed || typeof newWindow.closed == 'undefined') {
                showLog(context + ' - Popup blocked, trying alternative method with anchor element');
                try {
                    const tempLink = document.createElement('a');
                    tempLink.href = url;
                    tempLink.target = '_blank';
                    tempLink.rel = 'noopener noreferrer';
                    tempLink.style.display = 'none';
                    document.body.appendChild(tempLink);
                    tempLink.click();
                    document.body.removeChild(tempLink);

                    // Check if it worked
                    setTimeout(() => {
                        if (window.opener || window.name !== window.name) {
                            showLog(context + ' - Alternative method succeeded');
                        } else {
                            showLog(context + ' - Alternative method failed, will use fallback');
                        }
                    }, 100);

                    return false; // Indicate fallback is needed
                } catch (e) {
                    showLog(context + ' - Alternative method failed with error:', e);
                    return false; // Indicate fallback is needed
                }
            } else {
                showLog(context + ' - Successfully opened in new tab');
                return true; // Success
            }
        }

        /**
         * Utility function to handle redirect with new tab logic
         * parameters: url: string, poptin_id: string, shouldOpenInNewTab: boolean, context: string, fallbackFunction: function
         */
        function handleRedirect(url, poptin_id, shouldOpenInNewTab, context, fallbackFunction) {
            if (shouldOpenInNewTab) {
                const success = openUrlInNewTab(url, poptin_id, context);
                if (!success && fallbackFunction) {
                    showLog(context + ' - Using fallback function');
                    fallbackFunction();
                }
            } else {
                showLog(context + ' - Using same tab redirect');
                fallbackFunction();
            }
        }

        /**
         * Simple utility function for button redirects (no complex fallbacks needed)
         * parameters: url: string, shouldOpenInNewTab: boolean
         */
        function simpleButtonRedirect(url, shouldOpenInNewTab) {
            if (shouldOpenInNewTab) {
                window.open(url, '_blank');
            } else {
                window.location.href = url;
            }
        }

        /**
         * Trigger functions: submitPoptin(), poptinConversion()
         * parameters       : poptin:object
         * Desc             : Redirect visitor to poptin redirect page after poptin submit
         */
        function redirectAfterConversion(poptin){
            showLog('redirectAfterConversion: '+poptin.poptin_id);

            var _this = jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+']');
            var redirectPoptinType = _this.attr('data-redirect-poptin');
            var redirectPoptinId = _this.attr('data-redirect-poptin-id') || '';
            var shouldRedirectToPoptin = redirectPoptinType == "true" && redirectPoptinId.length == 13;
            var shouldUseStoreRedirect = redirectPoptinType == "shopify" || redirectPoptinType == "wix";

            if (window.poptins[poptin.poptin_id].redirect_flag!= undefined && !window.poptins[poptin.poptin_id].redirect_flag ){

                if (!shouldRedirectToPoptin && !shouldUseStoreRedirect){
                    setTimeout(function() {
                        if (window.poptins[poptin.poptin_id].redirect_url !== undefined && window.poptins[poptin.poptin_id].redirect_flag!=undefined && !window.poptins[poptin.poptin_id].redirect_flag){
                            showLog('redirectAfterConversion - About to call poptinRedirectToUrl with direct type');
                            showLog('redirectAfterConversion - redirect_url:', window.poptins[poptin.poptin_id].redirect_url);
                            showLog('redirectAfterConversion - redirect_target:', window.poptins[poptin.poptin_id].redirect_target);
                            poptinRedirectToUrl(poptin,'direct',false);
                        }
                    },50);
                }
            }

            if(poptin.poptin_type == "mobile"){
                if(
                    poptin.poptin_format == "format_1" ||
                    poptin.poptin_format == "format_6" ||
                    poptin.poptin_format == "format_11" ||
                    (!shouldRedirectToPoptin && !shouldUseStoreRedirect && typeof poptin.design_properties.poptin_design_redirect != 'undefined')
                ) {
                    setTimeout(function() {
                        showLog('redirectAfterConversion - Mobile redirect calling poptinRedirectToUrl with direct type');
                        poptinRedirectToUrl(poptin,'direct',false);
                    },50);
                }
            }
        }

        //*****************************

        /**
         * Trigger functions: redirectAfterConversion(), ifLinkConversion()
         * parameters       : poptin:object | type: string | click_type:string
         * Desc             : Handle redirect to url after poptin conversion
         */
        function poptinRedirectToUrl(poptin,type,click_type){
            showLog('poptinRedirectToUrl - Function called');
            showLog('poptinRedirectToUrl - Parameters:', {poptin_id: poptin.poptin_id, type: type, click_type: click_type});
            showLog('poptinRedirectToUrl - send_form_data enabled:', poptin.design_properties.poptin_design_redirect_send_form_data);

            // Ensure window.poptins object is initialized
            if (!window.poptins) {
                window.poptins = {};
            }
            if (!window.poptins[poptin.poptin_id]) {
                window.poptins[poptin.poptin_id] = {};
            }

            showLog('poptinRedirectToUrl - redirect_url stored:', window.poptins[poptin.poptin_id]?.redirect_url);
            showLog('poptinRedirectToUrl - redirect_target stored:', window.poptins[poptin.poptin_id]?.redirect_target);

            if (poptin.design_properties.poptin_design_redirect_send_form_data){
                showLog('poptinRedirectToUrl1');
                if (type=='click'){
                    showLog('poptinRedirectToUrl1.1');
                    var url = jQ224('[data-poptin-id='+poptin.poptin_id+']').find(click_type).attr('href');
                    url_conversion_query = url_conversion_query == '' ? getPoptinConversionFields(poptin) : url_conversion_query;
                    url = onlyOneQuestionMark(url,url_conversion_query);
                    var url_array = url.split('?');
                    var url_domain = url_array[0];
                    url_array.shift();
                    url = url_domain+'?'+(url_array.join('&'));
                    let newLocation = url;
                    var close_thank_screen_sec = 0;

                    if(ifMobilePoptin){
                        showLog('poptinRedirectToUrl1.1 ifMobilePoptin');
                        // Use common function to check if redirect should open in new tab
                        const shouldOpenInNewTab = shouldOpenRedirectInNewTab(poptin.poptin_id);

                        if (shouldOpenInNewTab){
                            showLog('Opening mobile redirect in new tab:', newLocation);
                            const success = openUrlInNewTab(newLocation, poptin.poptin_id, 'Mobile');
                            if (!success) {
                                showLog('Mobile fallback to click redirect');
                                jQ224('[data-poptin-id='+poptin.poptin_id+']').append('<a id="poptin-mob-redirection-'+poptin.poptin_id+'" href="'+newLocation+'" style="display:none"></a>');
                                document.getElementById('poptin-mob-redirection-'+poptin.poptin_id).click();
                            }
                        } else {
                            showLog('Using mobile click redirect:', newLocation);
                            jQ224('[data-poptin-id='+poptin.poptin_id+']').append('<a id="poptin-mob-redirection-'+poptin.poptin_id+'" href="'+newLocation+'" style="display:none"></a>');
                            document.getElementById('poptin-mob-redirection-'+poptin.poptin_id).click();
                        }
                    }
                    if(
                        poptin.design_properties.poptin_design_thank_screen != undefined &&
                        poptin.design_properties.poptin_design_thank_screen_auto_close != undefined &&
                        poptin.design_properties.poptin_design_thank_screen_auto_close_sec != undefined
                    ) {
                        close_thank_screen_sec = parseInt(poptin.design_properties.poptin_design_thank_screen_auto_close_sec);
                    }
                    // Use common function to check if redirect should open in new tab
                    const shouldOpenInNewTab = shouldOpenRedirectInNewTab(poptin.poptin_id);

                    // Always try to click immediately if element exists and is connected
                    const clickElement = jQ224('[data-poptin-id='+poptin.poptin_id+']').find(click_type);
                    if (clickElement.length > 0 && clickElement[0].isConnected) {
                        showLog('poptinRedirectToUrl1.1 - element found and connected, processing redirect');
                        clickElement.attr('href',newLocation);

                        if (shouldOpenInNewTab) {
                            showLog('Opening desktop redirect in new tab:', newLocation);
                            const success = openUrlInNewTab(newLocation, poptin.poptin_id, 'Desktop');
                            if (!success) {
                                showLog('Desktop fallback to same tab redirect');
                                window.location.href = newLocation;
                            }
                        } else {
                            showLog('Using desktop element click redirect:', newLocation);
                            clickElement[0].click();
                        }

                        window.poptins[poptin.poptin_id].redirect_flag=true;
                    } else {
                        showLog('poptinRedirectToUrl1.1 - element not found or disconnected, redirecting directly');
                        handleRedirect(newLocation, poptin.poptin_id, shouldOpenInNewTab, 'Desktop Element Not Found',
                            () => window.location.href = newLocation);
                    }

                    // Also set timeout as backup redirect - but only if NOT opening in new tab
                    if (!shouldOpenInNewTab) {
                        setTimeout(function() {
                            showLog('poptinRedirectToUrl1.1 timeout - executing backup redirect (same tab only)');
                            handleRedirect(newLocation, poptin.poptin_id, shouldOpenInNewTab, 'Desktop Backup Timeout',
                                () => window.location.href = newLocation);
                        }, close_thank_screen_sec * 1000 );
                    } else {
                        showLog('poptinRedirectToUrl1.1 - Skipping backup redirect timeout since opening in new tab');
                        // Set redirect_flag to true to prevent any other redirect attempts
                        window.poptins[poptin.poptin_id].redirect_flag = true;
                    }

                }else{
                    showLog('poptinRedirectToUrl1.2');
                    // Fix: Use onlyOneQuestionMark to properly handle URL parameters when send_form_data is enabled
                    var newLocation = onlyOneQuestionMark(window.poptins[poptin.poptin_id].redirect_url, url_conversion_query);

                    // Add comprehensive logging for debugging
                    showLog('poptinRedirectToUrl1.2 - send_form_data enabled');
                    showLog('Original redirect_url:', window.poptins[poptin.poptin_id].redirect_url);
                    showLog('url_conversion_query:', url_conversion_query);
                    showLog('Final newLocation:', newLocation);
                    showLog('redirect_target value:', window.poptins[poptin.poptin_id].redirect_target);
                    showLog('redirect_target type:', typeof window.poptins[poptin.poptin_id].redirect_target);
                    showLog('redirect_target === "_blank":', window.poptins[poptin.poptin_id].redirect_target === "_blank");

                    if(ifMobilePoptin){
                        showLog('poptinRedirectToUrl1.2 ifMobilePoptin');
                        // Use common function to check if redirect should open in new tab
                        const shouldOpenInNewTabMobile = shouldOpenRedirectInNewTab(poptin.poptin_id);

                        if (shouldOpenInNewTabMobile){
                            showLog('Opening mobile redirect in new tab:', newLocation);
                            const success = openUrlInNewTab(newLocation, poptin.poptin_id, 'Mobile');
                            if (!success) {
                                showLog('Mobile fallback to click redirect');
                                jQ224('[data-poptin-id='+poptin.poptin_id+']').append('<a id="poptin-mob-redirection-'+poptin.poptin_id+'" href="'+newLocation+'" style="display:none"></a>');
                                document.getElementById('poptin-mob-redirection-'+poptin.poptin_id).click();
                            }
                        } else {
                            showLog('Using mobile click redirect:', newLocation);
                            jQ224('[data-poptin-id='+poptin.poptin_id+']').append('<a id="poptin-mob-redirection-'+poptin.poptin_id+'" href="'+newLocation+'" style="display:none"></a>');
                            document.getElementById('poptin-mob-redirection-'+poptin.poptin_id).click();
                        }
                    }

                    // Use common function to check if redirect should open in new tab
                    const shouldOpenInNewTab = shouldOpenRedirectInNewTab(poptin.poptin_id);

                    if (shouldOpenInNewTab){
                        showLog('Opening desktop redirect in new tab:', newLocation);
                        const success = openUrlInNewTab(newLocation, poptin.poptin_id, 'Desktop');
                        if (!success) {
                            showLog('Desktop fallback to same tab redirect');
                            setTimeout(function(){ window.location.href = newLocation; },200);
                        }
                    } else {
                        showLog('Using desktop location.href redirect:', newLocation);
                        setTimeout(function(){ window.location.href = newLocation; },200);
                    }
                    // window.location.href = newLocation;
                }
            }else{
                showLog('poptinRedirectToUrl - send_form_data NOT enabled, using direct redirect');
                const direct_case_anchorTag = jQ224('[data-poptin-id='+poptin.poptin_id+']').find(".redirect-url-blank");
                const direct_case_anchorTagTargetProp = direct_case_anchorTag.prop("target");
                showLog('poptinRedirectToUrl2 - Direct case anchor tag found:', direct_case_anchorTag.length > 0);
                showLog('poptinRedirectToUrl2 - Direct case target prop:', direct_case_anchorTagTargetProp);
                if (type==='click'){
                    showLog('poptinRedirectToUrl2.1');
                    window.poptins[poptin.poptin_id].redirect_flag=true;
                    var close_thank_screen_sec = 0;
                    if(
                        poptin.design_properties.poptin_design_thank_screen != undefined &&
                        poptin.design_properties.poptin_design_thank_screen_auto_close != undefined &&
                        poptin.design_properties.poptin_design_thank_screen_auto_close_sec != undefined
                    ) {
                        close_thank_screen_sec = parseInt(poptin.design_properties.poptin_design_thank_screen_auto_close_sec);
                    }
                    setTimeout(function() {
                        showLog('poptinRedirectToUrl2.1 timeout');

                        var convUrl = window.location.href;
                        var convPath = window.location.pathname + window.location.search;
                        var newLocation = window.poptins[poptin.poptin_id].redirect_url;
                        showLog("newLocation", newLocation);

                        const anchorTag = jQ224(`[data-poptin-id=${poptin.poptin_id}]`).find(click_type);
                        const isBlankTarget = anchorTag.prop("target") === "_BLANK";
                        const finalUrl = newLocation
                            ? newLocation
                                .replace(/\{conversion_url\}|%7Bconversion_url%7D/g, `conversion_url=${encodeURI(convUrl)}`)
                                .replace(/\{path_url\}|%7Bpath_url%7D/g, `path_url=${encodeURI(convPath)}`)
                            : anchorTag.attr('href');

                        if (isBlankTarget) {
                            const success = openUrlInNewTab(finalUrl, poptin.poptin_id, 'poptinRedirectToUrl2.1');
                            if (!success) {
                                showLog('Popup blocked, falling back to same tab redirect');
                                window.location.href = finalUrl;
                            }
                        } else {
                            window.location.href = finalUrl;
                        }

                        if(ifMobilePoptin && newLocation){
                            showLog('poptinRedirectToUrl2.1 timeout ifMobilePoptin');
                            jQ224('[data-poptin-id='+poptin.poptin_id+']').append('<a id="poptin-mob-redirection-'+poptin.poptin_id+'" href="'+newLocation+'" style="display:none"></a>');
                            // document.getElementById('poptin-mob-redirection-'+poptin.poptin_id).click();
                        }
                        //window.location.href = newLocation;
                    }, close_thank_screen_sec * 1000 );
                }else{
                    if(click_type === "gamified"){
                        showLog('poptinRedirectToUrl2.2');
                        var close_screen_sec = poptin.wheel_has_coupon ? default_close_delay * 3 : default_close_delay;
                        if(
                            poptin.gamified_prize &&
                            poptin.gamified_prize.redirect_to == true &&
                            poptin.gamified_prize.redirect_to_options.redirect_close == true &&
                            poptin.gamified_prize.redirect_to_options.redirect_close_delay != undefined
                        ){
                            close_screen_sec = parseInt(poptin.gamified_prize.redirect_to_options.redirect_close_delay);
                        }
                        setTimeout(function() {
                            window.location.href = poptin.gamified_prize.redirect_to_options.redirect_to_url;
                        }, close_screen_sec * 1000 );
                    }else{
                        showLog('poptinRedirectToUrl2.3');
                        let newLocation = window.poptins[poptin.poptin_id].redirect_url;
                        if(ifMobilePoptin){
                            showLog('poptinRedirectToUrl2.2 ifMobilePoptin');
                            // Use common function to check if redirect should open in new tab
                            const shouldOpenInNewTabMobile = shouldOpenRedirectInNewTab(poptin.poptin_id);

                            if (shouldOpenInNewTabMobile) {
                                showLog('Opening mobile redirect in new tab:', newLocation);
                                const success = openUrlInNewTab(newLocation, poptin.poptin_id, 'Mobile poptinRedirectToUrl2.3');
                                if (!success) {
                                    showLog('Mobile fallback to click redirect');
                                    jQ224('[data-poptin-id='+poptin.poptin_id+']').append('<a id="poptin-mob-redirection-'+poptin.poptin_id+'" href="'+newLocation+'" style="display:none"></a>');
                                    document.getElementById('poptin-mob-redirection-'+poptin.poptin_id).click();
                                }
                            } else {
                                showLog('Using mobile click redirect:', newLocation);
                                jQ224('[data-poptin-id='+poptin.poptin_id+']').append('<a id="poptin-mob-redirection-'+poptin.poptin_id+'" href="'+newLocation+'" style="display:none"></a>');
                                document.getElementById('poptin-mob-redirection-'+poptin.poptin_id).click();
                            }
                        }
                        // window.location.href = newLocation;

                        // Use common function to check if redirect should open in new tab
                        const shouldOpenInNewTab = shouldOpenRedirectInNewTab(poptin.poptin_id);

                        if (shouldOpenInNewTab){
                            const success = openUrlInNewTab(newLocation, poptin.poptin_id, 'poptinRedirectToUrl2.3');
                            if (!success) {
                                showLog('Popup blocked, falling back to same tab redirect');
                                setTimeout(function(){ window.location.href = newLocation; },200);
                            }
                        } else {
                            setTimeout(function(){ window.location.href = newLocation; },200);
                        }
                    }
                }
            }
        }

        /**
         * Trigger functions: poptinRedirectToUrl()
         * parameters       : url:string | url_conversion_query: string
         * Desc             : return link with only one Question Mark
         */
        function onlyOneQuestionMark(url,url_conversion_query){
            showLog("onlyOneQuestionMark - Input url:", url);
            showLog("onlyOneQuestionMark - Input url_conversion_query:", url_conversion_query);
            showLog("onlyOneQuestionMark - url.indexOf('?'):", url.indexOf('?'));

            // If URL has no query parameters, just append the new ones
            if (url.indexOf('?') === -1){
                var finalUrl = url + url_conversion_query;
                showLog("onlyOneQuestionMark - URL has no ?, keeping original: new_conversion_query =", url_conversion_query);
                showLog("onlyOneQuestionMark - Final result:", finalUrl);
                return finalUrl;
            }

            // Parse existing URL parameters
            var urlObj = new URL(url);
            var existingParams = new URLSearchParams(urlObj.search);

            // Parse new conversion query parameters
            var newParams = new URLSearchParams(url_conversion_query[0] === '?' ? url_conversion_query.slice(1) : url_conversion_query);

            // Merge parameters: only replace if values are exactly the same, otherwise keep existing
            newParams.forEach(function(value, key) {
                if (existingParams.has(key)) {
                    // If the existing value is exactly the same, replace it
                    if (existingParams.get(key) === value) {
                        existingParams.set(key, value);
                    }
                    // If values are different, keep the existing one (don't overwrite)
                } else {
                    // Parameter doesn't exist, add it
                    existingParams.set(key, value);
                }
            });

            // Reconstruct the URL
            var finalUrl = urlObj.origin + urlObj.pathname + (existingParams.toString() ? '?' + existingParams.toString() : '');
            showLog("onlyOneQuestionMark - URL already has ?, merged parameters: finalUrl =", finalUrl);
            showLog("onlyOneQuestionMark - Final result:", finalUrl);
            return finalUrl;
        }

        /**
         * Trigger functions: poptinConversion()
         * parameters       : poptin:object
         * Desc             : get conversion field data and convert it to url query
         */
        function getPoptinConversionFields(poptin){
            var poptin_fields = new Array();
            var poptin_fields_temp = new Array();
            var field_type_arr = {};
            var field_value = new Array();
            var fields = poptin.poptin_fields;
            // convert fields to object
            var customFields = {};
            fields.forEach(field => {
                if(field) {
                    customFields[field.tag] = field;
                }
            });

            jQ224( "[data-poptin-id="+poptin.poptin_id+"] #poptinFormSubmit"+poptin.poptin_id+" .poptin-design-fields-form").each(function(){
                var field_key = '';
                var this_count = 0;
                var this_type = this.type;
                var this_id = this.id;
                var this_name = this.name;
                var this_short_name = "";
                var this_placeholder = jQ224(this).attr("placeholder");
                var this_value = this.value;

                // Find parent elements with metadata - check parents FIRST, then element itself
                var parentFormInput = jQ224(this).closest('.form-input-class');
                var parentWithPropertyName = jQ224(this).closest('[data-property-name]');

                // Get created version to check if property_name should be used
                var thisCreatedVer = parentFormInput.attr('data-created-ver') || parentWithPropertyName.attr('data-created-ver') || jQ224(this).attr('data-created-ver');

                // Get property name for version 9 and above
                // First try data-property-name attribute, then fall back to poptin_fields JSON
                var this_property_name = null;
                if (parseInt(thisCreatedVer) >= 9) {
                    // Search all parent elements for non-empty data-property-name
                    var foundPropertyName = null;
                    jQ224(this).parents('[data-property-name]').each(function() {
                        var propValue = jQ224(this).attr('data-property-name');
                        if (propValue && propValue.trim() !== '') {
                            foundPropertyName = propValue.trim();
                            return false; // Stop iteration once found
                        }
                    });

                    // Fallback to element itself if no parent has it
                    if (!foundPropertyName) {
                        var elementProp = jQ224(this).attr('data-property-name');
                        if (elementProp && elementProp.trim() !== '') {
                            foundPropertyName = elementProp.trim();
                        }
                    }

                    // If data-property-name not found, try poptin_fields JSON
                    if (!foundPropertyName && poptin.poptin_fields) {
                        foundPropertyName = getPropertyNameFromPoptinFields(this_id, this_name, poptin.poptin_fields);
                    }

                    this_property_name = foundPropertyName;
                }
                if(typeof field_value[this_name] == "undefined"){
                    field_value[this_name] = "";
                }
                // showLog(this_name, this_type, this_value, this_id, this.tagName);

                var isValueString = this_value && typeof this_value === 'string';

                if (this_name.indexOf('poptinDesignInputTextField') >=0){
                    field_key = this_name.split('poptinDesignInputTextField')[1];
                    if(this_id == "poptinDesignInputTextFieldCheckbox"){
                        field_key = "consent";
                        field_value[this_name] = this.checked ? "yes" : "no";
                    }else{
                        field_key = field_key;
                        field_value[this_name] = this_value;
                    }
                    this_count = 1;
                } else if (this_name.indexOf('poptinDesignInputFreeField') >=0){
                    field_key = this_name.split('poptinDesignInput')[1];
                    field_value[this_name] = isValueString && this_value.indexOf('=&=b:') > -1 ? this_value.split('=&=b:')[1] : this_value;
                    this_count = field_type_arr[field_key] = (field_type_arr[field_key] || 0) + 1;
                } else if (this_name.indexOf('poptinDesignRadioField') >=0 || this_name.indexOf('poptinDesignCheckboxField') >=0){
                    if(this.checked){
                        field_key = this_name;
                        field_value[this_name] = isValueString && this_value.indexOf('=&=b:') > -1 ? this_value.split('=&=b:')[1] : this_value;
                        this_count = field_type_arr[field_key] = (field_type_arr[field_key] || 0) + 1;
                    }
                } else if(this.tagName == "SELECT") {;
                    field_key = this_placeholder;
                    field_value[this_name] = this_value;
                } else {
                    // showLog("this_id", this_id);
                    if(this_id.includes("poptinDesignInputCustomField-CUSTOM_")){
                        this_short_name = this_id.split("poptinDesignInputCustomField-CUSTOM_")[1];
                    } else if(this_id.includes("poptinDesignPreferenceField")) {
                        this_name = "poptinDesignPreferenceField";
                        this_short_name = "Preference";
                    } else {
                        this_short_name = this_placeholder;
                    }
                    field_key = this_name == undefined ? this.tagName : this_name;
                    if(this_type == "checkbox"){
                        if(typeof field_value[this_name] == "string"){
                            field_value[this_name] = new Array();
                        }
                        if(this.checked){
                            field_value[this_name].push(this_value);
                        }
                    } else if(this_type == "radio"){
                        if(this.checked){
                            field_value[this_name] = this_value;
                        }
                    } else {
                        field_value[this_name] = this_value;
                    }
                    this_count = field_type_arr[this.type] = (field_type_arr[this.type] || 0) + 1;
                }
                if(jQ224(this).attr("data-multiple") == "true"){
                    var selectedInputParent = jQ224(this).parent();
                    var thisMultiSelectTexts = [];
                    var thisMultiSelectValues = [];
                    selectedInputParent.find('.poptin-multi-select input[type="checkbox"]:checked').each(function() {
                        thisMultiSelectTexts.push(jQ224(this).parent().text().trim());
                        thisMultiSelectValues.push(jQ224(this).val());
                    });
                    // showLog(thisMultiSelectTexts, thisMultiSelectValues);
                    field_value[this_name] = thisMultiSelectValues.join(",");
                }
                // showLog("field_key", field_key, JSON.stringify(field_value[this_name]));
                field_key = field_key ? field_key.toLowerCase().replace(/[^a-zA-Z0-9]/g, '_').replace(/_+/g, '_').replace(/^_+|_+$/g, '') : "";
                // showLog("field_key", field_key, JSON.stringify(field_value[this_name]));
                if (field_key !== '' && field_value[this_name] !== ''){
                    field_value[this_name] = field_value[this_name] === '' ? field_value[this_name] : field_value[this_name];
                    poptin_fields_temp[field_key] = poptin_fields_temp[field_key] ? poptin_fields_temp[field_key] : new Array();
                    if(this_name.indexOf('poptinDesignSelectField') > -1){ this_type = 'select'; }
                    if(this_name.indexOf('poptinDesignWebsiteField') > -1){ this_type = 'url'; }
                    poptin_fields_temp[field_key] = {
                        'count':this_count,
                        'type':this_type,
                        'id':this_id,
                        "field_key":field_key,
                        "type":this_type,
                        "name":this_name,
                        "short_name":this_short_name,
                        "placeholder":this_placeholder,
                        "value":field_value[this_name],
                        "property_name":this_property_name
                    };
                }
            });
            // showLog("poptin_fields_temp", JSON.stringify(poptin_fields_temp));
            for (var field_key in poptin_fields_temp) {
                if (!poptin_fields_temp.hasOwnProperty(field_key)) continue;
                var value_obj = poptin_fields_temp[field_key];
                // showLog(field_key, JSON.stringify(value_obj));
                var name = value_obj.name.split('poptinDesignInputCustomField-')[1];
                if(field_key.indexOf('poptindesign') > -1){
                    if(field_key.includes('customfield') && value_obj.short_name != "") {
                        field_key = customFields[name] ?
                            customFields[name].label.replace(/[^a-zA-Z0-9]/g, '_').replace(/^_+|_+$/g, '').toLowerCase() : value_obj.short_name.toLowerCase();
                    }
                    else if(value_obj.short_name && value_obj.short_name != ""){
                        field_key = value_obj.short_name.toLowerCase();
                    } else {
                        field_key = value_obj.type+'_'+value_obj.count;
                    }
                } else if(value_obj.name.includes('CUSTOM') && customFields[name]) {
                    // remove all special characters from the label
                    field_key = customFields[name].label.replace(/[^a-zA-Z0-9]/g, '_').replace(/^_+|_+$/g, '').toLowerCase()
                }
                poptin_fields.push(encodeURI(field_key)+'='+encodeURI(value_obj.value));
            }
            // showLog("poptin_fields", JSON.stringify(poptin_fields));
            query_fields = poptin_fields.length > 0 ? '?' + poptin_fields.join('&') : '';
            showLog("getPoptinConversionFields - Generated query_fields:", query_fields);
            showLog("getPoptinConversionFields - poptin_fields array:", poptin_fields);
            return query_fields;
        }

        //**********************************

        /**
         * Trigger functions: submitPoptin(), poptinConversion()
         * parameters       : poptin:object
         * Desc             : Handle poptin after submit event
         * Desc             : Redirect, Thank screen, Auto close etc...
         */
        function afterPoptinSubmit(poptin,click){

            var closeThankScreenSec = 0;

            showLog('afterPoptinSubmit: '+poptin.poptin_id);

            jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container:not(.poptin-tab-container)").find('audio, #poptinyoutube, video').remove();

            if(jQ224("[data-poptin-id="+poptin.poptin_id+"]").attr("data-redirect-poptin") != 'shopify' && jQ224("[data-poptin-id="+poptin.poptin_id+"]").attr("data-redirect-poptin") != 'wix'){
                // If redirect visitor is 'on'
                if (typeof poptin.design_properties.poptin_design_redirect != 'undefined'){
                    // if visitor is mobile
                    if (poptin.poptin_type == "mobile" && poptin.design_properties.poptin_design_redirect_url.match(/^[0-9*+-]+$/) != null){
                        redirect_phone = poptin.design_properties.poptin_design_redirect_url;
                        window.poptins[poptin.poptin_id].redirect_url = (redirect_phone.match("^tel:") ? redirect_phone : 'tel:'+redirect_phone);
                    }else if (poptin.poptin_type+'_'+poptin.poptin_format != "social_format_2" && poptin.poptin_type+'_'+poptin.poptin_format != "social_format_6" && poptin.poptin_type+'_'+poptin.poptin_format != "sside_format_19"){
                        redirect_url = window.poptins[poptin.poptin_id].redirect_url || poptin.design_properties.poptin_design_redirect_url;
                        if (redirect_url.match("^tel:") || redirect_url.match("^sms:") || redirect_url.match("^mailto:")){
                            window.poptins[poptin.poptin_id].redirect_url = redirect_url;
                        }
                        else{
                            window.poptins[poptin.poptin_id].redirect_url = ((!/^https?:\/\//i.test(redirect_url)) ? 'http://'+redirect_url : redirect_url);
                        }
                        window.poptins[poptin.poptin_id].redirect_flag = false;
                    }
                    //redirectToPoptin(poptin);
                }
            }

            // If Thank screen is 'on'
            if (poptin.design_properties.poptin_design_thank_screen != undefined){
                // If auto close thank screen is defined
                if (poptin.design_properties.poptin_design_thank_screen_auto_close != undefined){
                    if (click == undefined) {
                        ensurePoptinTrigger(poptin.poptin_id);
                        window.poptins[poptin.poptin_id].poptin_trigger.close_thank_screen_sec = ( poptin.design_properties.poptin_design_thank_screen_auto_close_sec !=  undefined ? parseInt(poptin.design_properties.poptin_design_thank_screen_auto_close_sec) : 5);
                    } else {
                        closeThankScreenSec = ( poptin.design_properties.poptin_design_thank_screen_auto_close_sec !=  undefined ? parseInt(poptin.design_properties.poptin_design_thank_screen_auto_close_sec) : 5);
                    }
                }else{
                    if (click == undefined) {
                        ensurePoptinTrigger(poptin.poptin_id);
                        window.poptins[poptin.poptin_id].poptin_trigger.close_thank_screen_sec = 60;
                    } else {
                        closeThankScreenSec = 600;
                    }
                }

                // handle poptin thank screen view
                if (poptin.poptin_type == "fullpage"){
                    var old_btn_left = jQ224("[data-poptin-id="+poptin.poptin_id+"] > #closeXButton").css("left");
                    jQ224("[data-poptin-id="+poptin.poptin_id+"] > #closeXButton").remove();
                    var thank_you_button_close_btn = jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_thank_you_screen #closeXButton").get(0).outerHTML;
                    jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_thank_you_screen #closeXButton").remove();
                    jQ224("[data-poptin-id="+poptin.poptin_id+"]").prepend(thank_you_button_close_btn);

                    jQ224('#closeXButton, #closeSkipButton').each(function(){
                        jQ224(this).css({
                        'position': 'fixed',
                        'right': 'auto',
                        'left': old_btn_left,
                        'margin': 'auto'
                        });
                    });
                }

                //Set thankyou screen button
                jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container:not(.poptin-tab-container)").css("display","none").find('.draggable.image-change-video').remove();
                jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container:not(.poptin-tab-container)").removeClass('poptin-visible poptin__animated');
                jQ224("[data-poptin-id="+poptin.poptin_id+"]").css('box-shadow','');
                //jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_thank_you_screen").css("font-family","Open Sans Hebrew").fadeIn('fast');
                //jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_thank_you_screen").fadeIn('fast');
                jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_thank_you_screen").addClass("poptin-visible poptin__animated animate__fadeIn animate__faster");
                jQ224("[data-poptin-id="+poptin.poptin_id+"] .close-x-button").show(100);

                // Handle video in thank you screen
                var thankYouScreen = jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_thank_you_screen");
                if(thankYouScreen.find('.froala-editor-video').length || thankYouScreen.find('.draggable.image-change-video').length){
                    var thankYouScreenData = thankYouScreen.find('.froala-editor-video .thumbnail-video').data();
                    var video_parent_top = thankYouScreen.find(".froala-video-wrapper").css("top"),
                        video_parent_left = thankYouScreen.find(".froala-video-wrapper").css("left"),
                        video_parent_width = thankYouScreen.find(".froala-video-wrapper").css("width"),
                        video_parent_height = thankYouScreen.find(".froala-video-wrapper").css("height");
                    var frameWrapper = thankYouScreen.find("#poptin"+thankYouScreenData.source);
                    frameWrapper.parent().css({
                        top:video_parent_top,
                        left:video_parent_left,
                        width:video_parent_width,
                        height:video_parent_height
                    });

                    var mute_video = '';
                    var is_autoplay = thankYouScreenData.autoplay;
                    if(!isFirefoxPoptin && (is_autoplay == "true" || is_autoplay == true)){mute_video = '&mute=1';}
                    thankYouScreen.find('#poptin'+thankYouScreenData.source).attr('src',thankYouScreenData.url+mute_video).parent().css('display','block');
                    thankYouScreen.find('.draggable.image-change-video').remove();
                    thankYouScreen.find('.froala-video-wrapper').css('display','none');
                }

                // Fetch and show coupon if it's attached to the thank you screen
                loadThankYouScreenCoupon(poptin);

                setTimeout(function(){
                    jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_thank_you_screen").removeClass('poptin__animated animate__fadeIn animate__faster');
                },800);
                if( poptin.poptin_type in fr_templates && fr_templates[poptin.poptin_type] >= parseInt(poptin.poptin_format.split('_')[1]) ){
                } else {
                    jQ224(document).on('click', '[data-poptin-id="'+poptin.poptin_id+'"] #closeXButton', function(){
                        closePoptinOnXclick(jQ224(this).get(0));
                    });
                }


                autoplayAttrSwitch("data-autoplay", "autoplay", "[data-poptin-id="+poptin.poptin_id+"] #poptinThankYouScreen");

                if (poptin.poptin_type == "fullpage"){
                    if (ifScrollVisible()){
                        jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] .draggable-container:not(.poptin-tab-container) .close-x-button").css({'padding-right':'25px'});
                    }
                }

                // Set mouseenter / mouseleave events
                if (parseInt(poptin.design_properties.poptin_design_close_on_screen_click)){
                    jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").on("mouseenter",function(event) {
                        if (click == undefined){
                            ensurePoptinTrigger(poptin.poptin_id);
                            window.poptins[poptin.poptin_id].poptin_trigger.poptin_area_flag_submit = true;
                        }else{
                            poptin_area_flag_submit = true;
                        }
                    }).on("mouseleave",function(event) {
                        if (click == undefined){
                            ensurePoptinTrigger(poptin.poptin_id);
                            window.poptins[poptin.poptin_id].poptin_trigger.poptin_area_flag_submit = false;
                        }else{
                            poptin_area_flag_submit = false;
                        }
                    });

                    // special event for lightbox poptin
                    if (poptin.poptin_type == "lightbox"){
                        jQ224(document).click(function(e) {
                            if(!jQ224(e.target).closest(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").length) {
                                if ( (click == undefined ? !window.poptins[poptin.poptin_id].poptin_trigger?.poptin_area_flag_submit : !poptin_area_flag_submit ) ){
                                    if(jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").is(":visible")) {
                                        showLog('close poptin'+poptin.poptin_id+' poptin_design_close_on_screen_click3');
                                        ensurePoptinTrigger(poptin.poptin_id);
                                        window.poptins[poptin.poptin_id].poptin_trigger.close_trigger = "bg_click";
                                        closePoptin(poptin.poptin_id,false,true);
                                    }
                                }
                            }
                        });
                    }
                }
            } else if( poptin.design_properties.poptin_design_thank_screen == undefined && poptin.poptin_type == "gamified" ){
                if(
                    ((poptin.poptin_format == "format_1" || poptin.poptin_format == "format_3") && poptin.gamified_prize) ||
                    (poptin.poptin_format == "format_3" && poptin.design_properties.disable_post_play_screen)
                ){
                    // Auto Close
                    if (poptin.gamified_prize && poptin.gamified_prize.redirect_to && poptin.gamified_prize.redirect_to == true){
                        if (click == undefined) {
                            ensurePoptinTrigger(poptin.poptin_id);
                            window.poptins[poptin.poptin_id].poptin_trigger.close_screen_sec = ( poptin.gamified_prize.redirect_to_options.redirect_close_delay !=  undefined ? parseInt(poptin.gamified_prize.redirect_to_options.redirect_close_delay) : 1);
                        } else {
                            closeScreenSec = ( poptin.gamified_prize.redirect_to_options.redirect_close_delay !=  undefined ? parseInt(poptin.gamified_prize.redirect_to_options.redirect_close_delay) : 1);
                        }
                    }else{
                        if (click == undefined) {
                            ensurePoptinTrigger(poptin.poptin_id);
                            window.poptins[poptin.poptin_id].poptin_trigger.close_screen_sec = 60;
                        } else {
                            closeScreenSec = 600;
                        }
                    }

                    var timeout = 0;
                    if(poptin.design_properties.disable_post_play_screen){
                        timeout = 8000;
                    }

                    setTimeout( function(){
                        // hide post play screen view
                        jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_play_screen").css("display","none");
                        jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_play_screen").removeClass('poptin-visible poptin__animated');
                        jQ224("[data-poptin-id="+poptin.poptin_id+"]").css('box-shadow','');

                        if(poptin.gamified_prize.is_winner == true){
                            show_winning_screen(poptin);
                        }else{
                            // show losing screen
                            jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_losing_screen").addClass("poptin-visible poptin__animated animate__fadeIn animate__faster");
                            setTimeout(function(){
                                jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_losing_screen").removeClass('poptin__animated animate__fadeIn animate__faster');
                            },800);
                        }
                    }, timeout);
                }

                // hide post play screen view
                if (poptin.poptin_format == "format_2") {
                    jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_play_screen").css("display","none");
                    jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_play_screen").removeClass('poptin-visible poptin__animated');
                    jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_winning_screen").addClass("poptin-visible poptin__animated animate__fadeIn animate__faster");
                }
            }else{
                setAccessibilityThankAfterSubmit(poptin);
                if (click == undefined) {
                    ensurePoptinTrigger(poptin.poptin_id);
                    window.poptins[poptin.poptin_id].poptin_trigger.close_thank_screen_sec = ifUserlangIsHe() && poptin.poptin_target !='click' ? 2 : 0.1;
                } else {
                    closeThankScreenSec = ifUserlangIsHe() && poptin.poptin_target !='click' ? 2 : 1;
                }
            }

            // Set close poptin timer
            if(poptin.poptin_type == "gamified" && poptin.poptin_format != "format_2" && poptin.gamified_prize){
                var close_screen_sec = window.poptins[poptin.poptin_id].poptin_trigger?.close_screen_sec;
                close_screen_sec = click == undefined && close_screen_sec != undefined ? close_screen_sec : closeScreenSec;
                close_screen_sec = close_screen_sec ? close_screen_sec : (poptin.wheel_has_coupon ? default_close_delay * 3 : default_close_delay);
                if( !(poptin.gamified_prize.redirect_to == true && poptin.gamified_prize.redirect_to_options.redirect_to_url != undefined) ){
                    setTimeout(function() {
                        ensurePoptinTrigger(poptin.poptin_id);
                        window.poptins[poptin.poptin_id].poptin_trigger.close_trigger = "submit";
                        closePoptin(poptin.poptin_id);
                    }, close_screen_sec * 1000);
                }
            }else if (
                (poptin.poptin_type !== "gamified" || (poptin.poptin_type == "gamified" && poptin.poptin_format !== "format_2"))
                // Everything works fine without this as well
                // && (!poptin.design_properties.disable_post_play_screen && poptin.poptin_type == "gamified" && poptin.poptin_format === "format_3")
            ) {
                ensurePoptinTrigger(poptin.poptin_id);
                if(poptin?.design_properties?.poptin_design_thank_screen && !poptin?.design_properties?.poptin_design_thank_screen_auto_close){
                    //Do Nothing
                } else {
                    setTimeout(function() {
                        ensurePoptinTrigger(poptin.poptin_id);
                        window.poptins[poptin.poptin_id].poptin_trigger.close_trigger = "submit";
                        closePoptin(poptin.poptin_id);
                    }, (click == undefined ? window.poptins[poptin.poptin_id].poptin_trigger.close_thank_screen_sec : closeThankScreenSec )*1000);
                }
            }
        }
        function show_winning_screen(poptin){
            //Replace Prize Labels & Codes
            var winnerScreenContainer = jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_winning_screen p");
            winnerScreenContainer.each(function() {
                var text = jQ224(this).html();
                if(text.indexOf("{{prize_label}}") != -1 && poptin.gamified_prize.label){
                    jQ224(this).html(text.replace("{{prize_label}}", poptin.gamified_prize.label ));
                }
                var text = jQ224(this).html();
                if(text.indexOf("{{prize_code}}") != -1 && poptin.gamified_prize.code){
                    jQ224(this).html(text.replace("{{prize_code}}", poptin.gamified_prize.code ));
                }
            });

            // show winning screen
            jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_winning_screen").addClass("poptin-visible poptin__animated animate__fadeIn animate__faster");
            setTimeout(function(){
                jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_winning_screen").removeClass('poptin__animated animate__fadeIn animate__faster');
            },800);
        }


        /**
         * Trigger functions: afterPoptinSubmit()
         * parameters       : poptin:object
         * Desc             : Trigger new popup
         */
        function redirectToPoptin(poptin){

            showLog('redirectToPoptin');
            // Set global poptin container
            if(poptin.redirectFromBtns){
                window.poptins[poptin.poptin_from].redirect_flag = true;
                $href = api_link+'/api/display/click/'+poptin.poptin_to;
                initiatePullPoptinsRequestOnClick($href,false,true)
            }else{
                var _this = jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+']');
                var redirectPoptinId = _this.attr('data-redirect-poptin-id') || '';
                if (_this.attr('data-redirect-poptin') == "true" && redirectPoptinId.length == 13){
                    window.poptins[poptin.poptin_id].redirect_flag = true;
                    // showLog('redirectToPoptin2')
                    $href = api_link+'/api/display/click/'+redirectPoptinId
                    initiatePullPoptinsRequestOnClick($href,false,true)
                }
            }

        }

        /**
         * Trigger functions: poptinConversion()
         * parameters       : poptin:object | click:Boolean (if poptin click trigger)
         * Desc             : Handle processes after poptin conversion
         * Desc             : set conversion cookie
         * Desc             : inject conversion code script like google / facebook
         */
        function handleConversionSuccess(poptin, response, count_conversion = false){

            if (poptin.poptin_type+'_'+poptin.poptin_format != 'social_format_2' && poptin.poptin_type+'_'+poptin.poptin_format != "social_format_6" && poptin.poptin_type+'_'+poptin.poptin_format != "sside_format_19"){
                //Set Cookies
                conversion_id = response.conversion_id;
                poptinSetCookie('poptin_conversion_'+poptin.poptin_id, conversion_id, 365);
            }
            //Append conversion Code To Head
            if (response.integration.conversion_code !== undefined){
                jQ224(response.integration.conversion_code).each(function($index,value){
                    jQ224('head').append(value);
                });
            }

            if (window.location.href.indexOf('biu.ac.il') > -1 && poptin.poptin_target=="lead"){
                window.location.href = app_link+"/integrations/barilan/"+response.conversion_id+"/";
            }

            // RedirectToBlankPage
            if(!count_conversion) {
                if ( poptin.poptin_type+'_'+poptin.poptin_format != 'gamified_format_3' ) {
                    ifLinkConversion(poptin);
                }
            }
        }

        /**
         * Trigger functions: showPoptin()
         * parameters       : poptin:object
         * Desc             : Ajax call with visitor data
         * Desc             : Poptin is viewed in this stage
         */
        function poptinViewed(poptin) {
            if (poptin.poptin_id === previewPoptinId) {
                return;
            }

            // Set cookies
            setOnceADayCookie(poptin);
            setPoptinViewedSession(poptin);
            setPoptinViewedUrl(poptin);
            setOnceAVisit(poptin);
            setABTestSession(poptin);

            // Get Auto pilot trigger if set
            const trigger = poptin.auto_pilot_trigger === undefined ? 'false' : poptin.auto_pilot_trigger;
            const type = ifMobilePoptin ? 'mobile' : 'desktop';
            const landing_page = window.location.href;

            const payload = {
                viewer_id: poptin.viewer_id,
                trigger: trigger,
                client_id: getClientId(),
                type: type,
                url: landing_page,
                store_integration: store_integration,
                store_integration_customer_id: store_integration_customer_id,
                converted_email: poptinGetCookie('poptin_converted_email')
            };

            // Ajax call
            jQ224.ajax({
                url: `${api_link}/api/display/viewed/${poptin.poptin_id}`,
                async: true,
                cache: true,
                dataType: 'json',
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(payload), // Send parameters as JSON in the body
            })
            .done(function(data) {
                // Setting poptin view ID
                poptinViewdArr[poptin.poptin_id] = { 'poptin_view_id': data.poptin_view_id };

                showLog(data);
                const onPoptinVisibleEvent = new CustomEvent("poptinView", {
                    bubbles: true,
                    detail: poptinEventDetails(poptin, { "event_name": "poptinView" })
                });
                document.dispatchEvent(onPoptinVisibleEvent);
            })
            .fail(function(xhr, status, error) {
                // monitorError('poptinViewed()->error()', error, status, xhr.responseText, poptin);
            });
        }



        /**
         * Trigger functions: getPoptinPosition(), appendPoptin()
         * parameters       : poptin:object
         * Desc             : Get width and height of poptin from HTML based on the data attributes
         */
        function getDataWidthHeight(poptin){
            poptin = typeof poptin == "string" ? poptin : poptin.poptin;
            poptin = poptin.trim();
            var this_poptin_width, this_poptin_height;

            var data_width = parseInt(jQ224(poptin).find('.draggable-container:not(.poptin-tab-container)').attr('data-width'));
            var data_height = parseInt(jQ224(poptin).find('.draggable-container:not(.poptin-tab-container)').attr('data-height'));
            // showLog('setPoptinSize', data_width, data_height);

            if(!isNaN(data_width) && data_width != undefined && data_width != '' && data_width != "undefined"){
                this_poptin_width = data_width;
            }
            if(!isNaN(data_height) && data_height != undefined && data_height != '' && data_height != "undefined"){
                this_poptin_height = data_height;
            }
            return { 'width' : this_poptin_width, 'height' : this_poptin_height }
        }


        /**
         * Trigger functions: setPoptin()
         * parameters       : poptin:object | click:Boolean (if poptin click trigger)
         * Desc             : Handle poptin center postion in the screen
         */
        function getPoptinPosition(poptin, click){

            // showLog('getPoptinSize2 poptinid: '+poptin.poptin_id);
            // showLog('poptin data', poptin);

            var poptin_data_width_height = getDataWidthHeight(poptin.poptin);
            // showLog('poptin data poptin_data_width_height', poptin_data_width_height);

            var this_poptin_width = poptin_data_width_height['width'];
            var this_poptin_height = poptin_data_width_height['height'];

            if( !this_poptin_width || !this_poptin_height || isNaN(this_poptin_width) || isNaN(this_poptin_height) ){
                if (poptin.poptin_type == "lightbox"){
                    this_poptin_width = this_poptin_width || litghtbox_poptin_width;
                    this_poptin_height = this_poptin_height || litghtbox_poptin_height;
                }else if (poptin.poptin_type == "bar"){
                    this_poptin_width = this_poptin_width || bar_poptin_width;
                    if (poptin.poptin_format == 'format_1' || poptin.poptin_format == 'format_6') {
                        this_poptin_height = this_poptin_height || bar_poptin_height;
                    } else if (poptin.poptin_format == 'format_2' || poptin.poptin_format == 'format_3' || poptin.poptin_format == 'format_7' || poptin.poptin_format == 'format_8') {
                        this_poptin_height = this_poptin_height || bar_poptin_height_2;
                    } else if (poptin.poptin_format == 'format_4' || poptin.poptin_format == 'format_9') {
                        this_poptin_height = this_poptin_height || bar_poptin_height_4;
                    } else if (poptin.poptin_format == 'format_5' || poptin.poptin_format == 'format_10') {
                        this_poptin_height = this_poptin_height || bar_poptin_height_5;
                    } else if (poptin.poptin_format == 'format_18') {
                        this_poptin_height = this_poptin_height || bar_poptin_height_18;
                    }
                }else if (poptin.poptin_type == "sside"){
                    if (poptin.poptin_format === 'format_1' || poptin.poptin_format === 'format_5'){
                        this_poptin_width = this_poptin_width || sside_poptin_width;
                        this_poptin_height = this_poptin_height || sside_poptin_height;
                    }else if (poptin.poptin_format === 'format_4' || poptin.poptin_format === 'format_8'){
                        this_poptin_width = this_poptin_width || sside_poptin_width_4;
                        this_poptin_height = this_poptin_height || sside_poptin_height_4;
                    }else if (poptin.poptin_format === 'format_19'){
                        this_poptin_width = this_poptin_width || sside_poptin_width_19;
                        this_poptin_height = this_poptin_height || sside_poptin_height_19;
                    }else if (poptin.poptin_format === 'format_20'){
                        this_poptin_width = this_poptin_width || sside_poptin_width_20;
                        this_poptin_height = this_poptin_height || sside_poptin_height_20;
                    }else if (poptin.poptin_format === 'format_21'){
                        this_poptin_width = this_poptin_width || sside_poptin_width_21;
                        this_poptin_height = this_poptin_height || sside_poptin_height_21;
                    }else if (poptin.poptin_format === 'format_22'){
                        this_poptin_width = this_poptin_width || sside_poptin_width_22;
                        this_poptin_height = this_poptin_height || sside_poptin_height_22;
                    }else if (poptin.poptin_format === 'format_23'){
                        this_poptin_width = this_poptin_width || sside_poptin_width_23;
                        this_poptin_height = this_poptin_height || sside_poptin_height_23;
                    }else{
                        this_poptin_width = this_poptin_width || sside_poptin_width_2;
                        this_poptin_height = this_poptin_height || sside_poptin_height;
                    }
                }else if (poptin.poptin_type == "bside"){
                    this_poptin_width = this_poptin_width || bside_poptin_width;
                    this_poptin_height = this_poptin_height || bside_poptin_height;
                }else if (poptin.poptin_type == "browsing"){
                    this_poptin_width = this_poptin_width || browsing_poptin_width;
                    this_poptin_height = this_poptin_height || browsing_poptin_height;
                }else if (poptin.poptin_type == "fullpage"){
                    this_poptin_width = this_poptin_width || "100%"; //fullpage_poptin_width;
                    this_poptin_height = this_poptin_height || "100%"; //fullpage_poptin_height;
                    if (poptin.poptin_format === 'format_4' || poptin.poptin_format === 'format_8'){
                        this_poptin_width = this_poptin_width || fullpage_poptin_width_2;
                        this_poptin_height = this_poptin_height || fullpage_poptin_height_2;
                    }
                }else if (poptin.poptin_type == "social"){
                    if (poptin.poptin_format === 'format_1' || poptin.poptin_format === 'format_5'){
                        this_poptin_width = this_poptin_width || social_poptin_width;
                        this_poptin_height = this_poptin_height || social_poptin_height;
                    }else if (poptin.poptin_format === 'format_2' || poptin.poptin_format === 'format_6'){
                        this_poptin_width = this_poptin_width || social_poptin_width_2;
                        this_poptin_height = this_poptin_height || social_poptin_height_2;
                    }else if (poptin.poptin_format === 'format_4' || poptin.poptin_format === 'format_8'){
                        this_poptin_width = this_poptin_width || social_poptin_width_4;
                        this_poptin_height = this_poptin_height || social_poptin_height_4;
                    }
                }else if (poptin.poptin_type == "mobile"){
                    this_poptin_width = this_poptin_width || mobile_poptin_width;
                    this_poptin_height = this_poptin_height || mobile_poptin_height;
                    if (poptin.poptin_format === 'format_3' || poptin.poptin_format === 'format_8'){
                        this_poptin_width = this_poptin_width || mobile_poptin_width_2;
                        this_poptin_height = this_poptin_height || mobile_poptin_height_2;
                    }else if (poptin.poptin_format === 'format_4' || poptin.poptin_format === 'format_9'){
                        this_poptin_height = this_poptin_height || mobile_poptin_height_4;
                    }else if (poptin.poptin_format === 'format_5' || poptin.poptin_format === 'format_10'){
                        this_poptin_height = this_poptin_height || mobile_poptin_height_5;
                    }
                }else if (poptin.poptin_type == "embedded"){
                    if (poptin.poptin_format === 'format_1'){
                        this_poptin_width = this_poptin_width || embedded_poptin_width_1;
                        this_poptin_height = this_poptin_height || embedded_poptin_height_1;
                    }else if (poptin.poptin_format === 'format_2'){
                        this_poptin_width = this_poptin_width || embedded_poptin_width_2;
                        this_poptin_height = this_poptin_height || embedded_poptin_height_2;
                    }else if (poptin.poptin_format === 'format_3'){
                        this_poptin_width = this_poptin_width || embedded_poptin_width_3;
                        this_poptin_height = this_poptin_height || embedded_poptin_height_3;
                    }else if (poptin.poptin_format === 'format_4'){
                        this_poptin_width = this_poptin_width || embedded_poptin_width_4;
                        this_poptin_height = this_poptin_height || embedded_poptin_height_4;
                    }else if (poptin.poptin_format === 'format_5'){
                        this_poptin_width = this_poptin_width || embedded_poptin_width_5;
                        this_poptin_height = this_poptin_height || embedded_poptin_height_5;
                    }else if (poptin.poptin_format === 'format_6'){
                        this_poptin_width = this_poptin_width || embedded_poptin_width_6;
                        this_poptin_height = this_poptin_height || embedded_poptin_height_6;
                    }else if (poptin.poptin_format === 'format_7'){
                        this_poptin_width = this_poptin_width || embedded_poptin_width_7;
                        this_poptin_height = this_poptin_height || embedded_poptin_height_7;
                    }else if (poptin.poptin_format === 'format_8'){
                        this_poptin_width = this_poptin_width || embedded_poptin_width_8;
                        this_poptin_height = this_poptin_height || embedded_poptin_height_8;
                    }else if (poptin.poptin_format === 'format_9'){
                        this_poptin_width = this_poptin_width || embedded_poptin_width_9;
                        this_poptin_height = this_poptin_height || embedded_poptin_height_9;
                    }
                }else if (poptin.poptin_type == "gamified"){
                    this_poptin_width = this_poptin_width || litghtbox_poptin_width;
                    this_poptin_height = this_poptin_height || litghtbox_poptin_height;
                }
            }

            // showLog('getPoptinPosition '+this_poptin_width+' '+this_poptin_height);

            if (poptin.poptin_type == "lightbox"){
                if (click == undefined){
                    if(window.poptins[poptin.poptin_id].poptin_size == undefined){
                        window.poptins[poptin.poptin_id].poptin_size = {
                            height: 800,
                            width: 500,
                        };
                    }
                    window.poptins[poptin.poptin_id].poptin_size.height = this_poptin_height;
                    window.poptins[poptin.poptin_id].poptin_size.width = this_poptin_width;
                }
                if (poptin.poptin_format == "format_3" || poptin.poptin_format == "format_9"){
                    litghtbox_poptin_width = litghtbox_poptin_height;
                }
                // showLog('getPoptinPosition '+litghtbox_poptin_width+' '+litghtbox_poptin_height);
                if (click==undefined)
                    window.poptins[poptin.poptin_id].position_center = {left:(screen_width - litghtbox_poptin_width)/2,up:(screen_height - litghtbox_poptin_height)/2};
                poptin_position = {left:(screen_width - litghtbox_poptin_width)/2,up:(screen_height - litghtbox_poptin_height)/2};
            }else if (poptin.poptin_type == "bar"){
                if (click==undefined)
                    window.poptins[poptin.poptin_id].position_center = {left:(screen_width - 1920)/2,up:(screen_height - 100)/2};
                poptin_position = {left:(screen_width - 1920)/2,up:(screen_height - 100)/2}
            }else if (poptin.poptin_type == "mobile" && (poptin.poptin_format == "format_3" || poptin.poptin_format == "format_8") ){
                screen_width = Math.min(screen_width, jQ224('body').outerWidth());
                if (click==undefined)
                    window.poptins[poptin.poptin_id].position_center = {left:(screen_width - 390)/2,up:(screen_height - 242)/2};
                poptin_position = {left:(screen_width - 390)/2,up:(screen_height - 242)/2}
            }else if (poptin.poptin_type == "gamified"){
                if (click == undefined){
                    if(window.poptins[poptin.poptin_id].poptin_size == undefined){
                        window.poptins[poptin.poptin_id].poptin_size = {};
                    }
                    window.poptins[poptin.poptin_id].poptin_size.height = this_poptin_height;
                    window.poptins[poptin.poptin_id].poptin_size.width = this_poptin_width;
                }
                // showLog('getPoptinPosition '+litghtbox_poptin_width+' '+litghtbox_poptin_height);
                if (click==undefined)
                    window.poptins[poptin.poptin_id].position_center = {left:(screen_width - litghtbox_poptin_width)/2,up:(screen_height - litghtbox_poptin_height)/2};
                poptin_position = {left:(screen_width - litghtbox_poptin_width)/2,up:(screen_height - litghtbox_poptin_height)/2};
            }
        }

        /**
         * Trigger functions: setPoptin(), ifAndroidPoptinKeyborad()
         * parameters       : poptin:object | click:Boolean (if poptin click trigger)
         * Desc             : Set window resize event
         */
        function windowResize(poptin,click){

            // showLog('set: windowResize()');
            // try{
            //  // showLog('windowResize()-off()');
            //  jQ224(window).off("resize");
            // }catch(err){
            //  showLog(err)
            // }
            jQ224(window).resize(function(){
                // Resize poptin to fit window screen size
                if (
                    ( poptin.poptin_type != "fullpage" && poptin.poptin_type != "browsing" ) ||
                    !( poptin.poptin_type == "fullpage" && jQ224.inArray(poptin.poptin_format, fr_templates["fullpage"]) !== -1 )
                ) {
                    setTimeout(() => {
                        doResizePoptin(poptin,click);
                    }, 100);
                }
            });
        }


        function checkElementCrossingDirection_tb(elem, cont) {
            if (typeof cont[0] != "undefined" && typeof elem[0] != "undefined") {
                var p = cont[0].getBoundingClientRect();
                var el = elem[0].getBoundingClientRect();

                var elem_dir = "";
                var elem_diff = 0;

                if (el.top < p.top) {
                    elem_dir = "top";
                    elem_diff = p.top - el.top;
                } else if (el.bottom > p.bottom) {
                    elem_dir = "bottom";
                    elem_diff = p.bottom - el.bottom;

                }
                var elem_object_ = {"direction":elem_dir,"elem_diff":elem_diff};
                return elem_object_;
            } else {
                return {};
            }
        }

        function checkElementCrossingDirection_lr(elem, cont) {
            if (typeof cont[0] != "undefined" && typeof elem[0] != "undefined") {
                var p = cont[0].getBoundingClientRect();
                var el = elem[0].getBoundingClientRect();

                var elem_dir = "";
                var elem_diff =0;
                if (el.left < p.left) {
                    elem_dir = "left";
                    elem_diff = p.left - el.left;

                } else if (el.right > p.right) {
                    elem_dir = "right";
                    elem_diff = el.right - p.right;

                }
                var elem_object_ = {"direction":elem_dir,"elem_diff":elem_diff};
                return elem_object_;
            } else {
                return {};
            }
        }

        /**
         * Trigger functions: reCaculateWidthformobile()
         * parameters       : poptin:object
         * Desc             : Calculate new width for mobile view scaling if there any element cross the poptincontainer
         */





        function reCaculateWidthformobile(poptin){
            var _this = jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+']');
            var el_left_cal = 0;
            var el_left_add = 0;
            var elmax_w =0;
            var outside_arr = new Array();
            var max_el_left_add = 0;
            var container_w = _this.css("width");
            var new_width = _this.css("width");

            jQ224(".poptin-popup[data-poptin-id=" + poptin.poptin_id + "] .element-notinside:not(.hiddenSnappingElem):visible").each(function(){
                var check_elem_lr = checkElementCrossingDirection_lr(jQ224(this),_this.find(".poptin-visible"));
                elmax_w = parseInt(jQ224(this).css("width"));

                if(!jQ224.isEmptyObject(check_elem_lr)){
                    if(check_elem_lr.direction=='left'){
                        el_left_cal = check_elem_lr.elem_diff;
                        el_left_cal = el_left_cal
                    }
                    if(check_elem_lr.direction=='right'){
                        el_left_cal = check_elem_lr.elem_diff;
                    }
                    el_left_add = el_left_cal;
                    outside_arr.push(el_left_add);

                }

            });

            if(outside_arr.length>0){
                max_el_left_add = Math.max(...outside_arr);
            }

            new_width = parseInt(container_w) + (max_el_left_add * 2);
            return {new_width, max_el_left_add};

        }

        function reCaculateheightformobile(poptin){
            var _this = jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+']');
            var el_top_cal = 0;
            var el_top_add = 0;
            var elmax_h =0;
            var outside_arr = new Array();
            var max_el_top_add = 0;
            var container_h = _this.css("height");
            var new_height = _this.css("height");


            jQ224(".poptin-popup[data-poptin-id=" + poptin.poptin_id + "] .element-notinside:not(.hiddenSnappingElem):visible").each(function(){
                var check_elem_tb = checkElementCrossingDirection_tb(jQ224(this),_this.find(".poptin-visible"));
                elmax_h= parseInt(jQ224(this).css("height"));

                if(!jQ224.isEmptyObject(check_elem_tb)){
                    if(check_elem_tb.direction=='top'){
                        el_top_cal = check_elem_tb.elem_diff;
                        el_top_cal = el_top_cal
                    }
                    if(check_elem_tb.direction=='bottom'){
                        el_top_cal = check_elem_tb.elem_diff;
                    }
                    el_top_add = el_top_cal;

                    //showLog("image_elemnt_width:"+elmax_h);
                    //showLog("image_elemnt_height_outside:"+el_top_cal);

                    outside_arr.push(el_top_add);

                }

            });
            if(outside_arr.length>0){
                max_el_top_add = Math.max(...outside_arr);
            }
            new_height=parseInt(container_h) + (max_el_top_add * 2);
            return new_height;

        }





        /**
         * Trigger functions: setPoptin(), windowResize()
         * parameters       : poptin:object | click:Boolean (if poptin click trigger)
         * Desc             : Handle poptin style, view, postion and size to fit to all window screen size(width*height)
         */
        function doResizePoptin(poptin,click) {

            var isEmbeddedPoptin = poptin.poptin_type == "embedded";
            var poptin_container = !isEmbeddedPoptin ? jQ224(window) : jQ224(".poptin-embedded[data-id='"+poptin.poptin_id+"']");

            if_responsice_flag = false;
            // showLog("doResizePoptin", poptin);

            // Set global poptin container
            var _this = jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+']');

            // Is new or old poptin
            poptin.is_new = _this.hasClass('new-popup') ? true : false;

            // Give default width and height data attributes to lightboxes
            if (poptin.poptin_type == "lightbox" || poptin.poptin_type == "gamified"){
                if( isNaN(parseInt(_this.find('.draggable-container:not(.poptin-tab-container)').attr('data-width'))) ){
                    _this.find('.draggable-container:not(.poptin-tab-container)').attr('data-width', 800);
                    _this.find('.draggable-container:not(.poptin-tab-container)').attr('data-height', 500);
                }
            }

            // Set local poptin size
            var poptin_size_width = window.poptins[poptin.poptin_id].poptin_size?.width;
            var poptin_size_height = window.poptins[poptin.poptin_id].poptin_size?.height;
            // showLog('poptin_size', poptin_size_width, poptin_size_height);

            var poptin_data_width_height = getDataWidthHeight(poptin.poptin);

            poptin_size_width = poptin_data_width_height['width'] || poptin_size_width;
            poptin_size_height = poptin_data_width_height['height'] || poptin_size_height;
            // showLog('poptin_size', poptin_size_width, poptin_size_height);

            if( isNaN(poptin_size_width) || isNaN(poptin_size_height) ){
                if (poptin.poptin_type == "lightbox"){
                    poptin_size_width = litghtbox_poptin_width;
                    poptin_size_height = litghtbox_poptin_height;
                }else if (poptin.poptin_type == "bar"){
                    poptin_size_width = bar_poptin_width;
                    if (poptin.poptin_format == 'format_1' || poptin.poptin_format == 'format_6') {
                        poptin_size_height = bar_poptin_height;
                    } else if (poptin.poptin_format == 'format_2' || poptin.poptin_format == 'format_3' || poptin.poptin_format == 'format_7' || poptin.poptin_format == 'format_8') {
                        poptin_size_height = bar_poptin_height_2;
                    } else if (poptin.poptin_format == 'format_4' || poptin.poptin_format == 'format_9') {
                        poptin_size_height = bar_poptin_height_4;
                    } else if (poptin.poptin_format == 'format_5' || poptin.poptin_format == 'format_10') {
                        poptin_size_height = bar_poptin_height_5;
                    } else if (poptin.poptin_format == 'format_18') {
                        poptin_size_height = bar_poptin_height_18;
                    }
                }else if (poptin.poptin_type == "sside"){
                    if (poptin.poptin_format === 'format_1' || poptin.poptin_format === 'format_5'){
                        poptin_size_width = sside_poptin_width;
                        poptin_size_height = sside_poptin_height;
                    }else if (poptin.poptin_format === 'format_4' || poptin.poptin_format === 'format_8'){
                        poptin_size_width = sside_poptin_width_4;
                        poptin_size_height = sside_poptin_height_4;
                    }else if (poptin.poptin_format === 'format_19'){
                        poptin_size_width = sside_poptin_width_19;
                        poptin_size_height = sside_poptin_height_19;
                    }else if (poptin.poptin_format === 'format_20'){
                        poptin_size_width = sside_poptin_width_20;
                        poptin_size_height = sside_poptin_height_20;
                    }else if (poptin.poptin_format === 'format_21'){
                        poptin_size_width = sside_poptin_width_21;
                        poptin_size_height = sside_poptin_height_21;
                    }else if (poptin.poptin_format === 'format_22'){
                        poptin_size_width = sside_poptin_width_22;
                        poptin_size_height = sside_poptin_height_22;
                    }else if (poptin.poptin_format === 'format_23'){
                        poptin_size_width = sside_poptin_width_23;
                        poptin_size_height = sside_poptin_height_23;
                    }else{
                        poptin_size_width = sside_poptin_width_2;
                        poptin_size_height = sside_poptin_height;
                    }
                }else if (poptin.poptin_type == "bside"){
                    poptin_size_width = bside_poptin_width;
                    poptin_size_height = bside_poptin_height;
                }else if (poptin.poptin_type == "browsing"){
                    poptin_size_width = browsing_poptin_width;
                    poptin_size_height = browsing_poptin_height;
                }else if (poptin.poptin_type == "fullpage"){
                    poptin_size_width = "100%"; //fullpage_poptin_width;
                    poptin_size_height = "100%"; //fullpage_poptin_height;
                    if (poptin.poptin_format === 'format_4' || poptin.poptin_format === 'format_8'){
                        poptin_size_width = fullpage_poptin_width_2;
                        poptin_size_height = fullpage_poptin_height_2;
                    }
                }else if (poptin.poptin_type == "social"){
                    if (poptin.poptin_format === 'format_1' || poptin.poptin_format === 'format_5'){
                        poptin_size_width = social_poptin_width;
                        poptin_size_height = social_poptin_height;
                    }else if (poptin.poptin_format === 'format_2' || poptin.poptin_format === 'format_6'){
                        poptin_size_width = social_poptin_width_2;
                        poptin_size_height = social_poptin_height_2;
                    }else if (poptin.poptin_format === 'format_4' || poptin.poptin_format === 'format_8'){
                        poptin_size_width = social_poptin_width_4;
                        poptin_size_height = social_poptin_height_4;
                    }
                }else if (poptin.poptin_type == "mobile"){
                    poptin_size_width = mobile_poptin_width;
                    poptin_size_height = mobile_poptin_height;
                    if (poptin.poptin_format === 'format_3' || poptin.poptin_format === 'format_8'){
                        poptin_size_width = mobile_poptin_width_2;
                        poptin_size_height = mobile_poptin_height_2;
                    }else if (poptin.poptin_format === 'format_4' || poptin.poptin_format === 'format_9'){
                        poptin_size_height = mobile_poptin_height_4;
                    }else if (poptin.poptin_format === 'format_5' || poptin.poptin_format === 'format_10'){
                        poptin_size_height = mobile_poptin_height_5;
                    }
                }else if (poptin.poptin_type == "embedded"){
                    if (poptin.poptin_format === 'format_1'){
                        poptin_size_width = embedded_poptin_width_1;
                        poptin_size_height = embedded_poptin_height_1;
                    }else if (poptin.poptin_format === 'format_2'){
                        poptin_size_width = embedded_poptin_width_2;
                        poptin_size_height = embedded_poptin_height_2;
                    }else if (poptin.poptin_format === 'format_3'){
                        poptin_size_width = embedded_poptin_width_3;
                        poptin_size_height = embedded_poptin_height_3;
                    }else if (poptin.poptin_format === 'format_4'){
                        poptin_size_width = embedded_poptin_width_4;
                        poptin_size_height = embedded_poptin_height_4;
                    }else if (poptin.poptin_format === 'format_5'){
                        poptin_size_width = embedded_poptin_width_5;
                        poptin_size_height = embedded_poptin_height_5;
                    }else if (poptin.poptin_format === 'format_6'){
                        poptin_size_width = embedded_poptin_width_6;
                        poptin_size_height = embedded_poptin_height_6;
                    }else if (poptin.poptin_format === 'format_7'){
                        poptin_size_width = embedded_poptin_width_7;
                        poptin_size_height = embedded_poptin_height_7;
                    }else if (poptin.poptin_format === 'format_8'){
                        poptin_size_width = embedded_poptin_width_8;
                        poptin_size_height = embedded_poptin_height_8;
                    }else if (poptin.poptin_format === 'format_9'){
                        poptin_size_width = embedded_poptin_width_9;
                        poptin_size_height = embedded_poptin_height_9;
                    }
                }else if (poptin.poptin_type == "gamified"){
                    poptin_size_width = litghtbox_poptin_width;
                    poptin_size_height = litghtbox_poptin_height;
                }
            }
            // showLog('poptin_size', poptin_size_width, poptin_size_height);

            _this.find('.draggable-container:not(.poptin-tab-container)').attr('data-width', poptin_size_width);
            _this.find('.draggable-container:not(.poptin-tab-container)').attr('data-height', poptin_size_height);

            // showLog('comparison', poptin_container.width(), poptin_size_width, poptin_container.height(), poptin_size_height)

            // Set new poptin size
            var best_window_width = jQ224('body').outerWidth() + 20 < jQ224(window).outerWidth() ? Math.min(jQ224(window).outerWidth(), jQ224('body').outerWidth()) : jQ224(window).outerWidth();
            this_comparable_width = isEmbeddedPoptin ? poptin_container.width() : best_window_width;
            this_comparable_height = isEmbeddedPoptin ? (poptin_container.height() != 0 ? poptin_container.height() : poptin_size_height) : window.innerHeight;
            // showLog('this_comparable', this_comparable_width, this_comparable_height);
            // showLog('poptin_size', poptin_size_width, poptin_size_height);

            window_width = poptin_container.width(); // jQ224('body').width()
            window_height = isEmbeddedPoptin ? poptin_container.height() : window.innerHeight;

            // IF poptin dmin is bigger than window && poptin_type is not 'fullpage' or is ligthbox
            if ( poptin.poptin_type != "fullpage" ) {

                //  (
                //      ( poptin_container.width() < poptin_size_width || poptin_container.height() < poptin_size_height )
                //      && poptin.poptin_type != "fullpage"
                //  ) || poptin.poptin_type == "lightbox"
                // ){

                var scale = 1;
                // if any element crossing template boundry calculate scale
                jQ224(".enable-snapping").addClass("element-notinside");
                jQ224(".elem-outofboundry").addClass("element-notinside");
                if (jQ224(".poptin-popup[data-poptin-id=" + poptin.poptin_id + "] .element-notinside:not(.hiddenSnappingElem):visible").length > 0) {
                    var recalw = reCaculateWidthformobile(poptin);
                    var recalh = reCaculateheightformobile(poptin);

                    var scale_width = Math.min(
                        (this_comparable_width - recalw.max_el_left_add) / recalw.new_width,
                        scale
                    );

                    var scale_height = Math.min(
                        this_comparable_height / recalh,
                        scale
                    );

                    // showLog("recal_this_comparable_width"+this_comparable_width);
                    // showLog("recal_w:"+recalw);

                    // showLog("recal_this_comparable_height"+this_comparable_height);
                    // showLog("recal_h:"+recalh);

                    // showLog("recal_width"+scale_width);
                    // showLog("recal_height"+scale_height);

                }else{
                    var scale_width = Math.min(
                        this_comparable_width  / poptin_size_width,
                        scale
                    );
                    var scale_height = Math.min(
                        this_comparable_height  / poptin_size_height,
                        scale
                    );
                }

                if (poptin.poptin_type == "lightbox" || poptin.poptin_type == "bside" || poptin.poptin_type == "sside" || poptin.is_new || poptin.poptin_type == "gamified"){
                    scale_width = Math.min(scale_width, scale_height);
                }

                // showLog('scale_dim', scale_width, scale_height, scale_width);

                // Set css scale ptoperties
                var new_pos_scale = {
                    "width": poptin_size_width+'px',
                    "height": poptin_size_height+'px',
                    "max-width": poptin_size_width+'px',
                    "max-height": poptin_size_height+'px'
                };

                // Dont change scale of browsing Actual Scale value
                if(poptin.poptin_type != "browsing"){
                    new_pos_scale["transform"] = "scale("+scale_width+")";
                }

                // Dont change scale of browsing
                if(poptin.poptin_type == "embedded"){
                    new_pos_scale["transform-origin"] = "center center 0px";
                    if(scale_width==0){
                        scale_width = 1;
                        new_pos_scale["transform"] = "scale("+scale_width+")";
                    }
                }

                //showLog("new_pos_scale"+JSON.stringify(new_pos_scale));

                _this.css(new_pos_scale);
                _this.attr('data-scale', scale_width);

                if(scale_width == 1){ _this.css("transform", "none"); }

                if (poptin.poptin_type == "bside" || poptin.poptin_type == "sside"){
                    if(poptin.design_properties.poptin_location.indexOf("left") < 0) {
                        _this.css({'left':'auto','right': ((this_comparable_width -(scale_height*poptin_size_width) )/2)+"px"});
                    } else {
                        _this.css({'right':'auto','left': ((this_comparable_width -(scale_height*poptin_size_width) )/2)+"px"});
                    }
                    // showLog('bside size', this_comparable_height, scale_height, poptin_size_height);
                    _this.css({'top': ((this_comparable_height -(scale_height*poptin_size_height) )/2)+"px"});
                }

                if (poptin.poptin_type == "sside" && _this.get(0) != undefined){
                    _this.get(0).style.setProperty('transform-origin', '');
                    if(this_comparable_height < poptin_size_height){
                        var poptin_location = poptin.design_properties.poptin_location;
                        if(poptin_location.indexOf("midlle") >= 0) {
                            _this.get(0).style.setProperty('top', '0px', 'important');
                            _this.get(0).style.setProperty('bottom', 'auto', 'important');
                            _this.get(0).style.setProperty('transform-origin', (poptin_location.split('-')[0])+' top 0', 'important');
                        }
                        if(poptin_location.indexOf("center") >= 0) {
                            _this.css({'left':'auto','right': ((this_comparable_width - poptin_size_width)/2)+"px"});
                        }
                    }
                }

                // change relevant poptin css attribute to fit to new 'scale' size
                if (poptin.poptin_type == "lightbox" || poptin.poptin_type == "gamified"){

                    // showLog(poptin_size_width, poptin_size_height);
                    // poptin_size_width = this_poptin_width || poptin_size_width;
                    // poptin_size_height = this_poptin_height || poptin_size_height;
                    // showLog(poptin_size_width, poptin_size_height);

                    // if(this_comparable_width < poptin_size_width){
                    //  this_comparable_width = this_comparable_width * 0.9
                    // }

                    this_css = {};
                    if( poptin_size_width > this_comparable_width ){
                        this_css = {
                            left: ((poptin_size_width - this_comparable_width )/-2)+"px",
                            right: ""
                        }
                    } else {
                        this_css = {
                            left: "0px",
                            right: "0px"
                        };
                    }
                    _this.css(this_css);
                    _this.animate({ top: ((poptin_size_height - this_comparable_height )/-2)+"px"}, poptin_animation_speed);
                    // showLog('this_css', this_css);
                    _this.css(this_css);
                }else if (poptin.poptin_type == "bar"){
                    _this.css({left: ((poptin_size_width - jQ224(window).width() )/-2)+"px"});
                    if (poptin.design_properties.poptin_location=="center-top"){
                        _this.css({top: ((poptin_size_height-(scale_width*poptin_size_height))/-2)+"px"});
                        barHtmlPadding(poptin);
                    }else if (poptin.design_properties.poptin_location=="center-bottom"){
                        _this.css({top: "auto"});
                    }else{
                        _this.css({top: (window.innerHeight -(scale_width*poptin_size_height + ((1-scale_width)*poptin_size_height)/2))+"px"});
                    }
                    _this.css("right","");
                    // }else if (poptin.poptin_type == "sside"){
                    // jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+']').css({left: ((poptin_size_width - window.innerWidth )/-2)+"px"});
                    // jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+']').css({bottom: ((poptin_size_height -(scale_width*poptin_size_height) )/-2)+"px"});
                }else if (poptin.poptin_type == "bside"){
                    // if (poptin.design_properties.poptin_location!== "left"){
                    //  _this.css({'right': ((poptin_size_width -(scale_width*poptin_size_width) )/-2)+"px"});
                    // }else{
                    //  _this.css({'left': ((poptin_size_width -(scale_width*poptin_size_width) )/-2)+"px"});
                    // }
                    // jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+']').css({'top': ((poptin_size_height -(scale_width*poptin_size_height) )/-2)+"px"});
                    // }else if (poptin.poptin_type == "browsing"){
                    // jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+']').css({'right': ((poptin_size_width -(scale_width*poptin_size_width) )/-2)+"px"});
                    // jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+']').css({'top': ((poptin_size_height -(scale_width*poptin_size_height) )/-2)+"px"});
                }else if (poptin.poptin_type == "mobile"){
                    if (jQ224("html").css("min-width")!=="100%")
                        _this.css({'left': ((poptin_size_width -(scale_width*poptin_size_width) )/-2)+"px"});
                    _this.css("right","");
                }else if (poptin.poptin_type == "social"){
                    // if (poptin.poptin_type+'_'+poptin.poptin_format != "social_format_2" && poptin.poptin_type+'_'+poptin.poptin_format != "social_format_6"){
                    //  switch(poptin.design_properties.poptin_location){
                    //      case "left-top":
                    //          _this.css({'left':((poptin_size_width -(scale_width*poptin_size_width) )/-2)+"px"});
                    //          _this.css({top: ((poptin_size_height-(scale_width*poptin_size_height))/-2)+"px"});
                    //          break;
                    //      case "left-midlle":
                    //          _this.css({'left':((poptin_size_width -(scale_width*poptin_size_width) )/-2)+"px"});
                    //          //jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").css({'top':(window.innerHeight -(scale_width*poptin_size_height)/2)+"px"});
                    //          break;
                    //      case "left-bottom":
                    //          _this.css({'left':((poptin_size_width -(scale_width*poptin_size_width) )/-2)+"px"});
                    //          _this.animate({"top": (window.innerHeight-poptin_height)+"px"}, poptin_animation_speed);
                    //          break;
                    //      case "center-top":
                    //          _this.css({'left': ((poptin_size_width -(scale_width*poptin_size_width) )/-2)+"px",'right':'','margin':'0px'});
                    //          _this.css({top: ((poptin_size_height-(scale_width*poptin_size_height))/-2)+"px"});
                    //          break;
                    //      case "center-midlle":
                    //          _this.css({'left': ((poptin_size_width -(scale_width*poptin_size_width) )/-2)+"px",'right':'','margin':'0px'});
                    //          //jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").css({'top':(window.innerHeight -(scale_width*poptin_size_height)/2)+"px"});
                    //      case "center-bottom":
                    //          _this.css({'left': ((poptin_size_width -(scale_width*poptin_size_width) )/-2)+"px",'right':'','margin':'0px'});
                    //          _this.css({'top':(window.innerHeight -(scale_width*poptin_size_height + ((1-scale_width)*poptin_size_height)/2))+"px"});
                    //          break;
                    //      case "right-top":
                    //          _this.css({'right':((poptin_size_width -(scale_width*poptin_size_width) )/-2)+"px"});
                    //          _this.css({top: ((poptin_size_height-(scale_width*poptin_size_height))/-2)+"px"});
                    //          break;
                    //      case "right-midlle":
                    //          _this.css({'right':((poptin_size_width -(scale_width*poptin_size_width) )/-2)+"px"});
                    //          //jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").css({'top':(window.innerHeight -(scale_width*poptin_size_height)/2)+"px"});
                    //          break;
                    //      case "right-bottom":
                    //          _this.css({'right':((poptin_size_width -(scale_width*poptin_size_width) )/-2)+"px"});
                    //          _this.css({'top':(window.innerHeight -(scale_width*poptin_size_height + ((1-scale_width)*poptin_size_height)/2))+"px"});
                    //          break;
                    //  }
                    // }else if (poptin.poptin_type+'_'+poptin.poptin_format== "social_format_2" || poptin.poptin_type+'_'+poptin.poptin_format == "social_format_6"){
                    //  switch(poptin.design_properties.poptin_location){
                    //      case "left-top":
                    //          _this.css({'left':((poptin_size_width -(scale_width*poptin_size_width) )/-2)+"px"});
                    //          _this.css({top: ((poptin_size_height-(scale_width*poptin_size_height))/-2)+"px"});
                    //          break;
                    //      case "left-midlle":
                    //          _this.css({'left':((poptin_size_width -(scale_width*poptin_size_width) )/-2)+"px"});
                    //          //jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").css({'top':(window.innerHeight -(scale_width*poptin_size_height)/2)+"px"});
                    //          break;
                    //      case "left-bottom":
                    //          _this.css({'left':((poptin_size_width -(scale_width*poptin_size_width) )/-2)+"px"});
                    //          _this.css({"top": (window.innerHeight-poptin_height-40)+"px"});
                    //          break;
                    //      case "center-top":
                    //          _this.css({'left': ((poptin_size_width -(scale_width*poptin_size_width) )/-2)+"px",'right':'','margin':'0px'});
                    //          _this.css({top: ((poptin_size_height-(scale_width*poptin_size_height))/-2)+"px"});
                    //          break;
                    //      case "center-midlle":
                    //          _this.css({'left':((poptin_size_width -(scale_width*poptin_size_width) )/-2)+"px",'right':'','margin':'0px'});
                    //          //jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").css({'top':(window.innerHeight -(scale_width*poptin_size_height)/2)+"px"});
                    //      case "center-bottom":
                    //          _this.css({'left': ((poptin_size_width -(scale_width*poptin_size_width) )/-2)+"px",'right':'','margin':'0px'});
                    //          _this.css({'top':(window.innerHeight - 40 -(scale_width*poptin_size_height + ((1-scale_width)*poptin_size_height)/2))+"px"});
                    //          break;
                    //      case "right-top":
                    //          _this.css({'right':((poptin_size_width -(scale_width*poptin_size_width) )/-2)+"px"});
                    //          _this.css({top: ((poptin_size_height-(scale_width*poptin_size_height))/-2)+"px"});
                    //          break;
                    //      case "right-midlle":
                    //          _this.css({'right':((poptin_size_width -(scale_width*poptin_size_width) )/-2)+"px"});
                    //          //jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").css({'top':(window.innerHeight -(scale_width*poptin_size_height)/2)+"px"});
                    //          break;
                    //      case "right-bottom":
                    //          _this.css({'right':((poptin_size_width -(scale_width*poptin_size_width) )/-2)+"px"});
                    //          _this.css({'top':(window.innerHeight - 40 -(scale_width*poptin_size_height + ((1-scale_width)*poptin_size_height)/2))+"px"});
                    //          break;
                    //  }
                    // }
                }
            }

            // If poptin_type is 'lightbox'
            if ( poptin.poptin_type == "lightbox" || poptin.poptin_type == "gamified" ){

                this_poptin_width = parseInt(_this.find('.draggable-container:not(.poptin-tab-container)').attr('data-width'));
                this_poptin_height = parseInt(_this.find('.draggable-container:not(.poptin-tab-container)').attr('data-height'));
                // showLog(this_poptin_width, this_poptin_height);

                poptin_size_width = this_poptin_width ? this_poptin_width : poptin_size_width;
                poptin_size_height = this_poptin_height ? this_poptin_height : poptin_size_height;
                // showLog(poptin_size_width, poptin_size_height);

                // Set new poptin size
                var scale = 1;

                // if(jQ224('html').height() > 300){
                //  this_comparable_height = Math.min(window.innerHeight, jQ224('html').height());
                // }

                if(this_comparable_width < poptin_size_width){
                    this_comparable_width = this_comparable_width * 0.9
                }

                var scale_width = Math.min(
                    this_comparable_width  / poptin_size_width,
                    scale
                );

                var scale_height = Math.min(
                    this_comparable_height  / poptin_size_height,
                    scale
                );
                // showLog("scale_width:"+scale_width);
                // showLog("scale_height:"+scale_height);
                new_scale = Math.min(scale_width, scale_height);

                //showLog('recalw new_scale:'+new_scale);

                window.poptins[poptin.poptin_id].poptin_scale = new_scale;
                // showLog('new_scale '+new_scale);
                // showLog('width '+window.innerWidth+' '+poptin_size_width);
                // showLog('height '+window.innerHeight+' '+poptin_size_height);
                // showLog('scale '+scale_width+' '+scale_height);
                // _this.css({"transform": "scale(" + new_scale +")"});
                _this.attr('data-scale', new_scale);
                // _this.css({'width': poptin_size_width,'height': poptin_size_height});
                if( typeof _this.get(0) != 'undefined' ) {
                    _this.get(0).style.setProperty('width', poptin_size_width+'px', 'important');
                    _this.get(0).style.setProperty('max-width', poptin_size_width+'px', 'important');
                    _this.get(0).style.setProperty('height', poptin_size_height+'px', 'important');
                }

            }

            if (poptin.poptin_type == "embedded"){
                var embedded_left = (_this.parent().width() - poptin_size_width )/2;
                var embedded_top = (_this.parent().height() - poptin_size_height )/2;
                embedded_left = embedded_left >= 0 ? 0 : embedded_left;
                if(embedded_left < 0){
                    _this.css({
                        'top': embedded_top+"px",
                        'left': embedded_left+"px",
                        'right': 'auto'
                    });
                } else {
                    _this.css({
                        'top': embedded_top+"px",
                        'left': '0px',
                        'right': '0px'
                    });
                    if(_this.attr('data-form-align') == 'right'){
                        _this.css({
                            'left': 'auto',
                            'right': '0px'
                        });
                    } else if(_this.attr('data-form-align') == 'left'){
                        _this.css({
                            'left': '0px',
                            'right': 'auto'
                        });
                    }
                }
            }

            // If poptin_type is 'lightbox'
            if ( poptin.poptin_type == "mobile" ){
                this_poptin_width = parseInt(_this.find('.draggable-container:not(.poptin-tab-container)').attr('data-width'));
                this_poptin_height = parseInt(_this.find('.draggable-container:not(.poptin-tab-container)').attr('data-height'));
                // showLog(this_poptin_width, this_poptin_height);

                poptin_size_width = this_poptin_width ? this_poptin_width : poptin_size_width;
                poptin_size_height = this_poptin_height ? this_poptin_height : poptin_size_height;
                // showLog(poptin_size_width, poptin_size_height);

                // Set new poptin size
                var scale = 1;

                // if(jQ224('html').height() > 300){
                //  this_comparable_height = Math.min(window.innerHeight, jQ224('html').height());
                // }

                var scale_width = 1;

                if(this_comparable_width > poptin_size_width){
                    scale_width = this_comparable_width  / poptin_size_width;
                }else{
                    scale_width = Math.min(
                        this_comparable_width  / poptin_size_width,
                        scale
                    );
                }

                new_scale = scale_width;
                window.poptins[poptin.poptin_id].poptin_scale = new_scale;
                // showLog('new_scale '+new_scale);
                // showLog('width '+window.innerWidth+' '+poptin_size_width+' '+this_comparable_width);
                // showLog('height '+window.innerHeight+' '+poptin_size_height+' '+this_comparable_height);
                // showLog('scale '+scale_width+' '+scale_height);
                //reset to 1 if scale is more than actual size
                if(new_scale>=1){new_scale = 1}
                _this.css({
                    "transform": "scale(" + new_scale + ")",
                    //"transform": "scale(" + "1" + ")",
                    "left": (this_comparable_width-poptin_size_width)/2
                });

                if(new_scale == 1){ _this.css("transform", "none"); }

                _this.attr('data-scale', new_scale);
                // _this.css({'width': poptin_size_width,'height': poptin_size_height});
                if( typeof _this.get(0) != 'undefined' ) {
                    _this.get(0).style.setProperty('width', poptin_size_width+'px', 'important');
                    _this.get(0).style.setProperty('max-width', poptin_size_width+'px', 'important');
                    _this.get(0).style.setProperty('height', poptin_size_height+'px', 'important');
                }

            }

            // if (window.innerWidth > poptin_size_width && poptin.poptin_type == "mobile"){
            //  // Set new poptin size
            //  if (jQ224.inArray(poptin.poptin_format,["format_1","format_2","format_4","format_6","format_7","format_9"]) >-1) {
            //      _this.css({'width': jQ224(window).width()+"px",'max-width': jQ224(window).width()+"px"});
            //  }
            // }

            // handle only poptin_type 'fullpage'
            if (poptin.poptin_type == "fullpage"){

                // Set new width and height
                ieVersion = GetIEVersion();
                _this.addClass('ie'+ieVersion);

                pop_wrappers_container = _this.find('.draggable-container:not(.poptin-tab-container) > form, .poptin_thank_you_screen');
                pop_wrappers_container.css('opacity', '0');

                try { clearTimeout(newScaleTimeout[poptin.poptin_id]); } catch (error) {}

                var this_format = parseInt(_this.attr('data-poptin-format').split('_')[1]);

                if(this_format && this_format < 9) {

                    newScaleTimeout[poptin.poptin_id] = setTimeout(function(){

                        poptin_size_width = 1920;
                        poptin_size_height = 1080;

                        // Set new poptin size
                        var scale = 1;

                        if(this_comparable_width < poptin_size_width){
                            this_comparable_width = this_comparable_width;
                        }

                        var scale_width = Math.min(
                            this_comparable_width  / poptin_size_width,
                            scale
                        );

                        var scale_height = Math.min(
                            this_comparable_height  / poptin_size_height,
                            scale
                        );

                        new_scale = Math.min(scale_width, scale_height);
                        window.poptins[poptin.poptin_id].poptin_scale = new_scale;
                        _this.attr('data-scale', new_scale);
                        _this.css({'width':'','height':'','max-width':'','max-height':''});

                        var static_bg_color = _this.find('.draggable-container:not(.poptin-tab-container)').css('background-color');
                        if(static_bg_color != "rgba(0, 0, 0, 0)"){
                            _this.css({'background-color' : static_bg_color});
                        }

                        _this.find('.draggable-container:not(.poptin-tab-container), .poptin_thank_you_screen').css({
                            'width':poptin_size_width+'px',
                            'max-width':poptin_size_width+'px',
                            'height':poptin_size_height+'px',
                            'max-height':poptin_size_height+'px',
                            "left": Math.floor((this_comparable_width-poptin_size_width)/2)+"px",
                            "top": Math.floor((this_comparable_height-poptin_size_height)/2)+"px",
                            'background-color': ''
                        });

                        _this.animate({ opacity : 1 }, 250, function(){
                            _this.find('.draggable-container:not(.poptin-tab-container), .poptin_thank_you_screen').css({"transform": "scale(" + new_scale +")"});
                            _this.find('.draggable-container:not(.poptin-tab-container), .poptin_thank_you_screen').attr('data-scale', new_scale);

                            if(new_scale == 1){ _this.css("transform", "none"); }

                            var form_x_close = _this.find('.draggable-container:not(.poptin-tab-container) #closeXButton');
                            var thank_x_close = _this.find('.poptin_thank_you_screen #closeXButton');
                            if( !(thank_x_close.length) ) {
                                _this.find('.poptin_thank_you_screen').prepend(form_x_close.clone());
                            }
                            jQ224('#closeXButton, #closeSkipButton').each(function(){
                                var this_original_pos = parseInt(jQ224(this).attr('data-original-pos'));
                                if(!this_original_pos) {
                                    this_original_pos = jQ224(this).position().left;
                                    jQ224(this).attr('data-original-pos', this_original_pos);
                                }
                                if( (this_original_pos + jQ224(this).width() + 50) > poptin_size_width){
                                    var new_left = (this_comparable_width - (poptin_size_width*new_scale)) / 2 / new_scale;
                                    jQ224(this).css({
                                        'position': 'fixed',
                                        'right': 'auto',
                                        'left': (this_original_pos+new_left)+'px'
                                    });
                                }
                            });
                            pop_wrappers_container.animate({ opacity : 1 }, 100);
                        });

                    }, 250);

                } else {

                    newScaleTimeout[poptin.poptin_id] = setTimeout(function(){

                        if (jQ224(window).width() < poptin_size_width){
                            // _this.css({'width': jQ224(window).width()+"px"});
                            _this.css({'width': '100%'});
                        }else if (window.innerWidth > poptin_size_width){
                            // _this.css({'width': jQ224(window).width()+"px",'max-width': jQ224(window).width()+"px"});
                            _this.css({'width': '100%','max-width': '100%'});
                        }

                        if (window.innerHeight > poptin_size_height){
                            // _this.css({'height':window.innerHeight+"px"});
                            // _this.find('#poptinDraggableContainer').first().css({'height':window.innerHeight+"px",'max-height': jQ224(window).width()+"px"});
                            _this.css({'height':'100%'});
                            _this.find('.draggable-container:not(.poptin-tab-container)').first().css({'height':'100%','max-height': '100%'});
                        }

                        // && poptin.poptin_format !=="format_4"
                        if (window.innerHeight < poptin_size_height){
                            _this.css({'height':window.innerHeight+"px"});
                        }

                        // Center poptin elements
                        var min_el_left = null;
                        var max_el_right = null;
                        var min_el_top = null;
                        var max_el_bottom = null;

                        var poptin_wrappers = jQ224('[data-poptin-id='+poptin.poptin_id+'] #poptinFormSubmit'+poptin.poptin_id+', [data-poptin-id='+poptin.poptin_id+'] .poptin_thank_you_screen, [data-poptin-id='+poptin.poptin_id+'] .poptin_play_screen, [data-poptin-id='+poptin.poptin_id+'] .poptin_winning_screen, [data-poptin-id='+poptin.poptin_id+'] .poptin_losing_screen');
                        poptin_wrappers.each(function(){

                            var $parent = jQ224(this);

                            $parent.children().each(function(i){

                                // showLog('min_max', min_el_left, max_el_right);

                                if(!jQ224(this).is('.draggable, .inputs-container, .redirect-url-blank, #closeSkipButton')){
                                    jQ224(this).remove();
                                    return false;
                                }

                                if(!jQ224(this).is(':visible')){
                                    return false;
                                }

                                this_left = jQ224(this).position().left;
                                this_top = jQ224(this).position().top;
                                this_right = this_left + jQ224(this).width();
                                this_bottom = this_top + jQ224(this).height();

                                if(min_el_left != null){
                                    min_el_left = Math.min(min_el_left, this_left);
                                } else {
                                    min_el_left = this_left;
                                }

                                if(min_el_top != null){
                                    min_el_top = Math.min(min_el_top, this_top);
                                } else {
                                    min_el_top = this_top;
                                }

                                if(max_el_right != null){
                                    max_el_right = Math.max(max_el_right, this_right);
                                } else {
                                    max_el_right = this_right;
                                }

                                if(max_el_bottom != null){
                                    max_el_bottom = Math.max(max_el_bottom, this_bottom);
                                } else {
                                    max_el_bottom = this_bottom;
                                }

                                // showLog('min_max', min_el_left, max_el_right);

                            });

                            if(ifMobilePoptin){
                                min_el_left = min_el_left - (jQ224(window).width()/10);
                                max_el_right = max_el_right + (jQ224(window).width()/10);
                            }

                        });

                        // Disable width resize after one time
                        if(poptin.poptin_format =="format_3" || poptin.poptin_format =="format_4"){
                            responsive_fullpage_width = true;
                        }
                        responsive_fullpage_height = true;

                        // Set default width value
                        var const_width, const_height;
                        if (poptin.poptin_format =="format_1"){
                            const_width = 600;
                            const_height = 950;
                        } else if(poptin.poptin_format =="format_2"){
                            const_width = 900;
                            const_height = 950;
                        }else if(poptin.poptin_format =="format_3"){
                            const_width = 1130;
                            const_height = 1000;
                        }else if(poptin.poptin_format =="format_4"){
                            const_width = 1130;
                            const_height = 1000;
                        } else {
                            const_width = 1920;
                            const_height = 1080;
                        }

                        //var const_height = screen.height;

                        var scale = 1;
                        var scale_width = 1;
                        var scale_height = 1;
                        if (jQ224(window).width() < const_width ){
                            scale_width = Math.min(
                                jQ224(window).width() / const_width,
                                scale
                            );
                        }
                        if (window.innerHeight < const_height ){
                            scale_height = Math.min(
                                window.innerHeight / const_height,
                                scale
                            );
                        }

                        new_scale = Math.min( scale_width,scale_height);

                        // showLog('new_scale', new_scale, scale_width, scale_height);
                        // jQ224('[data-poptin-id='+poptin.poptin_id+']').css({"transform": "scale("+new_scale+")"});
                        // jQ224('[data-poptin-id='+poptin.poptin_id+'] form').css({"transform": "scale("+new_scale+")"});
                        // showLog(this_poptin);
                        // showLog(this_poptin.find('#poptinDraggableContainer'));
                        var this_poptin_container = _this.find('#poptinDraggableContainer');
                        var this_poptin_thank_you = _this.find('#poptinThankYouScreen');
                        var this_poptin_play_screen = _this.find('#poptinPlayScreen');
                        var this_poptin_winning_screen = _this.find('#poptinWinningScreen');
                        var this_poptin_losing_screen = _this.find('#poptinLosingScreen');
                        // showLog(this_poptin_container);
                        // showLog('background-color : ' + this_poptin_container.css('background-color'));

                        setTimeout(function(){
                            container_width = '100%';
                            container_margin = 'auto';
                            if(fullpage_poptin_width < (screen_width / window.devicePixelRatio) ){
                                if(ieVersion == 11){
                                    container_width = fullpage_poptin_width;
                                }
                                // container_margin = '';
                                _this.addClass('with-margin');
                            } else {
                                _this.addClass('full-width');
                            }
                            if(!_this.hasClass('bg-moved')){
                                _this.css({ 'background' : this_poptin_container.css('background'), 'background-color' : this_poptin_container.css('background-color'), 'background-image' : this_poptin_container.css('background-image'), 'max-width' : 'initial', 'height' : '100%' });
                                _this.addClass('bg-moved');
                            }
                            container_css = { 'width' : container_width, 'background': 'none', 'background-color': 'none', 'background-image': 'none', 'transform' : 'scale('+new_scale+')', 'margin' : container_margin }
                            this_poptin_container.css(container_css);
                            this_poptin_container.attr('data-scale', new_scale);

                            if(new_scale == 1){ this_poptin_container.css("transform", "none"); }

                            this_poptin_thank_you.css(container_css);
                            this_poptin_thank_you.attr('data-scale', new_scale);

                            this_poptin_play_screen.css(container_css);
                            this_poptin_play_screen.attr('data-scale', new_scale);
                            this_poptin_winning_screen.css(container_css);
                            this_poptin_winning_screen.attr('data-scale', new_scale);
                            this_poptin_losing_screen.css(container_css);
                            this_poptin_losing_screen.attr('data-scale', new_scale);

                            // showLog('min_max', min_el_left, max_el_right);
                            el_width = max_el_right - min_el_left;
                            drag_cont_width = _this.find('#poptinDraggableContainer').width();
                            // if(win_width > el_width){
                            //  // showLog('here 1');
                            //  el_left = el_width/2;
                            // } else {
                            //  // showLog('here 2');
                            // }
                            // showLog(win_width, (el_width * scale_height));
                            // showLog(win_width/el_width, scale_height);
                            el_left = (drag_cont_width - el_width)/2;
                            // el_left = el_left;

                            // el_left = (el_width - jQ224(window).width())/2;
                            // el_left = '-'+((el_width * (1-scale_height))/2);
                            // el_left = '-'+((el_width/2)*scale_height);
                            // showLog('el', el_width, el_left);
                            jQ224('[data-poptin-id='+poptin.poptin_id+'] #poptinFormSubmit'+poptin.poptin_id).css({'width':el_width+'px','position':'absolute','left':el_left+'px'});

                            setTimeout(function(){

                                var close_button = _this.find('#poptinDraggableContainer #closeXButton').css({'position':'absolute !important','top':'40px !important','right':'40px !important'});
                                _this.find('#poptinDraggableContainer #closeXButton').remove();
                                _this.prepend(close_button);

                                var poptin_credit = _this.find('.poptin-credit');
                                _this.find('.poptin-credit').remove();
                                _this.prepend(poptin_credit);

                                // if( poptin.poptin_format == "format_4" ){
                                //  _this.css({"top": ((screen.height-(screen.height*scale_height))/-2)+"px"});
                                // } else {
                                    // showLog(this_poptin_container);
                                    // showLog("this_poptin_container css : -"+((window.innerHeight-(window.innerHeight*scale_height))/2)+"px");
                                    this_container_css = {
                                        "box-shadow" : "",
                                        'top': ((window.innerHeight - (const_height))/2)+'px',
                                        'left': ((window.innerWidth - (const_width))/2)+'px',
                                        'width':''
                                    };
                                    this_poptin_container.css(this_container_css);
                                    this_poptin_container.find('form').css({'width':'','left':''});
                                    this_poptin_thank_you.css(this_container_css);
                                    this_poptin_play_screen.css(this_container_css);
                                    this_poptin_winning_screen.css(this_container_css);
                                    this_poptin_losing_screen.css(this_container_css);
                                // }

                                if(jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").attr('data-wellcome-screen') == '1'){
                                    jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").css('position', 'absolute');
                                }

                                _this.animate({ opacity : 1 }, 250, function(){
                                    // _this.find('#poptinDraggableContainer, .poptin_thank_you_screen').css({"transform": "scale(" + new_scale +")"});
                                    var form_x_close = _this.find('.draggable-container:not(.poptin-tab-container) #closeXButton');
                                    var thank_x_close = _this.find('.poptin_thank_you_screen #closeXButton');
                                    // thank_x_close.remove();
                                    var play_x_close = _this.find('.poptin_play_screen #closeXButton');
                                    play_x_close.remove();
                                    var win_x_close = _this.find('.poptin_winning_screen #closeXButton');
                                    win_x_close.remove();
                                    var losing_x_close = _this.find('.poptin_losing_screen #closeXButton');
                                    losing_x_close.remove();
                                    // if( !(thank_x_close.length) ) {
                                    //  _this.find('.poptin_thank_you_screen').prepend(form_x_close.clone());
                                    // }
                                    jQ224('#closeXButton').each(function(){
                                        var this_original_pos = jQ224(this).offset().left;
                                        if( (this_original_pos + jQ224(this).width() + 50) > window.innerWidth){
                                            var new_left = window.innerWidth - jQ224(this).width() - 10;
                                            jQ224(this).css({
                                                'position': 'fixed',
                                                'right': 'auto',
                                                'left': new_left+'px'
                                            });
                                        }
                                    });

                                    jQ224('#closeSkipButton').each(function(){
                                        var this_original_pos = jQ224(this).offset().left;
                                        if( (this_original_pos + jQ224(this).width() + 50) > window.innerWidth){
                                            var new_left = window.innerWidth - jQ224(this).width() - 10;
                                            jQ224(this).css({
                                                'position': 'fixed',
                                                'right': '10px',
                                                'top': '5px'
                                            });
                                        }
                                    });

                                    pop_wrappers_container.animate({ opacity : 1 }, 100);
                                });

                            }, 500);

                        }, 500);

                        // showLog(screen.height,poptin_size_height,scale_height);
                        // showLog("-"+(screen.height-(poptin_size_height*scale_height))+"px");

                    }, 100);

                }

            }

        }

        /**
         * Trigger functions: doResizePoptin()
         * parameters       : poptin:object
         * Desc             : Handle poptin 'bar' type - padding top document
         */
        function barHtmlPadding(poptin){
            setTimeout(function(){
                showLog('barHtmlPadding()');
                padding_top = jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").height() * parseFloat(jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").attr('data-scale'));
                jQ224("html").animate({"padding-top": Math.floor(padding_top)+"px"}, 300);
                // jQ224("html").animate({"padding-top": (parseInt(jQ224("html").css('padding-top'))-(jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").height() - jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]")[0].getBoundingClientRect().height ))+"px"}, 300);
            },300);
        }


        /**
         * Trigger functions: initiatePullPoptinsRequestOnClick(), initiatePullPoptinsRequest(), poptinConversion()
         * Desc             : return visitor referrer value from "poptin_referrer" cookie
         */
        function getReferrer(){
            //Set protocol cookie for existing cookies and remove protocol from urls
            var protocolRegx = /^https?:\/\//;
            var poptin_referrer = poptinGetCookie("poptin_referrer");
            if ( poptin_referrer && protocolRegx.test(poptin_referrer) ) {
                var set_url_protocol = poptin_referrer.startsWith("https://") ? "secure" : "unsecure";
                poptinSetCookie('poptin_referrer_protocol', set_url_protocol, 0.00138888888888889);
                poptin_referrer = poptin_referrer.replace(/^https?:\/\//, '')
                poptinSetCookie('poptin_referrer', poptin_referrer, 0.00138888888888889);

            }

            var url_protocol = (poptinGetCookie("poptin_referrer_protocol") && poptinGetCookie("poptin_referrer_protocol") == "secure") ? "https://" : "http://";
            return (poptinGetCookie("poptin_referrer") ? ( poptinGetCookie("poptin_referrer").indexOf(window.location.host) !== -1 ? '' : url_protocol+poptinGetCookie("poptin_referrer")) : '' );
        }

        function getPreviousUrl() {
            //Set protocol cookie for existing cookies and remove http/https from urls
            var protocolRegx = /^https?:\/\//;
            var poptin_previous_url = poptinGetCookie("poptin_previous_url");
            if ( poptin_previous_url && protocolRegx.test(poptin_previous_url) ) {
                var set_url_protocol = poptin_previous_url.startsWith("https://") ? "secure" : "unsecure";
                poptinSetCookie('poptin_previous_url_protocol', set_url_protocol, 0.00138888888888889);
                poptin_previous_url = poptin_previous_url.replace(/^https?:\/\//, '')
                poptinSetCookie('poptin_previous_url', poptin_previous_url, 0.00138888888888889);

            }

            var url_protocol = (poptinGetCookie("poptin_previous_url_protocol") && poptinGetCookie("poptin_previous_url_protocol") == "secure") ? "https://" : "http://";
            return (poptinGetCookie("poptin_previous_url") ? ( poptinGetCookie("poptin_previous_url").indexOf(window.location.host) !== -1 ? url_protocol+poptinGetCookie("poptin_previous_url") : '' ) : '');
        }

        /**
         * Trigger functions: initiatePullPoptinsRequestOnClick(),initiatePullPoptinsRequest()
         * Desc             : Return all cookies with poptin index as string
         */
        function getReleventCookie(){
            cookies = document.cookie.split(';');
            relevent_cookie="";
            for (var i = 0; i < cookies.length; i++){
                if (cookies[i].split('=')[0].indexOf('poptin') !== -1){
                    // showLog(cookies[i]);
                    relevent_cookie += cookies[i];
                }
            }
            return relevent_cookie;
        }

        /**
         * Trigger functions: initiatePullPoptinsRequestOnClick(),initiatePullPoptinsRequest()
         * Desc             : Return all cookies with poptin index as string
         */
        function getLeaderCookie(){
            cookies = document.cookie.split(';');
            relevent_cookie="";
            for (var i = 0; i < cookies.length; i++){
                if (cookies[i].split('=')[0].startsWith(" cc_")){
                    // showLog(cookies[i]);
                    relevent_cookie += cookies[i];
                }
            }
            return relevent_cookie;
        }

        /**
         * Trigger functions: poptinCookiesFilter()
         * Desc             : Return array with all website cookies
         */

        function getAllCookies(){
            cookies = document.cookie.split(';');
            array = []
            for (var i = 0; i < cookies.length; i++){
                pair = cookies[i].split('=')
                $key = pair[0] == undefined ? '' : pair[0].trim();
                $value = pair[1] == undefined ? '' : pair[1].trim();
                if ($key != '')
                    array.push({key:$key,value:$value});
            }
            return array;
        }

        /**
         * Trigger functions: initiatePullPoptinsRequestOnClick(),initiatePullPoptinsRequest()
         * Desc             : Return all website cookies without Poptin oneline cookie
         */
        function getWebsiteCookie(){
            w_c = document.cookie.split(';');
            r_w_c="";
            for (var i = 0; i < w_c.length; i++){
                if (w_c[i].split('=')[0].indexOf('poptin') == -1){
                    r_w_c += w_c[i];
                }
            }
            return r_w_c;
        }

        /**
         * Trigger functions: initiatePullPoptinsRequestOnClick(),initiatePullPoptinsRequest()
         * Desc             : Return AutoPilot trigger as string from browser session storage
         */
        function getAutoPilots(){
            
            ap_triggers ='';
            try{
                if (typeof(Storage) !== "undefined") {
                    jQ224.each(window.sessionStorage,function(key,index){
                        if (key.indexOf('apt_') !== -1){
                            ap_triggers += key+':'+index+'|';
                        }
                    });
                } else {
                    showLog('Sorry! No Web Storage support..');
                }
            }catch(err){
                showLog(err);
            }
            return ap_triggers;
        }

        /**
         * Trigger functions: initiatePullPoptinsRequestOnClick(),initiatePullPoptinsRequest()
         * Desc             : Return user origin landing page
         */
        function getOriginLandingPage(){

            // Set defult landing page
        var plp = '';

            try{
                if (typeof(Storage) !== "undefined") {
                    if(window.sessionStorage.getItem("poptin_origin_landing_page") != null && window.sessionStorage.getItem("poptin_origin_landing_page") != undefined){
                        plp = window.sessionStorage.getItem("poptin_origin_landing_page");
                    }
                } else {
                    showLog('Sorry! No Web Storage support..');
                }
            }catch(err){
                showLog(err);
            }

            return plp;
        }

        /**
         * Trigger functions: initiatePullPoptinsRequestOnClick(),initiatePullPoptinsRequest()
         * Desc             : Return poptin viewed url
         */
        function getPoptinViewedUrl(poptin){

            // Set defult landing page
            var plp = window.location.href;

            try{
                if (typeof(Storage) !== "undefined" && poptin) {
                    if(window.sessionStorage.getItem("poptin_viewed_url_"+poptin.poptin_id) != null && window.sessionStorage.getItem("poptin_viewed_url_"+poptin.poptin_id) != undefined){
                        plp = window.sessionStorage.getItem("poptin_viewed_url_"+poptin.poptin_id);
                    }
                } else {
                    showLog('Sorry! No Web Storage support or poptin..');
                }
            }catch(err){
                showLog(err);
            }

            return plp;
        }

        /**
         * Trigger functions: initiatePullPoptinsRequest()
         * Desc             : Set poptin default cookies like:
         * Desc             : poptin_d_r_v_ -> poptin disaply returning visitors - 365 days
         * Desc             : poptin_d_a_x_v_ -> poptin disaply after 'x' visiting  - 365 days
         * Desc             : poptin_session -> for 30 minutes
         * Desc             : Etc...
         */
        function defaultCookie(){
            // Remove frequency cookies for inactive / removed campaigns before setting active ones
            cleanupStalePoptinFrequencyCookies();

            // If we have poptins
            if (window.all_poptins instanceof Object || window.all_poptins instanceof Array){
                // For each poptin
                jQ224.each(window.all_poptins,function(key,index){
                    // Phase 2: only create per-poptin frequency cookies when we have a valid id
                    if (!this.poptin_id) {
                        return;
                    }

                    if (this.d_f_a!= undefined && this.d_f_a && this.d_f_r.indexOf('display_once_every_few_visiting_4') > -1 ){
                        // if 'poptin disaply returning visitors' cookies is set
                        if (poptinCheckCookie('poptin_d_r_v_'+this.poptin_id)){
                            // If not first visitor visit
                            // -> increace by one
                            if (!window.sessionStorage.getItem("first_visit_"+this.poptin_id)){
                                value = parseInt(poptinGetCookie('poptin_d_r_v_'+this.poptin_id)) + 1 ;
                                poptinSetCookie('poptin_d_r_v_'+this.poptin_id, value, 365);
                                // Set first visit session
                                window.sessionStorage.setItem("first_visit_"+this.poptin_id,1);
                            }
                            // if 'poptin disaply returning visitors' cookies is not set
                        }else{
                            // Set cookies
                            poptinSetCookie('poptin_d_r_v_'+this.poptin_id, 0, 365);
                            // set seeion first_visit
                            window.sessionStorage.setItem("first_visit_"+this.poptin_id,1);
                        }
                    }

                    if (this.d_f_a!= undefined && this.d_f_a && this.d_f_r.indexOf('display_once_every_few_days_3') > -1 ){

                        // If 'poptin disaply after 'x' visiting' cookies is not set
                        if (!poptinCheckCookie('poptin_d_a_x_v_'+this.poptin_id)){
                            value  = getCurrentDate();
                            //value  = "2017-03-26";
                            // Set  cookies
                            poptinSetCookie('poptin_d_a_x_v_'+this.poptin_id, value, 365);
                        }
                    }

                    // If 'poptin_pageviews_' session is not set
                    if (!window.sessionStorage.getItem("poptin_pageviews_"+this.poptin_id)){
                        // set poptin_pageviews_ counter
                        window.sessionStorage.setItem("poptin_pageviews_"+this.poptin_id,0);
                    }else{
                        // increace by one poptin_pageviews_ counter
                        window.sessionStorage.setItem("poptin_pageviews_"+this.poptin_id,parseInt(window.sessionStorage.getItem("poptin_pageviews_"+this.poptin_id)) + 1);
                    }

                    if (!poptinCheckCookie('poptin_o_v_'+this.poptin_id)){
                        setOldVisitorCookie(this);
                    }

                    // As long page not closed, refresh cookies tine every 60 second
                    setInterval(function(){
                        setOldVisitorCookie(this);
                    },60000);


                    if (!poptinCheckCookie('poptin_session_account_'+this.account_id)){
                        poptinSetCookie('poptin_session_account_'+this.account_id, true, 30);
                    }

                    if (this.poptin_new_session){
                        setCustomNewVisitSession();
                    }
                });

                // Set poptin visitor per client
                if (!poptinCheckCookie('poptin_c_visitor')){
                    poptinSetCookie('poptin_c_visitor', true, 30);
                }
            }

            // Set poptin session for poptin display settings
            if (!poptinCheckCookie('poptin_session')){
                poptinSetCookie('poptin_session', true, 0.02083333333333333);
            }

            // Set poptin visitor per client - for new clients 29/10/2020
            // if (!poptinCheckCookie('poptin_c_new_visitor')){
            //     poptinSetCookie('poptin_c_new_visitor', true, 30);
            // }

            // Set session for visitor
            if (typeof(Storage) !== "undefined") {
                if (window.sessionStorage.getItem("poptin_every_visit_session") == null){
                    window.sessionStorage.setItem("poptin_every_visit_session",Date());
                    increaseTotalWebsiteSession();
                }
            }
            // // Set poptin implement cookie for poptin code implemet settings
            // if (!poptinCheckCookie('poptin_implement')){
            //  poptinSetCookie('poptin_implement', true, 0.02083333333333333);
            // }

            // As long page not closed, refresh cookies tine every 60 second
            // setInterval(function(){
            //  poptinSetCookie('poptin_session', true, 0.02083333333333333);
            //  //poptinSetCookie('poptin_implement', true, 0.02083333333333333);
            // },60000);

            //PC.delete('poptin_new_user');

            // Set old(new) visitor custom cookie.
            // Check if returning vistors or not
            // - for new clients or popus 12/07/2023

            setNewPoptinVisitorSession();
        }

        function increaseTotalWebsiteSession() {
            if (poptinCheckCookie('poptin_converted_email') || shopify_customer_id != 0 || wix_customer_id != 0) {
                var clientEmail = poptinGetCookie('poptin_converted_email');


                const payload = {
                    email: clientEmail,
                    url: document.location.hostname,
                    store_integration: store_integration,
                    store_integration_customer_id: store_integration_customer_id,
                };

                jQ224.ajax({
                    url: `${api_link}/api/display/total-website-session/${getClientId()}`,
                    type: 'POST',
                    dataType: 'json',
                    contentType: 'application/json',
                    async: true,
                    data: JSON.stringify(payload),
                })
                .done(function(data){
                    showLog('Total website session recorded');
                });
            }
        }


        function updateConversionActivities(activity, poptin) {
            if (poptinCheckCookie('poptin_converted_email') || shopify_customer_id != 0 || wix_customer_id != 0) {
                var visitorEmail = poptinGetCookie('poptin_converted_email');

                const payload = {
                    email: visitorEmail,
                    poptin_id: poptin,
                    activity: activity,
                    url: document.location.hostname,
                    store_integration: store_integration,
                    store_integration_customer_id: store_integration_customer_id
                };

                jQ224.ajax({
                    url: `${api_link}/api/display/conversion-activities/${getClientId()}`,
                    type: 'POST',
                    dataType: 'json',
                    contentType: 'application/json',
                    async: true,
                    data: JSON.stringify(payload)
                });
            }
        }


        /**
         * Trigger functions: defaultCookie()
         * parameters       : poptin:object
         * Desc             : Set 'once a session' cookie only if poptin have been viewed. avialble for 30 minutes
         */
        function setOldVisitorCookie(poptin){
            if (!poptinCheckCookie('poptin_o_v_'+poptin.poptin_id) && poptin !== undefined && poptin.display){
                var value  = poptin.viewer_id;
                poptinSetCookie('poptin_o_v_'+poptin.poptin_id, value, 0.02083333333333333);
            }
        }

        function getEveryVisitSession(){
            if (typeof(Storage) !== "undefined"){
                if (window.sessionStorage.getItem("poptin_every_visit_session") == null){
                    return "poptin_every_visit_session=true";
                }else{
                    return "poptin_every_visit_session=false";
                }
            } else{
                return "poptin_every_visit_session=true";
            }
        }

        function getCustomNewVisitSession(){
            if (typeof(Storage) !== "undefined"){
                if (window.sessionStorage.getItem("poptin_custom_new_visitor_session") == null){
                    return "";
                }else{
                    return "poptin_custom_new_visitor_session=true";
                }
            } else{
                return "";
            }
        }

        function setCustomNewVisitSession(){
    // Set session for visitor
            if (typeof(Storage) !== "undefined") {
                if (window.sessionStorage.getItem("poptin_custom_new_visitor_session") == null){
                    window.sessionStorage.setItem("poptin_custom_new_visitor_session",Date());
                }
            }
        }

        function getPoptinViewedSession(){

            poptin_viewed_session = '';
            poptin_once = 1;
            if (typeof(Storage) !== "undefined") {
                jQ224.each(sessionStorage, function(key, value){
                    if (key.indexOf('poptin_viewed_session')>=0){
                        if (poptin_once==1){
                            poptin_viewed_session+=key+'='+value
                            poptin_once=0;
                        }
                        else
                            poptin_viewed_session+=' '+key+'='+value
                    }
                });
                return poptin_viewed_session=='' ?  "poptin_viewed_session=false" : poptin_viewed_session;
            } else{
                return "poptin_viewed_session=false";
            }
        }

        function getPoptinNewUser(){
            if (typeof(Storage) !== "undefined") {
                if (window.sessionStorage.getItem("poptin_new_user") == null){
                    return "";
                }else{
                    return "poptin_new_user=true";
                }
            } else{
                return "";
            }
        }
        /**
         * Trigger functions: setPoptinSession()
         * Desc             : Set uniqe id for every visitor
         * Desc             : Good for BI
         */
        function setUserId(){
            if (!poptinCheckCookie('poptin_user_id')){
                poptinSetCookie('poptin_user_id', Math.random().toString(36).slice(-16), 365);
            }
        }

        /**
         * Trigger functions: DataPoint()
         * Desc             : Not relevant for this time!!!
         */
        function getUserId(){
            return (poptinCheckCookie("poptin_user_id") ? poptinGetCookie("poptin_user_id") : '' );
        }

        /**
         * Trigger functions: DataPoint()
         * Desc             : Not relevant for this time!!!
         */
        function getUserCountryCode(){
            return (poptinCheckCookie("poptin_user_country_code") ? poptinGetCookie("poptin_user_country_code") : false );
        }

        /**
         * Trigger functions: DataPoint()
         * Desc             : Not relevant for this time!!!
         */
        function getPoptinPageviews(poptin_id){
            return (window.sessionStorage.getItem("poptin_pageviews_"+poptin_id)==null ? 'error' : parseInt(window.sessionStorage.getItem("poptin_pageviews_"+poptin_id)));
        }

        /**
         * Trigger functions: poptinInit()
         * Desc             : Set Sessions per visitor
         */
        function setPoptinSession(){
            // return user
            // If not new user
            if(poptinCheckCookie('poptin_user_id')){
                if (!poptinCheckCookie('poptin_old_user')){
                    setNewUserSession();
                    setOldUserSession();
                }
                getOnceAVisitCookies();
                // if not set poptin_old_user cookie
            }else if (!poptinCheckCookie('poptin_old_user')){
                setNewUserSession();
                setOldUserSession();
                setUserId();
            }

            if (!poptinCheckCookie('poptin_last_visit')){
                setCustomNewVisitSession();
            }
        }

        /**
         * Trigger functions: setPoptinSession()
         * Desc             : Set poptin returning user cookie. avialble for days only
         */
        function setNewPoptinVisitorSession(){
            current_date = new Date().toJSON().slice(0,10).replace(/-/g,'-');
            poptinSetCookie('poptin_last_visit', current_date, 365);
        }

        /**
         * Trigger functions: setPoptinSession()
         * Desc             : Set poptin returning user cookie. avialble for days only
         */
        function setOldUserSession(){
            if(!poptinCheckCookie('poptin_old_user')){
                poptinSetCookie('poptin_old_user', true, 2);
                setInterval(function(){
                    poptinSetCookie('poptin_old_user', true,2);
                },60000);
            }
        }

        /**
         * Trigger functions: setPoptinSession()
         * Desc             : Set poptin ner user cookie. avialble for 30 minutes
         */
        function setNewUserSession(){
            // if(!poptinCheckCookie('poptin_new_user')){
            //  poptinSetCookie('poptin_new_user', true, 0.02083333333333333);
            //  setInterval(function(){
            //      poptinSetCookie('poptin_new_user', true, 0.02083333333333333);
            //  },60000);
            // }

            // Set session for visitor
            if (typeof(Storage) !== "undefined") {
                if (window.sessionStorage.getItem("poptin_new_user") == null){
                    window.sessionStorage.setItem("poptin_new_user",Date());
                }
            }
        }

        /**
         * Trigger functions: poptinViewed()
         * parameters       : poptin:object
         * Desc             : Set 'once a day' cookie only if poptin have been viewed. avialble for 1 day
         */
        function setOnceADayCookie(poptin){
            if (!poptinCheckCookie('poptin_o_a_d_'+poptin.poptin_id) && poptin !== undefined && poptin.display && poptin.cookie!="poptin_o_a_d_"+poptin.poptin_id){
                var value  = poptin.viewer_id;
                poptinSetCookie('poptin_o_a_d_'+poptin.poptin_id, value, 1);
                updateConversionActivities('viewed', poptin.poptin_id)
            }
        }

        /**
         * Trigger functions: poptinViewed()
         * parameters       : poptin:object
         * Desc             : Set 'Poptin Viewed' session only if poptin have been viewed. avialble for session
         */
        function setPoptinViewedSession(poptin){
            if (typeof(Storage) !== "undefined") {
                if (window.sessionStorage.getItem("poptin_viewed_session_"+poptin.poptin_id) == null){
                    window.sessionStorage.setItem("poptin_viewed_session_"+poptin.poptin_id,true);
                }
            }
        }

        /**
         * Trigger functions: poptinViewed()
         * parameters       : poptin:object
         * Desc             : Set 'Poptin Viewed' session only if poptin have been viewed. avialble for session
         */
        function setABTestSession(poptin){
            ab_test_parent_id = false;

            if (typeof(Storage) !== "undefined") {
                if (poptin.ab_test == false && poptin.ab_test_parent_id!=null){
                    ab_test_parent_id = poptin.ab_test_parent_id;
                }else if(poptin.ab_test == true){
                    ab_test_parent_id = poptin.poptin_id;
                }
                if (ab_test_parent_id){
                    if (window.sessionStorage.getItem("poptin_abtest_session_"+ab_test_parent_id) == null){
                        window.sessionStorage.setItem("poptin_abtest_session_"+ab_test_parent_id,poptin.poptin_id);
                    }
                }
            }
        }

        /**
         * Trigger functions: closePoptinOnXCookie()
         * parameters       : poptin:object
         * Desc             : Set cookie when user clicked 'X' button. avialble for 1 day
         * Desc             : poptin_c_p_o_x_c_ = close poptin on x click
         */
        function setClosePoptinOnXCookie(poptin_id){
            if (!poptinCheckCookie('poptin_c_p_o_x_c_'+poptin_id) && poptin_id !== undefined){
                poptinSetCookie('poptin_c_p_o_x_c_'+poptin_id, poptin_id, 1);
                updateConversionActivities('closed', poptin_id)
            }
        }

        /**
         * Trigger functions: getCloseCookiesArray()
         * parameters       :
         * Desc             : it returns all the close cookies available in the browser tab
         */

        function getCloseCookiesArray() {
            // Get all cookies
            const allCookies = document.cookie.split('; ');
            const prefix = 'poptin_c_p_o_x_c_';

            // Filter cookies with the specified prefix
            const filteredCookies = allCookies.filter(cookie => cookie.startsWith(prefix));

            // Extract cookie values and store them in an array
            const cookiesArray = filteredCookies.map(cookie => {
            const [name, value] = cookie.split('=');
            return { name: name, value: value };
            });

            return cookiesArray;
        }


        /**
         * Trigger functions: getOnceAVisitCookies(), poptinViewed()
         * parameters       : poptin:object
         * Desc             : Set 'once a visit' cookie. avialble for 30 minutes
         */
        function setOnceAVisit(poptin){
            if (poptin !== undefined && poptin.d_f_a!= undefined && poptin.d_f_a && poptin.d_f_r.indexOf('display_once_a_visitor_2') > -1 ){
                var value  = poptin.viewer_id;
                poptinSetCookie('poptin_o_a_v_'+poptin.poptin_id, value, 0.020833333);
                setInterval(function(){
                    poptinSetCookie('poptin_o_a_v_'+poptin.poptin_id, value,  0.020833333);
                },60000);
            }
        }

        /**
         * Trigger functions: setPoptinSession()
         * Desc             : Set default 'once a visit' cookie
         */
        function getOnceAVisitCookies(){
            cookies = document.cookie.split(';');
            var pop = {};
            for (var i = 0; i < cookies.length; i++){
                if (cookies[i].split('=')[0].indexOf('poptin_o_a_v_') !== -1){
                    pop.poptin_id=cookies[i].split('poptin_o_a_v_')[1].split('=')[0];
                    pop.viewer_id=cookies[i].split('=')[1];
                    setOnceAVisit(pop);
                }
            }
        }

        /**
         * Trigger functions:
         * parameters       : cname:string -> cookie name | cvalue:string -> cookie value | exdays:float -> expired time
         * Desc             : Set cookie constructor
         */
        function poptinSetCookie(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            var expires = "expires="+d.toUTCString();
            document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/; SameSite=Lax";
        }

        /**
         * Trigger functions:
         * parameters       : cname:string -> cookie name
         * Desc             : return cookie value by name
         * Desc             : return '' if not found
         */
        function poptinGetCookie(cname) {
            var name = cname + "=";
            var ca = document.cookie.split(';');
            for(var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }

        /**
         * Trigger functions: setPoptin()
         * parameters       : poptin:object
         * Desc             : Reset relevant cookies value when poptin is display
         */
        function resetReleventCookie(poptin){
            if (poptin.cookie == "poptin_d_r_v_"+poptin.poptin_id){
                poptinSetCookie("poptin_d_r_v_"+poptin.poptin_id,0, 365);
            }

            if (poptin.cookie == "poptin_d_a_x_v_"+poptin.poptin_id){
                value  = getCurrentDate();
                //value  = "2016-07-29";
                poptinSetCookie("poptin_d_a_x_v_"+poptin.poptin_id, value, 365);
            }
        }

        /**
         * Trigger functions:
         * parameters       : cname:string -> cookie name
         * Desc             : return boolean if cookie exist
         */
        function poptinCheckCookie(cname) {
            var cookie = poptinGetCookie(cname);
            if (cookie != "" && cookie !== null) {
                return true
            } else {
                return false;
            }
        }

        /**
         * Trigger functions: cleanupStalePoptinFrequencyCookies()
         * parameters       : cname:string -> cookie name
         * Desc             : delete cookie (must match path/SameSite used by poptinSetCookie)
         */
        function poptinDeleteCookie(cname){
            document.cookie = cname + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/; SameSite=Lax';
        }

        /**
         * Collect poptin IDs currently returned by the display API (active / in payload).
         */
        function getActivePoptinIdsFromPayload() {
            var ids = {};
            if (!(window.all_poptins instanceof Object || window.all_poptins instanceof Array)) {
                return ids;
            }
            jQ224.each(window.all_poptins, function (key, poptin) {
                var id = (poptin && poptin.poptin_id) ? poptin.poptin_id : key;
                if (id !== undefined && id !== null && id !== '') {
                    ids[String(id)] = true;
                }
            });
            return ids;
        }

        /**
         * Phase 1: Remove leftover frequency cookies for campaigns no longer in the pixel payload.
         * Only touches poptin_d_a_x_v_* and poptin_d_r_v_* (main 365-day quantity drivers).
         * Does not remove conversion / close / once-a-day cookies (engagement + targeting safe).
         * Hard cap: never retain more than MAX_STALE_POPTIN_FREQUENCY_COOKIES stale frequency cookies
         * (with no grace period we delete all stale; the cap documents the safety bound).
         */
        function cleanupStalePoptinFrequencyCookies() {
            var FREQUENCY_PREFIXES = ['poptin_d_a_x_v_', 'poptin_d_r_v_'];
            var MAX_STALE_POPTIN_FREQUENCY_COOKIES = 25;
            var activeIds = getActivePoptinIdsFromPayload();
            var staleNames = [];

            if (!document.cookie) {
                return;
            }

            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var name = cookies[i].split('=')[0].trim();
                if (!name) {
                    continue;
                }
                for (var p = 0; p < FREQUENCY_PREFIXES.length; p++) {
                    var prefix = FREQUENCY_PREFIXES[p];
                    if (name.indexOf(prefix) === 0) {
                        var id = name.substring(prefix.length);
                        if (id && !activeIds[id]) {
                            staleNames.push(name);
                        }
                        break;
                    }
                }
            }

            // No grace period in v1: delete all frequency cookies for IDs not in the current payload.
            // Cap is a safety bound — if stale count exceeds it we still delete all of them.
            if (staleNames.length > MAX_STALE_POPTIN_FREQUENCY_COOKIES) {
                showLog('cleanupStalePoptinFrequencyCookies: removing', staleNames.length, 'stale frequency cookies (over cap', MAX_STALE_POPTIN_FREQUENCY_COOKIES + ')');
            }

            for (var j = 0; j < staleNames.length; j++) {
                poptinDeleteCookie(staleNames[j]);
            }
        }

        /**
         * Trigger functions: defaultCookie(), resetReleventCookie()
         * Desc             : Return current date
         */
        function getCurrentDate(){
            today = new Date();
            dd = today.getDate();
            mm = today.getMonth()+1; //January is 0!

            yyyy = today.getFullYear();
            if(dd<10){
                dd='0'+dd
            }
            if(mm<10){
                mm='0'+mm
            }

            return yyyy+'-'+mm+'-'+dd;
        }

        /**
         * Trigger functions: poptinConversion(), displayPoptinOnClick(), poptinFormClickSubmit(), poptinSubmit()
         * parameters       : error_step:string ('when it happend') | error_message:string | c_status:string -> ajax status | response:string | poptin:object
         * Desc             : Send error message to server
         * Desc             : For monitorin purpose
         */
        function monitorError(error_step,error_message,c_status,response,poptin,extra_data = null){
            showLog('monitorError:',error_step,error_message,c_status,response,poptin);

            // Decrease server load.
            // We are not monitoring this anyway
            //try{
            //    jQ224.get(api_link+"/api/display/error/"+getClientId(),{poptin_user_id:poptinGetCookie('poptin_user_id'),error_step:error_step,error_message:error_message,call_status:c_status,result:response,poptin:(poptin!==false ? poptin.poptin_id : poptin),extra_data:extra_data});
            //}catch(err){
            //    showLog(err);
            //}
        }

        /**
         * Trigger functions: showPoptin()
         * parameters       : poptin:object
         * Desc             : Handle poptin display with animation effect
         */
        function showEffect(poptin, etype){
            var this_effect_poptin = jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]");
            var final_scale = this_effect_poptin.attr('data-scale');
            if(this_effect_poptin.length){
                var this_effect_poptin_container = this_effect_poptin.find(".draggable-container:not(.poptin-tab-container)");

                if(poptin.poptin_type == "embedded"){
                    var init_scale = "scale("+final_scale+", 0)";
                    var entryEffect = poptin.design_properties.poptin_design_entry_effect;
                    var selectedEffect = entryEffect ? entryEffect.split('-')[1] : "";
                    if (typeof poptin_landing_page != "undefined" || selectedEffect == "none") {
                        init_scale = "scale("+final_scale+")";
                    }
                    this_effect_poptin.css({"display": "block","transform":init_scale});
                    this_effect_poptin.attr("data-scale", final_scale);
                    if(init_scale == 1){ this_effect_poptin.css("transform", "none"); }
                    this_effect_poptin.find('#poptinDraggableContainer').css({"display": "block"});
                    jQ224(window).scroll(function(){
                        if(this_effect_poptin.length && this_effect_poptin.parent().length){
                            var scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
                            if( (scrollTop >= this_effect_poptin.parent().offset().top - window.innerHeight/1.5) && !this_effect_poptin.hasClass('scrolled') ){
                                this_effect_poptin.addClass('scrolled');
                                if(selectedEffect && selectedEffect != "none"){
                                    this_effect_poptin.addClass('poptin-visible poptin__animated');
                                    this_effect_poptin.addClass('animate__zoomIn');
                                }else{
                                    this_effect_poptin.addClass('poptin-visible poptin__animated');
                                }
                                this_effect_poptin.css('transform', final_scale != undefined ? 'scale('+final_scale+')' : 'none');
                            }
                        }
                    });
                    if(init_scale == 1){ this_effect_poptin.css("transform", "none"); }
                    poptinInputValidations(poptin);
                    poptinFormValidations(poptin); // Form validations
                } else {
                    if (poptin.poptin_type+"_"+poptin.poptin_format == "social_format_3" || poptin.poptin_type+"_"+poptin.poptin_format == "social_format_7"){
                        return false;
                    }

                    //"effect": effects from animate.css
                    //"speed": animation speed(default = 1s; slow = 2s; slower = 3s; fast = 800 ms; faster = 500 ms)
                    //"delay": animation delay(default = 0 seconds; 1s = 1 seconds; 2s = 2 seconds; 3s = 3 seconds; 4s = 4 seconds; 5s = 5 seconds)
                    var animateClass = {"effect":null, "speed":"_default", "delay":"-default"};

                    if(etype == "exit" && poptin.design_properties.poptin_design_exit_effect){
                        var selectedEffect = poptin.design_properties.poptin_design_exit_effect.split('-')[1];
                    }else if( poptin.design_properties.poptin_design_entry_effect ){
                        var ver = jQ224(".poptin-popup-background[data-poptin-id="+poptin.poptin_id+"]").outerWidth +100;
                        var hor = jQ224(".poptin-popup-background[data-poptin-id="+poptin.poptin_id+"]").outerHeight+100;
                        var selectedEffect = poptin.design_properties.poptin_design_entry_effect.split('-')[1];
                    }

                    switch(selectedEffect){
                        case "none" :
                            animateClass.effect = "_none";
                            break;
                        case "up" :
                            animateClass.effect = "_slideInDown";
                            break;
                        case "down" :
                            animateClass.effect = "_slideInUp";
                            break;
                        case "left" :
                            animateClass.effect = "_slideInLeft";
                            break;
                        case "right" :
                            animateClass.effect = "_slideInRight";
                            break;
                        case "blind" : //Removed Fold EntryEffect
                            animateClass.effect = "_flipInX";
                            break;
                        case "bounce" :
                            animateClass.effect = "_bounceIn";
                            break;
                        case "clip" :
                            animateClass.effect = "_zoomIn";
                            break;
                        case "explode" : //Removed Puzzle EntryEffect
                            animateClass.effect = "_fadeIn";
                            break;
                        case "fade" :
                            animateClass.effect = "_fadeIn";
                            break;
                        case "fold" :
                            animateClass.effect = "_flipInX";
                            break;
                        case "highlight" :
                            animateClass.effect = "_tada";
                            break;
                        case "puff" :
                            animateClass.effect = "_pulse";
                            break;
                        case "pulsate" :
                            animateClass.effect = "_flash";
                            break;
                        case "scale" :
                            animateClass.effect = "_heartBeat";
                            break;
                        case "shake" :
                            animateClass.effect = "_shakeX";
                            break;
                        case "size" : //Removed Resize EntryEffect
                            animateClass.effect = "_zoomIn";
                            break;
                        case "scale-out" :
                            animateClass.effect = "_zoomIn";
                            break;
                    }

                    var drag_cont = ".poptin-popup[data-poptin-id='"+poptin.poptin_id+"'] .draggable-container:not(.poptin-tab-container)";

                    if( etype == "exit" ){
                        var exitOut = animateClass.effect;
                        animateClass.effect = exitOut.replace("In","Out");

                        drag_cont = drag_cont + ", .poptin-popup[data-poptin-id='"+poptin.poptin_id+"'] .poptin_thank_you_screen, .poptin-popup[data-poptin-id='"+poptin.poptin_id+"'] .poptin_play_screen, .poptin-popup[data-poptin-id='"+poptin.poptin_id+"'] .poptin_winning_screen, .poptin-popup[data-poptin-id='"+poptin.poptin_id+"'] .poptin_losing_screen";
                        jQ224(drag_cont).addClass('poptin__animated');
                        if( animateClass.effect.indexOf('slide') !== -1  ){
                            jQ224(drag_cont).addClass('animate__faster');
                        }
                        jQ224(drag_cont).addClass('animate_'+animateClass.effect);
                    }else{
                        if(typeof jQ224(".poptin-popup-background[data-poptin-id="+poptin.poptin_id+"]").attr("style") == 'undefined'){
                            jQ224(".poptin-popup-background[data-poptin-id="+poptin.poptin_id+"]").addClass("no-backdrop-bg");
                        }else{
                            jQ224(".poptin-popup-background[data-poptin-id="+poptin.poptin_id+"]").removeClass("no-backdrop-bg");
                        }

                        if(poptin.poptin_type == "gamified" && jQ224(".poptin-popup-background[data-poptin-id="+poptin.poptin_id+"]").length > 0){
                            var check_backdrop_style = jQ224(".poptin-popup-background[data-poptin-id="+poptin.poptin_id+"]").attr("style");
                            var check_backdrop_status = jQ224(".poptin-popup-background[data-poptin-id="+poptin.poptin_id+"]").attr("data-overlay");
                            if(typeof check_backdrop_style!=='undefined'){
                                if(check_backdrop_style.indexOf("background-color")== -1 && typeof check_backdrop_status == 'undefined'){
                                    jQ224(".poptin-popup-background[data-poptin-id="+poptin.poptin_id+"]").removeClass("no-backdrop-bg");
                                }
                            }else{
                                jQ224(".poptin-popup-background[data-poptin-id="+poptin.poptin_id+"]").removeClass("no-backdrop-bg");
                            }
                        }

                        if(typeof jQ224(".poptin-live[data-poptin-id="+poptin.poptin_id+"]").attr("data-bg-animation")!='undefined'){
                            if(jQ224(".poptin-live[data-poptin-id="+poptin.poptin_id+"]").attr("data-bg-animation")=='wheel' || jQ224(".poptin-live[data-poptin-id="+poptin.poptin_id+"]").attr("data-bg-animation")=='rain'){
                                jQ224(".poptin-popup-background[data-poptin-id="+poptin.poptin_id+"]").removeClass("no-backdrop-bg");
                            }
                        }

                        if(poptin.poptin_type == "gamified" && jQ224(".poptin-popup-background[data-poptin-id="+poptin.poptin_id+"]").length > 0){
                            var check_backdrop_style = jQ224(".poptin-popup-background[data-poptin-id="+poptin.poptin_id+"]").attr("style");
                            var check_backdrop_status = jQ224(".poptin-popup-background[data-poptin-id="+poptin.poptin_id+"]").attr("data-overlay");
                            if(typeof check_backdrop_style!=='undefined'){
                                if(check_backdrop_style.indexOf("background-color")== -1 && typeof check_backdrop_status == 'undefined'){
                                    jQ224(".poptin-popup-background[data-poptin-id="+poptin.poptin_id+"]").removeClass("no-backdrop-bg");
                                }
                            }else{
                                jQ224(".poptin-popup-background[data-poptin-id="+poptin.poptin_id+"]").removeClass("no-backdrop-bg");
                            }
                        }


                        jQ224(".poptin-popup-background[data-poptin-id="+poptin.poptin_id+"]").css("display","block");
                        this_effect_poptin_container.css({"display": "none"});
                        this_effect_poptin.css({"display": "block"});

                        try{
                            showLog('Entry Animate');

                            jQ224(drag_cont).addClass('poptin-visible poptin__animated');
                            if( animateClass.effect.indexOf('slide') !== -1  ){
                                jQ224(drag_cont).addClass('animate__faster');
                            }
                            jQ224(drag_cont).addClass('animate_'+animateClass.effect);
                            //jQ224(drag_cont).addClass('animate_'+animateClass.effect+' animate_'+animateClass.speed+' animate__delay'+animateClass.delay);
                            doResizePoptin(poptin);
                            poptinVisible(poptin.poptin_id);

                        }catch(err){
                            showLog('Entry Animate err3');
                            jQ224(drag_cont).addClass('poptin-visible poptin__animated');
                            if( animateClass.effect.indexOf('slide') !== -1  ){
                                jQ224(drag_cont).addClass('animate__faster');
                            }
                            doResizePoptin(poptin);
                            jQ224(drag_cont).show(500, function(){
                                poptinVisible(poptin.poptin_id);
                            });
                        }
                        setTimeout(function(){
                            if (poptin.poptin_type == "lightbox" || poptin.poptin_type == "gamified"){
                                jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+'] .draggable-container:not(.poptin-tab-container)').animate({'top':'0px','left':'0px'},300);
                            }
                            jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]").css({"box-shadow": ( (poptin.poptin_type+'_'+poptin.poptin_format == "social_format_2") ||(poptin.poptin_type == "browsing") || (poptin.poptin_type == "lightbox" && poptin.poptin_format == "format_3") || (poptin.poptin_type == "lightbox" && poptin.poptin_format == "format_9") || (poptin.poptin_type == "bar" && poptin.design_properties.poptin_location == "center-top")|| (poptin.poptin_type+'_'+poptin.poptin_format == "mobile_format_3") || (poptin.poptin_type+'_'+poptin.poptin_format == "mobile_format_7") || (poptin.poptin_type+'_'+poptin.poptin_format == "lightbox_format_4") || (poptin.poptin_type+'_'+poptin.poptin_format == "lightbox_format_10") ? "" :"0 3px 9px rgba(0,0,0,.5)" ) });

                            // Form validations
                            poptinInputValidations(poptin);
                            poptinFormValidations(poptin);
                        },600);
                        //jQ224(id).show( selectedEffect, options, 500);
                    }
                }
                if(etype != "exit"){
                    hideTeaserOnPopupShow(poptin);
                }
                // Remove animation classes after 1sec
                const { design_properties, is_teasers_on } = poptin;
                if (!(is_teasers_on && (design_properties.poptin_design_auto_close || design_properties.poptin_design_close_on_screen_click))) {
                    setTimeout(function(){
                        jQ224(drag_cont).removeClass('poptin__animated');
                        jQ224(drag_cont).removeClass (function (index, className) {
                            return (className.match (/\banimate_\S+/g) || []).join(' ');
                        });
                    },1000);
                }

            }
        }

        /******************* Support page relode ******************/
        function ifPageRefreshed(){
            if (window.performance) {
                //console.info("window.performance works fine on this browser");
                if (performance.navigation.type == 1) {
                    return true;
                }
            }
            return false;
        }

        /******************* START poptins_queue ******************/

        PoptinQueue = function(){

            this.active     = false;
            this.poptins    = [];

            this.ifActive = function(){
                return this.active;
            }

            this.getActive = function(){
                return this.active;
            }
            this.setActive = function(val){
                this.active = val;
            }

            this.ifRelevent = function(poptin){
                return poptin.poptin_type == "lightbox" || poptin.poptin_type == "gamified" || poptin.poptin_type == "fullpage";
            }

            this.checkQueue = function(poptin,click){
                var poptin_container = (poptin.poptin_type != "embedded") ? jQ224("body") : jQ224(".poptin-embedded[data-id='"+poptin.poptin_id+"']");
                if (this.getActive()){
                    if (this.ifRelevent(poptin)){
                        //this.addPoptin({poptin:poptin,click:click})
                        // showLog('checkQueue active relevant')
                    }else{
                        if (jQ224('[data-poptin-id="'+poptin.poptin_id+'"]').length >0){
                            return false;
                        }else{
                            poptin_container.append(poptin.poptin);
                            window.poptins[poptin.poptin_id].poptin = poptin.poptin;
                            setPoptin(poptin, click);
                        }
                    }
                }else{
                    if (this.ifRelevent(poptin)){
                        this.setActive(true);
                    }
                    if (jQ224('[data-poptin-id="'+poptin.poptin_id+'"]').length >0){
                        return false;
                    }else{
                        if (!poptin.poptin.includes('data-poptin-id')) {
                            return false;
                        }
                        poptin_container.append(poptin.poptin);
                        window.poptins[poptin.poptin_id].poptin = poptin.poptin;
                        setPoptin(poptin, click)
                    }
                }
            }

            this.firePoptin = function(poptin_id){
                poptin = window.all_poptins[poptin_id];
                if (this.ifActive() && this.ifRelevent(poptin)){
                    this.setActive(false);
                }
            }
            // this.addPoptin = function(data){
            //  this.poptins[data.poptin.poptin_id] = data
            // }

            // this.ifEmpty = function(){
            //  return Object.keys(this.poptins).length == 0;
            // }

            // this.removePoptin = function(poptin_id){
            //  showLog(poptin_id);
            //  if (this.window.poptins[poptin_id] != undefined)
            //      delete this.window.poptins[poptin_id];

            //  if (this.ifEmpty()){
            //      this.setActive(false);
            //  }
            // }

            // this.first = function(){
            //  return this.poptins[Object.keys(this.poptins)[0]];
            // }
        }
        var PQ = new PoptinQueue();

        /******************* END poptins_queue ******************/



        function poptinFacebookMessangerConversion(poptin_id){
            showLog('poptinFacebookMessangerConversion')

            ensurePoptinTrigger(poptin_id);
            window.poptins[poptin_id].poptin_trigger.convert = true;
            poptin = window.all_poptins[poptin_id];

            // Set actions after poptin submit successfullt
            afterPoptinSubmit(poptin,undefined);

            try{
                // Initiate poptin convertion ajax call
                poptinConversion(poptin,undefined);
            }catch(err){
                // monitor error
                monitorError('submitPoptin()->poptinConversion()',err,'','',poptin);
                // redirect user to poptin redirect page
                redirectAfterConversion(poptin);
            }

            //jQ224('[data-poptin-id="'+poptin_id+'"] .facebook-plugin-redirect')[0].click();

            //jQ224('.poptin-popup .facebook-plugin-redirect')[0].click();
        }


    /******************* Support SPA Website ******************/


    var poptin_current_url = location.href;
    if (typeof poptin_single_page_app != 'undefined' && poptin_single_page_app)
    {
        poptin_single_page_app = poptinCheckCookie("poptin_single_page_app_debug") ? poptinCheckCookie("poptin_single_page_app_debug") : poptin_single_page_app;
    }

    if (typeof poptin_single_page_app != 'undefined' && poptin_single_page_app){

            function detect_url_change(a,b){
                if(poptinCheckCookie("poptin_single_page_app_debug")){
                    showLog("detect_url_change");
                }
                jQ224("#poptinDraggableContainer-tab").remove();
                jQ224(".poptin-popup").remove();
                jQ224("#modelBackdrip").remove();
                poptinStarted = false;
                jQ224(document).unbind();
                jQ224(window).off('scroll.poptinTriggerScrollEvent');
                clearTimeout(poptinTimeDelayTrigger);
                poptinTimeDelayTrigger = null;
                runPoptinNow();
                PQ = new PoptinQueue();
            }

            var pushState = history.pushState;
            history.pushState = function () {
                var pvp_path = document.location.pathname;
                var previousPages_spa = localStorage.getItem('poptin_previous_visited_pages');
                if (previousPages_spa && previousPages_spa.length > 0) {
                    var previousPagesArray_spa = previousPages_spa.split('|');
                    if (!previousPagesArray_spa.includes(pvp_path)) {
                        previousPagesArray_spa.push(pvp_path);
                    }
                    localStorage.setItem('poptin_previous_visited_pages', previousPagesArray_spa.join('|'));

                } else {
                localStorage.setItem('poptin_previous_visited_pages', pvp_path);
                }

                previous_url_spa = document.location.protocol+'//'+document.location.hostname+document.location.pathname+document.location.hash;
                setPreviousUrl();
                pushState.apply(history, arguments);
                detect_url_change('pushState', arguments);  // Some event-handling function
            };


        /*if (document.body!=null){

                    var check_client_url = window.location.href;
                    var flag_click_body=false;
                    document.body.addEventListener('click', (e)=>{
                        requestAnimationFrame(() => {
                            if(e.target.tagName!='svg' && e.target.tagName!='line' && e.target.tagName!='BUTTON' && e.target.tagName!='BODY')
                            {
                                document.body.click();
                            }

                            if(check_client_url !== window.location.href){
                                showLog("old location case1: " + check_client_url);
                                showLog("url changed to:"+window.location.href);
                                jQ224("#poptinDraggableContainer-tab").remove();
                                jQ224(".poptin-popup").remove();
                                jQ224("#modelBackdrip").remove();
                                poptinStarted = false;
                                jQ224(document).unbind();
                                runPoptinNow();
                            }
                            check_client_url = location.href;
                            poptin_current_url = check_client_url;
                            if(check_client_url !== location.href){
                                showLog("new location case1: " + poptin_current_url );
                            }
                            PQ = new PoptinQueue();
                            //showLog("Clicked tagName " + e.target.tagName );
                            //e.stopPropagation();

                        });
                    }, true);

        }else{
            document.addEventListener('click', function(){
                requestAnimationFrame(function(){
                    showLog("old location case2: " + poptin_current_url);
                    if (poptin_current_url!==location.href){
                    jQ224("#poptinDraggableContainer-tab").remove();
                    jQ224(".poptin-popup").remove();
                    jQ224("#modelBackdrip").remove();
                    poptinStarted = false;
                    jQ224(document).unbind();
                    runPoptinNow();
                    }
                    poptin_current_url = location.href;
                    showLog("new location case2: " + poptin_current_url );
                    PQ = new PoptinQueue();

                });
                }, true);
        }*/

        window.addEventListener('popstate', function (event) {
            showLog("old location: " + poptin_current_url);
            //if (poptin_current_url!==document.location){
            jQ224("#poptinDraggableContainer-tab").remove();
            jQ224(".poptin-popup").remove();
            jQ224("#modelBackdrip").remove();
                poptinStarted = false;
                jQ224(document).unbind();
                runPoptinNow();
            //}
            poptin_current_url = document.location;
            showLog("new location: " + poptin_current_url );
            PQ = new PoptinQueue();

        });

    }



        /******************* Animated Button ******************/
        var submitBtnAnimationInterval,
            closeBtnAnimationInterval,
            link_interval_array=[];
        function animateButton(poptin){
            //Remove old animate.css
            jQ224("style.animatebtnCss").remove();
            var poptinButton = jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] #poptinFormSubmitText .froala-editor-button");
            if(poptinButton.length && typeof poptinButton.attr("data-poptin-animate") !== "undefined" && poptinButton.attr("data-poptin-animate") != null) {
                var btnAnimate = poptinButton.attr("data-poptin-animate");
                submitBtnAnimationInterval = setInterval(function(){
                    poptinButton.toggleClass('poptin__animated animate__'+btnAnimate);
                }, 3000);
            }

            var poptinCloseButton = jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] #poptinFormCloseText .froala-editor-button");
            if(poptinCloseButton.length && typeof poptinCloseButton.attr("data-poptin-animate") !== "undefined" && poptinCloseButton.attr("data-poptin-animate") != null) {
                var btnCloseAnimate = poptinCloseButton.attr("data-poptin-animate");
                closeBtnAnimationInterval = setInterval(function(){
                    poptinCloseButton.toggleClass('poptin__animated animate__'+btnCloseAnimate);
                }, 3000);
            }

            var poptinlinkButton = jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] .froala-editor-link");
            if(poptinlinkButton.length && typeof poptinlinkButton.attr("data-poptin-animate") !== "undefined" && poptinlinkButton.attr("data-poptin-animate") != null){
                jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] .froala-editor-link").each(function(){
                    var linkbtnAnimate = jQ224(this).attr("data-poptin-animate");
                    var linkbtn_id= jQ224(this).parent().attr("id");
                    link_interval_array[poptin.poptin_id+"_"+linkbtn_id] = setInterval(function(){
                        jQ224("#"+linkbtn_id).find(".froala-editor-link").toggleClass('poptin__animated animate__'+linkbtnAnimate);
                    }, 3000);
                });
            }
        }

        /******************* Animated GiftBox ******************/
        var giftboxAnimationInterval;
        function animateGiftbox(poptin){
            var poptinGiftbox = jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] .froala-giftbox-wrapper .fr-giftbox-images .giftbox-img");
            var giftboxAnimate = jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] .froala-giftbox-wrapper .fr-giftbox-images").attr("data-poptin-animate");
            var giftboxCnt = poptinGiftbox.length ? poptinGiftbox.length : 1 ;
            if(poptinGiftbox.length > 0 && giftboxAnimate) {
                giftboxAnimationInterval = setInterval(function() {
                    poptinGiftbox.toggleClass('poptin__animated animate__'+giftboxAnimate);
                },giftboxCnt * 1000);
            }
        }

        function poptinBase64ToBytes(base64) {
            const binString = atob(base64);
            return Uint8Array.from(binString, (m) => m.codePointAt(0));
        }
        function poptinBytesToBase64(bytes) {
            const binString = String.fromCodePoint(...bytes);
            return btoa(binString);
        }
        function poptinEnc(str){
            return poptinBytesToBase64(new TextEncoder().encode(str));
        }
        function poptinDec(str){
            return new TextDecoder().decode(poptinBase64ToBytes(str));
        }

        function gamifiedGiftbox(poptin){
            var giftboxAnimate = jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] .froala-giftbox-wrapper .fr-giftbox-images").attr("data-poptin-animate");
            var poptinGiftbox = jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] .froala-giftbox-wrapper .fr-giftbox-images .giftbox-img");

            var weightJSON = {};
            var poptinEncPzeVal = jQ224("#poptinEncPze").val();
            var poptinEncPze = jQ224("#gamifiedPrizeJSON").length > 0 ? JSON.parse(jQ224("#gamifiedPrizeJSON").val()) : (poptinEncPzeVal ? JSON.parse(poptinDec(poptinEncPzeVal)) : []);

            jQ224.each(poptinEncPze.prizes, function(key, val){
                weightJSON[key] = val.chances ? Number(val.chances)/100 : 0;
            });

            jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+'] .fr-giftbox-images .fr-giftbox').on('click', function(e) {
                try{clearInterval(giftboxAnimationInterval);}catch(err){}
                var prizeSelected = jQ224(this).attr("data-prize");
                jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+'] .fr-giftbox-images .giftbox-img').removeClass('poptin__animated animate__'+giftboxAnimate).css({'animation-delay': '0s','-webkit-animation-delay': '0s','-moz-animation-delay': '0s','-ms-animation-delay': '0s'});
                jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+'] .fr-giftbox-images .giftbox-img')

                jQ224(e.target).addClass('poptin__animated animate__tada');
                setTimeout(function(){
                    jQ224(e.target).removeClass('poptin__animated animate__tada');
                }, 1000);
                var prizeWinner = weightRandom(weightJSON);
                showLog("prizeWinner",prizeWinner);
                showLog("prizeJSONGotSelected",poptinEncPze.prizes[prizeWinner]);

                poptin["gamified_prize"] = poptinEncPze.prizes[prizeWinner];
                poptin["gamified_prize"]["prize_id"] = prizeWinner;

                if( prizeWinner && poptinEncPze.prizes[prizeWinner].loosing_option == false ){
                    // Always win if loosing_option is false
                    showLog("Win");
                    poptin["gamified_prize"]["is_winner"] = true;
                    getIntlPhoneValidation(poptin)

                    //Replace Prize Labels
                    var playScreenContainer = jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_play_screen p");
                    playScreenContainer.each(function() {
                        var text = jQ224(this).html();
                        if(text.indexOf("{{prize_label}}") != -1 && poptinEncPze.prizes[prizeWinner].label){
                            jQ224(this).html(text.replace("{{prize_label}}", poptinEncPze.prizes[prizeWinner].label ));
                        }
                        if(text.indexOf("{{prize_code}}") != -1 && poptinEncPze.prizes[prizeWinner].code){
                            jQ224(this).html(text.replace("{{prize_code}}", poptinEncPze.prizes[prizeWinner].code ));
                        }
                    });

                    setTimeout(function(){
                        jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container").css("display","none").find('.draggable.image-change-video').remove();
                        jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container").removeClass('poptin-visible poptin__animated');
                        jQ224("[data-poptin-id="+poptin.poptin_id+"]").css('box-shadow','');

                        // show post play screen
                        if(poptin['design_properties'] && poptin['design_properties']['disable_post_play_screen'] && poptin['design_properties']['disable_post_play_screen'] == true){
                            show_winning_screen(poptin);
                            ifLinkConversion(poptin);
                        }else{
                            jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_play_screen").addClass("poptin-visible poptin__animated animate__fadeIn animate__faster");
                            setTimeout(function(){
                                jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_play_screen").removeClass('poptin__animated animate__fadeIn animate__faster');
                            },800);
                        }
                        jQ224(document).on('click', '[data-poptin-id="'+poptin.poptin_id+'"] #closeXButton', function(){
                            closePoptinOnXclick(jQ224(this).get(0));
                        });
                        jQ224("[data-poptin-id="+poptin.poptin_id+"] .close-x-button").show(100);
                        poptinFormValidations(poptin);
                    }, 1000);

                }else{
                    showLog("lose");
                    poptin["gamified_prize"]["is_winner"] = false;
                    setTimeout(function(){
                        jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container").css("display","none").find('.draggable.image-change-video').remove();
                        jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container").removeClass('poptin-visible poptin__animated');
                        jQ224("[data-poptin-id="+poptin.poptin_id+"]").css('box-shadow','');

                        // show post play screen
                        jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_losing_screen").addClass("poptin-visible poptin__animated animate__fadeIn animate__faster");
                        setTimeout(function(){
                            jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_losing_screen").removeClass('poptin__animated animate__fadeIn animate__faster');
                        },800);
                        jQ224(document).on('click', '[data-poptin-id="'+poptin.poptin_id+'"] #closeXButton', function(){
                            closePoptinOnXclick(jQ224(this).get(0));
                        });
                        jQ224("[data-poptin-id="+poptin.poptin_id+"] .close-x-button").show(100);

                        if(poptin.gamified_prize && poptin.gamified_prize.redirect_to == true && poptin.gamified_prize.redirect_to_options.redirect_to_url != undefined){
                            showLog('ifLinkConversion3');
                            //jQ224('[data-poptin-id='+poptin.poptin_id+']').find('#redirectBlank')[0].click();
                            //window.poptins[poptin.poptin_id].redirect_flag=true;
                            // var redirect_close_delay = poptin.gamified_prize.redirect_to_options.redirect_close_delay;
                            // setTimeout(function(){
                            // 	poptinRedirectToUrl(poptin,'direct','gamified');
                            // }, redirect_close_delay ? (parseInt(redirect_close_delay) + (poptin.design_properties.disable_post_play_screen ? 8 : 0)) * 1000 : (poptin.wheel_has_coupon ? default_close_delay * 3 : default_close_delay) * 1000);

                            var redirect_close_delay = poptin.gamified_prize.redirect_to_options.redirect_close_delay;
                            var total_redirect_close_delay = redirect_close_delay ? 0 : (poptin.wheel_has_coupon ? default_close_delay * 3 : default_close_delay) * 1000;
                            //var total_redirect_close_delay = redirect_close_delay ? (parseInt(redirect_close_delay) + (poptin.design_properties.disable_post_play_screen ? 8 : 0)) * 1000 : (poptin.wheel_has_coupon ? default_close_delay * 3 : default_close_delay) * 1000;
                            setTimeout(function(){
                                poptinRedirectToUrl(poptin,'direct','gamified');
                            }, total_redirect_close_delay );
                        }
                        poptinFormValidations(poptin);
                    }, 1000);

                }


            });
        }

        /******* Gamified random probability *******/
        function weightRandom(prob) {
            var i, sum=0, r=Math.random();
            for (i in prob) {
                sum += prob[i];
                if (r <= sum) return i;
            }
        }

        function poptinSpinWheelCall(poptin, parentEL, skips, popWheel, weightJSON, poptinEncPze) {
            var prizeWinner = weightRandom(weightJSON);
            var prizeSelectedIdx = 0;
            for (const prizeSelected in weightJSON) {
                if (Object.hasOwnProperty.call(weightJSON, prizeSelected)) {
                    // showLog(prizeSelected, prizeSelectedIdx, prizeWinner);
                    if(prizeSelected == prizeWinner){
                        showLog(prizeSelected, prizeSelectedIdx, poptinEncPze.prizes[prizeSelected], prizeWinner);

                        // Rotate wheel
                        skips = 24 + prizeSelectedIdx;
                        jQ224('.spin-wheel-animation-'+poptin.poptin_id).remove();
                        jQ224(parentEL).append(`<style class="spin-wheel-animation" id="spin-wheel-animation-`+poptin.poptin_id+`">
                            @keyframes spinning {
                                from { transform: rotate(0); }
                                to { transform: rotate(-`+(skips*30)+`deg); }
                            }
                        </style>`);
                        popWheel = jQ224(parentEL).find('.pop-wheel-wrap');
                        popWheel.toggleClass("pop-spinning");
                        jQ224(document).off('click', parentEL+' .pop-wheel-overlay');

                        setTimeout(function(){

                            if( prizeWinner && poptinEncPze.prizes[prizeWinner].loosing_option == false ){
                                // Always win if loosing_option is false
                                showLog("Win");
                                poptin["gamified_prize"]["is_winner"] = true;
                                getIntlPhoneValidation(poptin);

                                //Replace Prize Labels
                                var playScreenContainer = jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_play_screen p");
                                playScreenContainer.each(function() {
                                    var text = jQ224(this).html();
                                    if(text.indexOf("{{prize_label}}") != -1 && poptinEncPze.prizes[prizeSelected].label){
                                        jQ224(this).html(text.replace("{{prize_label}}", poptinEncPze.prizes[prizeSelected].label ));
                                    }
                                    if(text.indexOf("{{prize_code}}") != -1 && poptinEncPze.prizes[prizeSelected].code){
                                        jQ224(this).html(text.replace("{{prize_code}}", poptinEncPze.prizes[prizeSelected].code ));
                                    }
                                });

                                setTimeout(function(){
                                    jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container").css("display","none").find('.draggable.image-change-video').remove();
                                    jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container").removeClass('poptin-visible poptin__animated');
                                    jQ224("[data-poptin-id="+poptin.poptin_id+"]").css('box-shadow','');

                                    // show post play screen
                                    if(poptin['design_properties'] && poptin['design_properties']['disable_post_play_screen'] && poptin['design_properties']['disable_post_play_screen'] == true){
                                        show_winning_screen(poptin);
                                        ifLinkConversion(poptin);
                                    }else{
                                        jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_play_screen").addClass("poptin-visible poptin__animated animate__fadeIn animate__faster");
                                        setTimeout(function(){
                                            jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_play_screen").removeClass('poptin__animated animate__fadeIn animate__faster');
                                        },800);
                                    }
                                    jQ224(document).on('click', '[data-poptin-id="'+poptin.poptin_id+'"] #closeXButton', function(){
                                        closePoptinOnXclick(jQ224(this).get(0));
                                    });
                                    jQ224("[data-poptin-id="+poptin.poptin_id+"] .close-x-button").show(100);
                                    poptinFormValidations(poptin);
                                }, 1000);

                            }else{
                                showLog("lose");
                                poptin["gamified_prize"]["is_winner"] = false;
                                setTimeout(function(){
                                    jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container").css("display","none").find('.draggable.image-change-video').remove();
                                    jQ224("[data-poptin-id="+poptin.poptin_id+"] .draggable-container").removeClass('poptin-visible poptin__animated');
                                    jQ224("[data-poptin-id="+poptin.poptin_id+"]").css('box-shadow','');

                                    // show post play screen
                                    jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_losing_screen").addClass("poptin-visible poptin__animated animate__fadeIn animate__faster");
                                    setTimeout(function(){
                                        jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_losing_screen").removeClass('poptin__animated animate__fadeIn animate__faster');
                                    },800);
                                    jQ224(document).on('click', '[data-poptin-id="'+poptin.poptin_id+'"] #closeXButton', function(){
                                        closePoptinOnXclick(jQ224(this).get(0));
                                    });
                                    jQ224("[data-poptin-id="+poptin.poptin_id+"] .close-x-button").show(100);

                                    if(poptin.gamified_prize && poptin.gamified_prize.redirect_to == true && poptin.gamified_prize.redirect_to_options.redirect_to_url != undefined){
                                        showLog('ifLinkConversion3');
                                        //jQ224('[data-poptin-id='+poptin.poptin_id+']').find('#redirectBlank')[0].click();
                                        //window.poptins[poptin.poptin_id].redirect_flag=true;
                                        // var redirect_close_delay = poptin.gamified_prize.redirect_to_options.redirect_close_delay;
                                        // setTimeout(function(){
                                        // 	poptinRedirectToUrl(poptin,'direct','gamified');
                                        // }, redirect_close_delay ? (parseInt(redirect_close_delay) + (poptin.design_properties.disable_post_play_screen ? 8 : 0)) * 1000 : (poptin.wheel_has_coupon ? default_close_delay * 3 : default_close_delay) * 1000);
                                        var redirect_close_delay = poptin.gamified_prize.redirect_to_options.redirect_close_delay;
                                        var total_redirect_close_delay = redirect_close_delay ? ((poptin.design_properties.disable_post_play_screen ? 8 : 0)) * 1000 : (poptin.wheel_has_coupon ? default_close_delay * 3 : default_close_delay) * 1000;
                                        //var total_redirect_close_delay = redirect_close_delay ? (parseInt(redirect_close_delay) + (poptin.design_properties.disable_post_play_screen ? 8 : 0)) * 1000 : (poptin.wheel_has_coupon ? default_close_delay * 3 : default_close_delay) * 1000;
                                        setTimeout(function(){
                                            poptinRedirectToUrl(poptin,'direct','gamified');
                                        }, total_redirect_close_delay );
                                    }
                                    poptinFormValidations(poptin);
                                }, 1000);
                            }

                        }, 7000);

                        poptin["gamified_prize"] = poptinEncPze.prizes[prizeSelected];
                        poptin["gamified_prize"]["prize_id"] = prizeSelected;
                        if(prizeSelected == prizeWinner || poptinEncPze.prizes[prizeSelected].loosing_option == false ){
                            // Always win if loosing_option is false
                            showLog("Win");
                            poptin["gamified_prize"]["is_winner"] = true;
                            getIntlPhoneValidation(poptin)
                        }else{
                            showLog("lose");
                            poptin["gamified_prize"]["is_winner"] = false;
                        }
                    }
                    prizeSelectedIdx = prizeSelectedIdx + 1;
                }
            }
        }

        function poptinSpinWheelInit(poptin, spinAfterSubmit = false){
            var parentEL = "[data-poptin-id="+poptin.poptin_id+"]";
            var popWheel = jQ224(parentEL).find('.pop-wheel-wrap');
            var skips = 0;

            var weightJSON = {};
            var poptinEncPzeVal = jQ224("#poptinEncPze").val();
            var poptinEncPze = jQ224("#gamifiedPrizeJSON").length > 0 ? JSON.parse(jQ224("#gamifiedPrizeJSON").val()) : (poptinEncPzeVal ? JSON.parse(poptinDec(poptinEncPzeVal)) : []);

            jQ224.each(poptinEncPze.prizes, function(key, val){
                weightJSON[key] = val.chances ? Number(val.chances)/100 : 0;
            });
            if(!poptin.design_properties.disable_post_play_screen || jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] #poptinDraggableContainer #poptinFormSubmitText").length == 0){
                jQ224(parentEL).on('click', '.pop-wheel-overlay', function () {
                    poptinSpinWheelCall(poptin, parentEL, skips, popWheel, weightJSON, poptinEncPze);
                    jQ224(document).off('click', parentEL+' .pop-wheel-overlay');
                });
            } else if(spinAfterSubmit) {
                poptinSpinWheelCall(poptin, parentEL, skips, popWheel, weightJSON, poptinEncPze);
            }
        }

        function loadcouponbutton(poptin){
            jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] .poptin-coupon-element").css('position', 'absolute');
            var coupon_text='';
            jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] .froala-editor-coupon").each(function(){
                if(jQ224(this).parents('.poptin_thank_you_screen').length){
                    return;
                }
                // poptin.design_properties
                // console.log(poptin.design_properties.coupon);
                coupon_text=jQ224(this).text();

                if(poptin.design_properties.coupon && poptin.design_properties.coupon != "") {
                    var coupon_type = poptin.design_properties.coupon.coupon_type;
                    //if(coupon_type == 'unique'){
                        coupon_text = poptin.design_properties.coupon.code;
                        var coupon_element_text =  jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] .froala-editor-coupon p").text();
                        jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] .froala-editor-coupon p").html(jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] .froala-editor-coupon p").html().replace(coupon_element_text,coupon_text));
                    //}
                }

                jQ224(this).attr("data-cc",coupon_text);
                jQ224(this).css("cursor","pointer");
                jQ224(this).find('p').css("cursor","pointer");
                jQ224(this).find('span').css("cursor","pointer");
                if(coupon_text == ''){
                    jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] .poptin-coupon-element").each(function(){
                        if(jQ224(this).parents('.poptin_thank_you_screen').length == 0){
                            jQ224(this).remove();
                        }
                    });
                }
            });
            bindCouponCopyButton(poptin, jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+'] .froala-editor-coupon').filter(function(){
                return jQ224(this).parents('.poptin_thank_you_screen').length == 0;
            }));
        }

        /**
         * Thank you screen coupon: code is allocated on submit only, not at display time.
         * Fetch it from /api/display/coupon/{id} once and render into the thank you screen element.
         */
        function loadThankYouScreenCoupon(poptin){
            var thank_coupon_data = poptin.design_properties.coupon;
            if(typeof thank_coupon_data == 'undefined' || !thank_coupon_data || thank_coupon_data.coupon_screen != 'thank_you'){
                return;
            }
            if(jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_thank_you_screen .froala-editor-coupon").length == 0){
                return;
            }
            if(window.poptins[poptin.poptin_id] && window.poptins[poptin.poptin_id].thank_you_coupon_fetched){
                return;
            }
            if(window.poptins[poptin.poptin_id]){
                window.poptins[poptin.poptin_id].thank_you_coupon_fetched = true;
            }

            showLog('loadThankYouScreenCoupon: fetching '+poptin.poptin_id);
            var domain = window.location.href;
            jQ224.ajax({
                url: api_link+"/api/display/coupon/"+poptin.poptin_id,
                type: 'POST',
                data: {
                    client_id: getClientId(),
                    domain: domain,
                    cookies: getReleventCookie(),
                    if_mobile: ifMobilePoptin,
                    poptin_viewed_url: getPoptinViewedUrl(),
                },
                dataType: 'json',
                async: true,
            }, "json")
            .done(function(data){
                showLog(data);
                if(data && data.success && data.coupon && data.coupon.code != '' && data.coupon.coupon_display_flag !== false){
                    setThankYouScreenCoupon(poptin, data.coupon.code);
                }else{
                    hideThankYouScreenCoupon(poptin);
                }
            })
            .fail(function(){
                hideThankYouScreenCoupon(poptin);
            });
        }

        function setThankYouScreenCoupon(poptin, coupon_code){
            if(poptin.design_properties.coupon){
                poptin.design_properties.coupon.code = coupon_code;
            }
            jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_thank_you_screen .froala-editor-coupon").each(function(){
                var coupon_element_p = jQ224(this).find('p').first();
                var coupon_element_text = coupon_element_p.text();
                coupon_element_p.html(coupon_element_p.html().replace(coupon_element_text,coupon_code));
                jQ224(this).attr("data-cc",coupon_code);
                jQ224(this).css("cursor","pointer");
                jQ224(this).find('p').css("cursor","pointer");
                jQ224(this).find('span').css("cursor","pointer");
            });
            bindCouponCopyButton(poptin, jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_thank_you_screen .froala-editor-coupon"));
        }

        function hideThankYouScreenCoupon(poptin){
            jQ224("[data-poptin-id="+poptin.poptin_id+"] .poptin_thank_you_screen .poptin-coupon-element").remove();
        }

        function bindCouponCopyButton(poptin, targets){
            targets.off('click.poptinCouponCopy').on('click.poptinCouponCopy', function(e) {
                jQ224("#holdcoupontext").remove();
                jQ224(".poptin-coupon-tooltip").remove();
                var coupon_text=jQ224(this).text();

                // Send event to document DOM
                var poptinEventExtras = {"event_name" : "couponCopy", "coupon_code": coupon_text};
                if(poptin.gamified_prize){
                    poptinEventExtras["prize_label"] = poptin.gamified_prize.label;
                }
                const oncouponCopyEvent = new CustomEvent("couponCopy", {bubbles: true, detail: poptinEventDetails(poptin, poptinEventExtras)});
                document.dispatchEvent(oncouponCopyEvent);

                var html_copy_input='<input type="text" id="holdcoupontext" aria-label="Coupon" />';
                jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+']').append(html_copy_input);
                jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+'] #holdcoupontext').val(coupon_text).select();
                document.execCommand("Copy");
                var tooltip_div='<span style="position: absolute;background: #000;width: 70px;height: 24px;line-height: 25px;color: #fff;font-size: 12px;border-radius: 6px;top: -30px;left: calc(50% - 35px);display:none;" class="poptin-coupon-tooltip">'+(user_lang=="en"?copied_en:copied_he)+'</span>';
                jQ224(this).parent().append(tooltip_div);
                jQ224(this).parent().find(".poptin-coupon-tooltip").fadeIn();
                setTimeout(function() {
                    jQ224(".poptin-coupon-tooltip").fadeOut(300);
                }, 500);
                jQ224("#holdcoupontext").remove();
                var coupon_count_conversion = jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"] .poptin-coupon-element").attr("data-count-conversion");
                if(typeof coupon_count_conversion != 'undefined'){
                    if(coupon_count_conversion == 'true'){
                        var _conv_type = "coupon";
                        poptinConversion(poptin, null, _conv_type, this);
                    }
                }


            });
        }

        /*@nd third link buttons ready*/
        function readylinkbuttons(poptin){
            if(jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+'] .poptin-form-link-button').length>0){
                jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+'] .poptin-form-link-button').each(function(){
                    var btn_id=jQ224(this).attr("id"),
                        btnurl=jQ224(this).attr("data-btnurl"),
                        btntarget=jQ224(this).attr("data-btntarget");
                    if(jQ224(this).find("a").length>0){
                        btnurl=jQ224(this).find("a").attr("href");
                        if(typeof jQ224(this).find("a").attr("target")!="undefined"){
                            btntarget='_blank';
                            jQ224("#"+btn_id).attr("data-btntarget","_blank");
                        }
                        jQ224("#"+btn_id).attr("data-btnurl",btnurl);
                        var _a_btn_text= jQ224(this).find("a").text();
                        jQ224(this).find("a").parent().html(_a_btn_text);
                    }
                    jQ224(this).css("cursor","pointer");
                    jQ224(this).find('p, input, a, span, div, br, img').css("cursor","pointer");
                });
                jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+'] .poptin-form-link-button').on("click",function(e){
                    e.stopImmediatePropagation();
                    var linkBtnAttr = jQ224(this).data();
                    var parentPoptinId = jQ224(this).parents('.poptin-popup').attr('data-poptin-id');

                    if(linkBtnAttr['countConversion'] && linkBtnAttr['countConversion'] === true) {
                        var btn_conv_type = jQ224(this).attr("id");
                        if(btn_conv_type === "poptinFormCloseText") {
                            btn_conv_type = "close_btn";
                        }
                        poptinConversion(poptin, null, btn_conv_type, this);
                    }else{
                        jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+']').addClass("poptin-redirected");
                        buttonRedirectAfterClick(poptin,this);
                    }

                    // var link_button_url=jQ224(this).attr("data-btnurl"),
                    // link_button_target=jQ224(this).attr("data-btntarget");
                    // if( !(link_button_url.indexOf("http://") != -1 || link_button_url.indexOf("https://") != -1) ) {
                    //      link_button_url = "//" + link_button_url;
                    // }
                    // if(typeof link_button_url!='undefined' && typeof link_button_target=='undefined' ){
                    //     window.location.href = link_button_url;
                    // }else{
                    //     window.open(link_button_url, '_blank');
                    // }
                });
                jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+'] .poptin-form-link-button').on("keydown",function(e){
                    if (e.keyCode === 32 || e.keyCode === 13) {
                        jQ224(e.target).click();
                    }
                });
            }
            return false;
        }

        function buttonRedirectAfterClick(poptin, el) {
            var linkBtnAttr = jQ224(el).data();
            var parentPoptinId = jQ224(el).parents('.poptin-popup').attr('data-poptin-id');

            if( (linkBtnAttr["btnurl"] && !linkBtnAttr["launchPoptin"]) || (linkBtnAttr["linkUrl"] && linkBtnAttr["linkUrl"] == true) ){
                closePoptin( parentPoptinId, true );
                if(linkBtnAttr["btnurl"]) {
                    if( !(linkBtnAttr["btnurl"].indexOf("http://") != -1 || linkBtnAttr["btnurl"].indexOf("https://") != -1 ) ) {
                        var link_pstr=linkBtnAttr["btnurl"];
                        if(link_pstr.indexOf('tel:')!='-1' || link_pstr.indexOf('sms:')!='-1' || link_pstr.indexOf('mailto:')!='-1'){
                            linkBtnAttr["btnurl"] = linkBtnAttr["btnurl"];
                        }else{
                            linkBtnAttr["btnurl"] = "//" + linkBtnAttr["btnurl"];
                        }

                    }
                    if( !linkBtnAttr["btntarget"] ){
                        window.location.href = linkBtnAttr["btnurl"];
                    }else{
                        setTimeout(() => {
                            simpleButtonRedirect(linkBtnAttr["btnurl"], true);
                        }, 100);
                    }
                }
            }else if(linkBtnAttr["launchPoptin"] && linkBtnAttr["launchPoptin"] == true){
                closePoptin( parentPoptinId, true);
                var poptin_redirect ={};
                poptin_redirect.redirectFromBtns = true;
                poptin_redirect.poptin_from = parentPoptinId;
                poptin_redirect.poptin_to = linkBtnAttr["launchPoptinId"];
                if(linkBtnAttr["launchPoptinId"]){
                    redirectToPoptin(poptin_redirect);
                }
            }else if(linkBtnAttr["shopifyCart"] && linkBtnAttr["shopifyCart"] == true){
                showLog("Add to cart")
                showLog(poptin)
                // If Shopify then check for add to cart
                if(typeof Shopify != "undefined") {
                    showLog("handeShopifyAddToCart()");
                    handeShopifyAddToCart(poptin,false, jQ224(el).attr("id"));
                }
            } else if(linkBtnAttr["wixCart"] && linkBtnAttr["wixCart"] == true){
                showLog("Wix Add to cart")
                if(typeof window.wixDevelopersAnalytics !='undefined') {
                    showLog("handleWixAddToCart()");
                    handleWixAddToCart(poptin, false, jQ224(el).attr("id"));
                }
            } else{
                closePoptin( parentPoptinId );
            }
        }


        /*background Animation*/
        function loadbgAnimationOverlay(poptin){
            var poptinSelector = jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"]");
            var handles=[];
            var bganmval=poptinSelector.attr("data-bg-animation");

            if( poptin.poptin_type == 'embedded' || poptin.poptin_type == 'fullpage' ){
                bganmval = "";
            }
            var selector="modelBackdrip";
            var canvas_id="bgeffect_canvas_"+poptin.poptin_id;

            if(typeof bganmval!=='undefined' && typeof bganmval!==''){
                switch (bganmval) {
                    case 'wheel':
                        handles.push(new Wheel(2.5e-4 * window.innerWidth * window.innerHeight,selector,canvas_id));
                        break;
                    case 'starry-sky':
                        handles.push(new StarrySky(selector,canvas_id));
                        break;
                    case 'ball':
                        handles.push(new Balls(selector,canvas_id));
                        handles[handles.length - 1].play();
                        break;
                    case 'snow':
                        handles.push(new Snows(parseInt(5e-4 * window.innerWidth * window.innerHeight),selector,canvas_id));
                        handles[handles.length - 1].start();
                        break;
                    case 'rain':
                        handles.push(new Rain('01',selector,canvas_id));
                        break;
                    case 'confetti':
                        startConfetti(selector,canvas_id);
                        break;
                }
                if(bganmval=="starry-sky"){
                    jQ224("#"+selector+"[data-poptin-id="+poptin.poptin_id+"]").css("opacity",0.7);
                }
                else if(bganmval=="rain" || bganmval=="wheel"){
                    jQ224("#"+selector+"[data-poptin-id="+poptin.poptin_id+"]").css("opacity",0.5);
                }else{
                    var bg_effect_opacity = (poptin.poptin_type != 'gamified') ? 1 : 0.5;
                    if(typeof jQ224(".poptin-popup-background[data-poptin-id="+poptin.poptin_id+"]").attr("style") == 'undefined'){
                        bg_effect_opacity = 0.5;
                    }
                    else if(typeof jQ224(".poptin-popup-background[data-poptin-id="+poptin.poptin_id+"]").attr("style") != 'undefined' && jQ224(".poptin-popup-background[data-poptin-id="+poptin.poptin_id+"]").attr("style").indexOf('background-color') == -1
                    ){
                        bg_effect_opacity = 0.5;
                    }
                    jQ224("#"+selector+"[data-poptin-id="+poptin.poptin_id+"]").css("opacity",bg_effect_opacity);
                }
                setInterval(function(){
                    if(!jQ224("#bgeffect_canvas_"+poptin.poptin_id).length){
                        loadbgAnimationOverlay(poptin);}
                },10);

            }


        }

        /******************* Client Limit Popup Logs ******************/

        /**
         * Trigger functions: showPoptin()
         * parameters       : poptin:object
         * Desc             : Ajax call with visitor data
         * Desc             : Poptin is viewed in this stage
         */

        if(typeof poptinClientLimitLogStatus !== 'function'){
            window.poptinClientLimitLogStatus = function (client_select){
                showLog('poptinClientLimitLogStatus: '+client_select);
                // Set cookies
                jQ224("#poptinUpgradePoptin").hide();
                jQ224("#popupRemindMe").hide();

                status = client_select;
                log_id = upgrade_popup_setting.id;
                // Ajax call
                jQ224.ajax({
                    url: api_link+"/api/display/limitLogs/"+getClientId()+"?status="+status+"&id="+log_id,
                    async:true,
                    cache: true,
                    dataType: 'json',
                    type:'get',
                }, "json")
                    .done(function(data) {
                        // Do notting
                        showLog(data);
                    })
                    .fail(function(xhr, status, error) {
                        //monitorError('poptinViewed()->error()',error,status,xhr.responseText,poptin);
                    });
            }
        }

        function showPoptinLimitPopup(data){
            jQ224("body").append(data.client_restriction_setting.upgrade_popup);
        }


        if(typeof closeUpgradePopup !== 'function'){
            window.closeUpgradePopup = function (){
                jQ224("#poptinUpgradePoptin").hide()
                if (upgrade_popup_setting.mote_than_two_days){
                    jQ224("body").append(upgrade_popup_setting.remindme_popup);
                }
            }
        }


        if(typeof poptinUpgradeDontRemindMe !== 'function'){
            window.poptinUpgradeDontRemindMe = function (client_select){
                poptinClientLimitLogStatus(client_select)
            }
        }

        if(typeof poptinUpgradeRemindMe !== 'function'){
            window.poptinUpgradeRemindMe = function (client_select){
                poptinClientLimitLogStatus(client_select)
            }
        }

        if(typeof closeRemindMePopup !== 'function'){
            window.closeRemindMePopup = function (){
                jQ224("#popupRemindMe").hide();
            }
        }

        if(typeof poptinUpgradePopupClick !== 'function'){
            window.poptinUpgradePopupClick = function (client_select){
                poptinClientLimitLogStatus(client_select)
            }
        }


        /******************* Cookie ******************/

    function getSessionStorageByKey($term){
        var $result = ' ';
        for (var i = 0; i < window.sessionStorage.length; i++) {
            var key = window.sessionStorage.key(i);
            if (key.includes($term)){
                $result += key+"="+window.sessionStorage.getItem(key)+" ";
            }
        }
        return $result.slice(0, -1);
    }


        /**
         * Trigger functions:
         * parameters       : cname:string -> cookie name
         * Desc             : return boolean if cookie exist
         */
        // function poptinCheckMasterCookie(cname) {
        //     var cookie = poptinGetCookie(cname);
        //     if (cookie != "" && cookie !== null) {
        //         return true
        //     } else {
        //      return false;
        //     }
        // }


        // function PoptinCookies(){

        //  this.name   = "Poptin"
        //  this.exdays = 365
        //  this.cookies = {}

        //  this.init = function (){
        //      if (!poptinCheckMasterCookie(this.name)){
        //          this.initializeCookie()
        //      }else{
        //          this.cookies =  JSON.parse(poptinGetCookie(this.name))
        //      }

        //      this.checkExpire()

        //      $this = this

        //      setInterval(function(){
        //          $this.checkExpire()
        //      },60000)
        //  }

        //  this.initializeCookie = function(){
        //      this.updateCookies()
        //  }

        //  this.setCookie = function(cname, cvalue, exdays)
        //  {

        //      d = new Date();
        //      d.setTime(d.getTime() + (exdays*24*60*60*1000));
        //      expires = d.toUTCString();

        //      cook = {
        //          key: cname, // new_user
        //          value: cvalue,
        //          expire: expires,
        //      };

        //      this.cookies[cname] = cook
        //      $this = this
        //      setTimeout(function(){
        //          $this.updateCookies()
        //      },10)
        //  }

        //  this.checkCookie = function(cname){
        //      return (this.cookies.hasOwnProperty(cname) && !this.expire(cname))
        //  }

        //  this.getCookie = function(cname){
        //      if (this.cookies.hasOwnProperty(cname) && !this.expire(cname))
        //          return this.cookies[cname].value
        //      return ""
        //  }

        //  this.deleteCookie = function(cname){
        //      if (this.cookies.hasOwnProperty(cname)){
        //          delete this.cookies[cname]
        //          this.updateCookies()
        //      }
        //  }

        //  this.toString = function(){
        //      return JSON.stringify(this.cookies)
        //  }

        //  this.updateCookies = function(){
        //      var d = new Date();
        //      d.setTime(d.getTime() + (this.exdays*24*60*60*1000));
        //      var expires = "expires="+d.toUTCString();
        //      document.cookie = this.name + "=" + this.toString() + "; " + expires + ";path=/";
        //  }

        //  this.getReleventCookies = function(){
        //      var all_cookies = ""
        //      $this = this
        //      Object.keys(this.cookies).forEach(function(key) {
        //          if (!$this.expire(key)){
        //              all_cookies += key+'='+$this.cookies[key].value+' ';
        //          }
        //      });
        //      return all_cookies.trim()
        //  }

        //  this.checkExpire = function(){
        //      $this = this
        //      Object.keys(this.cookies).forEach(function(key) {
        //          $this.expire(key);
        //      });
        //  }

        //  this.expire = function(key){
        //      $expire = this.cookies[key].expire
        //      currentTime = new Date().valueOf();
        //      targetTime = new Date($expire).valueOf();
        //      if (currentTime >= targetTime) {
        //         this.deleteCookie(key)
        //         return true
        //      }
        //      return false;
        //  }
        // }

        /******************* datapoint ******************/

        // // For todays date;
        // Date.prototype.today = function () {
        // return ((this.getDate() < 10)?"0":"") + this.getDate() +"/"+(((this.getMonth()+1) < 10)?"0":"") + (this.getMonth()+1) +"/"+ this.getFullYear();
        // }

        // // For the time now
        // Date.prototype.timeNow = function () {
        // return ((this.getHours() < 10)?"0":"") + this.getHours() +":"+ ((this.getMinutes() < 10)?"0":"") + this.getMinutes() +":"+ ((this.getSeconds() < 10)?"0":"") + this.getSeconds();
        // }

        // function DataPoint(){
        // this.ids = {
        // poptin_id: '',
        // client_id : "",
        // user_id : "",
        // record_id:''
        // },
        // this.time = {
        // entered_time: '',
        // appeared_time : "",
        // closed_time : "",
        // converted_time :""
        // },
        // this.address = {
        // country : '',
        // city : '',
        // time_zone : '',
        // error:''
        // },
        // this.style = {
        // bg_color : "",
        // bg_transparency : "",
        // button_bg_color: "",
        // button_text: "",
        // button_text_size: "",
        // button_text_color: "",
        // button_text_family: "",
        // button_text_style: "",
        // text_all:"",
        // text_header:"",
        // text_p_all:"",
        // error:""
        // },
        // this.setting = {
        // content_lock : false,
        // credit : true,
        // if_was_x : true,
        // when_x_appear : '0',
        // x_hover_text : '',
        // automatic_close : '0',
        // resulotion : '',
        // appeared_url: '',
        // closed_by: 'by_x', // by X | click on background | click on cacncel button
        // scrolling_percent:'',
        // conversion:false,
        // conversion_target:"",
        // poptin_type:"",
        // poptin_format:"",
        // poptin_position:"",
        // trigger:"",
        // pageviews:0,
        // referrer:'',
        // error:""
        // },
        // this.fields = {
        // email:   {name:'email',active:false,validate:false,require:false},
        // name:    {name:'full name',active:false,validate:false,require:false},
        // phone:   {name:'phone',active:false,validate:false,require:false},
        // message:{name:'message',active:false,validate:false,require:false},
        // free_fields:[],
        // error:""
        // },
        // this.setLocation = function(){
        // showLog('setLocation');
        // var _this = this;
        // try{
        // jQ224.getJSON('https://freegeoip.net/json/')
        // .done(function(result){
        // _this.address.country = result.country_name;
        // _this.address.city = result.city;
        // //_this.address.time_zone = result.time_zone;
        // _this.address.time_zone = new Date();
        // }).complete(function(result){
        // _this.viewed();
        // });
        // }catch(err){
        // this.address.error = err;
        // }
        // },
        // this.currentTime = function(){
        // return new Date().today() + " " + new Date().timeNow();
        // },
        // this.setIds = function(poptin_id){
        // this.ids.poptin_id=poptin_id;
        // this.ids.client_id=query_string.id;
        // this.ids.user_id=getUserId();
        // },
        // this.setAppeared = function(){
        // showLog('setAppeared');
        // this.time.appeared_time = this.currentTime();
        // },
        // this.setRecordIds = function(id){
        // this.ids.record_id = id;
        // },
        // this.setClosed = function(poptin_id){
        // this.time.closed_time = this.currentTime();
        // this.setClosedBy(window.poptins[poptin_id].poptin_trigger.close_trigger);
        // this.closed();

        // },
        // this.setConverted = function(){
        // this.time.converted_time = this.currentTime();
        // this.setting.conversion = true;
        // this.converted();

        // },
        // this.setClosedBy = function(type){
        // var close_type = {'x_click':'by x','bg_click':'click on background','cancel_click':'click on cancel button','submit':'close after submit','auto_close':'close automatic','timer':'timer close'};
        // this.setting.closed_by = close_type[type];// by X | click on background | click on cacncel button
        // },
        // this.setSettings = function(poptin,trigger){
        // showLog('setSettings');
        // try{
        // this.setting.trigger             = window.poptins[poptin.poptin_id].poptin_trigger?.trigger;
        // this.setting.referrer            = getReferrer();
        // this.setting.resulotion      = screen.availWidth+'*'+screen.availHeight;
        // this.setting.appeared_url        = window.location.href;
        // this.setting.scrolling_percent   = jQ224(window).scrollTop();
        // this.setting.conversion_target   = poptin.poptin_target;
        // this.setting.poptin_type         = poptin.poptin_type;
        // this.setting.poptin_format       = poptin.poptin_format;
        // this.setting.pageviews           = getPoptinPageviews(poptin.poptin_id);
        // this.setting.poptin_position     =  poptin.design_properties.poptin_location;
        // this.setting.credit          = poptin.if_freemium;
        // this.setting.content_lock        = poptin.design_properties.poptin_design_content_lock;
        // this.setting.if_was_x            = (poptin.design_properties.poptin_design_close_options_type.split('-')==='x' ? true :false);
        // this.setting.when_x_appear       = (poptin.design_properties.poptin_design_show_x_after_sec==null ? 0 :poptin.design_properties.poptin_design_show_x_after_sec);
        // this.setting.x_hover_text        = (poptin.design_properties.poptin_design_show_x_comment==null ? 0 :poptin.design_properties.poptin_design_show_x_comment);
        // this.setting.automatic_close = (poptin.design_properties.poptin_design_auto_close_sec===undefined ? false :poptin.design_properties.poptin_design_auto_close_sec);
        // }catch(err){
        // this.setting.error=err;
        // }
        // },
        // this.setStyle = function(poptin){
        // showLog('setStyle');
        // try{
        // var $this = jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+'] .draggable-container');
        // if ((poptin.format== "format_3" || poptin.format== "format_9")&&poptin.type== "lightbox"){
        // this.style.bg_color = ($this.find('.alternative-background').first().css('background-image') == 'none' ? $this.find('.alternative-background').first().css('background-color') : 'img');
        // this.style.bg_transparency =  $this.find('.alternative-background').first().css('background-color');
        // }else{
        // this.style.bg_color = ($this.css('background-image') =='none' ? $this.css('background-color') : 'img');
        // this.style.bg_transparency = $this.css('background-color');
        // }
        // if ($this.find('.poptin-form-submit-button').is(':visible'))
        // this.style.button_bg_color = ($this.find('.poptin-form-submit-button').css('background-image') == 'none' ? $this.find('.poptin-form-submit-button').css('background-color') : 'img'),
        // $this_text = $this.find('#poptinFormSubmitText');
        // this.style.button_text= $this_text.text();
        // this.style.button_text_size= $this_text.css('font-size');
        // this.style.button_text_color= $this_text.css('color');
        // this.style.button_text_family= $this_text.css('font-family');
        // this.style.button_text_style= 'bold: '+$this_text.css('font-whight')+' | italic: '+$this_text.css('font-style')+' | underline:'+$this_text.css('text-decoration') ;
        // this.style.text_all= $this.find('p:not(.poptin-form-submit-button)').text();
        // this.style.text_header=$this.find('p').first().text();
        // this.style.text_p_all = $this.find('p:not(.poptin-form-submit-button, :first)').text();
        // }catch(err){
        // this.style.error=err;
        // }
        // },
        // this.setFields = function(poptin){
        // showLog('setFields');
        // try{
        // var $this = jQ224('.poptin-popup[data-poptin-id='+poptin.poptin_id+'] .inputs-container input');
        // if ($this.length>0){
        // for (var i=0;i<$this.length;i++){
        // if ($this[i].id.indexOf('poptinDesignInputFreeField')>-1){
        // this.fields.free_fields.push({name:jQ224($this[i]).attr('placeholder'),active:true,require:jQ224($this[i]).prop('required')});
        // }else if ($this[i].id.indexOf('poptinDesignInputTextField')>-1){
        // var type = $this[i].id.split('poptinDesignInputTextField')[1];
        // this.fields[type.toLowerCase()].active = true;
        // this.fields[type.toLowerCase()].require = jQ224($this[i]).prop('required');
        // this.fields[type.toLowerCase()].validate = (jQ224($this[i]).attr('validate') == false || jQ224($this[i]).attr('validate') == undefined ? false:true);
        // }
        // }
        // }
        // }catch(err){
        // this.fields.error=err;
        // }
        // },
        // this.onLoad = function(poptin_id){
        // this.time.entered_time = this.currentTime();
        // this.setIds(poptin_id);
        // },
        // this.onShow = function(poptin){
        // this.setAppeared();
        // this.setSettings(poptin);
        // this.setStyle(poptin);
        // this.setFields(poptin);
        // this.setLocation();
        // },
        // this.onConversion = function(){
        // this.setConverted();
        // },
        // this.onClose = function(poptin_id){
        // this.setClosed(poptin_id);
        // },
        // this.viewed = function(){
        // showLog('viewed');
        // var data = jQ224.extend( {},this.ids,this.time,this.address,this.setting,this.style,this.fields);
        // var url = api_link+"/datapoints/viewed/"+query_string.id;
        // var step = 'viewed';
        // this.send(url,step,data);
        // },
        // this.converted = function(){
        // if (this.ids.record_id=='' || this.ids.record_id==undefined){
        // this.viewed();
        // }else{
        // var data = {record_id:this.ids.record_id,conversion:this.setting.conversion,converted_time:this.time.converted_time};
        // var url = api_link+"/datapoints/converted/"+query_string.id;
        // var step = 'converted';
        // this.send(url,step,data);
        // }
        // },
        // this.closed = function(){
        // if (this.ids.record_id=='' || this.ids.record_id==undefined){
        // this.viewed();
        // }else{
        // var data = {record_id:this.ids.record_id,closed_by:this.setting.closed_by,closed_time:this.time.closed_time};
        // var url = api_link+"/datapoints/closed/"+query_string.id;
        // var step = 'closed';
        // this.send(url,step,data);
        // }
        // },
        // this.ajaxCompilte = function($result,step){
        // if ($result.success==true){
        // if (step=='viewed')
        // this.setRecordIds($result.data.datapoints_id);
        // }else{
        // if (step!=='viewed')
        // monitorError('datapoints()->after_send->'+step+'()->error()',$result.error,$result.status,$result.data.responseText,this.ids.poptin_id);
        // }
        // },
        // this.send = function(url,step,$data){
        // var _this = this;
        // try{
        // jQ224.ajax({
        // url: url,
        // type: 'get',
        // data: $data,
        // dataType: 'json',
        // cache: true,
        // async: true,
        // }, "json")
        // .done(function(data){
        // _this.ajaxCompilte({success:data.success,data:data},step);
        // })
        // .fail(function (xhr, status, error) {
        // _this.ajaxCompilte({success:false,data:xhr,status:status,error:error},step);
        // });
        // }catch(err){
        // monitorError('datapoints()->send()->'+step+'()->error()',err,'OK',false,_this.ids.poptin_id);
        // }
        // }
        // }

        // function hideEffect(poptin){
        //  var selectedEffect = poptin.design_properties.poptin_design_entry_effect.split('-')[1];
        //  // Most effect types need no options passed by default
        //     var options = {};
        //     // some effects have required parameters
        //  var ver = jQ224(".poptin-popup-background[data-poptin-id="+poptin.poptin_id+"]").outerWidth +100;
        //  var hor = jQ224(".poptin-popup-background[data-poptin-id="+poptin.poptin_id+"]").outerHeight+100;
        //  switch(selectedEffect){
        //      case "scale" :
        //          options = { percent: 10 };
        //          break;
        //      case "size" :
        //          options = { to: { width: 100, height: 100 } };
        //          break;
        //      case "up" :
        //          options = { direction: 'up' };
        //          selectedEffect = "slide";
        //          break;
        //      case "down" :
        //          options = { direction: 'down' };
        //          selectedEffect = "slide";
        //          break;
        //      case "left" :
        //          options = { direction: 'left'};
        //          selectedEffect = "slide";
        //          break;
        //      case "right" :
        //          options = { direction: 'right' };
        //          selectedEffect = "slide";
        //          break;
        //  }

        //  jQ224(".poptin-popup-background[data-poptin-id="+poptin.poptin_id+"]").fadeOut(500);
        //  try{
        //      if (typeof window.$ !== 'undefined' && window.$.ui !== undefined){
        //         jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"], .poptin-popup[data-poptin-id="+poptin.poptin_id+"] .draggable-container").hide(selectedEffect, options, 500);
        //      }else if (typeof window.jQuery !== 'undefined' && window.jQuery.ui !== undefined){
        //          jQuery(".poptin-popup[data-poptin-id="+poptin.poptin_id+"], .poptin-popup[data-poptin-id="+poptin.poptin_id+"] .draggable-container").hide(selectedEffect, options, 500);
        //      }else if (jQ224.ui !== undefined){
        //          jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"], .poptin-popup[data-poptin-id="+poptin.poptin_id+"] .draggable-container").hide(selectedEffect, options, 500);
        //      }else{
        //          jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"], .poptin-popup[data-poptin-id="+poptin.poptin_id+"] .draggable-container").fadeOut(500);
        //      }
        //  }catch(err){
        //      jQ224(".poptin-popup[data-poptin-id="+poptin.poptin_id+"], .poptin-popup[data-poptin-id="+poptin.poptin_id+"] .draggable-container").fadeOut(500);
        //  }
        // }



    }
})(window, document);
